var _toConsumableArray = require("/home/ubuntu/dev/moloch-monorepo/packages/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var i = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var i in e) {
      r.d(n, i, function (t) {
        return e[t];
      }.bind(null, i));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 87);
}([function (e, t, r) {
  e.exports = r(198)();
}, function (e, t) {
  e.exports = require("react");
}, function (e, t, r) {
  "use strict";

  var n = t;
  n.version = r(143).version, n.utils = r(144), n.rand = r(147), n.curve = r(33), n.curves = r(153), n.ec = r(161), n.eddsa = r(165);
}, function (e, t) {
  var r = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
  "number" == typeof __g && (__g = r);
}, function (e, t, r) {
  var n = r(66)("wks"),
      i = r(67),
      o = r(3).Symbol,
      a = "function" == typeof o;
  (e.exports = function (e) {
    return n[e] || (n[e] = a && o[e] || (a ? o : i)("Symbol." + e));
  }).store = n;
}, function (e, t, r) {
  "use strict";

  var n = r(13),
      i = r(34);

  function o(e, t) {
    return 55296 == (64512 & e.charCodeAt(t)) && !(t < 0 || t + 1 >= e.length) && 56320 == (64512 & e.charCodeAt(t + 1));
  }

  function a(e) {
    return (e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (255 & e) << 24) >>> 0;
  }

  function s(e) {
    return 1 === e.length ? "0" + e : e;
  }

  function f(e) {
    return 7 === e.length ? "0" + e : 6 === e.length ? "00" + e : 5 === e.length ? "000" + e : 4 === e.length ? "0000" + e : 3 === e.length ? "00000" + e : 2 === e.length ? "000000" + e : 1 === e.length ? "0000000" + e : e;
  }

  t.inherits = i, t.toArray = function (e, t) {
    if (Array.isArray(e)) return e.slice();
    if (!e) return [];
    var r = [];
    if ("string" == typeof e) {
      if (t) {
        if ("hex" === t) for ((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), i = 0; i < e.length; i += 2) {
          r.push(parseInt(e[i] + e[i + 1], 16));
        }
      } else for (var n = 0, i = 0; i < e.length; i++) {
        var a = e.charCodeAt(i);
        a < 128 ? r[n++] = a : a < 2048 ? (r[n++] = a >> 6 | 192, r[n++] = 63 & a | 128) : o(e, i) ? (a = 65536 + ((1023 & a) << 10) + (1023 & e.charCodeAt(++i)), r[n++] = a >> 18 | 240, r[n++] = a >> 12 & 63 | 128, r[n++] = a >> 6 & 63 | 128, r[n++] = 63 & a | 128) : (r[n++] = a >> 12 | 224, r[n++] = a >> 6 & 63 | 128, r[n++] = 63 & a | 128);
      }
    } else for (i = 0; i < e.length; i++) {
      r[i] = 0 | e[i];
    }
    return r;
  }, t.toHex = function (e) {
    for (var t = "", r = 0; r < e.length; r++) {
      t += s(e[r].toString(16));
    }

    return t;
  }, t.htonl = a, t.toHex32 = function (e, t) {
    for (var r = "", n = 0; n < e.length; n++) {
      var i = e[n];
      "little" === t && (i = a(i)), r += f(i.toString(16));
    }

    return r;
  }, t.zero2 = s, t.zero8 = f, t.join32 = function (e, t, r, i) {
    var o = r - t;
    n(o % 4 == 0);

    for (var a = new Array(o / 4), s = 0, f = t; s < a.length; s++, f += 4) {
      var c;
      c = "big" === i ? e[f] << 24 | e[f + 1] << 16 | e[f + 2] << 8 | e[f + 3] : e[f + 3] << 24 | e[f + 2] << 16 | e[f + 1] << 8 | e[f], a[s] = c >>> 0;
    }

    return a;
  }, t.split32 = function (e, t) {
    for (var r = new Array(4 * e.length), n = 0, i = 0; n < e.length; n++, i += 4) {
      var o = e[n];
      "big" === t ? (r[i] = o >>> 24, r[i + 1] = o >>> 16 & 255, r[i + 2] = o >>> 8 & 255, r[i + 3] = 255 & o) : (r[i + 3] = o >>> 24, r[i + 2] = o >>> 16 & 255, r[i + 1] = o >>> 8 & 255, r[i] = 255 & o);
    }

    return r;
  }, t.rotr32 = function (e, t) {
    return e >>> t | e << 32 - t;
  }, t.rotl32 = function (e, t) {
    return e << t | e >>> 32 - t;
  }, t.sum32 = function (e, t) {
    return e + t >>> 0;
  }, t.sum32_3 = function (e, t, r) {
    return e + t + r >>> 0;
  }, t.sum32_4 = function (e, t, r, n) {
    return e + t + r + n >>> 0;
  }, t.sum32_5 = function (e, t, r, n, i) {
    return e + t + r + n + i >>> 0;
  }, t.sum64 = function (e, t, r, n) {
    var i = e[t],
        o = n + e[t + 1] >>> 0,
        a = (o < n ? 1 : 0) + r + i;
    e[t] = a >>> 0, e[t + 1] = o;
  }, t.sum64_hi = function (e, t, r, n) {
    return (t + n >>> 0 < t ? 1 : 0) + e + r >>> 0;
  }, t.sum64_lo = function (e, t, r, n) {
    return t + n >>> 0;
  }, t.sum64_4_hi = function (e, t, r, n, i, o, a, s) {
    var f = 0,
        c = t;
    return f += (c = c + n >>> 0) < t ? 1 : 0, f += (c = c + o >>> 0) < o ? 1 : 0, e + r + i + a + (f += (c = c + s >>> 0) < s ? 1 : 0) >>> 0;
  }, t.sum64_4_lo = function (e, t, r, n, i, o, a, s) {
    return t + n + o + s >>> 0;
  }, t.sum64_5_hi = function (e, t, r, n, i, o, a, s, f, c) {
    var u = 0,
        d = t;
    return u += (d = d + n >>> 0) < t ? 1 : 0, u += (d = d + o >>> 0) < o ? 1 : 0, u += (d = d + s >>> 0) < s ? 1 : 0, e + r + i + a + f + (u += (d = d + c >>> 0) < c ? 1 : 0) >>> 0;
  }, t.sum64_5_lo = function (e, t, r, n, i, o, a, s, f, c) {
    return t + n + o + s + c >>> 0;
  }, t.rotr64_hi = function (e, t, r) {
    return (t << 32 - r | e >>> r) >>> 0;
  }, t.rotr64_lo = function (e, t, r) {
    return (e << 32 - r | t >>> r) >>> 0;
  }, t.shr64_hi = function (e, t, r) {
    return e >>> r;
  }, t.shr64_lo = function (e, t, r) {
    return (e << 32 - r | t >>> r) >>> 0;
  };
}, function (e, t) {
  e.exports = function (e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  };
}, function (e, t) {
  var r;

  r = function () {
    return this;
  }();

  try {
    r = r || new Function("return this")();
  } catch (e) {
    "object" == typeof window && (r = window);
  }

  e.exports = r;
}, function (e, t) {
  var r = e.exports = {
    version: "2.6.4"
  };
  "number" == typeof __e && (__e = r);
}, function (e, t, r) {
  (function (e) {
    !function (e, t) {
      "use strict";

      function n(e, t) {
        if (!e) throw new Error(t || "Assertion failed");
      }

      function i(e, t) {
        e.super_ = t;

        var r = function r() {};

        r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
      }

      function o(e, t, r) {
        if (o.isBN(e)) return e;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
      }

      var a;
      "object" == typeof e ? e.exports = o : t.BN = o, o.BN = o, o.wordSize = 26;

      try {
        a = r(146).Buffer;
      } catch (e) {}

      function s(e, t, r) {
        for (var n = 0, i = Math.min(e.length, r), o = t; o < i; o++) {
          var a = e.charCodeAt(o) - 48;
          n <<= 4, n |= a >= 49 && a <= 54 ? a - 49 + 10 : a >= 17 && a <= 22 ? a - 17 + 10 : 15 & a;
        }

        return n;
      }

      function f(e, t, r, n) {
        for (var i = 0, o = Math.min(e.length, r), a = t; a < o; a++) {
          var s = e.charCodeAt(a) - 48;
          i *= n, i += s >= 49 ? s - 49 + 10 : s >= 17 ? s - 17 + 10 : s;
        }

        return i;
      }

      o.isBN = function (e) {
        return e instanceof o || null !== e && "object" == typeof e && e.constructor.wordSize === o.wordSize && Array.isArray(e.words);
      }, o.max = function (e, t) {
        return e.cmp(t) > 0 ? e : t;
      }, o.min = function (e, t) {
        return e.cmp(t) < 0 ? e : t;
      }, o.prototype._init = function (e, t, r) {
        if ("number" == typeof e) return this._initNumber(e, t, r);
        if ("object" == typeof e) return this._initArray(e, t, r);
        "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
        var i = 0;
        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && i++, 16 === t ? this._parseHex(e, i) : this._parseBase(e, t, i), "-" === e[0] && (this.negative = 1), this.strip(), "le" === r && this._initArray(this.toArray(), t, r);
      }, o.prototype._initNumber = function (e, t, r) {
        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [67108863 & e], this.length = 1) : e < 4503599627370496 ? (this.words = [67108863 & e, e / 67108864 & 67108863], this.length = 2) : (n(e < 9007199254740992), this.words = [67108863 & e, e / 67108864 & 67108863, 1], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
      }, o.prototype._initArray = function (e, t, r) {
        if (n("number" == typeof e.length), e.length <= 0) return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);

        for (var i = 0; i < this.length; i++) {
          this.words[i] = 0;
        }

        var o,
            a,
            s = 0;
        if ("be" === r) for (i = e.length - 1, o = 0; i >= 0; i -= 3) {
          a = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);
        } else if ("le" === r) for (i = 0, o = 0; i < e.length; i += 3) {
          a = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);
        }
        return this.strip();
      }, o.prototype._parseHex = function (e, t) {
        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);

        for (var r = 0; r < this.length; r++) {
          this.words[r] = 0;
        }

        var n,
            i,
            o = 0;

        for (r = e.length - 6, n = 0; r >= t; r -= 6) {
          i = s(e, r, r + 6), this.words[n] |= i << o & 67108863, this.words[n + 1] |= i >>> 26 - o & 4194303, (o += 24) >= 26 && (o -= 26, n++);
        }

        r + 6 !== t && (i = s(e, t, r + 6), this.words[n] |= i << o & 67108863, this.words[n + 1] |= i >>> 26 - o & 4194303), this.strip();
      }, o.prototype._parseBase = function (e, t, r) {
        this.words = [0], this.length = 1;

        for (var n = 0, i = 1; i <= 67108863; i *= t) {
          n++;
        }

        n--, i = i / t | 0;

        for (var o = e.length - r, a = o % n, s = Math.min(o, o - a) + r, c = 0, u = r; u < s; u += n) {
          c = f(e, u, u + n, t), this.imuln(i), this.words[0] + c < 67108864 ? this.words[0] += c : this._iaddn(c);
        }

        if (0 !== a) {
          var d = 1;

          for (c = f(e, u, e.length, t), u = 0; u < a; u++) {
            d *= t;
          }

          this.imuln(d), this.words[0] + c < 67108864 ? this.words[0] += c : this._iaddn(c);
        }
      }, o.prototype.copy = function (e) {
        e.words = new Array(this.length);

        for (var t = 0; t < this.length; t++) {
          e.words[t] = this.words[t];
        }

        e.length = this.length, e.negative = this.negative, e.red = this.red;
      }, o.prototype.clone = function () {
        var e = new o(null);
        return this.copy(e), e;
      }, o.prototype._expand = function (e) {
        for (; this.length < e;) {
          this.words[this.length++] = 0;
        }

        return this;
      }, o.prototype.strip = function () {
        for (; this.length > 1 && 0 === this.words[this.length - 1];) {
          this.length--;
        }

        return this._normSign();
      }, o.prototype._normSign = function () {
        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
      }, o.prototype.inspect = function () {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var c = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
          u = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
          d = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

      function h(e, t, r) {
        r.negative = t.negative ^ e.negative;
        var n = e.length + t.length | 0;
        r.length = n, n = n - 1 | 0;
        var i = 0 | e.words[0],
            o = 0 | t.words[0],
            a = i * o,
            s = 67108863 & a,
            f = a / 67108864 | 0;
        r.words[0] = s;

        for (var c = 1; c < n; c++) {
          for (var u = f >>> 26, d = 67108863 & f, h = Math.min(c, t.length - 1), l = Math.max(0, c - e.length + 1); l <= h; l++) {
            var p = c - l | 0;
            u += (a = (i = 0 | e.words[p]) * (o = 0 | t.words[l]) + d) / 67108864 | 0, d = 67108863 & a;
          }

          r.words[c] = 0 | d, f = 0 | u;
        }

        return 0 !== f ? r.words[c] = 0 | f : r.length--, r.strip();
      }

      o.prototype.toString = function (e, t) {
        var r;

        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
          r = "";

          for (var i = 0, o = 0, a = 0; a < this.length; a++) {
            var s = this.words[a],
                f = (16777215 & (s << i | o)).toString(16);
            r = 0 !== (o = s >>> 24 - i & 16777215) || a !== this.length - 1 ? c[6 - f.length] + f + r : f + r, (i += 2) >= 26 && (i -= 26, a--);
          }

          for (0 !== o && (r = o.toString(16) + r); r.length % t != 0;) {
            r = "0" + r;
          }

          return 0 !== this.negative && (r = "-" + r), r;
        }

        if (e === (0 | e) && e >= 2 && e <= 36) {
          var h = u[e],
              l = d[e];
          r = "";
          var p = this.clone();

          for (p.negative = 0; !p.isZero();) {
            var b = p.modn(l).toString(e);
            r = (p = p.idivn(l)).isZero() ? b + r : c[h - b.length] + b + r;
          }

          for (this.isZero() && (r = "0" + r); r.length % t != 0;) {
            r = "0" + r;
          }

          return 0 !== this.negative && (r = "-" + r), r;
        }

        n(!1, "Base should be between 2 and 36");
      }, o.prototype.toNumber = function () {
        var e = this.words[0];
        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
      }, o.prototype.toJSON = function () {
        return this.toString(16);
      }, o.prototype.toBuffer = function (e, t) {
        return n(void 0 !== a), this.toArrayLike(a, e, t);
      }, o.prototype.toArray = function (e, t) {
        return this.toArrayLike(Array, e, t);
      }, o.prototype.toArrayLike = function (e, t, r) {
        var i = this.byteLength(),
            o = r || Math.max(1, i);
        n(i <= o, "byte array longer than desired length"), n(o > 0, "Requested array length <= 0"), this.strip();
        var a,
            s,
            f = "le" === t,
            c = new e(o),
            u = this.clone();

        if (f) {
          for (s = 0; !u.isZero(); s++) {
            a = u.andln(255), u.iushrn(8), c[s] = a;
          }

          for (; s < o; s++) {
            c[s] = 0;
          }
        } else {
          for (s = 0; s < o - i; s++) {
            c[s] = 0;
          }

          for (s = 0; !u.isZero(); s++) {
            a = u.andln(255), u.iushrn(8), c[o - s - 1] = a;
          }
        }

        return c;
      }, Math.clz32 ? o.prototype._countBits = function (e) {
        return 32 - Math.clz32(e);
      } : o.prototype._countBits = function (e) {
        var t = e,
            r = 0;
        return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
      }, o.prototype._zeroBits = function (e) {
        if (0 === e) return 26;
        var t = e,
            r = 0;
        return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
      }, o.prototype.bitLength = function () {
        var e = this.words[this.length - 1],
            t = this._countBits(e);

        return 26 * (this.length - 1) + t;
      }, o.prototype.zeroBits = function () {
        if (this.isZero()) return 0;

        for (var e = 0, t = 0; t < this.length; t++) {
          var r = this._zeroBits(this.words[t]);

          if (e += r, 26 !== r) break;
        }

        return e;
      }, o.prototype.byteLength = function () {
        return Math.ceil(this.bitLength() / 8);
      }, o.prototype.toTwos = function (e) {
        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
      }, o.prototype.fromTwos = function (e) {
        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
      }, o.prototype.isNeg = function () {
        return 0 !== this.negative;
      }, o.prototype.neg = function () {
        return this.clone().ineg();
      }, o.prototype.ineg = function () {
        return this.isZero() || (this.negative ^= 1), this;
      }, o.prototype.iuor = function (e) {
        for (; this.length < e.length;) {
          this.words[this.length++] = 0;
        }

        for (var t = 0; t < e.length; t++) {
          this.words[t] = this.words[t] | e.words[t];
        }

        return this.strip();
      }, o.prototype.ior = function (e) {
        return n(0 == (this.negative | e.negative)), this.iuor(e);
      }, o.prototype.or = function (e) {
        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
      }, o.prototype.uor = function (e) {
        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
      }, o.prototype.iuand = function (e) {
        var t;
        t = this.length > e.length ? e : this;

        for (var r = 0; r < t.length; r++) {
          this.words[r] = this.words[r] & e.words[r];
        }

        return this.length = t.length, this.strip();
      }, o.prototype.iand = function (e) {
        return n(0 == (this.negative | e.negative)), this.iuand(e);
      }, o.prototype.and = function (e) {
        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
      }, o.prototype.uand = function (e) {
        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
      }, o.prototype.iuxor = function (e) {
        var t, r;
        this.length > e.length ? (t = this, r = e) : (t = e, r = this);

        for (var n = 0; n < r.length; n++) {
          this.words[n] = t.words[n] ^ r.words[n];
        }

        if (this !== t) for (; n < t.length; n++) {
          this.words[n] = t.words[n];
        }
        return this.length = t.length, this.strip();
      }, o.prototype.ixor = function (e) {
        return n(0 == (this.negative | e.negative)), this.iuxor(e);
      }, o.prototype.xor = function (e) {
        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
      }, o.prototype.uxor = function (e) {
        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
      }, o.prototype.inotn = function (e) {
        n("number" == typeof e && e >= 0);
        var t = 0 | Math.ceil(e / 26),
            r = e % 26;
        this._expand(t), r > 0 && t--;

        for (var i = 0; i < t; i++) {
          this.words[i] = 67108863 & ~this.words[i];
        }

        return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
      }, o.prototype.notn = function (e) {
        return this.clone().inotn(e);
      }, o.prototype.setn = function (e, t) {
        n("number" == typeof e && e >= 0);
        var r = e / 26 | 0,
            i = e % 26;
        return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
      }, o.prototype.iadd = function (e) {
        var t, r, n;
        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
        this.length > e.length ? (r = this, n = e) : (r = e, n = this);

        for (var i = 0, o = 0; o < n.length; o++) {
          t = (0 | r.words[o]) + (0 | n.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
        }

        for (; 0 !== i && o < r.length; o++) {
          t = (0 | r.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
        }

        if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;else if (r !== this) for (; o < r.length; o++) {
          this.words[o] = r.words[o];
        }
        return this;
      }, o.prototype.add = function (e) {
        var t;
        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
      }, o.prototype.isub = function (e) {
        if (0 !== e.negative) {
          e.negative = 0;
          var t = this.iadd(e);
          return e.negative = 1, t._normSign();
        }

        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
        var r,
            n,
            i = this.cmp(e);
        if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        i > 0 ? (r = this, n = e) : (r = e, n = this);

        for (var o = 0, a = 0; a < n.length; a++) {
          o = (t = (0 | r.words[a]) - (0 | n.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
        }

        for (; 0 !== o && a < r.length; a++) {
          o = (t = (0 | r.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
        }

        if (0 === o && a < r.length && r !== this) for (; a < r.length; a++) {
          this.words[a] = r.words[a];
        }
        return this.length = Math.max(this.length, a), r !== this && (this.negative = 1), this.strip();
      }, o.prototype.sub = function (e) {
        return this.clone().isub(e);
      };

      var l = function l(e, t, r) {
        var n,
            i,
            o,
            a = e.words,
            s = t.words,
            f = r.words,
            c = 0,
            u = 0 | a[0],
            d = 8191 & u,
            h = u >>> 13,
            l = 0 | a[1],
            p = 8191 & l,
            b = l >>> 13,
            v = 0 | a[2],
            m = 8191 & v,
            y = v >>> 13,
            g = 0 | a[3],
            A = 8191 & g,
            w = g >>> 13,
            _ = 0 | a[4],
            x = 8191 & _,
            S = _ >>> 13,
            k = 0 | a[5],
            E = 8191 & k,
            M = k >>> 13,
            C = 0 | a[6],
            B = 8191 & C,
            P = C >>> 13,
            R = 0 | a[7],
            H = 8191 & R,
            O = R >>> 13,
            T = 0 | a[8],
            I = 8191 & T,
            j = T >>> 13,
            z = 0 | a[9],
            L = 8191 & z,
            N = z >>> 13,
            W = 0 | s[0],
            U = 8191 & W,
            D = W >>> 13,
            q = 0 | s[1],
            F = 8191 & q,
            X = q >>> 13,
            Y = 0 | s[2],
            V = 8191 & Y,
            K = Y >>> 13,
            J = 0 | s[3],
            G = 8191 & J,
            Z = J >>> 13,
            Q = 0 | s[4],
            $ = 8191 & Q,
            ee = Q >>> 13,
            te = 0 | s[5],
            re = 8191 & te,
            ne = te >>> 13,
            ie = 0 | s[6],
            oe = 8191 & ie,
            ae = ie >>> 13,
            se = 0 | s[7],
            fe = 8191 & se,
            ce = se >>> 13,
            ue = 0 | s[8],
            de = 8191 & ue,
            he = ue >>> 13,
            le = 0 | s[9],
            pe = 8191 & le,
            be = le >>> 13;

        r.negative = e.negative ^ t.negative, r.length = 19;
        var ve = (c + (n = Math.imul(d, U)) | 0) + ((8191 & (i = (i = Math.imul(d, D)) + Math.imul(h, U) | 0)) << 13) | 0;
        c = ((o = Math.imul(h, D)) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(p, U), i = (i = Math.imul(p, D)) + Math.imul(b, U) | 0, o = Math.imul(b, D);
        var me = (c + (n = n + Math.imul(d, F) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, X) | 0) + Math.imul(h, F) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(h, X) | 0) + (i >>> 13) | 0) + (me >>> 26) | 0, me &= 67108863, n = Math.imul(m, U), i = (i = Math.imul(m, D)) + Math.imul(y, U) | 0, o = Math.imul(y, D), n = n + Math.imul(p, F) | 0, i = (i = i + Math.imul(p, X) | 0) + Math.imul(b, F) | 0, o = o + Math.imul(b, X) | 0;
        var ye = (c + (n = n + Math.imul(d, V) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, K) | 0) + Math.imul(h, V) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(h, K) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(A, U), i = (i = Math.imul(A, D)) + Math.imul(w, U) | 0, o = Math.imul(w, D), n = n + Math.imul(m, F) | 0, i = (i = i + Math.imul(m, X) | 0) + Math.imul(y, F) | 0, o = o + Math.imul(y, X) | 0, n = n + Math.imul(p, V) | 0, i = (i = i + Math.imul(p, K) | 0) + Math.imul(b, V) | 0, o = o + Math.imul(b, K) | 0;
        var ge = (c + (n = n + Math.imul(d, G) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, Z) | 0) + Math.imul(h, G) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(h, Z) | 0) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(x, U), i = (i = Math.imul(x, D)) + Math.imul(S, U) | 0, o = Math.imul(S, D), n = n + Math.imul(A, F) | 0, i = (i = i + Math.imul(A, X) | 0) + Math.imul(w, F) | 0, o = o + Math.imul(w, X) | 0, n = n + Math.imul(m, V) | 0, i = (i = i + Math.imul(m, K) | 0) + Math.imul(y, V) | 0, o = o + Math.imul(y, K) | 0, n = n + Math.imul(p, G) | 0, i = (i = i + Math.imul(p, Z) | 0) + Math.imul(b, G) | 0, o = o + Math.imul(b, Z) | 0;
        var Ae = (c + (n = n + Math.imul(d, $) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ee) | 0) + Math.imul(h, $) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(h, ee) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(E, U), i = (i = Math.imul(E, D)) + Math.imul(M, U) | 0, o = Math.imul(M, D), n = n + Math.imul(x, F) | 0, i = (i = i + Math.imul(x, X) | 0) + Math.imul(S, F) | 0, o = o + Math.imul(S, X) | 0, n = n + Math.imul(A, V) | 0, i = (i = i + Math.imul(A, K) | 0) + Math.imul(w, V) | 0, o = o + Math.imul(w, K) | 0, n = n + Math.imul(m, G) | 0, i = (i = i + Math.imul(m, Z) | 0) + Math.imul(y, G) | 0, o = o + Math.imul(y, Z) | 0, n = n + Math.imul(p, $) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(b, $) | 0, o = o + Math.imul(b, ee) | 0;
        var we = (c + (n = n + Math.imul(d, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ne) | 0) + Math.imul(h, re) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(h, ne) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(B, U), i = (i = Math.imul(B, D)) + Math.imul(P, U) | 0, o = Math.imul(P, D), n = n + Math.imul(E, F) | 0, i = (i = i + Math.imul(E, X) | 0) + Math.imul(M, F) | 0, o = o + Math.imul(M, X) | 0, n = n + Math.imul(x, V) | 0, i = (i = i + Math.imul(x, K) | 0) + Math.imul(S, V) | 0, o = o + Math.imul(S, K) | 0, n = n + Math.imul(A, G) | 0, i = (i = i + Math.imul(A, Z) | 0) + Math.imul(w, G) | 0, o = o + Math.imul(w, Z) | 0, n = n + Math.imul(m, $) | 0, i = (i = i + Math.imul(m, ee) | 0) + Math.imul(y, $) | 0, o = o + Math.imul(y, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(b, re) | 0, o = o + Math.imul(b, ne) | 0;

        var _e = (c + (n = n + Math.imul(d, oe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ae) | 0) + Math.imul(h, oe) | 0)) << 13) | 0;

        c = ((o = o + Math.imul(h, ae) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(H, U), i = (i = Math.imul(H, D)) + Math.imul(O, U) | 0, o = Math.imul(O, D), n = n + Math.imul(B, F) | 0, i = (i = i + Math.imul(B, X) | 0) + Math.imul(P, F) | 0, o = o + Math.imul(P, X) | 0, n = n + Math.imul(E, V) | 0, i = (i = i + Math.imul(E, K) | 0) + Math.imul(M, V) | 0, o = o + Math.imul(M, K) | 0, n = n + Math.imul(x, G) | 0, i = (i = i + Math.imul(x, Z) | 0) + Math.imul(S, G) | 0, o = o + Math.imul(S, Z) | 0, n = n + Math.imul(A, $) | 0, i = (i = i + Math.imul(A, ee) | 0) + Math.imul(w, $) | 0, o = o + Math.imul(w, ee) | 0, n = n + Math.imul(m, re) | 0, i = (i = i + Math.imul(m, ne) | 0) + Math.imul(y, re) | 0, o = o + Math.imul(y, ne) | 0, n = n + Math.imul(p, oe) | 0, i = (i = i + Math.imul(p, ae) | 0) + Math.imul(b, oe) | 0, o = o + Math.imul(b, ae) | 0;
        var xe = (c + (n = n + Math.imul(d, fe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ce) | 0) + Math.imul(h, fe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(h, ce) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(I, U), i = (i = Math.imul(I, D)) + Math.imul(j, U) | 0, o = Math.imul(j, D), n = n + Math.imul(H, F) | 0, i = (i = i + Math.imul(H, X) | 0) + Math.imul(O, F) | 0, o = o + Math.imul(O, X) | 0, n = n + Math.imul(B, V) | 0, i = (i = i + Math.imul(B, K) | 0) + Math.imul(P, V) | 0, o = o + Math.imul(P, K) | 0, n = n + Math.imul(E, G) | 0, i = (i = i + Math.imul(E, Z) | 0) + Math.imul(M, G) | 0, o = o + Math.imul(M, Z) | 0, n = n + Math.imul(x, $) | 0, i = (i = i + Math.imul(x, ee) | 0) + Math.imul(S, $) | 0, o = o + Math.imul(S, ee) | 0, n = n + Math.imul(A, re) | 0, i = (i = i + Math.imul(A, ne) | 0) + Math.imul(w, re) | 0, o = o + Math.imul(w, ne) | 0, n = n + Math.imul(m, oe) | 0, i = (i = i + Math.imul(m, ae) | 0) + Math.imul(y, oe) | 0, o = o + Math.imul(y, ae) | 0, n = n + Math.imul(p, fe) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(b, fe) | 0, o = o + Math.imul(b, ce) | 0;
        var Se = (c + (n = n + Math.imul(d, de) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, he) | 0) + Math.imul(h, de) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(h, he) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(L, U), i = (i = Math.imul(L, D)) + Math.imul(N, U) | 0, o = Math.imul(N, D), n = n + Math.imul(I, F) | 0, i = (i = i + Math.imul(I, X) | 0) + Math.imul(j, F) | 0, o = o + Math.imul(j, X) | 0, n = n + Math.imul(H, V) | 0, i = (i = i + Math.imul(H, K) | 0) + Math.imul(O, V) | 0, o = o + Math.imul(O, K) | 0, n = n + Math.imul(B, G) | 0, i = (i = i + Math.imul(B, Z) | 0) + Math.imul(P, G) | 0, o = o + Math.imul(P, Z) | 0, n = n + Math.imul(E, $) | 0, i = (i = i + Math.imul(E, ee) | 0) + Math.imul(M, $) | 0, o = o + Math.imul(M, ee) | 0, n = n + Math.imul(x, re) | 0, i = (i = i + Math.imul(x, ne) | 0) + Math.imul(S, re) | 0, o = o + Math.imul(S, ne) | 0, n = n + Math.imul(A, oe) | 0, i = (i = i + Math.imul(A, ae) | 0) + Math.imul(w, oe) | 0, o = o + Math.imul(w, ae) | 0, n = n + Math.imul(m, fe) | 0, i = (i = i + Math.imul(m, ce) | 0) + Math.imul(y, fe) | 0, o = o + Math.imul(y, ce) | 0, n = n + Math.imul(p, de) | 0, i = (i = i + Math.imul(p, he) | 0) + Math.imul(b, de) | 0, o = o + Math.imul(b, he) | 0;
        var ke = (c + (n = n + Math.imul(d, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, be) | 0) + Math.imul(h, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(h, be) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, n = Math.imul(L, F), i = (i = Math.imul(L, X)) + Math.imul(N, F) | 0, o = Math.imul(N, X), n = n + Math.imul(I, V) | 0, i = (i = i + Math.imul(I, K) | 0) + Math.imul(j, V) | 0, o = o + Math.imul(j, K) | 0, n = n + Math.imul(H, G) | 0, i = (i = i + Math.imul(H, Z) | 0) + Math.imul(O, G) | 0, o = o + Math.imul(O, Z) | 0, n = n + Math.imul(B, $) | 0, i = (i = i + Math.imul(B, ee) | 0) + Math.imul(P, $) | 0, o = o + Math.imul(P, ee) | 0, n = n + Math.imul(E, re) | 0, i = (i = i + Math.imul(E, ne) | 0) + Math.imul(M, re) | 0, o = o + Math.imul(M, ne) | 0, n = n + Math.imul(x, oe) | 0, i = (i = i + Math.imul(x, ae) | 0) + Math.imul(S, oe) | 0, o = o + Math.imul(S, ae) | 0, n = n + Math.imul(A, fe) | 0, i = (i = i + Math.imul(A, ce) | 0) + Math.imul(w, fe) | 0, o = o + Math.imul(w, ce) | 0, n = n + Math.imul(m, de) | 0, i = (i = i + Math.imul(m, he) | 0) + Math.imul(y, de) | 0, o = o + Math.imul(y, he) | 0;
        var Ee = (c + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, be) | 0) + Math.imul(b, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(b, be) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(L, V), i = (i = Math.imul(L, K)) + Math.imul(N, V) | 0, o = Math.imul(N, K), n = n + Math.imul(I, G) | 0, i = (i = i + Math.imul(I, Z) | 0) + Math.imul(j, G) | 0, o = o + Math.imul(j, Z) | 0, n = n + Math.imul(H, $) | 0, i = (i = i + Math.imul(H, ee) | 0) + Math.imul(O, $) | 0, o = o + Math.imul(O, ee) | 0, n = n + Math.imul(B, re) | 0, i = (i = i + Math.imul(B, ne) | 0) + Math.imul(P, re) | 0, o = o + Math.imul(P, ne) | 0, n = n + Math.imul(E, oe) | 0, i = (i = i + Math.imul(E, ae) | 0) + Math.imul(M, oe) | 0, o = o + Math.imul(M, ae) | 0, n = n + Math.imul(x, fe) | 0, i = (i = i + Math.imul(x, ce) | 0) + Math.imul(S, fe) | 0, o = o + Math.imul(S, ce) | 0, n = n + Math.imul(A, de) | 0, i = (i = i + Math.imul(A, he) | 0) + Math.imul(w, de) | 0, o = o + Math.imul(w, he) | 0;
        var Me = (c + (n = n + Math.imul(m, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(m, be) | 0) + Math.imul(y, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(y, be) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, n = Math.imul(L, G), i = (i = Math.imul(L, Z)) + Math.imul(N, G) | 0, o = Math.imul(N, Z), n = n + Math.imul(I, $) | 0, i = (i = i + Math.imul(I, ee) | 0) + Math.imul(j, $) | 0, o = o + Math.imul(j, ee) | 0, n = n + Math.imul(H, re) | 0, i = (i = i + Math.imul(H, ne) | 0) + Math.imul(O, re) | 0, o = o + Math.imul(O, ne) | 0, n = n + Math.imul(B, oe) | 0, i = (i = i + Math.imul(B, ae) | 0) + Math.imul(P, oe) | 0, o = o + Math.imul(P, ae) | 0, n = n + Math.imul(E, fe) | 0, i = (i = i + Math.imul(E, ce) | 0) + Math.imul(M, fe) | 0, o = o + Math.imul(M, ce) | 0, n = n + Math.imul(x, de) | 0, i = (i = i + Math.imul(x, he) | 0) + Math.imul(S, de) | 0, o = o + Math.imul(S, he) | 0;
        var Ce = (c + (n = n + Math.imul(A, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(A, be) | 0) + Math.imul(w, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(w, be) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, n = Math.imul(L, $), i = (i = Math.imul(L, ee)) + Math.imul(N, $) | 0, o = Math.imul(N, ee), n = n + Math.imul(I, re) | 0, i = (i = i + Math.imul(I, ne) | 0) + Math.imul(j, re) | 0, o = o + Math.imul(j, ne) | 0, n = n + Math.imul(H, oe) | 0, i = (i = i + Math.imul(H, ae) | 0) + Math.imul(O, oe) | 0, o = o + Math.imul(O, ae) | 0, n = n + Math.imul(B, fe) | 0, i = (i = i + Math.imul(B, ce) | 0) + Math.imul(P, fe) | 0, o = o + Math.imul(P, ce) | 0, n = n + Math.imul(E, de) | 0, i = (i = i + Math.imul(E, he) | 0) + Math.imul(M, de) | 0, o = o + Math.imul(M, he) | 0;
        var Be = (c + (n = n + Math.imul(x, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(x, be) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(S, be) | 0) + (i >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, n = Math.imul(L, re), i = (i = Math.imul(L, ne)) + Math.imul(N, re) | 0, o = Math.imul(N, ne), n = n + Math.imul(I, oe) | 0, i = (i = i + Math.imul(I, ae) | 0) + Math.imul(j, oe) | 0, o = o + Math.imul(j, ae) | 0, n = n + Math.imul(H, fe) | 0, i = (i = i + Math.imul(H, ce) | 0) + Math.imul(O, fe) | 0, o = o + Math.imul(O, ce) | 0, n = n + Math.imul(B, de) | 0, i = (i = i + Math.imul(B, he) | 0) + Math.imul(P, de) | 0, o = o + Math.imul(P, he) | 0;
        var Pe = (c + (n = n + Math.imul(E, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(E, be) | 0) + Math.imul(M, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(M, be) | 0) + (i >>> 13) | 0) + (Pe >>> 26) | 0, Pe &= 67108863, n = Math.imul(L, oe), i = (i = Math.imul(L, ae)) + Math.imul(N, oe) | 0, o = Math.imul(N, ae), n = n + Math.imul(I, fe) | 0, i = (i = i + Math.imul(I, ce) | 0) + Math.imul(j, fe) | 0, o = o + Math.imul(j, ce) | 0, n = n + Math.imul(H, de) | 0, i = (i = i + Math.imul(H, he) | 0) + Math.imul(O, de) | 0, o = o + Math.imul(O, he) | 0;
        var Re = (c + (n = n + Math.imul(B, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(B, be) | 0) + Math.imul(P, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(P, be) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, n = Math.imul(L, fe), i = (i = Math.imul(L, ce)) + Math.imul(N, fe) | 0, o = Math.imul(N, ce), n = n + Math.imul(I, de) | 0, i = (i = i + Math.imul(I, he) | 0) + Math.imul(j, de) | 0, o = o + Math.imul(j, he) | 0;
        var He = (c + (n = n + Math.imul(H, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(H, be) | 0) + Math.imul(O, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(O, be) | 0) + (i >>> 13) | 0) + (He >>> 26) | 0, He &= 67108863, n = Math.imul(L, de), i = (i = Math.imul(L, he)) + Math.imul(N, de) | 0, o = Math.imul(N, he);
        var Oe = (c + (n = n + Math.imul(I, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(I, be) | 0) + Math.imul(j, pe) | 0)) << 13) | 0;
        c = ((o = o + Math.imul(j, be) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863;
        var Te = (c + (n = Math.imul(L, pe)) | 0) + ((8191 & (i = (i = Math.imul(L, be)) + Math.imul(N, pe) | 0)) << 13) | 0;
        return c = ((o = Math.imul(N, be)) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, f[0] = ve, f[1] = me, f[2] = ye, f[3] = ge, f[4] = Ae, f[5] = we, f[6] = _e, f[7] = xe, f[8] = Se, f[9] = ke, f[10] = Ee, f[11] = Me, f[12] = Ce, f[13] = Be, f[14] = Pe, f[15] = Re, f[16] = He, f[17] = Oe, f[18] = Te, 0 !== c && (f[19] = c, r.length++), r;
      };

      function p(e, t, r) {
        return new b().mulp(e, t, r);
      }

      function b(e, t) {
        this.x = e, this.y = t;
      }

      Math.imul || (l = h), o.prototype.mulTo = function (e, t) {
        var r = this.length + e.length;
        return 10 === this.length && 10 === e.length ? l(this, e, t) : r < 63 ? h(this, e, t) : r < 1024 ? function (e, t, r) {
          r.negative = t.negative ^ e.negative, r.length = e.length + t.length;

          for (var n = 0, i = 0, o = 0; o < r.length - 1; o++) {
            var a = i;
            i = 0;

            for (var s = 67108863 & n, f = Math.min(o, t.length - 1), c = Math.max(0, o - e.length + 1); c <= f; c++) {
              var u = o - c,
                  d = (0 | e.words[u]) * (0 | t.words[c]),
                  h = 67108863 & d;
              s = 67108863 & (h = h + s | 0), i += (a = (a = a + (d / 67108864 | 0) | 0) + (h >>> 26) | 0) >>> 26, a &= 67108863;
            }

            r.words[o] = s, n = a, a = i;
          }

          return 0 !== n ? r.words[o] = n : r.length--, r.strip();
        }(this, e, t) : p(this, e, t);
      }, b.prototype.makeRBT = function (e) {
        for (var t = new Array(e), r = o.prototype._countBits(e) - 1, n = 0; n < e; n++) {
          t[n] = this.revBin(n, r, e);
        }

        return t;
      }, b.prototype.revBin = function (e, t, r) {
        if (0 === e || e === r - 1) return e;

        for (var n = 0, i = 0; i < t; i++) {
          n |= (1 & e) << t - i - 1, e >>= 1;
        }

        return n;
      }, b.prototype.permute = function (e, t, r, n, i, o) {
        for (var a = 0; a < o; a++) {
          n[a] = t[e[a]], i[a] = r[e[a]];
        }
      }, b.prototype.transform = function (e, t, r, n, i, o) {
        this.permute(o, e, t, r, n, i);

        for (var a = 1; a < i; a <<= 1) {
          for (var s = a << 1, f = Math.cos(2 * Math.PI / s), c = Math.sin(2 * Math.PI / s), u = 0; u < i; u += s) {
            for (var d = f, h = c, l = 0; l < a; l++) {
              var p = r[u + l],
                  b = n[u + l],
                  v = r[u + l + a],
                  m = n[u + l + a],
                  y = d * v - h * m;
              m = d * m + h * v, v = y, r[u + l] = p + v, n[u + l] = b + m, r[u + l + a] = p - v, n[u + l + a] = b - m, l !== s && (y = f * d - c * h, h = f * h + c * d, d = y);
            }
          }
        }
      }, b.prototype.guessLen13b = function (e, t) {
        var r = 1 | Math.max(t, e),
            n = 1 & r,
            i = 0;

        for (r = r / 2 | 0; r; r >>>= 1) {
          i++;
        }

        return 1 << i + 1 + n;
      }, b.prototype.conjugate = function (e, t, r) {
        if (!(r <= 1)) for (var n = 0; n < r / 2; n++) {
          var i = e[n];
          e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
        }
      }, b.prototype.normalize13b = function (e, t) {
        for (var r = 0, n = 0; n < t / 2; n++) {
          var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
          e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
        }

        return e;
      }, b.prototype.convert13b = function (e, t, r, i) {
        for (var o = 0, a = 0; a < t; a++) {
          o += 0 | e[a], r[2 * a] = 8191 & o, o >>>= 13, r[2 * a + 1] = 8191 & o, o >>>= 13;
        }

        for (a = 2 * t; a < i; ++a) {
          r[a] = 0;
        }

        n(0 === o), n(0 == (-8192 & o));
      }, b.prototype.stub = function (e) {
        for (var t = new Array(e), r = 0; r < e; r++) {
          t[r] = 0;
        }

        return t;
      }, b.prototype.mulp = function (e, t, r) {
        var n = 2 * this.guessLen13b(e.length, t.length),
            i = this.makeRBT(n),
            o = this.stub(n),
            a = new Array(n),
            s = new Array(n),
            f = new Array(n),
            c = new Array(n),
            u = new Array(n),
            d = new Array(n),
            h = r.words;
        h.length = n, this.convert13b(e.words, e.length, a, n), this.convert13b(t.words, t.length, c, n), this.transform(a, o, s, f, n, i), this.transform(c, o, u, d, n, i);

        for (var l = 0; l < n; l++) {
          var p = s[l] * u[l] - f[l] * d[l];
          f[l] = s[l] * d[l] + f[l] * u[l], s[l] = p;
        }

        return this.conjugate(s, f, n), this.transform(s, f, h, o, n, i), this.conjugate(h, o, n), this.normalize13b(h, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r.strip();
      }, o.prototype.mul = function (e) {
        var t = new o(null);
        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
      }, o.prototype.mulf = function (e) {
        var t = new o(null);
        return t.words = new Array(this.length + e.length), p(this, e, t);
      }, o.prototype.imul = function (e) {
        return this.clone().mulTo(e, this);
      }, o.prototype.imuln = function (e) {
        n("number" == typeof e), n(e < 67108864);

        for (var t = 0, r = 0; r < this.length; r++) {
          var i = (0 | this.words[r]) * e,
              o = (67108863 & i) + (67108863 & t);
          t >>= 26, t += i / 67108864 | 0, t += o >>> 26, this.words[r] = 67108863 & o;
        }

        return 0 !== t && (this.words[r] = t, this.length++), this;
      }, o.prototype.muln = function (e) {
        return this.clone().imuln(e);
      }, o.prototype.sqr = function () {
        return this.mul(this);
      }, o.prototype.isqr = function () {
        return this.imul(this.clone());
      }, o.prototype.pow = function (e) {
        var t = function (e) {
          for (var t = new Array(e.bitLength()), r = 0; r < t.length; r++) {
            var n = r / 26 | 0,
                i = r % 26;
            t[r] = (e.words[n] & 1 << i) >>> i;
          }

          return t;
        }(e);

        if (0 === t.length) return new o(1);

        for (var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr()) {
          ;
        }

        if (++n < t.length) for (var i = r.sqr(); n < t.length; n++, i = i.sqr()) {
          0 !== t[n] && (r = r.mul(i));
        }
        return r;
      }, o.prototype.iushln = function (e) {
        n("number" == typeof e && e >= 0);
        var t,
            r = e % 26,
            i = (e - r) / 26,
            o = 67108863 >>> 26 - r << 26 - r;

        if (0 !== r) {
          var a = 0;

          for (t = 0; t < this.length; t++) {
            var s = this.words[t] & o,
                f = (0 | this.words[t]) - s << r;
            this.words[t] = f | a, a = s >>> 26 - r;
          }

          a && (this.words[t] = a, this.length++);
        }

        if (0 !== i) {
          for (t = this.length - 1; t >= 0; t--) {
            this.words[t + i] = this.words[t];
          }

          for (t = 0; t < i; t++) {
            this.words[t] = 0;
          }

          this.length += i;
        }

        return this.strip();
      }, o.prototype.ishln = function (e) {
        return n(0 === this.negative), this.iushln(e);
      }, o.prototype.iushrn = function (e, t, r) {
        var i;
        n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
        var o = e % 26,
            a = Math.min((e - o) / 26, this.length),
            s = 67108863 ^ 67108863 >>> o << o,
            f = r;

        if (i -= a, i = Math.max(0, i), f) {
          for (var c = 0; c < a; c++) {
            f.words[c] = this.words[c];
          }

          f.length = a;
        }

        if (0 === a) ;else if (this.length > a) for (this.length -= a, c = 0; c < this.length; c++) {
          this.words[c] = this.words[c + a];
        } else this.words[0] = 0, this.length = 1;
        var u = 0;

        for (c = this.length - 1; c >= 0 && (0 !== u || c >= i); c--) {
          var d = 0 | this.words[c];
          this.words[c] = u << 26 - o | d >>> o, u = d & s;
        }

        return f && 0 !== u && (f.words[f.length++] = u), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
      }, o.prototype.ishrn = function (e, t, r) {
        return n(0 === this.negative), this.iushrn(e, t, r);
      }, o.prototype.shln = function (e) {
        return this.clone().ishln(e);
      }, o.prototype.ushln = function (e) {
        return this.clone().iushln(e);
      }, o.prototype.shrn = function (e) {
        return this.clone().ishrn(e);
      }, o.prototype.ushrn = function (e) {
        return this.clone().iushrn(e);
      }, o.prototype.testn = function (e) {
        n("number" == typeof e && e >= 0);
        var t = e % 26,
            r = (e - t) / 26,
            i = 1 << t;
        return !(this.length <= r) && !!(this.words[r] & i);
      }, o.prototype.imaskn = function (e) {
        n("number" == typeof e && e >= 0);
        var t = e % 26,
            r = (e - t) / 26;
        if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;

        if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
          var i = 67108863 ^ 67108863 >>> t << t;
          this.words[this.length - 1] &= i;
        }

        return this.strip();
      }, o.prototype.maskn = function (e) {
        return this.clone().imaskn(e);
      }, o.prototype.iaddn = function (e) {
        return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
      }, o.prototype._iaddn = function (e) {
        this.words[0] += e;

        for (var t = 0; t < this.length && this.words[t] >= 67108864; t++) {
          this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
        }

        return this.length = Math.max(this.length, t + 1), this;
      }, o.prototype.isubn = function (e) {
        if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var t = 0; t < this.length && this.words[t] < 0; t++) {
          this.words[t] += 67108864, this.words[t + 1] -= 1;
        }
        return this.strip();
      }, o.prototype.addn = function (e) {
        return this.clone().iaddn(e);
      }, o.prototype.subn = function (e) {
        return this.clone().isubn(e);
      }, o.prototype.iabs = function () {
        return this.negative = 0, this;
      }, o.prototype.abs = function () {
        return this.clone().iabs();
      }, o.prototype._ishlnsubmul = function (e, t, r) {
        var i,
            o,
            a = e.length + r;

        this._expand(a);

        var s = 0;

        for (i = 0; i < e.length; i++) {
          o = (0 | this.words[i + r]) + s;
          var f = (0 | e.words[i]) * t;
          s = ((o -= 67108863 & f) >> 26) - (f / 67108864 | 0), this.words[i + r] = 67108863 & o;
        }

        for (; i < this.length - r; i++) {
          s = (o = (0 | this.words[i + r]) + s) >> 26, this.words[i + r] = 67108863 & o;
        }

        if (0 === s) return this.strip();

        for (n(-1 === s), s = 0, i = 0; i < this.length; i++) {
          s = (o = -(0 | this.words[i]) + s) >> 26, this.words[i] = 67108863 & o;
        }

        return this.negative = 1, this.strip();
      }, o.prototype._wordDiv = function (e, t) {
        var r = (this.length, e.length),
            n = this.clone(),
            i = e,
            a = 0 | i.words[i.length - 1];
        0 !== (r = 26 - this._countBits(a)) && (i = i.ushln(r), n.iushln(r), a = 0 | i.words[i.length - 1]);
        var s,
            f = n.length - i.length;

        if ("mod" !== t) {
          (s = new o(null)).length = f + 1, s.words = new Array(s.length);

          for (var c = 0; c < s.length; c++) {
            s.words[c] = 0;
          }
        }

        var u = n.clone()._ishlnsubmul(i, 1, f);

        0 === u.negative && (n = u, s && (s.words[f] = 1));

        for (var d = f - 1; d >= 0; d--) {
          var h = 67108864 * (0 | n.words[i.length + d]) + (0 | n.words[i.length + d - 1]);

          for (h = Math.min(h / a | 0, 67108863), n._ishlnsubmul(i, h, d); 0 !== n.negative;) {
            h--, n.negative = 0, n._ishlnsubmul(i, 1, d), n.isZero() || (n.negative ^= 1);
          }

          s && (s.words[d] = h);
        }

        return s && s.strip(), n.strip(), "div" !== t && 0 !== r && n.iushrn(r), {
          div: s || null,
          mod: n
        };
      }, o.prototype.divmod = function (e, t, r) {
        return n(!e.isZero()), this.isZero() ? {
          div: new o(0),
          mod: new o(0)
        } : 0 !== this.negative && 0 === e.negative ? (s = this.neg().divmod(e, t), "mod" !== t && (i = s.div.neg()), "div" !== t && (a = s.mod.neg(), r && 0 !== a.negative && a.iadd(e)), {
          div: i,
          mod: a
        }) : 0 === this.negative && 0 !== e.negative ? (s = this.divmod(e.neg(), t), "mod" !== t && (i = s.div.neg()), {
          div: i,
          mod: s.mod
        }) : 0 != (this.negative & e.negative) ? (s = this.neg().divmod(e.neg(), t), "div" !== t && (a = s.mod.neg(), r && 0 !== a.negative && a.isub(e)), {
          div: s.div,
          mod: a
        }) : e.length > this.length || this.cmp(e) < 0 ? {
          div: new o(0),
          mod: this
        } : 1 === e.length ? "div" === t ? {
          div: this.divn(e.words[0]),
          mod: null
        } : "mod" === t ? {
          div: null,
          mod: new o(this.modn(e.words[0]))
        } : {
          div: this.divn(e.words[0]),
          mod: new o(this.modn(e.words[0]))
        } : this._wordDiv(e, t);
        var i, a, s;
      }, o.prototype.div = function (e) {
        return this.divmod(e, "div", !1).div;
      }, o.prototype.mod = function (e) {
        return this.divmod(e, "mod", !1).mod;
      }, o.prototype.umod = function (e) {
        return this.divmod(e, "mod", !0).mod;
      }, o.prototype.divRound = function (e) {
        var t = this.divmod(e);
        if (t.mod.isZero()) return t.div;
        var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod,
            n = e.ushrn(1),
            i = e.andln(1),
            o = r.cmp(n);
        return o < 0 || 1 === i && 0 === o ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
      }, o.prototype.modn = function (e) {
        n(e <= 67108863);

        for (var t = (1 << 26) % e, r = 0, i = this.length - 1; i >= 0; i--) {
          r = (t * r + (0 | this.words[i])) % e;
        }

        return r;
      }, o.prototype.idivn = function (e) {
        n(e <= 67108863);

        for (var t = 0, r = this.length - 1; r >= 0; r--) {
          var i = (0 | this.words[r]) + 67108864 * t;
          this.words[r] = i / e | 0, t = i % e;
        }

        return this.strip();
      }, o.prototype.divn = function (e) {
        return this.clone().idivn(e);
      }, o.prototype.egcd = function (e) {
        n(0 === e.negative), n(!e.isZero());
        var t = this,
            r = e.clone();
        t = 0 !== t.negative ? t.umod(e) : t.clone();

        for (var i = new o(1), a = new o(0), s = new o(0), f = new o(1), c = 0; t.isEven() && r.isEven();) {
          t.iushrn(1), r.iushrn(1), ++c;
        }

        for (var u = r.clone(), d = t.clone(); !t.isZero();) {
          for (var h = 0, l = 1; 0 == (t.words[0] & l) && h < 26; ++h, l <<= 1) {
            ;
          }

          if (h > 0) for (t.iushrn(h); h-- > 0;) {
            (i.isOdd() || a.isOdd()) && (i.iadd(u), a.isub(d)), i.iushrn(1), a.iushrn(1);
          }

          for (var p = 0, b = 1; 0 == (r.words[0] & b) && p < 26; ++p, b <<= 1) {
            ;
          }

          if (p > 0) for (r.iushrn(p); p-- > 0;) {
            (s.isOdd() || f.isOdd()) && (s.iadd(u), f.isub(d)), s.iushrn(1), f.iushrn(1);
          }
          t.cmp(r) >= 0 ? (t.isub(r), i.isub(s), a.isub(f)) : (r.isub(t), s.isub(i), f.isub(a));
        }

        return {
          a: s,
          b: f,
          gcd: r.iushln(c)
        };
      }, o.prototype._invmp = function (e) {
        n(0 === e.negative), n(!e.isZero());
        var t = this,
            r = e.clone();
        t = 0 !== t.negative ? t.umod(e) : t.clone();

        for (var i, a = new o(1), s = new o(0), f = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;) {
          for (var c = 0, u = 1; 0 == (t.words[0] & u) && c < 26; ++c, u <<= 1) {
            ;
          }

          if (c > 0) for (t.iushrn(c); c-- > 0;) {
            a.isOdd() && a.iadd(f), a.iushrn(1);
          }

          for (var d = 0, h = 1; 0 == (r.words[0] & h) && d < 26; ++d, h <<= 1) {
            ;
          }

          if (d > 0) for (r.iushrn(d); d-- > 0;) {
            s.isOdd() && s.iadd(f), s.iushrn(1);
          }
          t.cmp(r) >= 0 ? (t.isub(r), a.isub(s)) : (r.isub(t), s.isub(a));
        }

        return (i = 0 === t.cmpn(1) ? a : s).cmpn(0) < 0 && i.iadd(e), i;
      }, o.prototype.gcd = function (e) {
        if (this.isZero()) return e.abs();
        if (e.isZero()) return this.abs();
        var t = this.clone(),
            r = e.clone();
        t.negative = 0, r.negative = 0;

        for (var n = 0; t.isEven() && r.isEven(); n++) {
          t.iushrn(1), r.iushrn(1);
        }

        for (;;) {
          for (; t.isEven();) {
            t.iushrn(1);
          }

          for (; r.isEven();) {
            r.iushrn(1);
          }

          var i = t.cmp(r);

          if (i < 0) {
            var o = t;
            t = r, r = o;
          } else if (0 === i || 0 === r.cmpn(1)) break;

          t.isub(r);
        }

        return r.iushln(n);
      }, o.prototype.invm = function (e) {
        return this.egcd(e).a.umod(e);
      }, o.prototype.isEven = function () {
        return 0 == (1 & this.words[0]);
      }, o.prototype.isOdd = function () {
        return 1 == (1 & this.words[0]);
      }, o.prototype.andln = function (e) {
        return this.words[0] & e;
      }, o.prototype.bincn = function (e) {
        n("number" == typeof e);
        var t = e % 26,
            r = (e - t) / 26,
            i = 1 << t;
        if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;

        for (var o = i, a = r; 0 !== o && a < this.length; a++) {
          var s = 0 | this.words[a];
          o = (s += o) >>> 26, s &= 67108863, this.words[a] = s;
        }

        return 0 !== o && (this.words[a] = o, this.length++), this;
      }, o.prototype.isZero = function () {
        return 1 === this.length && 0 === this.words[0];
      }, o.prototype.cmpn = function (e) {
        var t,
            r = e < 0;
        if (0 !== this.negative && !r) return -1;
        if (0 === this.negative && r) return 1;
        if (this.strip(), this.length > 1) t = 1;else {
          r && (e = -e), n(e <= 67108863, "Number is too big");
          var i = 0 | this.words[0];
          t = i === e ? 0 : i < e ? -1 : 1;
        }
        return 0 !== this.negative ? 0 | -t : t;
      }, o.prototype.cmp = function (e) {
        if (0 !== this.negative && 0 === e.negative) return -1;
        if (0 === this.negative && 0 !== e.negative) return 1;
        var t = this.ucmp(e);
        return 0 !== this.negative ? 0 | -t : t;
      }, o.prototype.ucmp = function (e) {
        if (this.length > e.length) return 1;
        if (this.length < e.length) return -1;

        for (var t = 0, r = this.length - 1; r >= 0; r--) {
          var n = 0 | this.words[r],
              i = 0 | e.words[r];

          if (n !== i) {
            n < i ? t = -1 : n > i && (t = 1);
            break;
          }
        }

        return t;
      }, o.prototype.gtn = function (e) {
        return 1 === this.cmpn(e);
      }, o.prototype.gt = function (e) {
        return 1 === this.cmp(e);
      }, o.prototype.gten = function (e) {
        return this.cmpn(e) >= 0;
      }, o.prototype.gte = function (e) {
        return this.cmp(e) >= 0;
      }, o.prototype.ltn = function (e) {
        return -1 === this.cmpn(e);
      }, o.prototype.lt = function (e) {
        return -1 === this.cmp(e);
      }, o.prototype.lten = function (e) {
        return this.cmpn(e) <= 0;
      }, o.prototype.lte = function (e) {
        return this.cmp(e) <= 0;
      }, o.prototype.eqn = function (e) {
        return 0 === this.cmpn(e);
      }, o.prototype.eq = function (e) {
        return 0 === this.cmp(e);
      }, o.red = function (e) {
        return new _(e);
      }, o.prototype.toRed = function (e) {
        return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
      }, o.prototype.fromRed = function () {
        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, o.prototype._forceRed = function (e) {
        return this.red = e, this;
      }, o.prototype.forceRed = function (e) {
        return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
      }, o.prototype.redAdd = function (e) {
        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
      }, o.prototype.redIAdd = function (e) {
        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
      }, o.prototype.redSub = function (e) {
        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
      }, o.prototype.redISub = function (e) {
        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
      }, o.prototype.redShl = function (e) {
        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
      }, o.prototype.redMul = function (e) {
        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
      }, o.prototype.redIMul = function (e) {
        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
      }, o.prototype.redSqr = function () {
        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, o.prototype.redISqr = function () {
        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, o.prototype.redSqrt = function () {
        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, o.prototype.redInvm = function () {
        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, o.prototype.redNeg = function () {
        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, o.prototype.redPow = function (e) {
        return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
      };
      var v = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };

      function m(e, t) {
        this.name = e, this.p = new o(t, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }

      function y() {
        m.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
      }

      function g() {
        m.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
      }

      function A() {
        m.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
      }

      function w() {
        m.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
      }

      function _(e) {
        if ("string" == typeof e) {
          var t = o._prime(e);

          this.m = t.p, this.prime = t;
        } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
      }

      function x(e) {
        _.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }

      m.prototype._tmp = function () {
        var e = new o(null);
        return e.words = new Array(Math.ceil(this.n / 13)), e;
      }, m.prototype.ireduce = function (e) {
        var t,
            r = e;

        do {
          this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
        } while (t > this.n);

        var n = t < this.n ? -1 : r.ucmp(this.p);
        return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : r.strip(), r;
      }, m.prototype.split = function (e, t) {
        e.iushrn(this.n, 0, t);
      }, m.prototype.imulK = function (e) {
        return e.imul(this.k);
      }, i(y, m), y.prototype.split = function (e, t) {
        for (var r = Math.min(e.length, 9), n = 0; n < r; n++) {
          t.words[n] = e.words[n];
        }

        if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
        var i = e.words[9];

        for (t.words[t.length++] = 4194303 & i, n = 10; n < e.length; n++) {
          var o = 0 | e.words[n];
          e.words[n - 10] = (4194303 & o) << 4 | i >>> 22, i = o;
        }

        i >>>= 22, e.words[n - 10] = i, 0 === i && e.length > 10 ? e.length -= 10 : e.length -= 9;
      }, y.prototype.imulK = function (e) {
        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;

        for (var t = 0, r = 0; r < e.length; r++) {
          var n = 0 | e.words[r];
          t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
        }

        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
      }, i(g, m), i(A, m), i(w, m), w.prototype.imulK = function (e) {
        for (var t = 0, r = 0; r < e.length; r++) {
          var n = 19 * (0 | e.words[r]) + t,
              i = 67108863 & n;
          n >>>= 26, e.words[r] = i, t = n;
        }

        return 0 !== t && (e.words[e.length++] = t), e;
      }, o._prime = function (e) {
        if (v[e]) return v[e];
        var t;
        if ("k256" === e) t = new y();else if ("p224" === e) t = new g();else if ("p192" === e) t = new A();else {
          if ("p25519" !== e) throw new Error("Unknown prime " + e);
          t = new w();
        }
        return v[e] = t, t;
      }, _.prototype._verify1 = function (e) {
        n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
      }, _.prototype._verify2 = function (e, t) {
        n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
      }, _.prototype.imod = function (e) {
        return this.prime ? this.prime.ireduce(e)._forceRed(this) : e.umod(this.m)._forceRed(this);
      }, _.prototype.neg = function (e) {
        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
      }, _.prototype.add = function (e, t) {
        this._verify2(e, t);

        var r = e.add(t);
        return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
      }, _.prototype.iadd = function (e, t) {
        this._verify2(e, t);

        var r = e.iadd(t);
        return r.cmp(this.m) >= 0 && r.isub(this.m), r;
      }, _.prototype.sub = function (e, t) {
        this._verify2(e, t);

        var r = e.sub(t);
        return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
      }, _.prototype.isub = function (e, t) {
        this._verify2(e, t);

        var r = e.isub(t);
        return r.cmpn(0) < 0 && r.iadd(this.m), r;
      }, _.prototype.shl = function (e, t) {
        return this._verify1(e), this.imod(e.ushln(t));
      }, _.prototype.imul = function (e, t) {
        return this._verify2(e, t), this.imod(e.imul(t));
      }, _.prototype.mul = function (e, t) {
        return this._verify2(e, t), this.imod(e.mul(t));
      }, _.prototype.isqr = function (e) {
        return this.imul(e, e.clone());
      }, _.prototype.sqr = function (e) {
        return this.mul(e, e);
      }, _.prototype.sqrt = function (e) {
        if (e.isZero()) return e.clone();
        var t = this.m.andln(3);

        if (n(t % 2 == 1), 3 === t) {
          var r = this.m.add(new o(1)).iushrn(2);
          return this.pow(e, r);
        }

        for (var i = this.m.subn(1), a = 0; !i.isZero() && 0 === i.andln(1);) {
          a++, i.iushrn(1);
        }

        n(!i.isZero());
        var s = new o(1).toRed(this),
            f = s.redNeg(),
            c = this.m.subn(1).iushrn(1),
            u = this.m.bitLength();

        for (u = new o(2 * u * u).toRed(this); 0 !== this.pow(u, c).cmp(f);) {
          u.redIAdd(f);
        }

        for (var d = this.pow(u, i), h = this.pow(e, i.addn(1).iushrn(1)), l = this.pow(e, i), p = a; 0 !== l.cmp(s);) {
          for (var b = l, v = 0; 0 !== b.cmp(s); v++) {
            b = b.redSqr();
          }

          n(v < p);
          var m = this.pow(d, new o(1).iushln(p - v - 1));
          h = h.redMul(m), d = m.redSqr(), l = l.redMul(d), p = v;
        }

        return h;
      }, _.prototype.invm = function (e) {
        var t = e._invmp(this.m);

        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
      }, _.prototype.pow = function (e, t) {
        if (t.isZero()) return new o(1).toRed(this);
        if (0 === t.cmpn(1)) return e.clone();
        var r = new Array(16);
        r[0] = new o(1).toRed(this), r[1] = e;

        for (var n = 2; n < r.length; n++) {
          r[n] = this.mul(r[n - 1], e);
        }

        var i = r[0],
            a = 0,
            s = 0,
            f = t.bitLength() % 26;

        for (0 === f && (f = 26), n = t.length - 1; n >= 0; n--) {
          for (var c = t.words[n], u = f - 1; u >= 0; u--) {
            var d = c >> u & 1;
            i !== r[0] && (i = this.sqr(i)), 0 !== d || 0 !== a ? (a <<= 1, a |= d, (4 === ++s || 0 === n && 0 === u) && (i = this.mul(i, r[a]), s = 0, a = 0)) : s = 0;
          }

          f = 26;
        }

        return i;
      }, _.prototype.convertTo = function (e) {
        var t = e.umod(this.m);
        return t === e ? t.clone() : t;
      }, _.prototype.convertFrom = function (e) {
        var t = e.clone();
        return t.red = null, t;
      }, o.mont = function (e) {
        return new x(e);
      }, i(x, _), x.prototype.convertTo = function (e) {
        return this.imod(e.ushln(this.shift));
      }, x.prototype.convertFrom = function (e) {
        var t = this.imod(e.mul(this.rinv));
        return t.red = null, t;
      }, x.prototype.imul = function (e, t) {
        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
        var r = e.imul(t),
            n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
            i = r.isub(n).iushrn(this.shift),
            o = i;
        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
      }, x.prototype.mul = function (e, t) {
        if (e.isZero() || t.isZero()) return new o(0)._forceRed(this);
        var r = e.mul(t),
            n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
            i = r.isub(n).iushrn(this.shift),
            a = i;
        return i.cmp(this.m) >= 0 ? a = i.isub(this.m) : i.cmpn(0) < 0 && (a = i.iadd(this.m)), a._forceRed(this);
      }, x.prototype.invm = function (e) {
        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
      };
    }(e, this);
  }).call(this, r(145)(e));
}, function (e, t, r) {
  "use strict";

  r.r(t), r.d(t, "getAddressDisplay", function () {
    return h;
  }), r.d(t, "formatUrl", function () {
    return b;
  }), r.d(t, "addToClipBoardLinks", function () {
    return v;
  }), r.d(t, "addToClipboard", function () {
    return m;
  }), r.d(t, "formatProfileData", function () {
    return y;
  }), r.d(t, "checkIsMobile", function () {
    return g;
  });
  var n = r(55),
      i = r.n(n),
      o = r(16),
      a = r(27),
      s = r(82),
      f = r(83),
      c = r(84),
      u = r(85),
      d = r(86);
  o.c.add(a.faCheck, s.faArrowRight, u.faGithub, c.faTwitter, f.faGlobeAmericas, d.faClone), o.a.watch();

  var h = function h(e, t) {
    return ("full" !== t ? l(e) : e).toLowerCase();
  },
      l = function l(e) {
    return e.substr(0, 6) + "..." + e.substr(-4);
  },
      p = function p(e, t, r) {
    try {
      if (!e.image && "image" === r && t) return i()(t);
      if (!e.coverPhoto && "coverPhoto" === r && t) return null;
      var n = e[r] ? e[r][0].contentUrl["/"] : "";
      return "https://ipfs.infura.io/ipfs/".concat(n);
    } catch (e) {
      console.log(e);
    }
  },
      b = function b(e) {
    if (e) return e.includes("http") ? e : "http://".concat(e);
  },
      v = function v(e, t, r) {
    m(e), t(r);
  },
      m = function m(e) {
    var t,
        r,
        n = document.createElement("textarea");
    n.readOnly = !0, n.value = e, document.body.appendChild(n), navigator.userAgent.match(/ipad|iphone/i) ? ((r = document.createRange()).selectNodeContents(n), (t = window.getSelection()).removeAllRanges(), t.addRange(r), n.setSelectionRange(0, 999999)) : n.select(), document.execCommand("copy"), document.body.removeChild(n);
  },
      y = function y() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = arguments.length > 2 ? arguments[2] : void 0,
        n = arguments.length > 3 ? arguments[3] : void 0;

    try {
      return {
        imgSrc: p(e, r, "image"),
        address: r,
        addressDisplay: n,
        github: t.github ? t.github.username : void 0,
        twitter: t.twitter ? t.twitter.username : void 0,
        emoji: e.emoji,
        name: e.name,
        website: e.website,
        description: e.description,
        coverPhoto: p(e, r, "coverPhoto"),
        websiteUrl: b(e.website)
      };
    } catch (e) {
      return {
        address: r,
        addressDisplay: n.toLowerCase(),
        imgSrc: i()(r)
      };
    }
  },
      g = function g() {
    try {
      return void 0 !== window.orientation || -1 !== navigator.userAgent.indexOf("IEMobile");
    } catch (e) {
      console.error(e);
    }
  };
}, function (e, t, r) {
  "use strict";

  (function (e) {
    /*!
     * The buffer module from node.js, for the browser.
     *
     * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
     * @license  MIT
     */
    var n = r(94),
        i = r(95),
        o = r(96);

    function a() {
      return f.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
    }

    function s(e, t) {
      if (a() < t) throw new RangeError("Invalid typed array length");
      return f.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t)).__proto__ = f.prototype : (null === e && (e = new f(t)), e.length = t), e;
    }

    function f(e, t, r) {
      if (!(f.TYPED_ARRAY_SUPPORT || this instanceof f)) return new f(e, t, r);

      if ("number" == typeof e) {
        if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");
        return d(this, e);
      }

      return c(this, e, t, r);
    }

    function c(e, t, r, n) {
      if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');
      return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? function (e, t, r, n) {
        if (t.byteLength, r < 0 || t.byteLength < r) throw new RangeError("'offset' is out of bounds");
        if (t.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
        t = void 0 === r && void 0 === n ? new Uint8Array(t) : void 0 === n ? new Uint8Array(t, r) : new Uint8Array(t, r, n);
        f.TYPED_ARRAY_SUPPORT ? (e = t).__proto__ = f.prototype : e = h(e, t);
        return e;
      }(e, t, r, n) : "string" == typeof t ? function (e, t, r) {
        "string" == typeof r && "" !== r || (r = "utf8");
        if (!f.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
        var n = 0 | p(t, r),
            i = (e = s(e, n)).write(t, r);
        i !== n && (e = e.slice(0, i));
        return e;
      }(e, t, r) : function (e, t) {
        if (f.isBuffer(t)) {
          var r = 0 | l(t.length);
          return 0 === (e = s(e, r)).length ? e : (t.copy(e, 0, 0, r), e);
        }

        if (t) {
          if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || (n = t.length) != n ? s(e, 0) : h(e, t);
          if ("Buffer" === t.type && o(t.data)) return h(e, t.data);
        }

        var n;
        throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
      }(e, t);
    }

    function u(e) {
      if ("number" != typeof e) throw new TypeError('"size" argument must be a number');
      if (e < 0) throw new RangeError('"size" argument must not be negative');
    }

    function d(e, t) {
      if (u(t), e = s(e, t < 0 ? 0 : 0 | l(t)), !f.TYPED_ARRAY_SUPPORT) for (var r = 0; r < t; ++r) {
        e[r] = 0;
      }
      return e;
    }

    function h(e, t) {
      var r = t.length < 0 ? 0 : 0 | l(t.length);
      e = s(e, r);

      for (var n = 0; n < r; n += 1) {
        e[n] = 255 & t[n];
      }

      return e;
    }

    function l(e) {
      if (e >= a()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a().toString(16) + " bytes");
      return 0 | e;
    }

    function p(e, t) {
      if (f.isBuffer(e)) return e.length;
      if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
      "string" != typeof e && (e = "" + e);
      var r = e.length;
      if (0 === r) return 0;

      for (var n = !1;;) {
        switch (t) {
          case "ascii":
          case "latin1":
          case "binary":
            return r;

          case "utf8":
          case "utf-8":
          case void 0:
            return W(e).length;

          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return 2 * r;

          case "hex":
            return r >>> 1;

          case "base64":
            return U(e).length;

          default:
            if (n) return W(e).length;
            t = ("" + t).toLowerCase(), n = !0;
        }
      }
    }

    function b(e, t, r) {
      var n = e[t];
      e[t] = e[r], e[r] = n;
    }

    function v(e, t, r, n, i) {
      if (0 === e.length) return -1;

      if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
        if (i) return -1;
        r = e.length - 1;
      } else if (r < 0) {
        if (!i) return -1;
        r = 0;
      }

      if ("string" == typeof t && (t = f.from(t, n)), f.isBuffer(t)) return 0 === t.length ? -1 : m(e, t, r, n, i);
      if ("number" == typeof t) return t &= 255, f.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, r) : Uint8Array.prototype.lastIndexOf.call(e, t, r) : m(e, [t], r, n, i);
      throw new TypeError("val must be string, number or Buffer");
    }

    function m(e, t, r, n, i) {
      var o,
          a = 1,
          s = e.length,
          f = t.length;

      if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
        if (e.length < 2 || t.length < 2) return -1;
        a = 2, s /= 2, f /= 2, r /= 2;
      }

      function c(e, t) {
        return 1 === a ? e[t] : e.readUInt16BE(t * a);
      }

      if (i) {
        var u = -1;

        for (o = r; o < s; o++) {
          if (c(e, o) === c(t, -1 === u ? 0 : o - u)) {
            if (-1 === u && (u = o), o - u + 1 === f) return u * a;
          } else -1 !== u && (o -= o - u), u = -1;
        }
      } else for (r + f > s && (r = s - f), o = r; o >= 0; o--) {
        for (var d = !0, h = 0; h < f; h++) {
          if (c(e, o + h) !== c(t, h)) {
            d = !1;
            break;
          }
        }

        if (d) return o;
      }

      return -1;
    }

    function y(e, t, r, n) {
      r = Number(r) || 0;
      var i = e.length - r;
      n ? (n = Number(n)) > i && (n = i) : n = i;
      var o = t.length;
      if (o % 2 != 0) throw new TypeError("Invalid hex string");
      n > o / 2 && (n = o / 2);

      for (var a = 0; a < n; ++a) {
        var s = parseInt(t.substr(2 * a, 2), 16);
        if (isNaN(s)) return a;
        e[r + a] = s;
      }

      return a;
    }

    function g(e, t, r, n) {
      return D(W(t, e.length - r), e, r, n);
    }

    function A(e, t, r, n) {
      return D(function (e) {
        for (var t = [], r = 0; r < e.length; ++r) {
          t.push(255 & e.charCodeAt(r));
        }

        return t;
      }(t), e, r, n);
    }

    function w(e, t, r, n) {
      return A(e, t, r, n);
    }

    function _(e, t, r, n) {
      return D(U(t), e, r, n);
    }

    function x(e, t, r, n) {
      return D(function (e, t) {
        for (var r, n, i, o = [], a = 0; a < e.length && !((t -= 2) < 0); ++a) {
          r = e.charCodeAt(a), n = r >> 8, i = r % 256, o.push(i), o.push(n);
        }

        return o;
      }(t, e.length - r), e, r, n);
    }

    function S(e, t, r) {
      return 0 === t && r === e.length ? n.fromByteArray(e) : n.fromByteArray(e.slice(t, r));
    }

    function k(e, t, r) {
      r = Math.min(e.length, r);

      for (var n = [], i = t; i < r;) {
        var o,
            a,
            s,
            f,
            c = e[i],
            u = null,
            d = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
        if (i + d <= r) switch (d) {
          case 1:
            c < 128 && (u = c);
            break;

          case 2:
            128 == (192 & (o = e[i + 1])) && (f = (31 & c) << 6 | 63 & o) > 127 && (u = f);
            break;

          case 3:
            o = e[i + 1], a = e[i + 2], 128 == (192 & o) && 128 == (192 & a) && (f = (15 & c) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (f < 55296 || f > 57343) && (u = f);
            break;

          case 4:
            o = e[i + 1], a = e[i + 2], s = e[i + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & s) && (f = (15 & c) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s) > 65535 && f < 1114112 && (u = f);
        }
        null === u ? (u = 65533, d = 1) : u > 65535 && (u -= 65536, n.push(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n.push(u), i += d;
      }

      return function (e) {
        var t = e.length;
        if (t <= E) return String.fromCharCode.apply(String, e);
        var r = "",
            n = 0;

        for (; n < t;) {
          r += String.fromCharCode.apply(String, e.slice(n, n += E));
        }

        return r;
      }(n);
    }

    t.Buffer = f, t.SlowBuffer = function (e) {
      +e != e && (e = 0);
      return f.alloc(+e);
    }, t.INSPECT_MAX_BYTES = 50, f.TYPED_ARRAY_SUPPORT = void 0 !== e.TYPED_ARRAY_SUPPORT ? e.TYPED_ARRAY_SUPPORT : function () {
      try {
        var e = new Uint8Array(1);
        return e.__proto__ = {
          __proto__: Uint8Array.prototype,
          foo: function foo() {
            return 42;
          }
        }, 42 === e.foo() && "function" == typeof e.subarray && 0 === e.subarray(1, 1).byteLength;
      } catch (e) {
        return !1;
      }
    }(), t.kMaxLength = a(), f.poolSize = 8192, f._augment = function (e) {
      return e.__proto__ = f.prototype, e;
    }, f.from = function (e, t, r) {
      return c(null, e, t, r);
    }, f.TYPED_ARRAY_SUPPORT && (f.prototype.__proto__ = Uint8Array.prototype, f.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && f[Symbol.species] === f && Object.defineProperty(f, Symbol.species, {
      value: null,
      configurable: !0
    })), f.alloc = function (e, t, r) {
      return function (e, t, r, n) {
        return u(t), t <= 0 ? s(e, t) : void 0 !== r ? "string" == typeof n ? s(e, t).fill(r, n) : s(e, t).fill(r) : s(e, t);
      }(null, e, t, r);
    }, f.allocUnsafe = function (e) {
      return d(null, e);
    }, f.allocUnsafeSlow = function (e) {
      return d(null, e);
    }, f.isBuffer = function (e) {
      return !(null == e || !e._isBuffer);
    }, f.compare = function (e, t) {
      if (!f.isBuffer(e) || !f.isBuffer(t)) throw new TypeError("Arguments must be Buffers");
      if (e === t) return 0;

      for (var r = e.length, n = t.length, i = 0, o = Math.min(r, n); i < o; ++i) {
        if (e[i] !== t[i]) {
          r = e[i], n = t[i];
          break;
        }
      }

      return r < n ? -1 : n < r ? 1 : 0;
    }, f.isEncoding = function (e) {
      switch (String(e).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;

        default:
          return !1;
      }
    }, f.concat = function (e, t) {
      if (!o(e)) throw new TypeError('"list" argument must be an Array of Buffers');
      if (0 === e.length) return f.alloc(0);
      var r;
      if (void 0 === t) for (t = 0, r = 0; r < e.length; ++r) {
        t += e[r].length;
      }
      var n = f.allocUnsafe(t),
          i = 0;

      for (r = 0; r < e.length; ++r) {
        var a = e[r];
        if (!f.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
        a.copy(n, i), i += a.length;
      }

      return n;
    }, f.byteLength = p, f.prototype._isBuffer = !0, f.prototype.swap16 = function () {
      var e = this.length;
      if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

      for (var t = 0; t < e; t += 2) {
        b(this, t, t + 1);
      }

      return this;
    }, f.prototype.swap32 = function () {
      var e = this.length;
      if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

      for (var t = 0; t < e; t += 4) {
        b(this, t, t + 3), b(this, t + 1, t + 2);
      }

      return this;
    }, f.prototype.swap64 = function () {
      var e = this.length;
      if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

      for (var t = 0; t < e; t += 8) {
        b(this, t, t + 7), b(this, t + 1, t + 6), b(this, t + 2, t + 5), b(this, t + 3, t + 4);
      }

      return this;
    }, f.prototype.toString = function () {
      var e = 0 | this.length;
      return 0 === e ? "" : 0 === arguments.length ? k(this, 0, e) : function (e, t, r) {
        var n = !1;
        if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
        if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
        if ((r >>>= 0) <= (t >>>= 0)) return "";

        for (e || (e = "utf8");;) {
          switch (e) {
            case "hex":
              return B(this, t, r);

            case "utf8":
            case "utf-8":
              return k(this, t, r);

            case "ascii":
              return M(this, t, r);

            case "latin1":
            case "binary":
              return C(this, t, r);

            case "base64":
              return S(this, t, r);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return P(this, t, r);

            default:
              if (n) throw new TypeError("Unknown encoding: " + e);
              e = (e + "").toLowerCase(), n = !0;
          }
        }
      }.apply(this, arguments);
    }, f.prototype.equals = function (e) {
      if (!f.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
      return this === e || 0 === f.compare(this, e);
    }, f.prototype.inspect = function () {
      var e = "",
          r = t.INSPECT_MAX_BYTES;
      return this.length > 0 && (e = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (e += " ... ")), "<Buffer " + e + ">";
    }, f.prototype.compare = function (e, t, r, n, i) {
      if (!f.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
      if (void 0 === t && (t = 0), void 0 === r && (r = e ? e.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), t < 0 || r > e.length || n < 0 || i > this.length) throw new RangeError("out of range index");
      if (n >= i && t >= r) return 0;
      if (n >= i) return -1;
      if (t >= r) return 1;
      if (this === e) return 0;

      for (var o = (i >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (t >>>= 0), s = Math.min(o, a), c = this.slice(n, i), u = e.slice(t, r), d = 0; d < s; ++d) {
        if (c[d] !== u[d]) {
          o = c[d], a = u[d];
          break;
        }
      }

      return o < a ? -1 : a < o ? 1 : 0;
    }, f.prototype.includes = function (e, t, r) {
      return -1 !== this.indexOf(e, t, r);
    }, f.prototype.indexOf = function (e, t, r) {
      return v(this, e, t, r, !0);
    }, f.prototype.lastIndexOf = function (e, t, r) {
      return v(this, e, t, r, !1);
    }, f.prototype.write = function (e, t, r, n) {
      if (void 0 === t) n = "utf8", r = this.length, t = 0;else if (void 0 === r && "string" == typeof t) n = t, r = this.length, t = 0;else {
        if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
        t |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
      }
      var i = this.length - t;
      if ((void 0 === r || r > i) && (r = i), e.length > 0 && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
      n || (n = "utf8");

      for (var o = !1;;) {
        switch (n) {
          case "hex":
            return y(this, e, t, r);

          case "utf8":
          case "utf-8":
            return g(this, e, t, r);

          case "ascii":
            return A(this, e, t, r);

          case "latin1":
          case "binary":
            return w(this, e, t, r);

          case "base64":
            return _(this, e, t, r);

          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return x(this, e, t, r);

          default:
            if (o) throw new TypeError("Unknown encoding: " + n);
            n = ("" + n).toLowerCase(), o = !0;
        }
      }
    }, f.prototype.toJSON = function () {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    var E = 4096;

    function M(e, t, r) {
      var n = "";
      r = Math.min(e.length, r);

      for (var i = t; i < r; ++i) {
        n += String.fromCharCode(127 & e[i]);
      }

      return n;
    }

    function C(e, t, r) {
      var n = "";
      r = Math.min(e.length, r);

      for (var i = t; i < r; ++i) {
        n += String.fromCharCode(e[i]);
      }

      return n;
    }

    function B(e, t, r) {
      var n = e.length;
      (!t || t < 0) && (t = 0), (!r || r < 0 || r > n) && (r = n);

      for (var i = "", o = t; o < r; ++o) {
        i += N(e[o]);
      }

      return i;
    }

    function P(e, t, r) {
      for (var n = e.slice(t, r), i = "", o = 0; o < n.length; o += 2) {
        i += String.fromCharCode(n[o] + 256 * n[o + 1]);
      }

      return i;
    }

    function R(e, t, r) {
      if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
      if (e + t > r) throw new RangeError("Trying to access beyond buffer length");
    }

    function H(e, t, r, n, i, o) {
      if (!f.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (t > i || t < o) throw new RangeError('"value" argument is out of bounds');
      if (r + n > e.length) throw new RangeError("Index out of range");
    }

    function O(e, t, r, n) {
      t < 0 && (t = 65535 + t + 1);

      for (var i = 0, o = Math.min(e.length - r, 2); i < o; ++i) {
        e[r + i] = (t & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
      }
    }

    function T(e, t, r, n) {
      t < 0 && (t = 4294967295 + t + 1);

      for (var i = 0, o = Math.min(e.length - r, 4); i < o; ++i) {
        e[r + i] = t >>> 8 * (n ? i : 3 - i) & 255;
      }
    }

    function I(e, t, r, n, i, o) {
      if (r + n > e.length) throw new RangeError("Index out of range");
      if (r < 0) throw new RangeError("Index out of range");
    }

    function j(e, t, r, n, o) {
      return o || I(e, 0, r, 4), i.write(e, t, r, n, 23, 4), r + 4;
    }

    function z(e, t, r, n, o) {
      return o || I(e, 0, r, 8), i.write(e, t, r, n, 52, 8), r + 8;
    }

    f.prototype.slice = function (e, t) {
      var r,
          n = this.length;
      if ((e = ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), (t = void 0 === t ? n : ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), t < e && (t = e), f.TYPED_ARRAY_SUPPORT) (r = this.subarray(e, t)).__proto__ = f.prototype;else {
        var i = t - e;
        r = new f(i, void 0);

        for (var o = 0; o < i; ++o) {
          r[o] = this[o + e];
        }
      }
      return r;
    }, f.prototype.readUIntLE = function (e, t, r) {
      e |= 0, t |= 0, r || R(e, t, this.length);

      for (var n = this[e], i = 1, o = 0; ++o < t && (i *= 256);) {
        n += this[e + o] * i;
      }

      return n;
    }, f.prototype.readUIntBE = function (e, t, r) {
      e |= 0, t |= 0, r || R(e, t, this.length);

      for (var n = this[e + --t], i = 1; t > 0 && (i *= 256);) {
        n += this[e + --t] * i;
      }

      return n;
    }, f.prototype.readUInt8 = function (e, t) {
      return t || R(e, 1, this.length), this[e];
    }, f.prototype.readUInt16LE = function (e, t) {
      return t || R(e, 2, this.length), this[e] | this[e + 1] << 8;
    }, f.prototype.readUInt16BE = function (e, t) {
      return t || R(e, 2, this.length), this[e] << 8 | this[e + 1];
    }, f.prototype.readUInt32LE = function (e, t) {
      return t || R(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
    }, f.prototype.readUInt32BE = function (e, t) {
      return t || R(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
    }, f.prototype.readIntLE = function (e, t, r) {
      e |= 0, t |= 0, r || R(e, t, this.length);

      for (var n = this[e], i = 1, o = 0; ++o < t && (i *= 256);) {
        n += this[e + o] * i;
      }

      return n >= (i *= 128) && (n -= Math.pow(2, 8 * t)), n;
    }, f.prototype.readIntBE = function (e, t, r) {
      e |= 0, t |= 0, r || R(e, t, this.length);

      for (var n = t, i = 1, o = this[e + --n]; n > 0 && (i *= 256);) {
        o += this[e + --n] * i;
      }

      return o >= (i *= 128) && (o -= Math.pow(2, 8 * t)), o;
    }, f.prototype.readInt8 = function (e, t) {
      return t || R(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
    }, f.prototype.readInt16LE = function (e, t) {
      t || R(e, 2, this.length);
      var r = this[e] | this[e + 1] << 8;
      return 32768 & r ? 4294901760 | r : r;
    }, f.prototype.readInt16BE = function (e, t) {
      t || R(e, 2, this.length);
      var r = this[e + 1] | this[e] << 8;
      return 32768 & r ? 4294901760 | r : r;
    }, f.prototype.readInt32LE = function (e, t) {
      return t || R(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
    }, f.prototype.readInt32BE = function (e, t) {
      return t || R(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
    }, f.prototype.readFloatLE = function (e, t) {
      return t || R(e, 4, this.length), i.read(this, e, !0, 23, 4);
    }, f.prototype.readFloatBE = function (e, t) {
      return t || R(e, 4, this.length), i.read(this, e, !1, 23, 4);
    }, f.prototype.readDoubleLE = function (e, t) {
      return t || R(e, 8, this.length), i.read(this, e, !0, 52, 8);
    }, f.prototype.readDoubleBE = function (e, t) {
      return t || R(e, 8, this.length), i.read(this, e, !1, 52, 8);
    }, f.prototype.writeUIntLE = function (e, t, r, n) {
      (e = +e, t |= 0, r |= 0, n) || H(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
      var i = 1,
          o = 0;

      for (this[t] = 255 & e; ++o < r && (i *= 256);) {
        this[t + o] = e / i & 255;
      }

      return t + r;
    }, f.prototype.writeUIntBE = function (e, t, r, n) {
      (e = +e, t |= 0, r |= 0, n) || H(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
      var i = r - 1,
          o = 1;

      for (this[t + i] = 255 & e; --i >= 0 && (o *= 256);) {
        this[t + i] = e / o & 255;
      }

      return t + r;
    }, f.prototype.writeUInt8 = function (e, t, r) {
      return e = +e, t |= 0, r || H(this, e, t, 1, 255, 0), f.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1;
    }, f.prototype.writeUInt16LE = function (e, t, r) {
      return e = +e, t |= 0, r || H(this, e, t, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : O(this, e, t, !0), t + 2;
    }, f.prototype.writeUInt16BE = function (e, t, r) {
      return e = +e, t |= 0, r || H(this, e, t, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : O(this, e, t, !1), t + 2;
    }, f.prototype.writeUInt32LE = function (e, t, r) {
      return e = +e, t |= 0, r || H(this, e, t, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : T(this, e, t, !0), t + 4;
    }, f.prototype.writeUInt32BE = function (e, t, r) {
      return e = +e, t |= 0, r || H(this, e, t, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : T(this, e, t, !1), t + 4;
    }, f.prototype.writeIntLE = function (e, t, r, n) {
      if (e = +e, t |= 0, !n) {
        var i = Math.pow(2, 8 * r - 1);
        H(this, e, t, r, i - 1, -i);
      }

      var o = 0,
          a = 1,
          s = 0;

      for (this[t] = 255 & e; ++o < r && (a *= 256);) {
        e < 0 && 0 === s && 0 !== this[t + o - 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
      }

      return t + r;
    }, f.prototype.writeIntBE = function (e, t, r, n) {
      if (e = +e, t |= 0, !n) {
        var i = Math.pow(2, 8 * r - 1);
        H(this, e, t, r, i - 1, -i);
      }

      var o = r - 1,
          a = 1,
          s = 0;

      for (this[t + o] = 255 & e; --o >= 0 && (a *= 256);) {
        e < 0 && 0 === s && 0 !== this[t + o + 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
      }

      return t + r;
    }, f.prototype.writeInt8 = function (e, t, r) {
      return e = +e, t |= 0, r || H(this, e, t, 1, 127, -128), f.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
    }, f.prototype.writeInt16LE = function (e, t, r) {
      return e = +e, t |= 0, r || H(this, e, t, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : O(this, e, t, !0), t + 2;
    }, f.prototype.writeInt16BE = function (e, t, r) {
      return e = +e, t |= 0, r || H(this, e, t, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : O(this, e, t, !1), t + 2;
    }, f.prototype.writeInt32LE = function (e, t, r) {
      return e = +e, t |= 0, r || H(this, e, t, 4, 2147483647, -2147483648), f.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : T(this, e, t, !0), t + 4;
    }, f.prototype.writeInt32BE = function (e, t, r) {
      return e = +e, t |= 0, r || H(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), f.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : T(this, e, t, !1), t + 4;
    }, f.prototype.writeFloatLE = function (e, t, r) {
      return j(this, e, t, !0, r);
    }, f.prototype.writeFloatBE = function (e, t, r) {
      return j(this, e, t, !1, r);
    }, f.prototype.writeDoubleLE = function (e, t, r) {
      return z(this, e, t, !0, r);
    }, f.prototype.writeDoubleBE = function (e, t, r) {
      return z(this, e, t, !1, r);
    }, f.prototype.copy = function (e, t, r, n) {
      if (r || (r = 0), n || 0 === n || (n = this.length), t >= e.length && (t = e.length), t || (t = 0), n > 0 && n < r && (n = r), n === r) return 0;
      if (0 === e.length || 0 === this.length) return 0;
      if (t < 0) throw new RangeError("targetStart out of bounds");
      if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
      if (n < 0) throw new RangeError("sourceEnd out of bounds");
      n > this.length && (n = this.length), e.length - t < n - r && (n = e.length - t + r);
      var i,
          o = n - r;
      if (this === e && r < t && t < n) for (i = o - 1; i >= 0; --i) {
        e[i + t] = this[i + r];
      } else if (o < 1e3 || !f.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) {
        e[i + t] = this[i + r];
      } else Uint8Array.prototype.set.call(e, this.subarray(r, r + o), t);
      return o;
    }, f.prototype.fill = function (e, t, r, n) {
      if ("string" == typeof e) {
        if ("string" == typeof t ? (n = t, t = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === e.length) {
          var i = e.charCodeAt(0);
          i < 256 && (e = i);
        }

        if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
        if ("string" == typeof n && !f.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
      } else "number" == typeof e && (e &= 255);

      if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
      if (r <= t) return this;
      var o;
      if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, e || (e = 0), "number" == typeof e) for (o = t; o < r; ++o) {
        this[o] = e;
      } else {
        var a = f.isBuffer(e) ? e : W(new f(e, n).toString()),
            s = a.length;

        for (o = 0; o < r - t; ++o) {
          this[o + t] = a[o % s];
        }
      }
      return this;
    };
    var L = /[^+\/0-9A-Za-z-_]/g;

    function N(e) {
      return e < 16 ? "0" + e.toString(16) : e.toString(16);
    }

    function W(e, t) {
      var r;
      t = t || 1 / 0;

      for (var n = e.length, i = null, o = [], a = 0; a < n; ++a) {
        if ((r = e.charCodeAt(a)) > 55295 && r < 57344) {
          if (!i) {
            if (r > 56319) {
              (t -= 3) > -1 && o.push(239, 191, 189);
              continue;
            }

            if (a + 1 === n) {
              (t -= 3) > -1 && o.push(239, 191, 189);
              continue;
            }

            i = r;
            continue;
          }

          if (r < 56320) {
            (t -= 3) > -1 && o.push(239, 191, 189), i = r;
            continue;
          }

          r = 65536 + (i - 55296 << 10 | r - 56320);
        } else i && (t -= 3) > -1 && o.push(239, 191, 189);

        if (i = null, r < 128) {
          if ((t -= 1) < 0) break;
          o.push(r);
        } else if (r < 2048) {
          if ((t -= 2) < 0) break;
          o.push(r >> 6 | 192, 63 & r | 128);
        } else if (r < 65536) {
          if ((t -= 3) < 0) break;
          o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
        } else {
          if (!(r < 1114112)) throw new Error("Invalid code point");
          if ((t -= 4) < 0) break;
          o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
        }
      }

      return o;
    }

    function U(e) {
      return n.toByteArray(function (e) {
        if ((e = function (e) {
          return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
        }(e).replace(L, "")).length < 2) return "";

        for (; e.length % 4 != 0;) {
          e += "=";
        }

        return e;
      }(e));
    }

    function D(e, t, r, n) {
      for (var i = 0; i < n && !(i + r >= t.length || i >= e.length); ++i) {
        t[i + r] = e[i];
      }

      return i;
    }
  }).call(this, r(7));
}, function (e, t, r) {
  var n = r(22);

  e.exports = function (e) {
    if (!n(e)) throw TypeError(e + " is not an object!");
    return e;
  };
}, function (e, t) {
  function r(e, t) {
    if (!e) throw new Error(t || "Assertion failed");
  }

  e.exports = r, r.equal = function (e, t, r) {
    if (e != t) throw new Error(r || "Assertion failed: " + e + " != " + t);
  };
}, function (e, t, r) {
  var n = r(30),
      i = r(62);
  e.exports = r(23) ? function (e, t, r) {
    return n.f(e, t, i(1, r));
  } : function (e, t, r) {
    return e[t] = r, e;
  };
}, function (e, t, r) {
  e.exports = r(88);
}, function (e, t, r) {
  "use strict";

  (function (e, n) {
    function i(e) {
      return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function o(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function a(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function s(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {},
            n = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
          return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), n.forEach(function (t) {
          a(e, t, r[t]);
        });
      }

      return e;
    }

    function f(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var r = [],
            n = !0,
            i = !1,
            o = void 0;

        try {
          for (var a, s = e[Symbol.iterator](); !(n = (a = s.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
            ;
          }
        } catch (e) {
          i = !0, o = e;
        } finally {
          try {
            n || null == s.return || s.return();
          } finally {
            if (i) throw o;
          }
        }

        return r;
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    function c(e) {
      return function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, r = new Array(e.length); t < e.length; t++) {
            r[t] = e[t];
          }

          return r;
        }
      }(e) || function (e) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    r.d(t, "b", function () {
      return Tt;
    }), r.d(t, "c", function () {
      return Pt;
    }), r.d(t, "a", function () {
      return Ht;
    }), r.d(t, "d", function () {
      return Ot;
    });

    var u = function u() {},
        d = {},
        h = {},
        l = null,
        p = {
      mark: u,
      measure: u
    };

    try {
      "undefined" != typeof window && (d = window), "undefined" != typeof document && (h = document), "undefined" != typeof MutationObserver && (l = MutationObserver), "undefined" != typeof performance && (p = performance);
    } catch (e) {}

    var b = (d.navigator || {}).userAgent,
        v = void 0 === b ? "" : b,
        m = d,
        y = h,
        g = l,
        A = p,
        w = (m.document, !!y.documentElement && !!y.head && "function" == typeof y.addEventListener && "function" == typeof y.createElement),
        _ = ~v.indexOf("MSIE") || ~v.indexOf("Trident/"),
        x = 16,
        S = "fa",
        k = "svg-inline--fa",
        E = "data-fa-i2svg",
        M = "data-fa-pseudo-element",
        C = "data-fa-pseudo-element-pending",
        B = "data-prefix",
        P = "data-icon",
        R = "fontawesome-i2svg",
        H = ["HTML", "HEAD", "STYLE", "SCRIPT"],
        O = function () {
      try {
        return !0;
      } catch (e) {
        return !1;
      }
    }(),
        T = {
      fas: "solid",
      far: "regular",
      fal: "light",
      fab: "brands",
      fa: "solid"
    },
        I = {
      solid: "fas",
      regular: "far",
      light: "fal",
      brands: "fab"
    },
        j = "fa-layers-text",
        z = /Font Awesome 5 (Solid|Regular|Light|Brands|Free|Pro)/,
        L = {
      900: "fas",
      400: "far",
      normal: "far",
      300: "fal"
    },
        N = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        W = N.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]),
        U = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"],
        D = ["xs", "sm", "lg", "fw", "ul", "li", "border", "pull-left", "pull-right", "spin", "pulse", "rotate-90", "rotate-180", "rotate-270", "flip-horizontal", "flip-vertical", "stack", "stack-1x", "stack-2x", "inverse", "layers", "layers-text", "layers-counter"].concat(N.map(function (e) {
      return "".concat(e, "x");
    })).concat(W.map(function (e) {
      return "w-".concat(e);
    })),
        q = m.FontAwesomeConfig || {};

    if (y && "function" == typeof y.querySelector) {
      [["data-family-prefix", "familyPrefix"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach(function (e) {
        var t = f(e, 2),
            r = t[0],
            n = t[1],
            i = function (e) {
          return "" === e || "false" !== e && ("true" === e || e);
        }(function (e) {
          var t = y.querySelector("script[" + e + "]");
          if (t) return t.getAttribute(e);
        }(r));

        null != i && (q[n] = i);
      });
    }

    var F = s({}, {
      familyPrefix: S,
      replacementClass: k,
      autoReplaceSvg: !0,
      autoAddCss: !0,
      autoA11y: !0,
      searchPseudoElements: !1,
      observeMutations: !0,
      keepOriginalSource: !0,
      measurePerformance: !1,
      showMissingIcons: !0
    }, q);
    F.autoReplaceSvg || (F.observeMutations = !1);
    var X = s({}, F);
    m.FontAwesomeConfig = X;
    var Y = m || {};
    Y.___FONT_AWESOME___ || (Y.___FONT_AWESOME___ = {}), Y.___FONT_AWESOME___.styles || (Y.___FONT_AWESOME___.styles = {}), Y.___FONT_AWESOME___.hooks || (Y.___FONT_AWESOME___.hooks = {}), Y.___FONT_AWESOME___.shims || (Y.___FONT_AWESOME___.shims = []);
    var V = Y.___FONT_AWESOME___,
        K = [],
        J = !1;
    w && ((J = (y.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(y.readyState)) || y.addEventListener("DOMContentLoaded", function e() {
      y.removeEventListener("DOMContentLoaded", e), J = 1, K.map(function (e) {
        return e();
      });
    }));

    var G,
        Z = "pending",
        Q = "settled",
        $ = "fulfilled",
        ee = "rejected",
        te = function te() {},
        re = void 0 !== e && void 0 !== e.process && "function" == typeof e.process.emit,
        ne = void 0 === n ? setTimeout : n,
        ie = [];

    function oe() {
      for (var e = 0; e < ie.length; e++) {
        ie[e][0](ie[e][1]);
      }

      ie = [], G = !1;
    }

    function ae(e, t) {
      ie.push([e, t]), G || (G = !0, ne(oe, 0));
    }

    function se(e) {
      var t = e.owner,
          r = t._state,
          n = t._data,
          i = e[r],
          o = e.then;

      if ("function" == typeof i) {
        r = $;

        try {
          n = i(n);
        } catch (e) {
          de(o, e);
        }
      }

      fe(o, n) || (r === $ && ce(o, n), r === ee && de(o, n));
    }

    function fe(e, t) {
      var r;

      try {
        if (e === t) throw new TypeError("A promises callback cannot return that same promise.");

        if (t && ("function" == typeof t || "object" === i(t))) {
          var n = t.then;
          if ("function" == typeof n) return n.call(t, function (n) {
            r || (r = !0, t === n ? ue(e, n) : ce(e, n));
          }, function (t) {
            r || (r = !0, de(e, t));
          }), !0;
        }
      } catch (t) {
        return r || de(e, t), !0;
      }

      return !1;
    }

    function ce(e, t) {
      e !== t && fe(e, t) || ue(e, t);
    }

    function ue(e, t) {
      e._state === Z && (e._state = Q, e._data = t, ae(le, e));
    }

    function de(e, t) {
      e._state === Z && (e._state = Q, e._data = t, ae(pe, e));
    }

    function he(e) {
      e._then = e._then.forEach(se);
    }

    function le(e) {
      e._state = $, he(e);
    }

    function pe(t) {
      t._state = ee, he(t), !t._handled && re && e.process.emit("unhandledRejection", t._data, t);
    }

    function be(t) {
      e.process.emit("rejectionHandled", t);
    }

    function ve(e) {
      if ("function" != typeof e) throw new TypeError("Promise resolver " + e + " is not a function");
      if (this instanceof ve == !1) throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
      this._then = [], function (e, t) {
        function r(e) {
          de(t, e);
        }

        try {
          e(function (e) {
            ce(t, e);
          }, r);
        } catch (e) {
          r(e);
        }
      }(e, this);
    }

    ve.prototype = {
      constructor: ve,
      _state: Z,
      _then: null,
      _data: void 0,
      _handled: !1,
      then: function then(e, t) {
        var r = {
          owner: this,
          then: new this.constructor(te),
          fulfilled: e,
          rejected: t
        };
        return !t && !e || this._handled || (this._handled = !0, this._state === ee && re && ae(be, this)), this._state === $ || this._state === ee ? ae(se, r) : this._then.push(r), r.then;
      },
      catch: function _catch(e) {
        return this.then(null, e);
      }
    }, ve.all = function (e) {
      if (!Array.isArray(e)) throw new TypeError("You must pass an array to Promise.all().");
      return new ve(function (t, r) {
        var n = [],
            i = 0;

        function o(e) {
          return i++, function (r) {
            n[e] = r, --i || t(n);
          };
        }

        for (var a, s = 0; s < e.length; s++) {
          (a = e[s]) && "function" == typeof a.then ? a.then(o(s), r) : n[s] = a;
        }

        i || t(n);
      });
    }, ve.race = function (e) {
      if (!Array.isArray(e)) throw new TypeError("You must pass an array to Promise.race().");
      return new ve(function (t, r) {
        for (var n, i = 0; i < e.length; i++) {
          (n = e[i]) && "function" == typeof n.then ? n.then(t, r) : t(n);
        }
      });
    }, ve.resolve = function (e) {
      return e && "object" === i(e) && e.constructor === ve ? e : new ve(function (t) {
        t(e);
      });
    }, ve.reject = function (e) {
      return new ve(function (t, r) {
        r(e);
      });
    };
    var me = "function" == typeof Promise ? Promise : ve,
        ye = x,
        ge = {
      size: 16,
      x: 0,
      y: 0,
      rotate: 0,
      flipX: !1,
      flipY: !1
    };

    function Ae(e) {
      if (e && w) {
        var t = y.createElement("style");
        t.setAttribute("type", "text/css"), t.innerHTML = e;

        for (var r = y.head.childNodes, n = null, i = r.length - 1; i > -1; i--) {
          var o = r[i],
              a = (o.tagName || "").toUpperCase();
          ["STYLE", "LINK"].indexOf(a) > -1 && (n = o);
        }

        return y.head.insertBefore(t, n), e;
      }
    }

    var we = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

    function _e() {
      for (var e = 12, t = ""; e-- > 0;) {
        t += we[62 * Math.random() | 0];
      }

      return t;
    }

    function xe(e) {
      for (var t = [], r = (e || []).length >>> 0; r--;) {
        t[r] = e[r];
      }

      return t;
    }

    function Se(e) {
      return e.classList ? xe(e.classList) : (e.getAttribute("class") || "").split(" ").filter(function (e) {
        return e;
      });
    }

    function ke(e, t) {
      var r,
          n = t.split("-"),
          i = n[0],
          o = n.slice(1).join("-");
      return i !== e || "" === o || (r = o, ~D.indexOf(r)) ? null : o;
    }

    function Ee(e) {
      return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }

    function Me(e) {
      return Object.keys(e || {}).reduce(function (t, r) {
        return t + "".concat(r, ": ").concat(e[r], ";");
      }, "");
    }

    function Ce(e) {
      return e.size !== ge.size || e.x !== ge.x || e.y !== ge.y || e.rotate !== ge.rotate || e.flipX || e.flipY;
    }

    function Be(e) {
      var t = e.transform,
          r = e.containerWidth,
          n = e.iconWidth,
          i = {
        transform: "translate(".concat(r / 2, " 256)")
      },
          o = "translate(".concat(32 * t.x, ", ").concat(32 * t.y, ") "),
          a = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "),
          s = "rotate(".concat(t.rotate, " 0 0)");
      return {
        outer: i,
        inner: {
          transform: "".concat(o, " ").concat(a, " ").concat(s)
        },
        path: {
          transform: "translate(".concat(n / 2 * -1, " -256)")
        }
      };
    }

    var Pe = {
      x: 0,
      y: 0,
      width: "100%",
      height: "100%"
    };

    function Re(e) {
      var t = e.icons,
          r = t.main,
          n = t.mask,
          i = e.prefix,
          o = e.iconName,
          a = e.transform,
          f = e.symbol,
          c = e.title,
          u = e.extra,
          d = e.watchable,
          h = void 0 !== d && d,
          l = n.found ? n : r,
          p = l.width,
          b = l.height,
          v = "fa-w-".concat(Math.ceil(p / b * 16)),
          m = [X.replacementClass, o ? "".concat(X.familyPrefix, "-").concat(o) : "", v].filter(function (e) {
        return -1 === u.classes.indexOf(e);
      }).concat(u.classes).join(" "),
          y = {
        children: [],
        attributes: s({}, u.attributes, {
          "data-prefix": i,
          "data-icon": o,
          class: m,
          role: "img",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 ".concat(p, " ").concat(b)
        })
      };
      h && (y.attributes[E] = ""), c && y.children.push({
        tag: "title",
        attributes: {
          id: y.attributes["aria-labelledby"] || "title-".concat(_e())
        },
        children: [c]
      });
      var g = s({}, y, {
        prefix: i,
        iconName: o,
        main: r,
        mask: n,
        transform: a,
        symbol: f,
        styles: u.styles
      }),
          A = n.found && r.found ? function (e) {
        var t = e.children,
            r = e.attributes,
            n = e.main,
            i = e.mask,
            o = e.transform,
            a = n.width,
            f = n.icon,
            c = i.width,
            u = i.icon,
            d = Be({
          transform: o,
          containerWidth: c,
          iconWidth: a
        }),
            h = {
          tag: "rect",
          attributes: s({}, Pe, {
            fill: "white"
          })
        },
            l = {
          tag: "g",
          attributes: s({}, d.inner),
          children: [{
            tag: "path",
            attributes: s({}, f.attributes, d.path, {
              fill: "black"
            })
          }]
        },
            p = {
          tag: "g",
          attributes: s({}, d.outer),
          children: [l]
        },
            b = "mask-".concat(_e()),
            v = "clip-".concat(_e()),
            m = {
          tag: "defs",
          children: [{
            tag: "clipPath",
            attributes: {
              id: v
            },
            children: [u]
          }, {
            tag: "mask",
            attributes: s({}, Pe, {
              id: b,
              maskUnits: "userSpaceOnUse",
              maskContentUnits: "userSpaceOnUse"
            }),
            children: [h, p]
          }]
        };
        return t.push(m, {
          tag: "rect",
          attributes: s({
            fill: "currentColor",
            "clip-path": "url(#".concat(v, ")"),
            mask: "url(#".concat(b, ")")
          }, Pe)
        }), {
          children: t,
          attributes: r
        };
      }(g) : function (e) {
        var t = e.children,
            r = e.attributes,
            n = e.main,
            i = e.transform,
            o = Me(e.styles);

        if (o.length > 0 && (r.style = o), Ce(i)) {
          var a = Be({
            transform: i,
            containerWidth: n.width,
            iconWidth: n.width
          });
          t.push({
            tag: "g",
            attributes: s({}, a.outer),
            children: [{
              tag: "g",
              attributes: s({}, a.inner),
              children: [{
                tag: n.icon.tag,
                children: n.icon.children,
                attributes: s({}, n.icon.attributes, a.path)
              }]
            }]
          });
        } else t.push(n.icon);

        return {
          children: t,
          attributes: r
        };
      }(g),
          w = A.children,
          _ = A.attributes;
      return g.children = w, g.attributes = _, f ? function (e) {
        var t = e.prefix,
            r = e.iconName,
            n = e.children,
            i = e.attributes,
            o = e.symbol;
        return [{
          tag: "svg",
          attributes: {
            style: "display: none;"
          },
          children: [{
            tag: "symbol",
            attributes: s({}, i, {
              id: !0 === o ? "".concat(t, "-").concat(X.familyPrefix, "-").concat(r) : o
            }),
            children: n
          }]
        }];
      }(g) : function (e) {
        var t = e.children,
            r = e.main,
            n = e.mask,
            i = e.attributes,
            o = e.styles,
            a = e.transform;

        if (Ce(a) && r.found && !n.found) {
          var f = {
            x: r.width / r.height / 2,
            y: .5
          };
          i.style = Me(s({}, o, {
            "transform-origin": "".concat(f.x + a.x / 16, "em ").concat(f.y + a.y / 16, "em")
          }));
        }

        return [{
          tag: "svg",
          attributes: i,
          children: t
        }];
      }(g);
    }

    function He(e) {
      var t = e.content,
          r = e.width,
          n = e.height,
          i = e.transform,
          o = e.title,
          a = e.extra,
          f = e.watchable,
          c = void 0 !== f && f,
          u = s({}, a.attributes, o ? {
        title: o
      } : {}, {
        class: a.classes.join(" ")
      });
      c && (u[E] = "");
      var d = s({}, a.styles);
      Ce(i) && (d.transform = function (e) {
        var t = e.transform,
            r = e.width,
            n = void 0 === r ? x : r,
            i = e.height,
            o = void 0 === i ? x : i,
            a = e.startCentered,
            s = void 0 !== a && a,
            f = "";
        return f += s && _ ? "translate(".concat(t.x / ye - n / 2, "em, ").concat(t.y / ye - o / 2, "em) ") : s ? "translate(calc(-50% + ".concat(t.x / ye, "em), calc(-50% + ").concat(t.y / ye, "em)) ") : "translate(".concat(t.x / ye, "em, ").concat(t.y / ye, "em) "), f += "scale(".concat(t.size / ye * (t.flipX ? -1 : 1), ", ").concat(t.size / ye * (t.flipY ? -1 : 1), ") "), f += "rotate(".concat(t.rotate, "deg) ");
      }({
        transform: i,
        startCentered: !0,
        width: r,
        height: n
      }), d["-webkit-transform"] = d.transform);
      var h = Me(d);
      h.length > 0 && (u.style = h);
      var l = [];
      return l.push({
        tag: "span",
        attributes: u,
        children: [t]
      }), o && l.push({
        tag: "span",
        attributes: {
          class: "sr-only"
        },
        children: [o]
      }), l;
    }

    var Oe = function Oe() {},
        Te = X.measurePerformance && A && A.mark && A.measure ? A : {
      mark: Oe,
      measure: Oe
    },
        Ie = function Ie(e) {
      Te.mark("".concat('FA "5.7.2"', " ").concat(e, " ends")), Te.measure("".concat('FA "5.7.2"', " ").concat(e), "".concat('FA "5.7.2"', " ").concat(e, " begins"), "".concat('FA "5.7.2"', " ").concat(e, " ends"));
    },
        je = {
      begin: function begin(e) {
        return Te.mark("".concat('FA "5.7.2"', " ").concat(e, " begins")), function () {
          return Ie(e);
        };
      },
      end: Ie
    },
        ze = function ze(e, t, r, n) {
      var i,
          o,
          a,
          s = Object.keys(e),
          f = s.length,
          c = void 0 !== n ? function (e, t) {
        return function (r, n, i, o) {
          return e.call(t, r, n, i, o);
        };
      }(t, n) : t;

      for (void 0 === r ? (i = 1, a = e[s[0]]) : (i = 0, a = r); i < f; i++) {
        a = c(a, e[o = s[i]], o, e);
      }

      return a;
    };

    var Le = V.styles,
        Ne = V.shims,
        We = {},
        Ue = {},
        De = {},
        qe = function qe() {
      var e = function e(_e2) {
        return ze(Le, function (t, r, n) {
          return t[n] = ze(r, _e2, {}), t;
        }, {});
      };

      We = e(function (e, t, r) {
        return t[3] && (e[t[3]] = r), e;
      }), Ue = e(function (e, t, r) {
        var n = t[2];
        return e[r] = r, n.forEach(function (t) {
          e[t] = r;
        }), e;
      });
      var t = "far" in Le;
      De = ze(Ne, function (e, r) {
        var n = r[0],
            i = r[1],
            o = r[2];
        return "far" !== i || t || (i = "fas"), e[n] = {
          prefix: i,
          iconName: o
        }, e;
      }, {});
    };

    function Fe(e, t) {
      return We[e][t];
    }

    qe();

    var Xe = V.styles,
        Ye = function Ye() {
      return {
        prefix: null,
        iconName: null,
        rest: []
      };
    };

    function Ve(e) {
      return e.reduce(function (e, t) {
        var r = ke(X.familyPrefix, t);
        if (Xe[t]) e.prefix = t;else if (X.autoFetchSvg && ["fas", "far", "fal", "fab", "fa"].indexOf(t) > -1) e.prefix = t;else if (r) {
          var n = "fa" === e.prefix ? De[r] || {
            prefix: null,
            iconName: null
          } : {};
          e.iconName = n.iconName || r, e.prefix = n.prefix || e.prefix;
        } else t !== X.replacementClass && 0 !== t.indexOf("fa-w-") && e.rest.push(t);
        return e;
      }, Ye());
    }

    function Ke(e, t, r) {
      if (e && e[t] && e[t][r]) return {
        prefix: t,
        iconName: r,
        icon: e[t][r]
      };
    }

    function Je(e) {
      var t = e.tag,
          r = e.attributes,
          n = void 0 === r ? {} : r,
          i = e.children,
          o = void 0 === i ? [] : i;
      return "string" == typeof e ? Ee(e) : "<".concat(t, " ").concat(function (e) {
        return Object.keys(e || {}).reduce(function (t, r) {
          return t + "".concat(r, '="').concat(Ee(e[r]), '" ');
        }, "").trim();
      }(n), ">").concat(o.map(Je).join(""), "</").concat(t, ">");
    }

    var Ge = function Ge() {};

    function Ze(e) {
      return "string" == typeof (e.getAttribute ? e.getAttribute(E) : null);
    }

    var Qe = {
      replace: function replace(e) {
        var t = e[0],
            r = e[1].map(function (e) {
          return Je(e);
        }).join("\n");
        if (t.parentNode && t.outerHTML) t.outerHTML = r + (X.keepOriginalSource && "svg" !== t.tagName.toLowerCase() ? "\x3c!-- ".concat(t.outerHTML, " --\x3e") : "");else if (t.parentNode) {
          var n = document.createElement("span");
          t.parentNode.replaceChild(n, t), n.outerHTML = r;
        }
      },
      nest: function nest(e) {
        var t = e[0],
            r = e[1];
        if (~Se(t).indexOf(X.replacementClass)) return Qe.replace(e);
        var n = new RegExp("".concat(X.familyPrefix, "-.*"));
        delete r[0].attributes.style;
        var i = r[0].attributes.class.split(" ").reduce(function (e, t) {
          return t === X.replacementClass || t.match(n) ? e.toSvg.push(t) : e.toNode.push(t), e;
        }, {
          toNode: [],
          toSvg: []
        });
        r[0].attributes.class = i.toSvg.join(" ");
        var o = r.map(function (e) {
          return Je(e);
        }).join("\n");
        t.setAttribute("class", i.toNode.join(" ")), t.setAttribute(E, ""), t.innerHTML = o;
      }
    };

    function $e(e, t) {
      var r = "function" == typeof t ? t : Ge;
      0 === e.length ? r() : (m.requestAnimationFrame || function (e) {
        return e();
      })(function () {
        var t = !0 === X.autoReplaceSvg ? Qe.replace : Qe[X.autoReplaceSvg] || Qe.replace,
            n = je.begin("mutate");
        e.map(t), n(), r();
      });
    }

    var et = !1;

    function tt() {
      et = !1;
    }

    var rt = null;

    function nt(e) {
      for (var t = "", r = 0; r < e.length; r++) {
        t += ("000" + e.charCodeAt(r).toString(16)).slice(-4);
      }

      return t;
    }

    function it(e) {
      var t,
          r,
          n = e.getAttribute("data-prefix"),
          i = e.getAttribute("data-icon"),
          o = void 0 !== e.innerText ? e.innerText.trim() : "",
          a = Ve(Se(e));
      return n && i && (a.prefix = n, a.iconName = i), a.prefix && o.length > 1 ? a.iconName = (t = a.prefix, r = e.innerText, Ue[t][r]) : a.prefix && 1 === o.length && (a.iconName = Fe(a.prefix, nt(e.innerText))), a;
    }

    var ot = function ot(e) {
      var t = {
        size: 16,
        x: 0,
        y: 0,
        flipX: !1,
        flipY: !1,
        rotate: 0
      };
      return e ? e.toLowerCase().split(" ").reduce(function (e, t) {
        var r = t.toLowerCase().split("-"),
            n = r[0],
            i = r.slice(1).join("-");
        if (n && "h" === i) return e.flipX = !0, e;
        if (n && "v" === i) return e.flipY = !0, e;
        if (i = parseFloat(i), isNaN(i)) return e;

        switch (n) {
          case "grow":
            e.size = e.size + i;
            break;

          case "shrink":
            e.size = e.size - i;
            break;

          case "left":
            e.x = e.x - i;
            break;

          case "right":
            e.x = e.x + i;
            break;

          case "up":
            e.y = e.y - i;
            break;

          case "down":
            e.y = e.y + i;
            break;

          case "rotate":
            e.rotate = e.rotate + i;
        }

        return e;
      }, t) : t;
    };

    function at(e) {
      var t = it(e),
          r = t.iconName,
          n = t.prefix,
          i = t.rest,
          o = function (e) {
        var t = e.getAttribute("style"),
            r = [];
        return t && (r = t.split(";").reduce(function (e, t) {
          var r = t.split(":"),
              n = r[0],
              i = r.slice(1);
          return n && i.length > 0 && (e[n] = i.join(":").trim()), e;
        }, {})), r;
      }(e),
          a = function (e) {
        return ot(e.getAttribute("data-fa-transform"));
      }(e),
          s = function (e) {
        var t = e.getAttribute("data-fa-symbol");
        return null !== t && ("" === t || t);
      }(e),
          f = function (e) {
        var t = xe(e.attributes).reduce(function (e, t) {
          return "class" !== e.name && "style" !== e.name && (e[t.name] = t.value), e;
        }, {}),
            r = e.getAttribute("title");
        return X.autoA11y && (r ? t["aria-labelledby"] = "".concat(X.replacementClass, "-title-").concat(_e()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
      }(e),
          c = function (e) {
        var t = e.getAttribute("data-fa-mask");
        return t ? Ve(t.split(" ").map(function (e) {
          return e.trim();
        })) : Ye();
      }(e);

      return {
        iconName: r,
        title: e.getAttribute("title"),
        prefix: n,
        transform: a,
        symbol: s,
        mask: c,
        extra: {
          classes: i,
          styles: o,
          attributes: f
        }
      };
    }

    function st(e) {
      this.name = "MissingIcon", this.message = e || "Icon unavailable", this.stack = new Error().stack;
    }

    st.prototype = Object.create(Error.prototype), st.prototype.constructor = st;
    var ft = {
      fill: "currentColor"
    },
        ct = {
      attributeType: "XML",
      repeatCount: "indefinite",
      dur: "2s"
    },
        ut = {
      tag: "path",
      attributes: s({}, ft, {
        d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
      })
    },
        dt = s({}, ct, {
      attributeName: "opacity"
    }),
        ht = {
      tag: "g",
      children: [ut, {
        tag: "circle",
        attributes: s({}, ft, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: [{
          tag: "animate",
          attributes: s({}, ct, {
            attributeName: "r",
            values: "28;14;28;28;14;28;"
          })
        }, {
          tag: "animate",
          attributes: s({}, dt, {
            values: "1;0;1;1;0;1;"
          })
        }]
      }, {
        tag: "path",
        attributes: s({}, ft, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: [{
          tag: "animate",
          attributes: s({}, dt, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }, {
        tag: "path",
        attributes: s({}, ft, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: s({}, dt, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }]
    },
        lt = V.styles;

    function pt(e, t) {
      return new me(function (r, n) {
        var i = {
          found: !1,
          width: 512,
          height: 512,
          icon: ht
        };

        if (e && t && lt[t] && lt[t][e]) {
          var o = lt[t][e];
          return r(i = {
            found: !0,
            width: o[0],
            height: o[1],
            icon: {
              tag: "path",
              attributes: {
                fill: "currentColor",
                d: o.slice(4)[0]
              }
            }
          });
        }

        e && t && !X.showMissingIcons ? n(new st("Icon is missing for prefix ".concat(t, " with icon name ").concat(e))) : r(i);
      });
    }

    var bt = V.styles;

    function vt(e) {
      var t = at(e);
      return ~t.extra.classes.indexOf(j) ? function (e, t) {
        var r = t.title,
            n = t.transform,
            i = t.extra,
            o = null,
            a = null;

        if (_) {
          var s = parseInt(getComputedStyle(e).fontSize, 10),
              f = e.getBoundingClientRect();
          o = f.width / s, a = f.height / s;
        }

        return X.autoA11y && !r && (i.attributes["aria-hidden"] = "true"), me.resolve([e, He({
          content: e.innerHTML,
          width: o,
          height: a,
          transform: n,
          title: r,
          extra: i,
          watchable: !0
        })]);
      }(e, t) : function (e, t) {
        var r = t.iconName,
            n = t.title,
            i = t.prefix,
            o = t.transform,
            a = t.symbol,
            s = t.mask,
            c = t.extra;
        return new me(function (t, u) {
          me.all([pt(r, i), pt(s.iconName, s.prefix)]).then(function (s) {
            var u = f(s, 2),
                d = u[0],
                h = u[1];
            t([e, Re({
              icons: {
                main: d,
                mask: h
              },
              prefix: i,
              iconName: r,
              transform: o,
              symbol: a,
              mask: h,
              title: n,
              extra: c,
              watchable: !0
            })]);
          });
        });
      }(e, t);
    }

    function mt(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;

      if (w) {
        var r = y.documentElement.classList,
            n = function n(e) {
          return r.add("".concat(R, "-").concat(e));
        },
            i = function i(e) {
          return r.remove("".concat(R, "-").concat(e));
        },
            o = X.autoFetchSvg ? Object.keys(T) : Object.keys(bt),
            a = [".".concat(j, ":not([").concat(E, "])")].concat(o.map(function (e) {
          return ".".concat(e, ":not([").concat(E, "])");
        })).join(", ");

        if (0 !== a.length) {
          var s = xe(e.querySelectorAll(a));

          if (s.length > 0) {
            n("pending"), i("complete");
            var f = je.begin("onTree"),
                c = s.reduce(function (e, t) {
              try {
                var r = vt(t);
                r && e.push(r);
              } catch (e) {
                O || e instanceof st && console.error(e);
              }

              return e;
            }, []);
            return new me(function (e, r) {
              me.all(c).then(function (r) {
                $e(r, function () {
                  n("active"), n("complete"), i("pending"), "function" == typeof t && t(), f(), e();
                });
              }).catch(function () {
                f(), r();
              });
            });
          }
        }
      }
    }

    function yt(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
      vt(e).then(function (e) {
        e && $e([e], t);
      });
    }

    function gt(e, t) {
      var r = "".concat(C).concat(t.replace(":", "-"));
      return new me(function (n, i) {
        if (null !== e.getAttribute(r)) return n();
        var o = xe(e.children).filter(function (e) {
          return e.getAttribute(M) === t;
        })[0],
            a = m.getComputedStyle(e, t),
            f = a.getPropertyValue("font-family").match(z),
            c = a.getPropertyValue("font-weight");
        if (o && !f) return e.removeChild(o), n();

        if (f) {
          var u = a.getPropertyValue("content"),
              d = ~["Light", "Regular", "Solid", "Brands"].indexOf(f[1]) ? I[f[1].toLowerCase()] : L[c],
              h = Fe(d, nt(3 === u.length ? u.substr(1, 1) : u));
          if (o && o.getAttribute(B) === d && o.getAttribute(P) === h) n();else {
            e.setAttribute(r, h), o && e.removeChild(o);
            var l = {
              iconName: null,
              title: null,
              prefix: null,
              transform: ge,
              symbol: !1,
              mask: null,
              extra: {
                classes: [],
                styles: {},
                attributes: {}
              }
            },
                p = l.extra;
            p.attributes[M] = t, pt(h, d).then(function (i) {
              var o = Re(s({}, l, {
                icons: {
                  main: i,
                  mask: Ye()
                },
                prefix: d,
                iconName: h,
                extra: p,
                watchable: !0
              })),
                  a = y.createElement("svg");
              ":before" === t ? e.insertBefore(a, e.firstChild) : e.appendChild(a), a.outerHTML = o.map(function (e) {
                return Je(e);
              }).join("\n"), e.removeAttribute(r), n();
            }).catch(i);
          }
        } else n();
      });
    }

    function At(e) {
      return me.all([gt(e, ":before"), gt(e, ":after")]);
    }

    function wt(e) {
      return !(e.parentNode === document.head || ~H.indexOf(e.tagName.toUpperCase()) || e.getAttribute(M) || e.parentNode && "svg" === e.parentNode.tagName);
    }

    function _t(e) {
      if (w) return new me(function (t, r) {
        var n = xe(e.querySelectorAll("*")).filter(wt).map(At),
            i = je.begin("searchPseudoElements");
        et = !0, me.all(n).then(function () {
          i(), tt(), t();
        }).catch(function () {
          i(), tt(), r();
        });
      });
    }

    var xt = 'svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}';

    function St() {
      var e = S,
          t = k,
          r = X.familyPrefix,
          n = X.replacementClass,
          i = xt;

      if (r !== e || n !== t) {
        var o = new RegExp("\\.".concat(e, "\\-"), "g"),
            a = new RegExp("\\.".concat(t), "g");
        i = i.replace(o, ".".concat(r, "-")).replace(a, ".".concat(n));
      }

      return i;
    }

    function kt(e) {
      return {
        found: !0,
        width: e[0],
        height: e[1],
        icon: {
          tag: "path",
          attributes: {
            fill: "currentColor",
            d: e.slice(4)[0]
          }
        }
      };
    }

    function Et() {
      X.autoAddCss && !Rt && (Ae(St()), Rt = !0);
    }

    function Mt(e, t) {
      return Object.defineProperty(e, "abstract", {
        get: t
      }), Object.defineProperty(e, "html", {
        get: function get() {
          return e.abstract.map(function (e) {
            return Je(e);
          });
        }
      }), Object.defineProperty(e, "node", {
        get: function get() {
          if (w) {
            var t = y.createElement("div");
            return t.innerHTML = e.html, t.children;
          }
        }
      }), e;
    }

    function Ct(e) {
      var t = e.prefix,
          r = void 0 === t ? "fa" : t,
          n = e.iconName;
      if (n) return Ke(Pt.definitions, r, n) || Ke(V.styles, r, n);
    }

    var Bt,
        Pt = new (function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.definitions = {};
      }

      var t, r, n;
      return t = e, (r = [{
        key: "add",
        value: function value() {
          for (var e = this, t = arguments.length, r = new Array(t), n = 0; n < t; n++) {
            r[n] = arguments[n];
          }

          var i = r.reduce(this._pullDefinitions, {});
          Object.keys(i).forEach(function (t) {
            e.definitions[t] = s({}, e.definitions[t] || {}, i[t]), function e(t, r) {
              var n = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).skipHooks,
                  i = void 0 !== n && n,
                  o = Object.keys(r).reduce(function (e, t) {
                var n = r[t];
                return n.icon ? e[n.iconName] = n.icon : e[t] = n, e;
              }, {});
              "function" != typeof V.hooks.addPack || i ? V.styles[t] = s({}, V.styles[t] || {}, o) : V.hooks.addPack(t, o), "fas" === t && e("fa", r);
            }(t, i[t]), qe();
          });
        }
      }, {
        key: "reset",
        value: function value() {
          this.definitions = {};
        }
      }, {
        key: "_pullDefinitions",
        value: function value(e, t) {
          var r = t.prefix && t.iconName && t.icon ? {
            0: t
          } : t;
          return Object.keys(r).map(function (t) {
            var n = r[t],
                i = n.prefix,
                o = n.iconName,
                a = n.icon;
            e[i] || (e[i] = {}), e[i][o] = a;
          }), e;
        }
      }]) && o(t.prototype, r), n && o(t, n), e;
    }())(),
        Rt = !1,
        Ht = {
      i2svg: function i2svg() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};

        if (w) {
          Et();
          var t = e.node,
              r = void 0 === t ? y : t,
              n = e.callback,
              i = void 0 === n ? function () {} : n;
          return X.searchPseudoElements && _t(r), mt(r, i);
        }

        return me.reject("Operation requires a DOM of some kind.");
      },
      css: St,
      insertCss: function insertCss() {
        Rt || (Ae(St()), Rt = !0);
      },
      watch: function watch() {
        var e,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = t.autoReplaceSvgRoot,
            n = t.observeMutationsRoot;
        !1 === X.autoReplaceSvg && (X.autoReplaceSvg = !0), X.observeMutations = !0, e = function e() {
          jt({
            autoReplaceSvgRoot: r
          }), function (e) {
            if (g && X.observeMutations) {
              var t = e.treeCallback,
                  r = e.nodeCallback,
                  n = e.pseudoElementsCallback,
                  i = e.observeMutationsRoot,
                  o = void 0 === i ? y : i;
              rt = new g(function (e) {
                et || xe(e).forEach(function (e) {
                  if ("childList" === e.type && e.addedNodes.length > 0 && !Ze(e.addedNodes[0]) && (X.searchPseudoElements && n(e.target), t(e.target)), "attributes" === e.type && e.target.parentNode && X.searchPseudoElements && n(e.target.parentNode), "attributes" === e.type && Ze(e.target) && ~U.indexOf(e.attributeName)) if ("class" === e.attributeName) {
                    var i = Ve(Se(e.target)),
                        o = i.prefix,
                        a = i.iconName;
                    o && e.target.setAttribute("data-prefix", o), a && e.target.setAttribute("data-icon", a);
                  } else r(e.target);
                });
              }), w && rt.observe(o, {
                childList: !0,
                attributes: !0,
                characterData: !0,
                subtree: !0
              });
            }
          }({
            treeCallback: mt,
            nodeCallback: yt,
            pseudoElementsCallback: _t,
            observeMutationsRoot: n
          });
        }, w && (J ? setTimeout(e, 0) : K.push(e));
      }
    },
        Ot = {
      transform: function transform(e) {
        return ot(e);
      }
    },
        Tt = (Bt = function Bt(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = t.transform,
          n = void 0 === r ? ge : r,
          i = t.symbol,
          o = void 0 !== i && i,
          a = t.mask,
          f = void 0 === a ? null : a,
          c = t.title,
          u = void 0 === c ? null : c,
          d = t.classes,
          h = void 0 === d ? [] : d,
          l = t.attributes,
          p = void 0 === l ? {} : l,
          b = t.styles,
          v = void 0 === b ? {} : b;

      if (e) {
        var m = e.prefix,
            y = e.iconName,
            g = e.icon;
        return Mt(s({
          type: "icon"
        }, e), function () {
          return Et(), X.autoA11y && (u ? p["aria-labelledby"] = "".concat(X.replacementClass, "-title-").concat(_e()) : (p["aria-hidden"] = "true", p.focusable = "false")), Re({
            icons: {
              main: kt(g),
              mask: f ? kt(f.icon) : {
                found: !1,
                width: null,
                height: null,
                icon: {}
              }
            },
            prefix: m,
            iconName: y,
            transform: s({}, ge, n),
            symbol: o,
            title: u,
            extra: {
              attributes: p,
              styles: v,
              classes: h
            }
          });
        });
      }
    }, function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = (e || {}).icon ? e : Ct(e || {}),
          n = t.mask;
      return n && (n = (n || {}).icon ? n : Ct(n || {})), Bt(r, s({}, t, {
        mask: n
      }));
    }),
        It = {
      noAuto: function noAuto() {
        X.autoReplaceSvg = !1, X.observeMutations = !1, rt && rt.disconnect();
      },
      config: X,
      dom: Ht,
      library: Pt,
      parse: Ot,
      findIconDefinition: Ct,
      icon: Tt,
      text: function text(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = t.transform,
            n = void 0 === r ? ge : r,
            i = t.title,
            o = void 0 === i ? null : i,
            a = t.classes,
            f = void 0 === a ? [] : a,
            u = t.attributes,
            d = void 0 === u ? {} : u,
            h = t.styles,
            l = void 0 === h ? {} : h;
        return Mt({
          type: "text",
          content: e
        }, function () {
          return Et(), He({
            content: e,
            transform: s({}, ge, n),
            title: o,
            extra: {
              attributes: d,
              styles: l,
              classes: ["".concat(X.familyPrefix, "-layers-text")].concat(c(f))
            }
          });
        });
      },
      counter: function counter(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = t.title,
            n = void 0 === r ? null : r,
            i = t.classes,
            o = void 0 === i ? [] : i,
            a = t.attributes,
            f = void 0 === a ? {} : a,
            u = t.styles,
            d = void 0 === u ? {} : u;
        return Mt({
          type: "counter",
          content: e
        }, function () {
          return Et(), function (e) {
            var t = e.content,
                r = e.title,
                n = e.extra,
                i = s({}, n.attributes, r ? {
              title: r
            } : {}, {
              class: n.classes.join(" ")
            }),
                o = Me(n.styles);
            o.length > 0 && (i.style = o);
            var a = [];
            return a.push({
              tag: "span",
              attributes: i,
              children: [t]
            }), r && a.push({
              tag: "span",
              attributes: {
                class: "sr-only"
              },
              children: [r]
            }), a;
          }({
            content: e.toString(),
            title: n,
            extra: {
              attributes: f,
              styles: d,
              classes: ["".concat(X.familyPrefix, "-layers-counter")].concat(c(o))
            }
          });
        });
      },
      layer: function layer(e) {
        return Mt({
          type: "layer"
        }, function () {
          Et();
          var t = [];
          return e(function (e) {
            Array.isArray(e) ? e.map(function (e) {
              t = t.concat(e.abstract);
            }) : t = t.concat(e.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: "".concat(X.familyPrefix, "-layers")
            },
            children: t
          }];
        });
      },
      toHtml: Je
    },
        jt = function jt() {
      var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).autoReplaceSvgRoot,
          t = void 0 === e ? y : e;
      (Object.keys(V.styles).length > 0 || X.autoFetchSvg) && w && X.autoReplaceSvg && It.dom.i2svg({
        node: t
      });
    };
  }).call(this, r(7), r(194).setImmediate);
}, function (e, t, r) {
  var n = r(100).Buffer;

  e.exports = function (e) {
    for (var t = {}, r = e.length, i = e.charAt(0), o = 0; o < e.length; o++) {
      var a = e.charAt(o);
      if (void 0 !== t[a]) throw new TypeError(a + " is ambiguous");
      t[a] = o;
    }

    function s(e) {
      if ("string" != typeof e) throw new TypeError("Expected String");
      if (0 === e.length) return n.allocUnsafe(0);

      for (var o = [0], a = 0; a < e.length; a++) {
        var s = t[e[a]];
        if (void 0 === s) return;

        for (var f = 0, c = s; f < o.length; ++f) {
          c += o[f] * r, o[f] = 255 & c, c >>= 8;
        }

        for (; c > 0;) {
          o.push(255 & c), c >>= 8;
        }
      }

      for (var u = 0; e[u] === i && u < e.length - 1; ++u) {
        o.push(0);
      }

      return n.from(o.reverse());
    }

    return {
      encode: function encode(t) {
        if (0 === t.length) return "";

        for (var n = [0], o = 0; o < t.length; ++o) {
          for (var a = 0, s = t[o]; a < n.length; ++a) {
            s += n[a] << 8, n[a] = s % r, s = s / r | 0;
          }

          for (; s > 0;) {
            n.push(s % r), s = s / r | 0;
          }
        }

        for (var f = "", c = 0; 0 === t[c] && c < t.length - 1; ++c) {
          f += i;
        }

        for (var u = n.length - 1; u >= 0; --u) {
          f += e[n[u]];
        }

        return f;
      },
      decodeUnsafe: s,
      decode: function decode(e) {
        var t = s(e);
        if (t) return t;
        throw new Error("Non-base" + r + " character");
      }
    };
  };
}, function (e, t) {
  var r,
      n,
      i = e.exports = {};

  function o() {
    throw new Error("setTimeout has not been defined");
  }

  function a() {
    throw new Error("clearTimeout has not been defined");
  }

  function s(e) {
    if (r === setTimeout) return setTimeout(e, 0);
    if ((r === o || !r) && setTimeout) return r = setTimeout, setTimeout(e, 0);

    try {
      return r(e, 0);
    } catch (t) {
      try {
        return r.call(null, e, 0);
      } catch (t) {
        return r.call(this, e, 0);
      }
    }
  }

  !function () {
    try {
      r = "function" == typeof setTimeout ? setTimeout : o;
    } catch (e) {
      r = o;
    }

    try {
      n = "function" == typeof clearTimeout ? clearTimeout : a;
    } catch (e) {
      n = a;
    }
  }();
  var f,
      c = [],
      u = !1,
      d = -1;

  function h() {
    u && f && (u = !1, f.length ? c = f.concat(c) : d = -1, c.length && l());
  }

  function l() {
    if (!u) {
      var e = s(h);
      u = !0;

      for (var t = c.length; t;) {
        for (f = c, c = []; ++d < t;) {
          f && f[d].run();
        }

        d = -1, t = c.length;
      }

      f = null, u = !1, function (e) {
        if (n === clearTimeout) return clearTimeout(e);
        if ((n === a || !n) && clearTimeout) return n = clearTimeout, clearTimeout(e);

        try {
          n(e);
        } catch (t) {
          try {
            return n.call(null, e);
          } catch (t) {
            return n.call(this, e);
          }
        }
      }(e);
    }
  }

  function p(e, t) {
    this.fun = e, this.array = t;
  }

  function b() {}

  i.nextTick = function (e) {
    var t = new Array(arguments.length - 1);
    if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
      t[r - 1] = arguments[r];
    }
    c.push(new p(e, t)), 1 !== c.length || u || s(l);
  }, p.prototype.run = function () {
    this.fun.apply(null, this.array);
  }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = b, i.addListener = b, i.once = b, i.off = b, i.removeListener = b, i.removeAllListeners = b, i.emit = b, i.prependListener = b, i.prependOnceListener = b, i.listeners = function (e) {
    return [];
  }, i.binding = function (e) {
    throw new Error("process.binding is not supported");
  }, i.cwd = function () {
    return "/";
  }, i.chdir = function (e) {
    throw new Error("process.chdir is not supported");
  }, i.umask = function () {
    return 0;
  };
}, function (e, t, r) {
  e.exports = r(109);
}, function (e, t, r) {
  "use strict";

  t.__esModule = !0;
  var n,
      i = r(60),
      o = (n = i) && n.__esModule ? n : {
    default: n
  };

  t.default = function (e) {
    return function () {
      var t = e.apply(this, arguments);
      return new o.default(function (e, r) {
        return function n(i, a) {
          try {
            var s = t[i](a),
                f = s.value;
          } catch (e) {
            return void r(e);
          }

          if (!s.done) return o.default.resolve(f).then(function (e) {
            n("next", e);
          }, function (e) {
            n("throw", e);
          });
          e(f);
        }("next");
      });
    };
  };
}, function (e, t, r) {
  var n = r(3),
      i = r(8),
      o = r(28),
      a = r(14),
      s = r(31),
      f = function f(e, t, r) {
    var c,
        u,
        d,
        h = e & f.F,
        l = e & f.G,
        p = e & f.S,
        b = e & f.P,
        v = e & f.B,
        m = e & f.W,
        y = l ? i : i[t] || (i[t] = {}),
        g = y.prototype,
        A = l ? n : p ? n[t] : (n[t] || {}).prototype;

    for (c in l && (r = t), r) {
      (u = !h && A && void 0 !== A[c]) && s(y, c) || (d = u ? A[c] : r[c], y[c] = l && "function" != typeof A[c] ? r[c] : v && u ? o(d, n) : m && A[c] == d ? function (e) {
        var t = function t(_t2, r, n) {
          if (this instanceof e) {
            switch (arguments.length) {
              case 0:
                return new e();

              case 1:
                return new e(_t2);

              case 2:
                return new e(_t2, r);
            }

            return new e(_t2, r, n);
          }

          return e.apply(this, arguments);
        };

        return t.prototype = e.prototype, t;
      }(d) : b && "function" == typeof d ? o(Function.call, d) : d, b && ((y.virtual || (y.virtual = {}))[c] = d, e & f.R && g && !g[c] && a(g, c, d)));
    }
  };

  f.F = 1, f.G = 2, f.S = 4, f.P = 8, f.B = 16, f.W = 32, f.U = 64, f.R = 128, e.exports = f;
}, function (e, t) {
  e.exports = function (e) {
    return "object" == typeof e ? null !== e : "function" == typeof e;
  };
}, function (e, t, r) {
  e.exports = !r(45)(function () {
    return 7 != Object.defineProperty({}, "a", {
      get: function get() {
        return 7;
      }
    }).a;
  });
}, function (e, t) {
  e.exports = {};
}, function (e, t, r) {
  "use strict";

  var n = r(5),
      i = r(13);

  function o() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
  }

  t.BlockHash = o, o.prototype.update = function (e, t) {
    if (e = n.toArray(e, t), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
      var r = (e = this.pending).length % this._delta8;
      this.pending = e.slice(e.length - r, e.length), 0 === this.pending.length && (this.pending = null), e = n.join32(e, 0, e.length - r, this.endian);

      for (var i = 0; i < e.length; i += this._delta32) {
        this._update(e, i, i + this._delta32);
      }
    }

    return this;
  }, o.prototype.digest = function (e) {
    return this.update(this._pad()), i(null === this.pending), this._digest(e);
  }, o.prototype._pad = function () {
    var e = this.pendingTotal,
        t = this._delta8,
        r = t - (e + this.padLength) % t,
        n = new Array(r + this.padLength);
    n[0] = 128;

    for (var i = 1; i < r; i++) {
      n[i] = 0;
    }

    if (e <<= 3, "big" === this.endian) {
      for (var o = 8; o < this.padLength; o++) {
        n[i++] = 0;
      }

      n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = e >>> 24 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 8 & 255, n[i++] = 255 & e;
    } else for (n[i++] = 255 & e, n[i++] = e >>> 8 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 24 & 255, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, o = 8; o < this.padLength; o++) {
      n[i++] = 0;
    }

    return n;
  };
}, function (e, t) {
  function r(e, t, r, n, i, o, a) {
    try {
      var s = e[o](a),
          f = s.value;
    } catch (e) {
      return void r(e);
    }

    s.done ? t(f) : Promise.resolve(f).then(n, i);
  }

  e.exports = function (e) {
    return function () {
      var t = this,
          n = arguments;
      return new Promise(function (i, o) {
        var a = e.apply(t, n);

        function s(e) {
          r(a, i, o, s, f, "next", e);
        }

        function f(e) {
          r(a, i, o, s, f, "throw", e);
        }

        s(void 0);
      });
    };
  };
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = [],
      i = "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z";
  t.definition = {
    prefix: "fas",
    iconName: "check",
    icon: [512, 512, n, "f00c", i]
  }, t.faCheck = t.definition, t.prefix = "fas", t.iconName = "check", t.width = 512, t.height = 512, t.ligatures = n, t.unicode = "f00c", t.svgPathData = i;
}, function (e, t, r) {
  var n = r(29);

  e.exports = function (e, t, r) {
    if (n(e), void 0 === t) return e;

    switch (r) {
      case 1:
        return function (r) {
          return e.call(t, r);
        };

      case 2:
        return function (r, n) {
          return e.call(t, r, n);
        };

      case 3:
        return function (r, n, i) {
          return e.call(t, r, n, i);
        };
    }

    return function () {
      return e.apply(t, arguments);
    };
  };
}, function (e, t) {
  e.exports = function (e) {
    if ("function" != typeof e) throw TypeError(e + " is not a function!");
    return e;
  };
}, function (e, t, r) {
  var n = r(12),
      i = r(115),
      o = r(116),
      a = Object.defineProperty;
  t.f = r(23) ? Object.defineProperty : function (e, t, r) {
    if (n(e), t = o(t, !0), n(r), i) try {
      return a(e, t, r);
    } catch (e) {}
    if ("get" in r || "set" in r) throw TypeError("Accessors not supported!");
    return "value" in r && (e[t] = r.value), e;
  };
}, function (e, t) {
  var r = {}.hasOwnProperty;

  e.exports = function (e, t) {
    return r.call(e, t);
  };
}, function (e, t) {
  var r = {}.toString;

  e.exports = function (e) {
    return r.call(e).slice(8, -1);
  };
}, function (e, t, r) {
  "use strict";

  var n = t;
  n.base = r(149), n.short = r(150), n.mont = r(151), n.edwards = r(152);
}, function (e, t) {
  "function" == typeof Object.create ? e.exports = function (e, t) {
    e.super_ = t, e.prototype = Object.create(t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    });
  } : e.exports = function (e, t) {
    e.super_ = t;

    var r = function r() {};

    r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
  };
}, function (e, t, r) {
  "use strict";

  (function (e) {
    var r,
        n,
        i = this && this.__awaiter || function (e, t, r, n) {
      return new (r || (r = Promise))(function (i, o) {
        function a(e) {
          try {
            f(n.next(e));
          } catch (e) {
            o(e);
          }
        }

        function s(e) {
          try {
            f(n.throw(e));
          } catch (e) {
            o(e);
          }
        }

        function f(e) {
          e.done ? i(e.value) : new r(function (t) {
            t(e.value);
          }).then(a, s);
        }

        f((n = n.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var r,
          n,
          i,
          o,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: []
      };
      return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;

      function s(o) {
        return function (s) {
          return function (o) {
            if (r) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                  case 0:
                  case 1:
                    i = o;
                    break;

                  case 4:
                    return a.label++, {
                      value: o[1],
                      done: !1
                    };

                  case 5:
                    a.label++, n = o[1], o = [0];
                    continue;

                  case 7:
                    o = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      a.label = o[1];
                      break;
                    }

                    if (6 === o[0] && a.label < i[1]) {
                      a.label = i[1], i = o;
                      break;
                    }

                    if (i && a.label < i[2]) {
                      a.label = i[2], a.ops.push(o);
                      break;
                    }

                    i[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                o = t.call(e, a);
              } catch (e) {
                o = [6, e], n = 0;
              } finally {
                r = i = 0;
              }
            }

            if (5 & o[0]) throw o[1];
            return {
              value: o[0] ? o[1] : void 0,
              done: !0
            };
          }([o, s]);
        };
      }
    };

    function a(e) {
      if ("" === e) throw new Error("Missing DID");
      var t = e.match(/^did:([a-zA-Z0-9_]+):([[a-zA-Z0-9_.-]+)(\/[^#]*)?(#.*)?$/);

      if (t) {
        var r = {
          did: t[0],
          method: t[1],
          id: t[2]
        };
        return t[3] && (r.path = t[3]), t[4] && (r.fragment = t[4].slice(1)), r;
      }

      throw new Error("Invalid DID " + e);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), r = "object" == typeof window ? window : "object" == typeof e ? e : {
      DID_REGISTRY: {}
    }, n = r.DID_REGISTRY ? r.DID_REGISTRY : r.DID_REGISTRY = {}, t.registerMethod = function (e, t) {
      n[e] = t;
    }, t.parse = a, t.default = function (e) {
      return i(this, void 0, void 0, function () {
        var t, r;
        return o(this, function (i) {
          switch (i.label) {
            case 0:
              return t = a(e), (r = n[t.method]) ? [4, r(e, t)] : [3, 2];

            case 1:
              return [2, i.sent()];

            case 2:
              throw new Error("Unsupported DID method: '" + t.method + "'");
          }
        });
      });
    };
  }).call(this, r(7));
}, function (e, t) {
  e.exports = function (e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  };
}, function (e, t) {
  function r(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  e.exports = function (e, t, n) {
    return t && r(e.prototype, t), n && r(e, n), e;
  };
}, function (e, t, r) {
  var n = r(90),
      i = r(6);

  e.exports = function (e, t) {
    return !t || "object" !== n(t) && "function" != typeof t ? i(e) : t;
  };
}, function (e, t) {
  function r(t) {
    return e.exports = r = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    }, r(t);
  }

  e.exports = r;
}, function (e, t, r) {
  var n = r(91);

  e.exports = function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && n(e, t);
  };
}, function (e, t) {
  e.exports = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };
}, function (e, t) {
  var r = Math.ceil,
      n = Math.floor;

  e.exports = function (e) {
    return isNaN(e = +e) ? 0 : (e > 0 ? n : r)(e);
  };
}, function (e, t) {
  e.exports = function (e) {
    if (null == e) throw TypeError("Can't call method on  " + e);
    return e;
  };
}, function (e, t) {
  e.exports = !0;
}, function (e, t) {
  e.exports = function (e) {
    try {
      return !!e();
    } catch (e) {
      return !0;
    }
  };
}, function (e, t, r) {
  var n = r(22),
      i = r(3).document,
      o = n(i) && n(i.createElement);

  e.exports = function (e) {
    return o ? i.createElement(e) : {};
  };
}, function (e, t, r) {
  var n = r(64),
      i = r(43);

  e.exports = function (e) {
    return n(i(e));
  };
}, function (e, t, r) {
  var n = r(66)("keys"),
      i = r(67);

  e.exports = function (e) {
    return n[e] || (n[e] = i(e));
  };
}, function (e, t, r) {
  var n = r(30).f,
      i = r(31),
      o = r(4)("toStringTag");

  e.exports = function (e, t, r) {
    e && !i(e = r ? e : e.prototype, o) && n(e, o, {
      configurable: !0,
      value: t
    });
  };
}, function (e, t, r) {
  "use strict";

  var n = r(29);

  function i(e) {
    var t, r;
    this.promise = new e(function (e, n) {
      if (void 0 !== t || void 0 !== r) throw TypeError("Bad Promise constructor");
      t = e, r = n;
    }), this.resolve = n(t), this.reject = n(r);
  }

  e.exports.f = function (e) {
    return new i(e);
  };
}, function (e, t, r) {
  var n = t;
  n.utils = r(5), n.common = r(25), n.sha = r(154), n.ripemd = r(158), n.hmac = r(159), n.sha1 = n.sha.sha1, n.sha256 = n.sha.sha256, n.sha224 = n.sha.sha224, n.sha384 = n.sha.sha384, n.sha512 = n.sha.sha512, n.ripemd160 = n.ripemd.ripemd160;
}, function (e, t, r) {
  e.exports = r(182).default, e.exports.default = e.exports;
}, function (e, t, r) {
  "use strict";

  r.r(t), function (e) {
    r.d(t, "FontAwesomeIcon", function () {
      return g;
    });
    var n = r(16),
        i = r(0),
        o = r.n(i),
        a = r(1),
        s = r.n(a);

    function f(e) {
      return (f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function c(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function u(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {},
            n = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
          return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), n.forEach(function (t) {
          c(e, t, r[t]);
        });
      }

      return e;
    }

    function d(e, t) {
      if (null == e) return {};

      var r,
          n,
          i = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            i = {},
            o = Object.keys(e);

        for (n = 0; n < o.length; n++) {
          r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        }

        return i;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (n = 0; n < o.length; n++) {
          r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
        }
      }

      return i;
    }

    function h(e) {
      return function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, r = new Array(e.length); t < e.length; t++) {
            r[t] = e[t];
          }

          return r;
        }
      }(e) || function (e) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    var l = "undefined" != typeof window ? window : void 0 !== e ? e : "undefined" != typeof self ? self : {};
    var p,
        b = (function (e) {
      var t, _r, n, i, o, a, s, f, c, u, d, h, p, b, v;

      t = l, _r = function r(e, t, n) {
        if (!f(t) || u(t) || d(t) || h(t) || s(t)) return t;
        var i,
            o = 0,
            a = 0;
        if (c(t)) for (i = [], a = t.length; o < a; o++) {
          i.push(_r(e, t[o], n));
        } else for (var l in i = {}, t) {
          Object.prototype.hasOwnProperty.call(t, l) && (i[e(l, n)] = _r(e, t[l], n));
        }
        return i;
      }, n = function n(e) {
        return p(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function (e, t) {
          return t ? t.toUpperCase() : "";
        })).substr(0, 1).toLowerCase() + e.substr(1);
      }, i = function i(e) {
        var t = n(e);
        return t.substr(0, 1).toUpperCase() + t.substr(1);
      }, o = function o(e, t) {
        return function (e, t) {
          var r = (t = t || {}).separator || "_",
              n = t.split || /(?=[A-Z])/;
          return e.split(n).join(r);
        }(e, t).toLowerCase();
      }, a = Object.prototype.toString, s = function s(e) {
        return "function" == typeof e;
      }, f = function f(e) {
        return e === Object(e);
      }, c = function c(e) {
        return "[object Array]" == a.call(e);
      }, u = function u(e) {
        return "[object Date]" == a.call(e);
      }, d = function d(e) {
        return "[object RegExp]" == a.call(e);
      }, h = function h(e) {
        return "[object Boolean]" == a.call(e);
      }, p = function p(e) {
        return (e -= 0) == e;
      }, b = function b(e, t) {
        var r = t && "process" in t ? t.process : t;
        return "function" != typeof r ? e : function (t, n) {
          return r(t, e, n);
        };
      }, v = {
        camelize: n,
        decamelize: o,
        pascalize: i,
        depascalize: o,
        camelizeKeys: function camelizeKeys(e, t) {
          return _r(b(n, t), e);
        },
        decamelizeKeys: function decamelizeKeys(e, t) {
          return _r(b(o, t), e, t);
        },
        pascalizeKeys: function pascalizeKeys(e, t) {
          return _r(b(i, t), e);
        },
        depascalizeKeys: function depascalizeKeys() {
          return this.decamelizeKeys.apply(this, arguments);
        }
      }, e.exports ? e.exports = v : t.humps = v;
    }(p = {
      exports: {}
    }, p.exports), p.exports);
    var v = !1;

    try {
      v = !0;
    } catch (e) {}

    function m(e, t) {
      return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? c({}, e, t) : {};
    }

    function y(e) {
      return null === e ? null : "object" === f(e) && e.prefix && e.iconName ? e : Array.isArray(e) && 2 === e.length ? {
        prefix: e[0],
        iconName: e[1]
      } : "string" == typeof e ? {
        prefix: "fas",
        iconName: e
      } : void 0;
    }

    function g(e) {
      var t = e.icon,
          r = e.mask,
          i = e.symbol,
          o = e.className,
          a = e.title,
          s = y(t),
          f = m("classes", [].concat(h(function (e) {
        var t,
            r = (c(t = {
          "fa-spin": e.spin,
          "fa-pulse": e.pulse,
          "fa-fw": e.fixedWidth,
          "fa-inverse": e.inverse,
          "fa-border": e.border,
          "fa-li": e.listItem,
          "fa-flip-horizontal": "horizontal" === e.flip || "both" === e.flip,
          "fa-flip-vertical": "vertical" === e.flip || "both" === e.flip
        }, "fa-".concat(e.size), null !== e.size), c(t, "fa-rotate-".concat(e.rotation), null !== e.rotation), c(t, "fa-pull-".concat(e.pull), null !== e.pull), t);
        return Object.keys(r).map(function (e) {
          return r[e] ? e : null;
        }).filter(function (e) {
          return e;
        });
      }(e)), h(o.split(" ")))),
          d = m("transform", "string" == typeof e.transform ? n.d.transform(e.transform) : e.transform),
          l = m("mask", y(r)),
          p = Object(n.b)(s, u({}, f, d, l, {
        symbol: i,
        title: a
      }));
      if (!p) return function () {
        var e;
        !v && console && "function" == typeof console.error && (e = console).error.apply(e, arguments);
      }("Could not find icon", s), null;
      var b = p.abstract,
          w = {};
      return Object.keys(e).forEach(function (t) {
        g.defaultProps.hasOwnProperty(t) || (w[t] = e[t]);
      }), A(b[0], w);
    }

    g.displayName = "FontAwesomeIcon", g.propTypes = {
      border: o.a.bool,
      className: o.a.string,
      mask: o.a.oneOfType([o.a.object, o.a.array, o.a.string]),
      fixedWidth: o.a.bool,
      inverse: o.a.bool,
      flip: o.a.oneOf(["horizontal", "vertical", "both"]),
      icon: o.a.oneOfType([o.a.object, o.a.array, o.a.string]),
      listItem: o.a.bool,
      pull: o.a.oneOf(["right", "left"]),
      pulse: o.a.bool,
      rotation: o.a.oneOf([90, 180, 270]),
      size: o.a.oneOf(["lg", "xs", "sm", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
      spin: o.a.bool,
      symbol: o.a.oneOfType([o.a.bool, o.a.string]),
      title: o.a.string,
      transform: o.a.oneOfType([o.a.string, o.a.object])
    }, g.defaultProps = {
      border: !1,
      className: "",
      mask: null,
      fixedWidth: !1,
      inverse: !1,
      flip: null,
      icon: null,
      listItem: !1,
      pull: null,
      pulse: !1,
      rotation: null,
      size: null,
      spin: !1,
      symbol: !1,
      title: "",
      transform: null
    };

    var A = function e(t, r) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      if ("string" == typeof r) return r;
      var i = (r.children || []).map(function (r) {
        return e(t, r);
      }),
          o = Object.keys(r.attributes || {}).reduce(function (e, t) {
        var n = r.attributes[t];

        switch (t) {
          case "class":
            e.attrs.className = n, delete r.attributes.class;
            break;

          case "style":
            e.attrs.style = n.split(";").map(function (e) {
              return e.trim();
            }).filter(function (e) {
              return e;
            }).reduce(function (e, t) {
              var r,
                  n = t.indexOf(":"),
                  i = b.camelize(t.slice(0, n)),
                  o = t.slice(n + 1).trim();
              return i.startsWith("webkit") ? e[(r = i, r.charAt(0).toUpperCase() + r.slice(1))] = o : e[i] = o, e;
            }, {});
            break;

          default:
            0 === t.indexOf("aria-") || 0 === t.indexOf("data-") ? e.attrs[t.toLowerCase()] = n : e.attrs[b.camelize(t)] = n;
        }

        return e;
      }, {
        attrs: {}
      }),
          a = n.style,
          s = void 0 === a ? {} : a,
          f = d(n, ["style"]);
      return o.attrs.style = u({}, o.attrs.style, s), t.apply(void 0, [r.tag, u({}, o.attrs, f)].concat(h(i)));
    }.bind(null, s.a.createElement);
  }.call(this, r(7));
}, function (e, t, r) {
  "use strict";

  var n = r(41),
      i = n(r(15)),
      o = n(r(26)),
      a = r(92).request,
      s = r(57),
      f = r(106),
      c = r(193),
      u = c.graphql_server_url,
      d = c.profile_server_url,
      h = c.address_server_url;

  function l() {
    return (l = (0, o.default)(i.default.mark(function e(t) {
      var r,
          n,
          o = arguments;
      return i.default.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return r = o.length > 1 && void 0 !== o[1] ? o[1] : h, e.next = 3, s.fetchJson(r + "/odbAddress/" + t);

            case 3:
              if ("success" !== (n = e.sent).status) {
                e.next = 8;
                break;
              }

              return e.abrupt("return", n.data.rootStoreAddress);

            case 8:
              throw new Error(n.message);

            case 9:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    }))).apply(this, arguments);
  }

  function p() {
    return (p = (0, o.default)(i.default.mark(function e(t) {
      var r,
          n = arguments;
      return i.default.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return r = n.length > 1 && void 0 !== n[1] ? n[1] : d, e.abrupt("return", new Promise(function () {
                var e = (0, o.default)(i.default.mark(function e(n, o) {
                  var a;
                  return i.default.wrap(function (e) {
                    for (;;) {
                      switch (e.prev = e.next) {
                        case 0:
                          return e.prev = 0, e.next = 3, s.fetchJson(r + "/profile?address=" + encodeURIComponent(t));

                        case 3:
                          a = e.sent, n(a), e.next = 10;
                          break;

                        case 7:
                          e.prev = 7, e.t0 = e.catch(0), o(e.t0);

                        case 10:
                        case "end":
                          return e.stop();
                      }
                    }
                  }, e, this, [[0, 7]]);
                }));
                return function (t, r) {
                  return e.apply(this, arguments);
                };
              }()));

            case 2:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    }))).apply(this, arguments);
  }

  function b() {
    return (b = (0, o.default)(i.default.mark(function e(t) {
      var r,
          n,
          o,
          a = arguments;
      return i.default.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return r = a.length > 1 && void 0 !== a[1] ? a[1] : {}, r = Object.assign({
                profileServer: d
              }, r), n = {
                addressList: t
              }, o = "".concat(r.profileServer, "/profileList"), e.abrupt("return", s.fetchJson(o, n));

            case 5:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    }))).apply(this, arguments);
  }

  function v() {
    return (v = (0, o.default)(i.default.mark(function e(t) {
      var r,
          n = arguments;
      return i.default.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return r = n.length > 1 && void 0 !== n[1] ? n[1] : {}, r = Object.assign({
                graphqlServer: u
              }, r), e.abrupt("return", a(r.graphqlServer, t));

            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    }))).apply(this, arguments);
  }

  function m() {
    return (m = (0, o.default)(i.default.mark(function e(t) {
      var r, n;
      return i.default.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return r = {}, e.prev = 1, e.next = 4, f.verifyDID(t.proof_did);

            case 4:
              if (n = e.sent, !t.proof_github) {
                e.next = 14;
                break;
              }

              return e.prev = 6, e.next = 9, f.verifyGithub(n, t.proof_github);

            case 9:
              r.github = e.sent, e.next = 14;
              break;

            case 12:
              e.prev = 12, e.t0 = e.catch(6);

            case 14:
              if (!t.proof_twitter) {
                e.next = 23;
                break;
              }

              return e.prev = 15, e.next = 18, f.verifyTwitter(n, t.proof_twitter);

            case 18:
              r.twitter = e.sent, e.next = 23;
              break;

            case 21:
              e.prev = 21, e.t1 = e.catch(15);

            case 23:
              e.next = 27;
              break;

            case 25:
              e.prev = 25, e.t2 = e.catch(1);

            case 27:
              return e.abrupt("return", r);

            case 28:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[1, 25], [6, 12], [15, 21]]);
    }))).apply(this, arguments);
  }

  e.exports = {
    profileGraphQL: function profileGraphQL(e) {
      return v.apply(this, arguments);
    },
    getProfile: function getProfile(e) {
      return p.apply(this, arguments);
    },
    getRootStoreAddress: function getRootStoreAddress(e) {
      return l.apply(this, arguments);
    },
    getProfiles: function getProfiles(e) {
      return b.apply(this, arguments);
    },
    getVerifiedAccounts: function getVerifiedAccounts(e) {
      return m.apply(this, arguments);
    }
  };
}, function (e, t, r) {
  var n;
  n = function n() {
    return function (e) {
      var t = {};

      function r(n) {
        if (t[n]) return t[n].exports;
        var i = t[n] = {
          exports: {},
          id: n,
          loaded: !1
        };
        return e[n].call(i.exports, i, i.exports, r), i.loaded = !0, i.exports;
      }

      return r.m = e, r.c = t, r.p = "", r(0);
    }([function (e, t, r) {
      var n = r(1),
          i = r(2),
          o = new Array(4);

      function a() {
        var e = o[0] ^ o[0] << 11;
        return o[0] = o[1], o[1] = o[2], o[2] = o[3], o[3] = o[3] ^ o[3] >> 19 ^ e ^ e >> 8, (o[3] >>> 0) / (1 << 31 >>> 0);
      }

      function s() {
        return [Math.floor(360 * a()) / 360, (60 * a() + 40) / 100, 25 * (a() + a() + a() + a()) / 100];
      }

      function f(e, t, r, n, i, o) {
        for (var _a = 0; _a < n; _a++) {
          for (var _n = 0; _n < i; _n++) {
            e.buffer[e.index(t + _a, r + _n)] = o;
          }
        }
      }

      function c(e) {
        if (!e.seed) throw new Error("No seed provided");
        return function (e) {
          for (var _e3 = 0; _e3 < o.length; _e3++) {
            o[_e3] = 0;
          }

          for (var _t3 = 0; _t3 < e.length; _t3++) {
            o[_t3 % 4] = (o[_t3 % 4] << 5) - o[_t3 % 4] + e.charCodeAt(_t3);
          }
        }(e.seed), Object.assign({
          size: 8,
          scale: 16,
          color: s(),
          bgcolor: s(),
          spotcolor: s()
        }, e);
      }

      e.exports = function (e) {
        var t = c({
          seed: e.toLowerCase()
        }),
            r = function (e) {
          var t = e,
              r = e,
              n = Math.ceil(t / 2),
              i = t - n,
              o = [];

          for (var _e4 = 0; _e4 < r; _e4++) {
            var _e5 = [];

            for (var _t5 = 0; _t5 < n; _t5++) {
              _e5[_t5] = Math.floor(2.3 * a());
            }

            var _t4 = _e5.slice(0, i).reverse();

            _e5 = _e5.concat(_t4);

            for (var _t6 = 0; _t6 < _e5.length; _t6++) {
              o.push(_e5[_t6]);
            }
          }

          return o;
        }(t.size),
            o = Math.sqrt(r.length),
            s = new n(t.size * t.scale, t.size * t.scale, 3),
            u = (s.color.apply(s, _toConsumableArray(i.apply(void 0, _toConsumableArray(t.bgcolor)))), s.color.apply(s, _toConsumableArray(i.apply(void 0, _toConsumableArray(t.color))))),
            d = s.color.apply(s, _toConsumableArray(i.apply(void 0, _toConsumableArray(t.spotcolor))));

        for (var _e6 = 0; _e6 < r.length; _e6++) {
          var _n2 = Math.floor(_e6 / o),
              _i = _e6 % o;

          if (r[_e6]) {
            var _o = 1 == r[_e6] ? u : d;

            f(s, _i * t.scale, _n2 * t.scale, t.scale, t.scale, _o);
          }
        }

        return "data:image/png;base64,".concat(s.getBase64());
      };
    }, function (e, t) {
      /**
      	 * A handy class to calculate color values.
      	 *
      	 * @version 1.0
      	 * @author Robert Eisele <robert@xarg.org>
      	 * @copyright Copyright (c) 2010, Robert Eisele
      	 * @link http://www.xarg.org/2010/03/generate-client-side-png-files-using-javascript/
      	 * @license http://www.opensource.org/licenses/bsd-license.php BSD License
      	 *
      	 */
      e.exports = function (e, t, r) {
        function n(e, t) {
          for (var r = 2; r < arguments.length; r++) {
            for (var n = 0; n < arguments[r].length; n++) {
              e[t++] = arguments[r].charAt(n);
            }
          }
        }

        function i(e) {
          return String.fromCharCode(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, 255 & e);
        }

        function o(e) {
          return String.fromCharCode(255 & e, e >> 8 & 255);
        }

        this.width = e, this.height = t, this.depth = r, this.pix_size = t * (e + 1), this.data_size = 2 + this.pix_size + 5 * Math.floor((65534 + this.pix_size) / 65535) + 4, this.ihdr_offs = 0, this.ihdr_size = 25, this.plte_offs = this.ihdr_offs + this.ihdr_size, this.plte_size = 8 + 3 * r + 4, this.trns_offs = this.plte_offs + this.plte_size, this.trns_size = 8 + r + 4, this.idat_offs = this.trns_offs + this.trns_size, this.idat_size = 8 + this.data_size + 4, this.iend_offs = this.idat_offs + this.idat_size, this.iend_size = 12, this.buffer_size = this.iend_offs + this.iend_size, this.buffer = new Array(), this.palette = new Object(), this.pindex = 0;

        for (var a = new Array(), s = 0; s < this.buffer_size; s++) {
          this.buffer[s] = "\0";
        }

        n(this.buffer, this.ihdr_offs, i(this.ihdr_size - 12), "IHDR", i(e), i(t), "\b"), n(this.buffer, this.plte_offs, i(this.plte_size - 12), "PLTE"), n(this.buffer, this.trns_offs, i(this.trns_size - 12), "tRNS"), n(this.buffer, this.idat_offs, i(this.idat_size - 12), "IDAT"), n(this.buffer, this.iend_offs, i(this.iend_size - 12), "IEND");
        var f,
            c = 30912;
        c += 31 - c % 31, n(this.buffer, this.idat_offs + 8, (f = c, String.fromCharCode(f >> 8 & 255, 255 & f)));

        for (s = 0; (s << 16) - 1 < this.pix_size; s++) {
          var u, d;
          s + 65535 < this.pix_size ? (u = 65535, d = "\0") : (u = this.pix_size - (s << 16) - s, d = ""), n(this.buffer, this.idat_offs + 8 + 2 + (s << 16) + (s << 2), d, o(u), o(~u));
        }

        for (s = 0; s < 256; s++) {
          for (var h = s, l = 0; l < 8; l++) {
            h = 1 & h ? -306674912 ^ h >> 1 & 2147483647 : h >> 1 & 2147483647;
          }

          a[s] = h;
        }

        this.index = function (e, t) {
          var r = t * (this.width + 1) + e + 1;
          return this.idat_offs + 8 + 2 + 5 * Math.floor(r / 65535 + 1) + r;
        }, this.color = function (e, t, r, n) {
          var i = (((n = n >= 0 ? n : 255) << 8 | e) << 8 | t) << 8 | r;

          if (void 0 === this.palette[i]) {
            if (this.pindex == this.depth) return "\0";
            var o = this.plte_offs + 8 + 3 * this.pindex;
            this.buffer[o + 0] = String.fromCharCode(e), this.buffer[o + 1] = String.fromCharCode(t), this.buffer[o + 2] = String.fromCharCode(r), this.buffer[this.trns_offs + 8 + this.pindex] = String.fromCharCode(n), this.palette[i] = String.fromCharCode(this.pindex++);
          }

          return this.palette[i];
        }, this.getBase64 = function () {
          var e,
              t,
              r,
              n,
              i,
              o,
              a,
              s = this.getDump(),
              f = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
              c = s.length,
              u = 0,
              d = "";

          do {
            n = (e = s.charCodeAt(u)) >> 2, i = (3 & e) << 4 | (t = s.charCodeAt(u + 1)) >> 4, r = s.charCodeAt(u + 2), o = c < u + 2 ? 64 : (15 & t) << 2 | r >> 6, a = c < u + 3 ? 64 : 63 & r, d += f.charAt(n) + f.charAt(i) + f.charAt(o) + f.charAt(a);
          } while ((u += 3) < c);

          return d;
        }, this.getDump = function () {
          for (var e = 1, t = 0, r = 5552, o = 0; o < this.height; o++) {
            for (var s = -1; s < this.width; s++) {
              t += e += this.buffer[this.index(s, o)].charCodeAt(0), 0 == (r -= 1) && (e %= 65521, t %= 65521, r = 5552);
            }
          }

          function f(e, t, r) {
            for (var o = -1, s = 4; s < r - 4; s += 1) {
              o = a[255 & (o ^ e[t + s].charCodeAt(0))] ^ o >> 8 & 16777215;
            }

            n(e, t + r - 4, i(-1 ^ o));
          }

          return e %= 65521, t %= 65521, n(this.buffer, this.idat_offs + this.idat_size - 8, i(t << 16 | e)), f(this.buffer, this.ihdr_offs, this.ihdr_size), f(this.buffer, this.plte_offs, this.plte_size), f(this.buffer, this.trns_offs, this.trns_size), f(this.buffer, this.idat_offs, this.idat_size), f(this.buffer, this.iend_offs, this.iend_size), "PNG\r\n\n" + this.buffer.join("");
        };
      };
    }, function (e, t) {
      function r(e, t, r) {
        return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? e + 6 * (t - e) * r : r < .5 ? t : r < 2 / 3 ? e + (t - e) * (2 / 3 - r) * 6 : e;
      }

      e.exports = function (e, t, n) {
        var i, o, a;
        if (0 == t) i = o = a = n;else {
          var s = n < .5 ? n * (1 + t) : n + t - n * t,
              f = 2 * n - s;
          i = r(f, s, e + 1 / 3), o = r(f, s, e), a = r(f, s, e - 1 / 3);
        }
        return [Math.round(255 * i), Math.round(255 * o), Math.round(255 * a), 255];
      };
    }]);
  }, e.exports = n();
}, function (e, t, r) {
  "use strict";

  var n,
      i = this && this.__extends || (n = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (e, t) {
    e.__proto__ = t;
  } || function (e, t) {
    for (var r in t) {
      t.hasOwnProperty(r) && (e[r] = t[r]);
    }
  }, function (e, t) {
    function r() {
      this.constructor = e;
    }

    n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
  });
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = function (e) {
    function t(r, n) {
      var i = this,
          o = t.extractMessage(r) + ": " + JSON.stringify({
        response: r,
        request: n
      });
      return (i = e.call(this, o) || this).response = r, i.request = n, "function" == typeof Error.captureStackTrace && Error.captureStackTrace(i, t), i;
    }

    return i(t, e), t.extractMessage = function (e) {
      try {
        return e.errors[0].message;
      } catch (t) {
        return "GraphQL Error (Code: " + e.status + ")";
      }
    }, t;
  }(Error);

  t.ClientError = o;
}, function (e, t, r) {
  "use strict";

  (function (t) {
    var n,
        i,
        o = r(41),
        a = o(r(15)),
        s = o(r(26)),
        f = "undefined" != typeof window ? window.fetch : r(97),
        c = r(98),
        u = r(58).sha256;
    e.exports = {
      openBoxConsent: function openBoxConsent(e, r) {
        var n = ["0x" + t.from("This app wants to view and update your 3Box profile.", "utf8").toString("hex"), e];
        return new Promise(function (t, i) {
          r.sendAsync({
            method: "personal_sign",
            params: n,
            fromAddress: e
          }, function (e, r) {
            e && i(e), r.error && i(r.error), t(r.result);
          });
        });
      },
      openSpaceConsent: function openSpaceConsent(e, r, n) {
        var i = "Allow this app to open your ".concat(n, " space."),
            o = ["0x" + t.from(i, "utf8").toString("hex"), e];
        return new Promise(function (t, n) {
          r.sendAsync({
            method: "personal_sign",
            params: o,
            fromAddress: e
          }, function (e, r) {
            e && n(e), r.error && n(r.error), t(r.result);
          });
        });
      },
      getLinkConsent: function getLinkConsent(e, r, n) {
        var i = "Create a new 3Box profile\n\n- \nYour unique profile ID is " + r,
            o = ["0x" + t.from(i, "utf8").toString("hex"), e];
        return new Promise(function (t, r) {
          n.sendAsync({
            method: "personal_sign",
            params: o,
            fromAddress: e
          }, function (e, n) {
            e && r(e), n.error && r(n.error);
            var o = {
              msg: i,
              sig: n.result
            };
            t(o);
          });
        });
      },
      fetchJson: (i = (0, s.default)(a.default.mark(function e(t, r) {
        var n;
        return a.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return r && (n = {
                  body: JSON.stringify(r),
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json"
                  }
                }), e.next = 3, f(t, n);

              case 3:
                return e.abrupt("return", e.sent.json());

              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, t) {
        return i.apply(this, arguments);
      }),
      fetchText: (n = (0, s.default)(a.default.mark(function e(t, r) {
        return a.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, f(t, r);

              case 2:
                return e.abrupt("return", e.sent.text());

              case 3:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, t) {
        return n.apply(this, arguments);
      }),
      sha256Multihash: function sha256Multihash(e) {
        var r = t.from(u.digest(e));
        return c.encode(r, "sha2-256").toString("hex");
      },
      sha256: u
    };
  }).call(this, r(11).Buffer);
}, function (module, exports, __webpack_require__) {
  (function (process, global) {
    var __WEBPACK_AMD_DEFINE_RESULT__;
    /**
     * [js-sha256]{@link https://github.com/emn178/js-sha256}
     *
     * @version 0.9.0
     * @author Chen, Yi-Cyuan [emn178@gmail.com]
     * @copyright Chen, Yi-Cyuan 2014-2017
     * @license MIT
     */

    /**
     * [js-sha256]{@link https://github.com/emn178/js-sha256}
     *
     * @version 0.9.0
     * @author Chen, Yi-Cyuan [emn178@gmail.com]
     * @copyright Chen, Yi-Cyuan 2014-2017
     * @license MIT
     */


    !function () {
      "use strict";

      var ERROR = "input is invalid type",
          WINDOW = "object" == typeof window,
          root = WINDOW ? window : {};
      root.JS_SHA256_NO_WINDOW && (WINDOW = !1);
      var WEB_WORKER = !WINDOW && "object" == typeof self,
          NODE_JS = !root.JS_SHA256_NO_NODE_JS && "object" == typeof process && process.versions && process.versions.node;
      NODE_JS ? root = global : WEB_WORKER && (root = self);

      var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && "object" == typeof module && module.exports,
          AMD = __webpack_require__(59),
          ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer,
          HEX_CHARS = "0123456789abcdef".split(""),
          EXTRA = [-2147483648, 8388608, 32768, 128],
          SHIFT = [24, 16, 8, 0],
          K = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298],
          OUTPUT_TYPES = ["hex", "array", "digest", "arrayBuffer"],
          blocks = [];

      !root.JS_SHA256_NO_NODE_JS && Array.isArray || (Array.isArray = function (e) {
        return "[object Array]" === Object.prototype.toString.call(e);
      }), !ARRAY_BUFFER || !root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function (e) {
        return "object" == typeof e && e.buffer && e.buffer.constructor === ArrayBuffer;
      });

      var createOutputMethod = function createOutputMethod(e, t) {
        return function (r) {
          return new Sha256(t, !0).update(r)[e]();
        };
      },
          createMethod = function createMethod(e) {
        var t = createOutputMethod("hex", e);
        NODE_JS && (t = nodeWrap(t, e)), t.create = function () {
          return new Sha256(e);
        }, t.update = function (e) {
          return t.create().update(e);
        };

        for (var r = 0; r < OUTPUT_TYPES.length; ++r) {
          var n = OUTPUT_TYPES[r];
          t[n] = createOutputMethod(n, e);
        }

        return t;
      },
          nodeWrap = function nodeWrap(method, is224) {
        var crypto = eval("require('crypto')"),
            Buffer = eval("require('buffer').Buffer"),
            algorithm = is224 ? "sha224" : "sha256",
            nodeMethod = function nodeMethod(e) {
          if ("string" == typeof e) return crypto.createHash(algorithm).update(e, "utf8").digest("hex");
          if (null == e) throw new Error(ERROR);
          return e.constructor === ArrayBuffer && (e = new Uint8Array(e)), Array.isArray(e) || ArrayBuffer.isView(e) || e.constructor === Buffer ? crypto.createHash(algorithm).update(new Buffer(e)).digest("hex") : method(e);
        };

        return nodeMethod;
      },
          createHmacOutputMethod = function createHmacOutputMethod(e, t) {
        return function (r, n) {
          return new HmacSha256(r, t, !0).update(n)[e]();
        };
      },
          createHmacMethod = function createHmacMethod(e) {
        var t = createHmacOutputMethod("hex", e);
        t.create = function (t) {
          return new HmacSha256(t, e);
        }, t.update = function (e, r) {
          return t.create(e).update(r);
        };

        for (var r = 0; r < OUTPUT_TYPES.length; ++r) {
          var n = OUTPUT_TYPES[r];
          t[n] = createHmacOutputMethod(n, e);
        }

        return t;
      };

      function Sha256(e, t) {
        t ? (blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0, this.blocks = blocks) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], e ? (this.h0 = 3238371032, this.h1 = 914150663, this.h2 = 812702999, this.h3 = 4144912697, this.h4 = 4290775857, this.h5 = 1750603025, this.h6 = 1694076839, this.h7 = 3204075428) : (this.h0 = 1779033703, this.h1 = 3144134277, this.h2 = 1013904242, this.h3 = 2773480762, this.h4 = 1359893119, this.h5 = 2600822924, this.h6 = 528734635, this.h7 = 1541459225), this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0, this.is224 = e;
      }

      function HmacSha256(e, t, r) {
        var n,
            i = typeof e;

        if ("string" === i) {
          var o,
              a = [],
              s = e.length,
              f = 0;

          for (n = 0; n < s; ++n) {
            (o = e.charCodeAt(n)) < 128 ? a[f++] = o : o < 2048 ? (a[f++] = 192 | o >> 6, a[f++] = 128 | 63 & o) : o < 55296 || o >= 57344 ? (a[f++] = 224 | o >> 12, a[f++] = 128 | o >> 6 & 63, a[f++] = 128 | 63 & o) : (o = 65536 + ((1023 & o) << 10 | 1023 & e.charCodeAt(++n)), a[f++] = 240 | o >> 18, a[f++] = 128 | o >> 12 & 63, a[f++] = 128 | o >> 6 & 63, a[f++] = 128 | 63 & o);
          }

          e = a;
        } else {
          if ("object" !== i) throw new Error(ERROR);
          if (null === e) throw new Error(ERROR);
          if (ARRAY_BUFFER && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || ARRAY_BUFFER && ArrayBuffer.isView(e))) throw new Error(ERROR);
        }

        e.length > 64 && (e = new Sha256(t, !0).update(e).array());
        var c = [],
            u = [];

        for (n = 0; n < 64; ++n) {
          var d = e[n] || 0;
          c[n] = 92 ^ d, u[n] = 54 ^ d;
        }

        Sha256.call(this, t, r), this.update(u), this.oKeyPad = c, this.inner = !0, this.sharedMemory = r;
      }

      Sha256.prototype.update = function (e) {
        if (!this.finalized) {
          var t,
              r = typeof e;

          if ("string" !== r) {
            if ("object" !== r) throw new Error(ERROR);
            if (null === e) throw new Error(ERROR);
            if (ARRAY_BUFFER && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || ARRAY_BUFFER && ArrayBuffer.isView(e))) throw new Error(ERROR);
            t = !0;
          }

          for (var n, i, o = 0, a = e.length, s = this.blocks; o < a;) {
            if (this.hashed && (this.hashed = !1, s[0] = this.block, s[16] = s[1] = s[2] = s[3] = s[4] = s[5] = s[6] = s[7] = s[8] = s[9] = s[10] = s[11] = s[12] = s[13] = s[14] = s[15] = 0), t) for (i = this.start; o < a && i < 64; ++o) {
              s[i >> 2] |= e[o] << SHIFT[3 & i++];
            } else for (i = this.start; o < a && i < 64; ++o) {
              (n = e.charCodeAt(o)) < 128 ? s[i >> 2] |= n << SHIFT[3 & i++] : n < 2048 ? (s[i >> 2] |= (192 | n >> 6) << SHIFT[3 & i++], s[i >> 2] |= (128 | 63 & n) << SHIFT[3 & i++]) : n < 55296 || n >= 57344 ? (s[i >> 2] |= (224 | n >> 12) << SHIFT[3 & i++], s[i >> 2] |= (128 | n >> 6 & 63) << SHIFT[3 & i++], s[i >> 2] |= (128 | 63 & n) << SHIFT[3 & i++]) : (n = 65536 + ((1023 & n) << 10 | 1023 & e.charCodeAt(++o)), s[i >> 2] |= (240 | n >> 18) << SHIFT[3 & i++], s[i >> 2] |= (128 | n >> 12 & 63) << SHIFT[3 & i++], s[i >> 2] |= (128 | n >> 6 & 63) << SHIFT[3 & i++], s[i >> 2] |= (128 | 63 & n) << SHIFT[3 & i++]);
            }
            this.lastByteIndex = i, this.bytes += i - this.start, i >= 64 ? (this.block = s[16], this.start = i - 64, this.hash(), this.hashed = !0) : this.start = i;
          }

          return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
        }
      }, Sha256.prototype.finalize = function () {
        if (!this.finalized) {
          this.finalized = !0;
          var e = this.blocks,
              t = this.lastByteIndex;
          e[16] = this.block, e[t >> 2] |= EXTRA[3 & t], this.block = e[16], t >= 56 && (this.hashed || this.hash(), e[0] = this.block, e[16] = e[1] = e[2] = e[3] = e[4] = e[5] = e[6] = e[7] = e[8] = e[9] = e[10] = e[11] = e[12] = e[13] = e[14] = e[15] = 0), e[14] = this.hBytes << 3 | this.bytes >>> 29, e[15] = this.bytes << 3, this.hash();
        }
      }, Sha256.prototype.hash = function () {
        var e,
            t,
            r,
            n,
            i,
            o,
            a,
            s,
            f,
            c = this.h0,
            u = this.h1,
            d = this.h2,
            h = this.h3,
            l = this.h4,
            p = this.h5,
            b = this.h6,
            v = this.h7,
            m = this.blocks;

        for (e = 16; e < 64; ++e) {
          t = ((i = m[e - 15]) >>> 7 | i << 25) ^ (i >>> 18 | i << 14) ^ i >>> 3, r = ((i = m[e - 2]) >>> 17 | i << 15) ^ (i >>> 19 | i << 13) ^ i >>> 10, m[e] = m[e - 16] + t + m[e - 7] + r << 0;
        }

        for (f = u & d, e = 0; e < 64; e += 4) {
          this.first ? (this.is224 ? (o = 300032, v = (i = m[0] - 1413257819) - 150054599 << 0, h = i + 24177077 << 0) : (o = 704751109, v = (i = m[0] - 210244248) - 1521486534 << 0, h = i + 143694565 << 0), this.first = !1) : (t = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10), n = (o = c & u) ^ c & d ^ f, v = h + (i = v + (r = (l >>> 6 | l << 26) ^ (l >>> 11 | l << 21) ^ (l >>> 25 | l << 7)) + (l & p ^ ~l & b) + K[e] + m[e]) << 0, h = i + (t + n) << 0), t = (h >>> 2 | h << 30) ^ (h >>> 13 | h << 19) ^ (h >>> 22 | h << 10), n = (a = h & c) ^ h & u ^ o, b = d + (i = b + (r = (v >>> 6 | v << 26) ^ (v >>> 11 | v << 21) ^ (v >>> 25 | v << 7)) + (v & l ^ ~v & p) + K[e + 1] + m[e + 1]) << 0, t = ((d = i + (t + n) << 0) >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10), n = (s = d & h) ^ d & c ^ a, p = u + (i = p + (r = (b >>> 6 | b << 26) ^ (b >>> 11 | b << 21) ^ (b >>> 25 | b << 7)) + (b & v ^ ~b & l) + K[e + 2] + m[e + 2]) << 0, t = ((u = i + (t + n) << 0) >>> 2 | u << 30) ^ (u >>> 13 | u << 19) ^ (u >>> 22 | u << 10), n = (f = u & d) ^ u & h ^ s, l = c + (i = l + (r = (p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + (p & b ^ ~p & v) + K[e + 3] + m[e + 3]) << 0, c = i + (t + n) << 0;
        }

        this.h0 = this.h0 + c << 0, this.h1 = this.h1 + u << 0, this.h2 = this.h2 + d << 0, this.h3 = this.h3 + h << 0, this.h4 = this.h4 + l << 0, this.h5 = this.h5 + p << 0, this.h6 = this.h6 + b << 0, this.h7 = this.h7 + v << 0;
      }, Sha256.prototype.hex = function () {
        this.finalize();
        var e = this.h0,
            t = this.h1,
            r = this.h2,
            n = this.h3,
            i = this.h4,
            o = this.h5,
            a = this.h6,
            s = this.h7,
            f = HEX_CHARS[e >> 28 & 15] + HEX_CHARS[e >> 24 & 15] + HEX_CHARS[e >> 20 & 15] + HEX_CHARS[e >> 16 & 15] + HEX_CHARS[e >> 12 & 15] + HEX_CHARS[e >> 8 & 15] + HEX_CHARS[e >> 4 & 15] + HEX_CHARS[15 & e] + HEX_CHARS[t >> 28 & 15] + HEX_CHARS[t >> 24 & 15] + HEX_CHARS[t >> 20 & 15] + HEX_CHARS[t >> 16 & 15] + HEX_CHARS[t >> 12 & 15] + HEX_CHARS[t >> 8 & 15] + HEX_CHARS[t >> 4 & 15] + HEX_CHARS[15 & t] + HEX_CHARS[r >> 28 & 15] + HEX_CHARS[r >> 24 & 15] + HEX_CHARS[r >> 20 & 15] + HEX_CHARS[r >> 16 & 15] + HEX_CHARS[r >> 12 & 15] + HEX_CHARS[r >> 8 & 15] + HEX_CHARS[r >> 4 & 15] + HEX_CHARS[15 & r] + HEX_CHARS[n >> 28 & 15] + HEX_CHARS[n >> 24 & 15] + HEX_CHARS[n >> 20 & 15] + HEX_CHARS[n >> 16 & 15] + HEX_CHARS[n >> 12 & 15] + HEX_CHARS[n >> 8 & 15] + HEX_CHARS[n >> 4 & 15] + HEX_CHARS[15 & n] + HEX_CHARS[i >> 28 & 15] + HEX_CHARS[i >> 24 & 15] + HEX_CHARS[i >> 20 & 15] + HEX_CHARS[i >> 16 & 15] + HEX_CHARS[i >> 12 & 15] + HEX_CHARS[i >> 8 & 15] + HEX_CHARS[i >> 4 & 15] + HEX_CHARS[15 & i] + HEX_CHARS[o >> 28 & 15] + HEX_CHARS[o >> 24 & 15] + HEX_CHARS[o >> 20 & 15] + HEX_CHARS[o >> 16 & 15] + HEX_CHARS[o >> 12 & 15] + HEX_CHARS[o >> 8 & 15] + HEX_CHARS[o >> 4 & 15] + HEX_CHARS[15 & o] + HEX_CHARS[a >> 28 & 15] + HEX_CHARS[a >> 24 & 15] + HEX_CHARS[a >> 20 & 15] + HEX_CHARS[a >> 16 & 15] + HEX_CHARS[a >> 12 & 15] + HEX_CHARS[a >> 8 & 15] + HEX_CHARS[a >> 4 & 15] + HEX_CHARS[15 & a];
        return this.is224 || (f += HEX_CHARS[s >> 28 & 15] + HEX_CHARS[s >> 24 & 15] + HEX_CHARS[s >> 20 & 15] + HEX_CHARS[s >> 16 & 15] + HEX_CHARS[s >> 12 & 15] + HEX_CHARS[s >> 8 & 15] + HEX_CHARS[s >> 4 & 15] + HEX_CHARS[15 & s]), f;
      }, Sha256.prototype.toString = Sha256.prototype.hex, Sha256.prototype.digest = function () {
        this.finalize();
        var e = this.h0,
            t = this.h1,
            r = this.h2,
            n = this.h3,
            i = this.h4,
            o = this.h5,
            a = this.h6,
            s = this.h7,
            f = [e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, 255 & e, t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, 255 & t, r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, 255 & r, n >> 24 & 255, n >> 16 & 255, n >> 8 & 255, 255 & n, i >> 24 & 255, i >> 16 & 255, i >> 8 & 255, 255 & i, o >> 24 & 255, o >> 16 & 255, o >> 8 & 255, 255 & o, a >> 24 & 255, a >> 16 & 255, a >> 8 & 255, 255 & a];
        return this.is224 || f.push(s >> 24 & 255, s >> 16 & 255, s >> 8 & 255, 255 & s), f;
      }, Sha256.prototype.array = Sha256.prototype.digest, Sha256.prototype.arrayBuffer = function () {
        this.finalize();
        var e = new ArrayBuffer(this.is224 ? 28 : 32),
            t = new DataView(e);
        return t.setUint32(0, this.h0), t.setUint32(4, this.h1), t.setUint32(8, this.h2), t.setUint32(12, this.h3), t.setUint32(16, this.h4), t.setUint32(20, this.h5), t.setUint32(24, this.h6), this.is224 || t.setUint32(28, this.h7), e;
      }, HmacSha256.prototype = new Sha256(), HmacSha256.prototype.finalize = function () {
        if (Sha256.prototype.finalize.call(this), this.inner) {
          this.inner = !1;
          var e = this.array();
          Sha256.call(this, this.is224, this.sharedMemory), this.update(this.oKeyPad), this.update(e), Sha256.prototype.finalize.call(this);
        }
      };
      var exports = createMethod();
      exports.sha256 = exports, exports.sha224 = createMethod(!0), exports.sha256.hmac = createHmacMethod(), exports.sha224.hmac = createHmacMethod(!0), COMMON_JS ? module.exports = exports : (root.sha256 = exports.sha256, root.sha224 = exports.sha224, AMD && (__WEBPACK_AMD_DEFINE_RESULT__ = function () {
        return exports;
      }.call(exports, __webpack_require__, exports, module), void 0 === __WEBPACK_AMD_DEFINE_RESULT__ || (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)));
    }();
  }).call(this, __webpack_require__(18), __webpack_require__(7));
}, function (e, t) {
  (function (t) {
    e.exports = t;
  }).call(this, {});
}, function (e, t, r) {
  e.exports = {
    default: r(111),
    __esModule: !0
  };
}, function (e, t, r) {
  "use strict";

  var n = r(44),
      i = r(21),
      o = r(117),
      a = r(14),
      s = r(24),
      f = r(118),
      c = r(49),
      u = r(124),
      d = r(4)("iterator"),
      h = !([].keys && "next" in [].keys()),
      l = function l() {
    return this;
  };

  e.exports = function (e, t, r, p, b, v, m) {
    f(r, t, p);

    var y,
        g,
        A,
        w = function w(e) {
      if (!h && e in k) return k[e];

      switch (e) {
        case "keys":
        case "values":
          return function () {
            return new r(this, e);
          };
      }

      return function () {
        return new r(this, e);
      };
    },
        _ = t + " Iterator",
        x = "values" == b,
        S = !1,
        k = e.prototype,
        E = k[d] || k["@@iterator"] || b && k[b],
        M = E || w(b),
        C = b ? x ? w("entries") : M : void 0,
        B = "Array" == t && k.entries || E;

    if (B && (A = u(B.call(new e()))) !== Object.prototype && A.next && (c(A, _, !0), n || "function" == typeof A[d] || a(A, d, l)), x && E && "values" !== E.name && (S = !0, M = function M() {
      return E.call(this);
    }), n && !m || !h && !S && k[d] || a(k, d, M), s[t] = M, s[_] = l, b) if (y = {
      values: x ? M : w("values"),
      keys: v ? M : w("keys"),
      entries: C
    }, m) for (g in y) {
      g in k || o(k, g, y[g]);
    } else i(i.P + i.F * (h || S), t, y);
    return y;
  };
}, function (e, t) {
  e.exports = function (e, t) {
    return {
      enumerable: !(1 & e),
      configurable: !(2 & e),
      writable: !(4 & e),
      value: t
    };
  };
}, function (e, t, r) {
  var n = r(121),
      i = r(68);

  e.exports = Object.keys || function (e) {
    return n(e, i);
  };
}, function (e, t, r) {
  var n = r(32);
  e.exports = Object("z").propertyIsEnumerable(0) ? Object : function (e) {
    return "String" == n(e) ? e.split("") : Object(e);
  };
}, function (e, t, r) {
  var n = r(42),
      i = Math.min;

  e.exports = function (e) {
    return e > 0 ? i(n(e), 9007199254740991) : 0;
  };
}, function (e, t, r) {
  var n = r(8),
      i = r(3),
      o = i["__core-js_shared__"] || (i["__core-js_shared__"] = {});
  (e.exports = function (e, t) {
    return o[e] || (o[e] = void 0 !== t ? t : {});
  })("versions", []).push({
    version: n.version,
    mode: r(44) ? "pure" : "global",
    copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
  });
}, function (e, t) {
  var r = 0,
      n = Math.random();

  e.exports = function (e) {
    return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++r + n).toString(36));
  };
}, function (e, t) {
  e.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
}, function (e, t, r) {
  var n = r(3).document;
  e.exports = n && n.documentElement;
}, function (e, t, r) {
  var n = r(43);

  e.exports = function (e) {
    return Object(n(e));
  };
}, function (e, t, r) {
  var n = r(32),
      i = r(4)("toStringTag"),
      o = "Arguments" == n(function () {
    return arguments;
  }());

  e.exports = function (e) {
    var t, r, a;
    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (r = function (e, t) {
      try {
        return e[t];
      } catch (e) {}
    }(t = Object(e), i)) ? r : o ? n(t) : "Object" == (a = n(t)) && "function" == typeof t.callee ? "Arguments" : a;
  };
}, function (e, t, r) {
  var n = r(12),
      i = r(29),
      o = r(4)("species");

  e.exports = function (e, t) {
    var r,
        a = n(e).constructor;
    return void 0 === a || null == (r = n(a)[o]) ? t : i(r);
  };
}, function (e, t, r) {
  var n,
      i,
      o,
      a = r(28),
      s = r(135),
      f = r(69),
      c = r(46),
      u = r(3),
      d = u.process,
      h = u.setImmediate,
      l = u.clearImmediate,
      p = u.MessageChannel,
      b = u.Dispatch,
      v = 0,
      m = {},
      y = function y() {
    var e = +this;

    if (m.hasOwnProperty(e)) {
      var t = m[e];
      delete m[e], t();
    }
  },
      g = function g(e) {
    y.call(e.data);
  };

  h && l || (h = function h(e) {
    for (var t = [], r = 1; arguments.length > r;) {
      t.push(arguments[r++]);
    }

    return m[++v] = function () {
      s("function" == typeof e ? e : Function(e), t);
    }, n(v), v;
  }, l = function l(e) {
    delete m[e];
  }, "process" == r(32)(d) ? n = function n(e) {
    d.nextTick(a(y, e, 1));
  } : b && b.now ? n = function n(e) {
    b.now(a(y, e, 1));
  } : p ? (o = (i = new p()).port2, i.port1.onmessage = g, n = a(o.postMessage, o, 1)) : u.addEventListener && "function" == typeof postMessage && !u.importScripts ? (n = function n(e) {
    u.postMessage(e + "", "*");
  }, u.addEventListener("message", g, !1)) : n = "onreadystatechange" in c("script") ? function (e) {
    f.appendChild(c("script")).onreadystatechange = function () {
      f.removeChild(this), y.call(e);
    };
  } : function (e) {
    setTimeout(a(y, e, 1), 0);
  }), e.exports = {
    set: h,
    clear: l
  };
}, function (e, t) {
  e.exports = function (e) {
    try {
      return {
        e: !1,
        v: e()
      };
    } catch (e) {
      return {
        e: !0,
        v: e
      };
    }
  };
}, function (e, t, r) {
  var n = r(12),
      i = r(22),
      o = r(50);

  e.exports = function (e, t) {
    if (n(e), i(t) && t.constructor === e) return t;
    var r = o.f(e);
    return (0, r.resolve)(t), r.promise;
  };
}, function (e, t, r) {
  "use strict";

  var n = t;

  function i(e) {
    return 1 === e.length ? "0" + e : e;
  }

  function o(e) {
    for (var t = "", r = 0; r < e.length; r++) {
      t += i(e[r].toString(16));
    }

    return t;
  }

  n.toArray = function (e, t) {
    if (Array.isArray(e)) return e.slice();
    if (!e) return [];
    var r = [];

    if ("string" != typeof e) {
      for (var n = 0; n < e.length; n++) {
        r[n] = 0 | e[n];
      }

      return r;
    }

    if ("hex" === t) for ((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), n = 0; n < e.length; n += 2) {
      r.push(parseInt(e[n] + e[n + 1], 16));
    } else for (n = 0; n < e.length; n++) {
      var i = e.charCodeAt(n),
          o = i >> 8,
          a = 255 & i;
      o ? r.push(o, a) : r.push(a);
    }
    return r;
  }, n.zero2 = i, n.toHex = o, n.encode = function (e, t) {
    return "hex" === t ? o(e) : e;
  };
}, function (e, t, r) {
  "use strict";

  var n = r(5).rotr32;

  function i(e, t, r) {
    return e & t ^ ~e & r;
  }

  function o(e, t, r) {
    return e & t ^ e & r ^ t & r;
  }

  function a(e, t, r) {
    return e ^ t ^ r;
  }

  t.ft_1 = function (e, t, r, n) {
    return 0 === e ? i(t, r, n) : 1 === e || 3 === e ? a(t, r, n) : 2 === e ? o(t, r, n) : void 0;
  }, t.ch32 = i, t.maj32 = o, t.p32 = a, t.s0_256 = function (e) {
    return n(e, 2) ^ n(e, 13) ^ n(e, 22);
  }, t.s1_256 = function (e) {
    return n(e, 6) ^ n(e, 11) ^ n(e, 25);
  }, t.g0_256 = function (e) {
    return n(e, 7) ^ n(e, 18) ^ e >>> 3;
  }, t.g1_256 = function (e) {
    return n(e, 17) ^ n(e, 19) ^ e >>> 10;
  };
}, function (e, t, r) {
  "use strict";

  var n = r(5),
      i = r(25),
      o = r(77),
      a = r(13),
      s = n.sum32,
      f = n.sum32_4,
      c = n.sum32_5,
      u = o.ch32,
      d = o.maj32,
      h = o.s0_256,
      l = o.s1_256,
      p = o.g0_256,
      b = o.g1_256,
      v = i.BlockHash,
      m = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];

  function y() {
    if (!(this instanceof y)) return new y();
    v.call(this), this.h = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], this.k = m, this.W = new Array(64);
  }

  n.inherits(y, v), e.exports = y, y.blockSize = 512, y.outSize = 256, y.hmacStrength = 192, y.padLength = 64, y.prototype._update = function (e, t) {
    for (var r = this.W, n = 0; n < 16; n++) {
      r[n] = e[t + n];
    }

    for (; n < r.length; n++) {
      r[n] = f(b(r[n - 2]), r[n - 7], p(r[n - 15]), r[n - 16]);
    }

    var i = this.h[0],
        o = this.h[1],
        v = this.h[2],
        m = this.h[3],
        y = this.h[4],
        g = this.h[5],
        A = this.h[6],
        w = this.h[7];

    for (a(this.k.length === r.length), n = 0; n < r.length; n++) {
      var _ = c(w, l(y), u(y, g, A), this.k[n], r[n]),
          x = s(h(i), d(i, o, v));

      w = A, A = g, g = y, y = s(m, _), m = v, v = o, o = i, i = s(_, x);
    }

    this.h[0] = s(this.h[0], i), this.h[1] = s(this.h[1], o), this.h[2] = s(this.h[2], v), this.h[3] = s(this.h[3], m), this.h[4] = s(this.h[4], y), this.h[5] = s(this.h[5], g), this.h[6] = s(this.h[6], A), this.h[7] = s(this.h[7], w);
  }, y.prototype._digest = function (e) {
    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
  };
}, function (e, t, r) {
  "use strict";

  var n = r(5),
      i = r(25),
      o = r(13),
      a = n.rotr64_hi,
      s = n.rotr64_lo,
      f = n.shr64_hi,
      c = n.shr64_lo,
      u = n.sum64,
      d = n.sum64_hi,
      h = n.sum64_lo,
      l = n.sum64_4_hi,
      p = n.sum64_4_lo,
      b = n.sum64_5_hi,
      v = n.sum64_5_lo,
      m = i.BlockHash,
      y = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];

  function g() {
    if (!(this instanceof g)) return new g();
    m.call(this), this.h = [1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762, 1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547, 1541459225, 327033209], this.k = y, this.W = new Array(160);
  }

  function A(e, t, r, n, i) {
    var o = e & r ^ ~e & i;
    return o < 0 && (o += 4294967296), o;
  }

  function w(e, t, r, n, i, o) {
    var a = t & n ^ ~t & o;
    return a < 0 && (a += 4294967296), a;
  }

  function _(e, t, r, n, i) {
    var o = e & r ^ e & i ^ r & i;
    return o < 0 && (o += 4294967296), o;
  }

  function x(e, t, r, n, i, o) {
    var a = t & n ^ t & o ^ n & o;
    return a < 0 && (a += 4294967296), a;
  }

  function S(e, t) {
    var r = a(e, t, 28) ^ a(t, e, 2) ^ a(t, e, 7);
    return r < 0 && (r += 4294967296), r;
  }

  function k(e, t) {
    var r = s(e, t, 28) ^ s(t, e, 2) ^ s(t, e, 7);
    return r < 0 && (r += 4294967296), r;
  }

  function E(e, t) {
    var r = a(e, t, 14) ^ a(e, t, 18) ^ a(t, e, 9);
    return r < 0 && (r += 4294967296), r;
  }

  function M(e, t) {
    var r = s(e, t, 14) ^ s(e, t, 18) ^ s(t, e, 9);
    return r < 0 && (r += 4294967296), r;
  }

  function C(e, t) {
    var r = a(e, t, 1) ^ a(e, t, 8) ^ f(e, t, 7);
    return r < 0 && (r += 4294967296), r;
  }

  function B(e, t) {
    var r = s(e, t, 1) ^ s(e, t, 8) ^ c(e, t, 7);
    return r < 0 && (r += 4294967296), r;
  }

  function P(e, t) {
    var r = a(e, t, 19) ^ a(t, e, 29) ^ f(e, t, 6);
    return r < 0 && (r += 4294967296), r;
  }

  function R(e, t) {
    var r = s(e, t, 19) ^ s(t, e, 29) ^ c(e, t, 6);
    return r < 0 && (r += 4294967296), r;
  }

  n.inherits(g, m), e.exports = g, g.blockSize = 1024, g.outSize = 512, g.hmacStrength = 192, g.padLength = 128, g.prototype._prepareBlock = function (e, t) {
    for (var r = this.W, n = 0; n < 32; n++) {
      r[n] = e[t + n];
    }

    for (; n < r.length; n += 2) {
      var i = P(r[n - 4], r[n - 3]),
          o = R(r[n - 4], r[n - 3]),
          a = r[n - 14],
          s = r[n - 13],
          f = C(r[n - 30], r[n - 29]),
          c = B(r[n - 30], r[n - 29]),
          u = r[n - 32],
          d = r[n - 31];
      r[n] = l(i, o, a, s, f, c, u, d), r[n + 1] = p(i, o, a, s, f, c, u, d);
    }
  }, g.prototype._update = function (e, t) {
    this._prepareBlock(e, t);

    var r = this.W,
        n = this.h[0],
        i = this.h[1],
        a = this.h[2],
        s = this.h[3],
        f = this.h[4],
        c = this.h[5],
        l = this.h[6],
        p = this.h[7],
        m = this.h[8],
        y = this.h[9],
        g = this.h[10],
        C = this.h[11],
        B = this.h[12],
        P = this.h[13],
        R = this.h[14],
        H = this.h[15];
    o(this.k.length === r.length);

    for (var O = 0; O < r.length; O += 2) {
      var T = R,
          I = H,
          j = E(m, y),
          z = M(m, y),
          L = A(m, y, g, C, B),
          N = w(m, y, g, C, B, P),
          W = this.k[O],
          U = this.k[O + 1],
          D = r[O],
          q = r[O + 1],
          F = b(T, I, j, z, L, N, W, U, D, q),
          X = v(T, I, j, z, L, N, W, U, D, q);
      T = S(n, i), I = k(n, i), j = _(n, i, a, s, f), z = x(n, i, a, s, f, c);
      var Y = d(T, I, j, z),
          V = h(T, I, j, z);
      R = B, H = P, B = g, P = C, g = m, C = y, m = d(l, p, F, X), y = h(p, p, F, X), l = f, p = c, f = a, c = s, a = n, s = i, n = d(F, X, Y, V), i = h(F, X, Y, V);
    }

    u(this.h, 0, n, i), u(this.h, 2, a, s), u(this.h, 4, f, c), u(this.h, 6, l, p), u(this.h, 8, m, y), u(this.h, 10, g, C), u(this.h, 12, B, P), u(this.h, 14, R, H);
  }, g.prototype._digest = function (e) {
    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
  };
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.sha256 = function (e) {
    return o.Buffer.from(n.sha256.arrayBuffer(e));
  }, t.keccak = a, t.toEthereumAddress = function (e) {
    return "0x" + a(o.Buffer.from(e.slice(2), "hex")).slice(-20).toString("hex");
  };
  var n = r(58),
      i = r(168),
      o = r(11);

  function a(e) {
    return o.Buffer.from(i.keccak_256.buffer(e));
  }
}, function (e, t, r) {
  var n = r(200);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var i = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  r(202)(n, i);
  n.locals && (e.exports = n.locals);
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = [],
      i = "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z";
  t.definition = {
    prefix: "fas",
    iconName: "arrow-right",
    icon: [448, 512, n, "f061", i]
  }, t.faArrowRight = t.definition, t.prefix = "fas", t.iconName = "arrow-right", t.width = 448, t.height = 512, t.ligatures = n, t.unicode = "f061", t.svgPathData = i;
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = [],
      i = "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z";
  t.definition = {
    prefix: "fas",
    iconName: "globe-americas",
    icon: [496, 512, n, "f57d", i]
  }, t.faGlobeAmericas = t.definition, t.prefix = "fas", t.iconName = "globe-americas", t.width = 496, t.height = 512, t.ligatures = n, t.unicode = "f57d", t.svgPathData = i;
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = [],
      i = "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z";
  t.definition = {
    prefix: "fab",
    iconName: "twitter",
    icon: [512, 512, n, "f099", i]
  }, t.faTwitter = t.definition, t.prefix = "fab", t.iconName = "twitter", t.width = 512, t.height = 512, t.ligatures = n, t.unicode = "f099", t.svgPathData = i;
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = [],
      i = "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z";
  t.definition = {
    prefix: "fab",
    iconName: "github",
    icon: [496, 512, n, "f09b", i]
  }, t.faGithub = t.definition, t.prefix = "fab", t.iconName = "github", t.width = 496, t.height = 512, t.ligatures = n, t.unicode = "f09b", t.svgPathData = i;
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = [],
      i = "M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z";
  t.definition = {
    prefix: "far",
    iconName: "clone",
    icon: [512, 512, n, "f24d", i]
  }, t.faClone = t.definition, t.prefix = "far", t.iconName = "clone", t.width = 512, t.height = 512, t.ligatures = n, t.unicode = "f24d", t.svgPathData = i;
}, function (e, t, r) {
  "use strict";

  r.r(t), r.d(t, "default", function () {
    return E;
  });

  var n = r(15),
      i = r.n(n),
      o = r(26),
      a = r.n(o),
      s = r(36),
      f = r.n(s),
      c = r(37),
      u = r.n(c),
      d = r(38),
      h = r.n(d),
      l = r(39),
      p = r.n(l),
      b = r(40),
      v = r.n(b),
      m = r(6),
      y = r.n(m),
      g = r(1),
      A = r.n(g),
      w = r(54),
      _ = r(10),
      x = r(196)({
    React: A.a,
    Fragment: g.Fragment
  }),
      S = x.BaseTemplate,
      k = x.LoadingTemplate,
      E = function (e) {
    function t(e) {
      var r;
      return f()(this, t), (r = h()(this, p()(t).call(this, e))).state = {
        profile: void 0,
        verified: void 0,
        adjustOrientation: void 0,
        isMobile: !1,
        showHover: !1,
        hasWeb3Mobile: !1,
        copySuccessful: ""
      }, r.selector = A.a.createRef(), r.checkWindowSize = r.checkWindowSize.bind(y()(y()(r))), r.handleShowHover = r.handleShowHover.bind(y()(y()(r))), r.handleCopySuccessful = r.handleCopySuccessful.bind(y()(y()(r))), r.checkHasWeb3Mobile = r.checkHasWeb3Mobile.bind(y()(y()(r))), r;
    }

    return v()(t, e), u()(t, [{
      key: "componentDidCatch",
      value: function value(e, t) {
        console.error({
          error: e,
          info: t
        });
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        this.setState({
          isMobile: Object(_.checkIsMobile)()
        }), this.checkHasWeb3Mobile(), this._fetchProfile();
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e) {
        this.props.address !== e.address && this._fetchProfile();
      }
    }, {
      key: "_fetchProfile",
      value: function () {
        var e = a()(i.a.mark(function e() {
          var t, r;
          return i.a.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.prev = 0, e.next = 3, Object(w.getProfile)(this.props.address);

                case 3:
                  return t = e.sent, e.next = 6, Object(w.getVerifiedAccounts)(t);

                case 6:
                  r = e.sent, this.setState({
                    profile: t,
                    verified: r,
                    hasUpdated: !1
                  }), e.next = 13;
                  break;

                case 10:
                  e.prev = 10, e.t0 = e.catch(0), console.error("3box profile fetch failed", e.t0);

                case 13:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[0, 10]]);
        }));
        return function () {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "checkWindowSize",
      value: function value(e) {
        try {
          if (!this.state.hasUpdated && e) {
            var t = this.state.adjustOrientation,
                r = window.innerHeight,
                n = this.selector.current.getBoundingClientRect(),
                i = n.height,
                o = n.y,
                a = t;
            i + o > r ? a = "top" : o < 0 && (a = "bottom"), this.setState({
              adjustOrientation: a,
              hasUpdated: !0
            });
          }
        } catch (e) {
          console.error(e);
        }
      }
    }, {
      key: "checkHasWeb3Mobile",
      value: function value() {
        var e = Object(_.checkIsMobile)() && (void 0 !== window.web3 || void 0 !== window.ethereum);
        this.setState({
          hasWeb3Mobile: e
        });
      }
    }, {
      key: "handleShowHover",
      value: function value(e) {
        var t = this,
            r = this.state,
            n = r.showHover,
            i = r.hasUpdated;
        e && this.setState({
          showHover: !n
        }, function () {
          i || t.checkWindowSize(!0);
        });
      }
    }, {
      key: "handleCopySuccessful",
      value: function value(e) {
        var t = this;
        this.setState({
          copySuccessful: e
        }, function () {
          return setTimeout(function () {
            t.setState({
              copySuccessful: ""
            });
          }, 2e3);
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.address,
            r = e.fullDisplay,
            n = e.children,
            i = e.noTheme,
            o = e.noImgs,
            a = e.noProfileImg,
            s = e.noCoverImg,
            f = e.orientation,
            c = e.url,
            u = e.showName,
            d = e.tileStyle,
            h = this.state,
            l = h.profile,
            p = h.verified,
            b = h.adjustOrientation,
            v = h.isMobile,
            m = h.showHover,
            y = h.hasWeb3Mobile,
            g = h.copySuccessful;
        if (null == t) return null;
        var w = {
          html: i ? n : void 0,
          noImgs: o,
          noProfileImg: a,
          noCoverImg: s,
          showName: u,
          tileStyle: d,
          url: Object(_.formatUrl)(c),
          orientation: b || f || "right"
        },
            x = Object(_.getAddressDisplay)(t, r ? "full" : void 0),
            E = Object(_.formatProfileData)(l, p, t, x);
        return null == l ? A.a.createElement(k, {
          data: E,
          opts: w,
          isMobile: v,
          showHover: m,
          handleShowHover: this.handleShowHover,
          ref: this.selector,
          checkWindowSize: this.checkWindowSize
        }) : "error" === l.status ? A.a.createElement(S, {
          data: E,
          opts: w,
          id: t,
          isMobile: v,
          showHover: m,
          checkWindowSize: this.checkWindowSize,
          ref: this.selector,
          handleShowHover: this.handleShowHover
        }) : A.a.createElement(S, {
          data: E,
          opts: w,
          id: t,
          hasWeb3Mobile: y,
          isMobile: v,
          showHover: m,
          ref: this.selector,
          handleShowHover: this.handleShowHover,
          checkWindowSize: this.checkWindowSize,
          handleCopySuccessful: this.handleCopySuccessful,
          copySuccessful: g
        });
      }
    }]), t;
  }(A.a.PureComponent);
}, function (e, t, r) {
  var n = function () {
    return this || "object" == typeof self && self;
  }() || Function("return this")(),
      i = n.regeneratorRuntime && Object.getOwnPropertyNames(n).indexOf("regeneratorRuntime") >= 0,
      o = i && n.regeneratorRuntime;

  if (n.regeneratorRuntime = void 0, e.exports = r(89), i) n.regeneratorRuntime = o;else try {
    delete n.regeneratorRuntime;
  } catch (e) {
    n.regeneratorRuntime = void 0;
  }
}, function (e, t) {
  !function (t) {
    "use strict";

    var r,
        n = Object.prototype,
        i = n.hasOwnProperty,
        o = "function" == typeof Symbol ? Symbol : {},
        a = o.iterator || "@@iterator",
        s = o.asyncIterator || "@@asyncIterator",
        f = o.toStringTag || "@@toStringTag",
        c = "object" == typeof e,
        u = t.regeneratorRuntime;
    if (u) c && (e.exports = u);else {
      (u = t.regeneratorRuntime = c ? e.exports : {}).wrap = A;
      var d = "suspendedStart",
          h = "suspendedYield",
          l = "executing",
          p = "completed",
          b = {},
          v = {};

      v[a] = function () {
        return this;
      };

      var m = Object.getPrototypeOf,
          y = m && m(m(R([])));
      y && y !== n && i.call(y, a) && (v = y);
      var g = S.prototype = _.prototype = Object.create(v);
      x.prototype = g.constructor = S, S.constructor = x, S[f] = x.displayName = "GeneratorFunction", u.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === x || "GeneratorFunction" === (t.displayName || t.name));
      }, u.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, S) : (e.__proto__ = S, f in e || (e[f] = "GeneratorFunction")), e.prototype = Object.create(g), e;
      }, u.awrap = function (e) {
        return {
          __await: e
        };
      }, k(E.prototype), E.prototype[s] = function () {
        return this;
      }, u.AsyncIterator = E, u.async = function (e, t, r, n) {
        var i = new E(A(e, t, r, n));
        return u.isGeneratorFunction(t) ? i : i.next().then(function (e) {
          return e.done ? e.value : i.next();
        });
      }, k(g), g[f] = "Generator", g[a] = function () {
        return this;
      }, g.toString = function () {
        return "[object Generator]";
      }, u.keys = function (e) {
        var t = [];

        for (var r in e) {
          t.push(r);
        }

        return t.reverse(), function r() {
          for (; t.length;) {
            var n = t.pop();
            if (n in e) return r.value = n, r.done = !1, r;
          }

          return r.done = !0, r;
        };
      }, u.values = R, P.prototype = {
        constructor: P,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = r, this.done = !1, this.delegate = null, this.method = "next", this.arg = r, this.tryEntries.forEach(B), !e) for (var t in this) {
            "t" === t.charAt(0) && i.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = r);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var t = this;

          function n(n, i) {
            return s.type = "throw", s.arg = e, t.next = n, i && (t.method = "next", t.arg = r), !!i;
          }

          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var a = this.tryEntries[o],
                s = a.completion;
            if ("root" === a.tryLoc) return n("end");

            if (a.tryLoc <= this.prev) {
              var f = i.call(a, "catchLoc"),
                  c = i.call(a, "finallyLoc");

              if (f && c) {
                if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return n(a.finallyLoc);
              } else if (f) {
                if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
              } else {
                if (!c) throw new Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return n(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var n = this.tryEntries[r];

            if (n.tryLoc <= this.prev && i.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
              var o = n;
              break;
            }
          }

          o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
          var a = o ? o.completion : {};
          return a.type = e, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, b) : this.complete(a);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), b;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), B(r), b;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];

            if (r.tryLoc === e) {
              var n = r.completion;

              if ("throw" === n.type) {
                var i = n.arg;
                B(r);
              }

              return i;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, t, n) {
          return this.delegate = {
            iterator: R(e),
            resultName: t,
            nextLoc: n
          }, "next" === this.method && (this.arg = r), b;
        }
      };
    }

    function A(e, t, r, n) {
      var i = t && t.prototype instanceof _ ? t : _,
          o = Object.create(i.prototype),
          a = new P(n || []);
      return o._invoke = function (e, t, r) {
        var n = d;
        return function (i, o) {
          if (n === l) throw new Error("Generator is already running");

          if (n === p) {
            if ("throw" === i) throw o;
            return H();
          }

          for (r.method = i, r.arg = o;;) {
            var a = r.delegate;

            if (a) {
              var s = M(a, r);

              if (s) {
                if (s === b) continue;
                return s;
              }
            }

            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if (n === d) throw n = p, r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            n = l;
            var f = w(e, t, r);

            if ("normal" === f.type) {
              if (n = r.done ? p : h, f.arg === b) continue;
              return {
                value: f.arg,
                done: r.done
              };
            }

            "throw" === f.type && (n = p, r.method = "throw", r.arg = f.arg);
          }
        };
      }(e, r, a), o;
    }

    function w(e, t, r) {
      try {
        return {
          type: "normal",
          arg: e.call(t, r)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }

    function _() {}

    function x() {}

    function S() {}

    function k(e) {
      ["next", "throw", "return"].forEach(function (t) {
        e[t] = function (e) {
          return this._invoke(t, e);
        };
      });
    }

    function E(e) {
      var t;

      this._invoke = function (r, n) {
        function o() {
          return new Promise(function (t, o) {
            !function t(r, n, o, a) {
              var s = w(e[r], e, n);

              if ("throw" !== s.type) {
                var f = s.arg,
                    c = f.value;
                return c && "object" == typeof c && i.call(c, "__await") ? Promise.resolve(c.__await).then(function (e) {
                  t("next", e, o, a);
                }, function (e) {
                  t("throw", e, o, a);
                }) : Promise.resolve(c).then(function (e) {
                  f.value = e, o(f);
                }, function (e) {
                  return t("throw", e, o, a);
                });
              }

              a(s.arg);
            }(r, n, t, o);
          });
        }

        return t = t ? t.then(o, o) : o();
      };
    }

    function M(e, t) {
      var n = e.iterator[t.method];

      if (n === r) {
        if (t.delegate = null, "throw" === t.method) {
          if (e.iterator.return && (t.method = "return", t.arg = r, M(e, t), "throw" === t.method)) return b;
          t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return b;
      }

      var i = w(n, e.iterator, t.arg);
      if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, b;
      var o = i.arg;
      return o ? o.done ? (t[e.resultName] = o.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = r), t.delegate = null, b) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, b);
    }

    function C(e) {
      var t = {
        tryLoc: e[0]
      };
      1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }

    function B(e) {
      var t = e.completion || {};
      t.type = "normal", delete t.arg, e.completion = t;
    }

    function P(e) {
      this.tryEntries = [{
        tryLoc: "root"
      }], e.forEach(C, this), this.reset(!0);
    }

    function R(e) {
      if (e) {
        var t = e[a];
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;

        if (!isNaN(e.length)) {
          var n = -1,
              o = function t() {
            for (; ++n < e.length;) {
              if (i.call(e, n)) return t.value = e[n], t.done = !1, t;
            }

            return t.value = r, t.done = !0, t;
          };

          return o.next = o;
        }
      }

      return {
        next: H
      };
    }

    function H() {
      return {
        value: r,
        done: !0
      };
    }
  }(function () {
    return this || "object" == typeof self && self;
  }() || Function("return this")());
}, function (e, t) {
  function r(e) {
    return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function n(t) {
    return "function" == typeof Symbol && "symbol" === r(Symbol.iterator) ? e.exports = n = function n(e) {
      return r(e);
    } : e.exports = n = function n(e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : r(e);
    }, n(t);
  }

  e.exports = n;
}, function (e, t) {
  function r(t, n) {
    return e.exports = r = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    }, r(t, n);
  }

  e.exports = r;
}, function (e, t, r) {
  "use strict";

  var n = this && this.__assign || Object.assign || function (e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      for (var i in t = arguments[r]) {
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
      }
    }

    return e;
  },
      i = this && this.__awaiter || function (e, t, r, n) {
    return new (r || (r = Promise))(function (i, o) {
      function a(e) {
        try {
          f(n.next(e));
        } catch (e) {
          o(e);
        }
      }

      function s(e) {
        try {
          f(n.throw(e));
        } catch (e) {
          o(e);
        }
      }

      function f(e) {
        e.done ? i(e.value) : new r(function (t) {
          t(e.value);
        }).then(a, s);
      }

      f((n = n.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var r,
        n,
        i,
        o,
        a = {
      label: 0,
      sent: function sent() {
        if (1 & i[0]) throw i[1];
        return i[1];
      },
      trys: [],
      ops: []
    };
    return o = {
      next: s(0),
      throw: s(1),
      return: s(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
      return this;
    }), o;

    function s(o) {
      return function (s) {
        return function (o) {
          if (r) throw new TypeError("Generator is already executing.");

          for (; a;) {
            try {
              if (r = 1, n && (i = n[2 & o[0] ? "return" : o[0] ? "throw" : "next"]) && !(i = i.call(n, o[1])).done) return i;

              switch (n = 0, i && (o = [0, i.value]), o[0]) {
                case 0:
                case 1:
                  i = o;
                  break;

                case 4:
                  return a.label++, {
                    value: o[1],
                    done: !1
                  };

                case 5:
                  a.label++, n = o[1], o = [0];
                  continue;

                case 7:
                  o = a.ops.pop(), a.trys.pop();
                  continue;

                default:
                  if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                    a = 0;
                    continue;
                  }

                  if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                    a.label = o[1];
                    break;
                  }

                  if (6 === o[0] && a.label < i[1]) {
                    a.label = i[1], i = o;
                    break;
                  }

                  if (i && a.label < i[2]) {
                    a.label = i[2], a.ops.push(o);
                    break;
                  }

                  i[2] && a.ops.pop(), a.trys.pop();
                  continue;
              }

              o = t.call(e, a);
            } catch (e) {
              o = [6, e], n = 0;
            } finally {
              r = i = 0;
            }
          }

          if (5 & o[0]) throw o[1];
          return {
            value: o[0] ? o[1] : void 0,
            done: !0
          };
        }([o, s]);
      };
    }
  },
      a = this && this.__rest || function (e, t) {
    var r = {};

    for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
    }

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var i = 0;

      for (n = Object.getOwnPropertySymbols(e); i < n.length; i++) {
        t.indexOf(n[i]) < 0 && (r[n[i]] = e[n[i]]);
      }
    }

    return r;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var s = r(56),
      f = r(56);
  t.ClientError = f.ClientError, r(93);

  var c = function () {
    function e(e, t) {
      this.url = e, this.options = t || {};
    }

    return e.prototype.rawRequest = function (e, t) {
      return i(this, void 0, void 0, function () {
        var r, i, f, c, u, h, l, p, b;
        return o(this, function (o) {
          switch (o.label) {
            case 0:
              return r = this.options, i = r.headers, f = a(r, ["headers"]), c = JSON.stringify({
                query: e,
                variables: t || void 0
              }), [4, fetch(this.url, n({
                method: "POST",
                headers: Object.assign({
                  "Content-Type": "application/json"
                }, i),
                body: c
              }, f))];

            case 1:
              return [4, d(u = o.sent())];

            case 2:
              if (h = o.sent(), u.ok && !h.errors && h.data) return l = u.headers, p = u.status, [2, n({}, h, {
                headers: l,
                status: p
              })];
              throw b = "string" == typeof h ? {
                error: h
              } : h, new s.ClientError(n({}, b, {
                status: u.status,
                headers: u.headers
              }), {
                query: e,
                variables: t
              });
          }
        });
      });
    }, e.prototype.request = function (e, t) {
      return i(this, void 0, void 0, function () {
        var r, i, f, c, u, h, l;
        return o(this, function (o) {
          switch (o.label) {
            case 0:
              return r = this.options, i = r.headers, f = a(r, ["headers"]), c = JSON.stringify({
                query: e,
                variables: t || void 0
              }), [4, fetch(this.url, n({
                method: "POST",
                headers: Object.assign({
                  "Content-Type": "application/json"
                }, i),
                body: c
              }, f))];

            case 1:
              return [4, d(u = o.sent())];

            case 2:
              if (h = o.sent(), u.ok && !h.errors && h.data) return [2, h.data];
              throw l = "string" == typeof h ? {
                error: h
              } : h, new s.ClientError(n({}, l, {
                status: u.status
              }), {
                query: e,
                variables: t
              });
          }
        });
      });
    }, e.prototype.setHeaders = function (e) {
      return this.options.headers = e, this;
    }, e.prototype.setHeader = function (e, t) {
      var r,
          n = this.options.headers;
      return n ? n[e] = t : this.options.headers = ((r = {})[e] = t, r), this;
    }, e;
  }();

  function u(e, t, r) {
    return i(this, void 0, void 0, function () {
      return o(this, function (n) {
        return [2, new c(e).request(t, r)];
      });
    });
  }

  function d(e) {
    return i(this, void 0, void 0, function () {
      var t;
      return o(this, function (r) {
        return (t = e.headers.get("Content-Type")) && t.startsWith("application/json") ? [2, e.json()] : [2, e.text()];
      });
    });
  }

  t.GraphQLClient = c, t.rawRequest = function (e, t, r) {
    return i(this, void 0, void 0, function () {
      return o(this, function (n) {
        return [2, new c(e).rawRequest(t, r)];
      });
    });
  }, t.request = u, t.default = u;
}, function (e, t) {
  !function (e) {
    if (!e.fetch) {
      var t = {
        searchParams: "URLSearchParams" in e,
        iterable: "Symbol" in e && "iterator" in Symbol,
        blob: "FileReader" in e && "Blob" in e && function () {
          try {
            return new Blob(), !0;
          } catch (e) {
            return !1;
          }
        }(),
        formData: "FormData" in e,
        arrayBuffer: "ArrayBuffer" in e
      };
      if (t.arrayBuffer) var r = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
          n = function n(e) {
        return e && DataView.prototype.isPrototypeOf(e);
      },
          i = ArrayBuffer.isView || function (e) {
        return e && r.indexOf(Object.prototype.toString.call(e)) > -1;
      };
      u.prototype.append = function (e, t) {
        e = s(e), t = f(t);
        var r = this.map[e];
        this.map[e] = r ? r + "," + t : t;
      }, u.prototype.delete = function (e) {
        delete this.map[s(e)];
      }, u.prototype.get = function (e) {
        return e = s(e), this.has(e) ? this.map[e] : null;
      }, u.prototype.has = function (e) {
        return this.map.hasOwnProperty(s(e));
      }, u.prototype.set = function (e, t) {
        this.map[s(e)] = f(t);
      }, u.prototype.forEach = function (e, t) {
        for (var r in this.map) {
          this.map.hasOwnProperty(r) && e.call(t, this.map[r], r, this);
        }
      }, u.prototype.keys = function () {
        var e = [];
        return this.forEach(function (t, r) {
          e.push(r);
        }), c(e);
      }, u.prototype.values = function () {
        var e = [];
        return this.forEach(function (t) {
          e.push(t);
        }), c(e);
      }, u.prototype.entries = function () {
        var e = [];
        return this.forEach(function (t, r) {
          e.push([r, t]);
        }), c(e);
      }, t.iterable && (u.prototype[Symbol.iterator] = u.prototype.entries);
      var o = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      v.prototype.clone = function () {
        return new v(this, {
          body: this._bodyInit
        });
      }, b.call(v.prototype), b.call(y.prototype), y.prototype.clone = function () {
        return new y(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new u(this.headers),
          url: this.url
        });
      }, y.error = function () {
        var e = new y(null, {
          status: 0,
          statusText: ""
        });
        return e.type = "error", e;
      };
      var a = [301, 302, 303, 307, 308];
      y.redirect = function (e, t) {
        if (-1 === a.indexOf(t)) throw new RangeError("Invalid status code");
        return new y(null, {
          status: t,
          headers: {
            location: e
          }
        });
      }, e.Headers = u, e.Request = v, e.Response = y, e.fetch = function (e, r) {
        return new Promise(function (n, i) {
          var o = new v(e, r),
              a = new XMLHttpRequest();
          a.onload = function () {
            var e,
                t,
                r = {
              status: a.status,
              statusText: a.statusText,
              headers: (e = a.getAllResponseHeaders() || "", t = new u(), e.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (e) {
                var r = e.split(":"),
                    n = r.shift().trim();

                if (n) {
                  var i = r.join(":").trim();
                  t.append(n, i);
                }
              }), t)
            };
            r.url = "responseURL" in a ? a.responseURL : r.headers.get("X-Request-URL");
            var i = "response" in a ? a.response : a.responseText;
            n(new y(i, r));
          }, a.onerror = function () {
            i(new TypeError("Network request failed"));
          }, a.ontimeout = function () {
            i(new TypeError("Network request failed"));
          }, a.open(o.method, o.url, !0), "include" === o.credentials ? a.withCredentials = !0 : "omit" === o.credentials && (a.withCredentials = !1), "responseType" in a && t.blob && (a.responseType = "blob"), o.headers.forEach(function (e, t) {
            a.setRequestHeader(t, e);
          }), a.send(void 0 === o._bodyInit ? null : o._bodyInit);
        });
      }, e.fetch.polyfill = !0;
    }

    function s(e) {
      if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
      return e.toLowerCase();
    }

    function f(e) {
      return "string" != typeof e && (e = String(e)), e;
    }

    function c(e) {
      var r = {
        next: function next() {
          var t = e.shift();
          return {
            done: void 0 === t,
            value: t
          };
        }
      };
      return t.iterable && (r[Symbol.iterator] = function () {
        return r;
      }), r;
    }

    function u(e) {
      this.map = {}, e instanceof u ? e.forEach(function (e, t) {
        this.append(t, e);
      }, this) : Array.isArray(e) ? e.forEach(function (e) {
        this.append(e[0], e[1]);
      }, this) : e && Object.getOwnPropertyNames(e).forEach(function (t) {
        this.append(t, e[t]);
      }, this);
    }

    function d(e) {
      if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
      e.bodyUsed = !0;
    }

    function h(e) {
      return new Promise(function (t, r) {
        e.onload = function () {
          t(e.result);
        }, e.onerror = function () {
          r(e.error);
        };
      });
    }

    function l(e) {
      var t = new FileReader(),
          r = h(t);
      return t.readAsArrayBuffer(e), r;
    }

    function p(e) {
      if (e.slice) return e.slice(0);
      var t = new Uint8Array(e.byteLength);
      return t.set(new Uint8Array(e)), t.buffer;
    }

    function b() {
      return this.bodyUsed = !1, this._initBody = function (e) {
        if (this._bodyInit = e, e) {
          if ("string" == typeof e) this._bodyText = e;else if (t.blob && Blob.prototype.isPrototypeOf(e)) this._bodyBlob = e;else if (t.formData && FormData.prototype.isPrototypeOf(e)) this._bodyFormData = e;else if (t.searchParams && URLSearchParams.prototype.isPrototypeOf(e)) this._bodyText = e.toString();else if (t.arrayBuffer && t.blob && n(e)) this._bodyArrayBuffer = p(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer]);else {
            if (!t.arrayBuffer || !ArrayBuffer.prototype.isPrototypeOf(e) && !i(e)) throw new Error("unsupported BodyInit type");
            this._bodyArrayBuffer = p(e);
          }
        } else this._bodyText = "";
        this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : t.searchParams && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
      }, t.blob && (this.blob = function () {
        var e = d(this);
        if (e) return e;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        if (this._bodyFormData) throw new Error("could not read FormData body as blob");
        return Promise.resolve(new Blob([this._bodyText]));
      }, this.arrayBuffer = function () {
        return this._bodyArrayBuffer ? d(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(l);
      }), this.text = function () {
        var e,
            t,
            r,
            n = d(this);
        if (n) return n;
        if (this._bodyBlob) return e = this._bodyBlob, t = new FileReader(), r = h(t), t.readAsText(e), r;
        if (this._bodyArrayBuffer) return Promise.resolve(function (e) {
          for (var t = new Uint8Array(e), r = new Array(t.length), n = 0; n < t.length; n++) {
            r[n] = String.fromCharCode(t[n]);
          }

          return r.join("");
        }(this._bodyArrayBuffer));
        if (this._bodyFormData) throw new Error("could not read FormData body as text");
        return Promise.resolve(this._bodyText);
      }, t.formData && (this.formData = function () {
        return this.text().then(m);
      }), this.json = function () {
        return this.text().then(JSON.parse);
      }, this;
    }

    function v(e, t) {
      var r,
          n,
          i = (t = t || {}).body;

      if (e instanceof v) {
        if (e.bodyUsed) throw new TypeError("Already read");
        this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new u(e.headers)), this.method = e.method, this.mode = e.mode, i || null == e._bodyInit || (i = e._bodyInit, e.bodyUsed = !0);
      } else this.url = String(e);

      if (this.credentials = t.credentials || this.credentials || "omit", !t.headers && this.headers || (this.headers = new u(t.headers)), this.method = (r = t.method || this.method || "GET", n = r.toUpperCase(), o.indexOf(n) > -1 ? n : r), this.mode = t.mode || this.mode || null, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && i) throw new TypeError("Body not allowed for GET or HEAD requests");

      this._initBody(i);
    }

    function m(e) {
      var t = new FormData();
      return e.trim().split("&").forEach(function (e) {
        if (e) {
          var r = e.split("="),
              n = r.shift().replace(/\+/g, " "),
              i = r.join("=").replace(/\+/g, " ");
          t.append(decodeURIComponent(n), decodeURIComponent(i));
        }
      }), t;
    }

    function y(e, t) {
      t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new u(t.headers), this.url = t.url || "", this._initBody(e);
    }
  }("undefined" != typeof self ? self : this);
}, function (e, t, r) {
  "use strict";

  t.byteLength = function (e) {
    var t = c(e),
        r = t[0],
        n = t[1];
    return 3 * (r + n) / 4 - n;
  }, t.toByteArray = function (e) {
    for (var t, r = c(e), n = r[0], a = r[1], s = new o(function (e, t, r) {
      return 3 * (t + r) / 4 - r;
    }(0, n, a)), f = 0, u = a > 0 ? n - 4 : n, d = 0; d < u; d += 4) {
      t = i[e.charCodeAt(d)] << 18 | i[e.charCodeAt(d + 1)] << 12 | i[e.charCodeAt(d + 2)] << 6 | i[e.charCodeAt(d + 3)], s[f++] = t >> 16 & 255, s[f++] = t >> 8 & 255, s[f++] = 255 & t;
    }

    2 === a && (t = i[e.charCodeAt(d)] << 2 | i[e.charCodeAt(d + 1)] >> 4, s[f++] = 255 & t);
    1 === a && (t = i[e.charCodeAt(d)] << 10 | i[e.charCodeAt(d + 1)] << 4 | i[e.charCodeAt(d + 2)] >> 2, s[f++] = t >> 8 & 255, s[f++] = 255 & t);
    return s;
  }, t.fromByteArray = function (e) {
    for (var t, r = e.length, i = r % 3, o = [], a = 0, s = r - i; a < s; a += 16383) {
      o.push(u(e, a, a + 16383 > s ? s : a + 16383));
    }

    1 === i ? (t = e[r - 1], o.push(n[t >> 2] + n[t << 4 & 63] + "==")) : 2 === i && (t = (e[r - 2] << 8) + e[r - 1], o.push(n[t >> 10] + n[t >> 4 & 63] + n[t << 2 & 63] + "="));
    return o.join("");
  };

  for (var n = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, f = a.length; s < f; ++s) {
    n[s] = a[s], i[a.charCodeAt(s)] = s;
  }

  function c(e) {
    var t = e.length;
    if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    var r = e.indexOf("=");
    return -1 === r && (r = t), [r, r === t ? 0 : 4 - r % 4];
  }

  function u(e, t, r) {
    for (var i, o, a = [], s = t; s < r; s += 3) {
      i = (e[s] << 16 & 16711680) + (e[s + 1] << 8 & 65280) + (255 & e[s + 2]), a.push(n[(o = i) >> 18 & 63] + n[o >> 12 & 63] + n[o >> 6 & 63] + n[63 & o]);
    }

    return a.join("");
  }

  i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
}, function (e, t) {
  t.read = function (e, t, r, n, i) {
    var o,
        a,
        s = 8 * i - n - 1,
        f = (1 << s) - 1,
        c = f >> 1,
        u = -7,
        d = r ? i - 1 : 0,
        h = r ? -1 : 1,
        l = e[t + d];

    for (d += h, o = l & (1 << -u) - 1, l >>= -u, u += s; u > 0; o = 256 * o + e[t + d], d += h, u -= 8) {
      ;
    }

    for (a = o & (1 << -u) - 1, o >>= -u, u += n; u > 0; a = 256 * a + e[t + d], d += h, u -= 8) {
      ;
    }

    if (0 === o) o = 1 - c;else {
      if (o === f) return a ? NaN : 1 / 0 * (l ? -1 : 1);
      a += Math.pow(2, n), o -= c;
    }
    return (l ? -1 : 1) * a * Math.pow(2, o - n);
  }, t.write = function (e, t, r, n, i, o) {
    var a,
        s,
        f,
        c = 8 * o - i - 1,
        u = (1 << c) - 1,
        d = u >> 1,
        h = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
        l = n ? 0 : o - 1,
        p = n ? 1 : -1,
        b = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;

    for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, a = u) : (a = Math.floor(Math.log(t) / Math.LN2), t * (f = Math.pow(2, -a)) < 1 && (a--, f *= 2), (t += a + d >= 1 ? h / f : h * Math.pow(2, 1 - d)) * f >= 2 && (a++, f /= 2), a + d >= u ? (s = 0, a = u) : a + d >= 1 ? (s = (t * f - 1) * Math.pow(2, i), a += d) : (s = t * Math.pow(2, d - 1) * Math.pow(2, i), a = 0)); i >= 8; e[r + l] = 255 & s, l += p, s /= 256, i -= 8) {
      ;
    }

    for (a = a << i | s, c += i; c > 0; e[r + l] = 255 & a, l += p, a /= 256, c -= 8) {
      ;
    }

    e[r + l - p] |= 128 * b;
  };
}, function (e, t) {
  var r = {}.toString;

  e.exports = Array.isArray || function (e) {
    return "[object Array]" == r.call(e);
  };
}, function (e, t, r) {
  "use strict";

  var n = function () {
    if ("undefined" != typeof self) return self;
    if ("undefined" != typeof window) return window;
    if (void 0 !== n) return n;
    throw new Error("unable to locate global object");
  }();

  e.exports = t = n.fetch, t.default = n.fetch.bind(n), t.Headers = n.Headers, t.Request = n.Request, t.Response = n.Response;
}, function (e, t, r) {
  "use strict";

  (function (e) {
    var n = r(99),
        i = r(101);
    t.names = i.names, t.codes = i.codes, t.defaultLengths = i.defaultLengths;
    var o = r(102);

    function a(e) {
      t.decode(e);
    }

    t.toHexString = function (t) {
      if (!e.isBuffer(t)) throw new Error("must be passed a buffer");
      return t.toString("hex");
    }, t.fromHexString = function (t) {
      return e.from(t, "hex");
    }, t.toB58String = function (t) {
      if (!e.isBuffer(t)) throw new Error("must be passed a buffer");
      return n.encode(t);
    }, t.fromB58String = function (t) {
      var r = t;
      return e.isBuffer(t) && (r = t.toString()), e.from(n.decode(r));
    }, t.decode = function (r) {
      if (!e.isBuffer(r)) throw new Error("multihash must be a Buffer");
      if (r.length < 3) throw new Error("multihash too short. must be > 3 bytes.");
      var n = o.decode(r);
      if (!t.isValidCode(n)) throw new Error("multihash unknown function code: 0x".concat(n.toString(16)));
      r = r.slice(o.decode.bytes);
      var a = o.decode(r);
      if (a < 1) throw new Error("multihash invalid length: 0x".concat(a.toString(16)));
      if ((r = r.slice(o.decode.bytes)).length !== a) throw new Error("multihash length inconsistent: 0x".concat(r.toString("hex")));
      return {
        code: n,
        name: i.codes[n],
        length: a,
        digest: r
      };
    }, t.encode = function (r, n, i) {
      if (!r || !n) throw new Error("multihash encode requires at least two args: digest, code");
      var a = t.coerceCode(n);
      if (!e.isBuffer(r)) throw new Error("digest should be a Buffer");
      if (null == i && (i = r.length), i && r.length !== i) throw new Error("digest length should be equal to specified length.");
      return e.concat([e.from(o.encode(a)), e.from(o.encode(i)), r]);
    }, t.coerceCode = function (e) {
      var r = e;

      if ("string" == typeof e) {
        if (!i.names[e]) throw new Error("Unrecognized hash function named: ".concat(e));
        r = i.names[e];
      }

      if ("number" != typeof r) throw new Error("Hash function code should be a number. Got: ".concat(r));
      if (!i.codes[r] && !t.isAppCode(r)) throw new Error("Unrecognized function code: ".concat(r));
      return r;
    }, t.isAppCode = function (e) {
      return e > 0 && e < 16;
    }, t.isValidCode = function (e) {
      return !!t.isAppCode(e) || !!i.codes[e];
    }, t.validate = a, t.prefix = function (e) {
      return a(e), e.slice(0, 2);
    };
  }).call(this, r(11).Buffer);
}, function (e, t, r) {
  var n = r(17);
  e.exports = n("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
}, function (e, t, r) {
  var n = r(11),
      i = n.Buffer;

  function o(e, t) {
    for (var r in e) {
      t[r] = e[r];
    }
  }

  function a(e, t, r) {
    return i(e, t, r);
  }

  i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? e.exports = n : (o(n, t), t.Buffer = a), o(i, a), a.from = function (e, t, r) {
    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
    return i(e, t, r);
  }, a.alloc = function (e, t, r) {
    if ("number" != typeof e) throw new TypeError("Argument must be a number");
    var n = i(e);
    return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
  }, a.allocUnsafe = function (e) {
    if ("number" != typeof e) throw new TypeError("Argument must be a number");
    return i(e);
  }, a.allocUnsafeSlow = function (e) {
    if ("number" != typeof e) throw new TypeError("Argument must be a number");
    return n.SlowBuffer(e);
  };
}, function (e, t, r) {
  "use strict";

  t.names = Object.freeze({
    id: 0,
    sha1: 17,
    "sha2-256": 18,
    "sha2-512": 19,
    "dbl-sha2-256": 86,
    "sha3-224": 23,
    "sha3-256": 22,
    "sha3-384": 21,
    "sha3-512": 20,
    "shake-128": 24,
    "shake-256": 25,
    "keccak-224": 26,
    "keccak-256": 27,
    "keccak-384": 28,
    "keccak-512": 29,
    "murmur3-128": 34,
    "murmur3-32": 35,
    "blake2b-8": 45569,
    "blake2b-16": 45570,
    "blake2b-24": 45571,
    "blake2b-32": 45572,
    "blake2b-40": 45573,
    "blake2b-48": 45574,
    "blake2b-56": 45575,
    "blake2b-64": 45576,
    "blake2b-72": 45577,
    "blake2b-80": 45578,
    "blake2b-88": 45579,
    "blake2b-96": 45580,
    "blake2b-104": 45581,
    "blake2b-112": 45582,
    "blake2b-120": 45583,
    "blake2b-128": 45584,
    "blake2b-136": 45585,
    "blake2b-144": 45586,
    "blake2b-152": 45587,
    "blake2b-160": 45588,
    "blake2b-168": 45589,
    "blake2b-176": 45590,
    "blake2b-184": 45591,
    "blake2b-192": 45592,
    "blake2b-200": 45593,
    "blake2b-208": 45594,
    "blake2b-216": 45595,
    "blake2b-224": 45596,
    "blake2b-232": 45597,
    "blake2b-240": 45598,
    "blake2b-248": 45599,
    "blake2b-256": 45600,
    "blake2b-264": 45601,
    "blake2b-272": 45602,
    "blake2b-280": 45603,
    "blake2b-288": 45604,
    "blake2b-296": 45605,
    "blake2b-304": 45606,
    "blake2b-312": 45607,
    "blake2b-320": 45608,
    "blake2b-328": 45609,
    "blake2b-336": 45610,
    "blake2b-344": 45611,
    "blake2b-352": 45612,
    "blake2b-360": 45613,
    "blake2b-368": 45614,
    "blake2b-376": 45615,
    "blake2b-384": 45616,
    "blake2b-392": 45617,
    "blake2b-400": 45618,
    "blake2b-408": 45619,
    "blake2b-416": 45620,
    "blake2b-424": 45621,
    "blake2b-432": 45622,
    "blake2b-440": 45623,
    "blake2b-448": 45624,
    "blake2b-456": 45625,
    "blake2b-464": 45626,
    "blake2b-472": 45627,
    "blake2b-480": 45628,
    "blake2b-488": 45629,
    "blake2b-496": 45630,
    "blake2b-504": 45631,
    "blake2b-512": 45632,
    "blake2s-8": 45633,
    "blake2s-16": 45634,
    "blake2s-24": 45635,
    "blake2s-32": 45636,
    "blake2s-40": 45637,
    "blake2s-48": 45638,
    "blake2s-56": 45639,
    "blake2s-64": 45640,
    "blake2s-72": 45641,
    "blake2s-80": 45642,
    "blake2s-88": 45643,
    "blake2s-96": 45644,
    "blake2s-104": 45645,
    "blake2s-112": 45646,
    "blake2s-120": 45647,
    "blake2s-128": 45648,
    "blake2s-136": 45649,
    "blake2s-144": 45650,
    "blake2s-152": 45651,
    "blake2s-160": 45652,
    "blake2s-168": 45653,
    "blake2s-176": 45654,
    "blake2s-184": 45655,
    "blake2s-192": 45656,
    "blake2s-200": 45657,
    "blake2s-208": 45658,
    "blake2s-216": 45659,
    "blake2s-224": 45660,
    "blake2s-232": 45661,
    "blake2s-240": 45662,
    "blake2s-248": 45663,
    "blake2s-256": 45664,
    "Skein256-8": 45825,
    "Skein256-16": 45826,
    "Skein256-24": 45827,
    "Skein256-32": 45828,
    "Skein256-40": 45829,
    "Skein256-48": 45830,
    "Skein256-56": 45831,
    "Skein256-64": 45832,
    "Skein256-72": 45833,
    "Skein256-80": 45834,
    "Skein256-88": 45835,
    "Skein256-96": 45836,
    "Skein256-104": 45837,
    "Skein256-112": 45838,
    "Skein256-120": 45839,
    "Skein256-128": 45840,
    "Skein256-136": 45841,
    "Skein256-144": 45842,
    "Skein256-152": 45843,
    "Skein256-160": 45844,
    "Skein256-168": 45845,
    "Skein256-176": 45846,
    "Skein256-184": 45847,
    "Skein256-192": 45848,
    "Skein256-200": 45849,
    "Skein256-208": 45850,
    "Skein256-216": 45851,
    "Skein256-224": 45852,
    "Skein256-232": 45853,
    "Skein256-240": 45854,
    "Skein256-248": 45855,
    "Skein256-256": 45856,
    "Skein512-8": 45857,
    "Skein512-16": 45858,
    "Skein512-24": 45859,
    "Skein512-32": 45860,
    "Skein512-40": 45861,
    "Skein512-48": 45862,
    "Skein512-56": 45863,
    "Skein512-64": 45864,
    "Skein512-72": 45865,
    "Skein512-80": 45866,
    "Skein512-88": 45867,
    "Skein512-96": 45868,
    "Skein512-104": 45869,
    "Skein512-112": 45870,
    "Skein512-120": 45871,
    "Skein512-128": 45872,
    "Skein512-136": 45873,
    "Skein512-144": 45874,
    "Skein512-152": 45875,
    "Skein512-160": 45876,
    "Skein512-168": 45877,
    "Skein512-176": 45878,
    "Skein512-184": 45879,
    "Skein512-192": 45880,
    "Skein512-200": 45881,
    "Skein512-208": 45882,
    "Skein512-216": 45883,
    "Skein512-224": 45884,
    "Skein512-232": 45885,
    "Skein512-240": 45886,
    "Skein512-248": 45887,
    "Skein512-256": 45888,
    "Skein512-264": 45889,
    "Skein512-272": 45890,
    "Skein512-280": 45891,
    "Skein512-288": 45892,
    "Skein512-296": 45893,
    "Skein512-304": 45894,
    "Skein512-312": 45895,
    "Skein512-320": 45896,
    "Skein512-328": 45897,
    "Skein512-336": 45898,
    "Skein512-344": 45899,
    "Skein512-352": 45900,
    "Skein512-360": 45901,
    "Skein512-368": 45902,
    "Skein512-376": 45903,
    "Skein512-384": 45904,
    "Skein512-392": 45905,
    "Skein512-400": 45906,
    "Skein512-408": 45907,
    "Skein512-416": 45908,
    "Skein512-424": 45909,
    "Skein512-432": 45910,
    "Skein512-440": 45911,
    "Skein512-448": 45912,
    "Skein512-456": 45913,
    "Skein512-464": 45914,
    "Skein512-472": 45915,
    "Skein512-480": 45916,
    "Skein512-488": 45917,
    "Skein512-496": 45918,
    "Skein512-504": 45919,
    "Skein512-512": 45920,
    "Skein1024-8": 45921,
    "Skein1024-16": 45922,
    "Skein1024-24": 45923,
    "Skein1024-32": 45924,
    "Skein1024-40": 45925,
    "Skein1024-48": 45926,
    "Skein1024-56": 45927,
    "Skein1024-64": 45928,
    "Skein1024-72": 45929,
    "Skein1024-80": 45930,
    "Skein1024-88": 45931,
    "Skein1024-96": 45932,
    "Skein1024-104": 45933,
    "Skein1024-112": 45934,
    "Skein1024-120": 45935,
    "Skein1024-128": 45936,
    "Skein1024-136": 45937,
    "Skein1024-144": 45938,
    "Skein1024-152": 45939,
    "Skein1024-160": 45940,
    "Skein1024-168": 45941,
    "Skein1024-176": 45942,
    "Skein1024-184": 45943,
    "Skein1024-192": 45944,
    "Skein1024-200": 45945,
    "Skein1024-208": 45946,
    "Skein1024-216": 45947,
    "Skein1024-224": 45948,
    "Skein1024-232": 45949,
    "Skein1024-240": 45950,
    "Skein1024-248": 45951,
    "Skein1024-256": 45952,
    "Skein1024-264": 45953,
    "Skein1024-272": 45954,
    "Skein1024-280": 45955,
    "Skein1024-288": 45956,
    "Skein1024-296": 45957,
    "Skein1024-304": 45958,
    "Skein1024-312": 45959,
    "Skein1024-320": 45960,
    "Skein1024-328": 45961,
    "Skein1024-336": 45962,
    "Skein1024-344": 45963,
    "Skein1024-352": 45964,
    "Skein1024-360": 45965,
    "Skein1024-368": 45966,
    "Skein1024-376": 45967,
    "Skein1024-384": 45968,
    "Skein1024-392": 45969,
    "Skein1024-400": 45970,
    "Skein1024-408": 45971,
    "Skein1024-416": 45972,
    "Skein1024-424": 45973,
    "Skein1024-432": 45974,
    "Skein1024-440": 45975,
    "Skein1024-448": 45976,
    "Skein1024-456": 45977,
    "Skein1024-464": 45978,
    "Skein1024-472": 45979,
    "Skein1024-480": 45980,
    "Skein1024-488": 45981,
    "Skein1024-496": 45982,
    "Skein1024-504": 45983,
    "Skein1024-512": 45984,
    "Skein1024-520": 45985,
    "Skein1024-528": 45986,
    "Skein1024-536": 45987,
    "Skein1024-544": 45988,
    "Skein1024-552": 45989,
    "Skein1024-560": 45990,
    "Skein1024-568": 45991,
    "Skein1024-576": 45992,
    "Skein1024-584": 45993,
    "Skein1024-592": 45994,
    "Skein1024-600": 45995,
    "Skein1024-608": 45996,
    "Skein1024-616": 45997,
    "Skein1024-624": 45998,
    "Skein1024-632": 45999,
    "Skein1024-640": 46e3,
    "Skein1024-648": 46001,
    "Skein1024-656": 46002,
    "Skein1024-664": 46003,
    "Skein1024-672": 46004,
    "Skein1024-680": 46005,
    "Skein1024-688": 46006,
    "Skein1024-696": 46007,
    "Skein1024-704": 46008,
    "Skein1024-712": 46009,
    "Skein1024-720": 46010,
    "Skein1024-728": 46011,
    "Skein1024-736": 46012,
    "Skein1024-744": 46013,
    "Skein1024-752": 46014,
    "Skein1024-760": 46015,
    "Skein1024-768": 46016,
    "Skein1024-776": 46017,
    "Skein1024-784": 46018,
    "Skein1024-792": 46019,
    "Skein1024-800": 46020,
    "Skein1024-808": 46021,
    "Skein1024-816": 46022,
    "Skein1024-824": 46023,
    "Skein1024-832": 46024,
    "Skein1024-840": 46025,
    "Skein1024-848": 46026,
    "Skein1024-856": 46027,
    "Skein1024-864": 46028,
    "Skein1024-872": 46029,
    "Skein1024-880": 46030,
    "Skein1024-888": 46031,
    "Skein1024-896": 46032,
    "Skein1024-904": 46033,
    "Skein1024-912": 46034,
    "Skein1024-920": 46035,
    "Skein1024-928": 46036,
    "Skein1024-936": 46037,
    "Skein1024-944": 46038,
    "Skein1024-952": 46039,
    "Skein1024-960": 46040,
    "Skein1024-968": 46041,
    "Skein1024-976": 46042,
    "Skein1024-984": 46043,
    "Skein1024-992": 46044,
    "Skein1024-1000": 46045,
    "Skein1024-1008": 46046,
    "Skein1024-1016": 46047,
    "Skein1024-1024": 46048
  }), t.codes = Object.freeze({
    17: "sha1",
    18: "sha2-256",
    19: "sha2-512",
    86: "dbl-sha2-256",
    23: "sha3-224",
    22: "sha3-256",
    21: "sha3-384",
    20: "sha3-512",
    24: "shake-128",
    25: "shake-256",
    26: "keccak-224",
    27: "keccak-256",
    28: "keccak-384",
    29: "keccak-512",
    34: "murmur3-128",
    35: "murmur3-32",
    45569: "blake2b-8",
    45570: "blake2b-16",
    45571: "blake2b-24",
    45572: "blake2b-32",
    45573: "blake2b-40",
    45574: "blake2b-48",
    45575: "blake2b-56",
    45576: "blake2b-64",
    45577: "blake2b-72",
    45578: "blake2b-80",
    45579: "blake2b-88",
    45580: "blake2b-96",
    45581: "blake2b-104",
    45582: "blake2b-112",
    45583: "blake2b-120",
    45584: "blake2b-128",
    45585: "blake2b-136",
    45586: "blake2b-144",
    45587: "blake2b-152",
    45588: "blake2b-160",
    45589: "blake2b-168",
    45590: "blake2b-176",
    45591: "blake2b-184",
    45592: "blake2b-192",
    45593: "blake2b-200",
    45594: "blake2b-208",
    45595: "blake2b-216",
    45596: "blake2b-224",
    45597: "blake2b-232",
    45598: "blake2b-240",
    45599: "blake2b-248",
    45600: "blake2b-256",
    45601: "blake2b-264",
    45602: "blake2b-272",
    45603: "blake2b-280",
    45604: "blake2b-288",
    45605: "blake2b-296",
    45606: "blake2b-304",
    45607: "blake2b-312",
    45608: "blake2b-320",
    45609: "blake2b-328",
    45610: "blake2b-336",
    45611: "blake2b-344",
    45612: "blake2b-352",
    45613: "blake2b-360",
    45614: "blake2b-368",
    45615: "blake2b-376",
    45616: "blake2b-384",
    45617: "blake2b-392",
    45618: "blake2b-400",
    45619: "blake2b-408",
    45620: "blake2b-416",
    45621: "blake2b-424",
    45622: "blake2b-432",
    45623: "blake2b-440",
    45624: "blake2b-448",
    45625: "blake2b-456",
    45626: "blake2b-464",
    45627: "blake2b-472",
    45628: "blake2b-480",
    45629: "blake2b-488",
    45630: "blake2b-496",
    45631: "blake2b-504",
    45632: "blake2b-512",
    45633: "blake2s-8",
    45634: "blake2s-16",
    45635: "blake2s-24",
    45636: "blake2s-32",
    45637: "blake2s-40",
    45638: "blake2s-48",
    45639: "blake2s-56",
    45640: "blake2s-64",
    45641: "blake2s-72",
    45642: "blake2s-80",
    45643: "blake2s-88",
    45644: "blake2s-96",
    45645: "blake2s-104",
    45646: "blake2s-112",
    45647: "blake2s-120",
    45648: "blake2s-128",
    45649: "blake2s-136",
    45650: "blake2s-144",
    45651: "blake2s-152",
    45652: "blake2s-160",
    45653: "blake2s-168",
    45654: "blake2s-176",
    45655: "blake2s-184",
    45656: "blake2s-192",
    45657: "blake2s-200",
    45658: "blake2s-208",
    45659: "blake2s-216",
    45660: "blake2s-224",
    45661: "blake2s-232",
    45662: "blake2s-240",
    45663: "blake2s-248",
    45664: "blake2s-256",
    45825: "Skein256-8",
    45826: "Skein256-16",
    45827: "Skein256-24",
    45828: "Skein256-32",
    45829: "Skein256-40",
    45830: "Skein256-48",
    45831: "Skein256-56",
    45832: "Skein256-64",
    45833: "Skein256-72",
    45834: "Skein256-80",
    45835: "Skein256-88",
    45836: "Skein256-96",
    45837: "Skein256-104",
    45838: "Skein256-112",
    45839: "Skein256-120",
    45840: "Skein256-128",
    45841: "Skein256-136",
    45842: "Skein256-144",
    45843: "Skein256-152",
    45844: "Skein256-160",
    45845: "Skein256-168",
    45846: "Skein256-176",
    45847: "Skein256-184",
    45848: "Skein256-192",
    45849: "Skein256-200",
    45850: "Skein256-208",
    45851: "Skein256-216",
    45852: "Skein256-224",
    45853: "Skein256-232",
    45854: "Skein256-240",
    45855: "Skein256-248",
    45856: "Skein256-256",
    45857: "Skein512-8",
    45858: "Skein512-16",
    45859: "Skein512-24",
    45860: "Skein512-32",
    45861: "Skein512-40",
    45862: "Skein512-48",
    45863: "Skein512-56",
    45864: "Skein512-64",
    45865: "Skein512-72",
    45866: "Skein512-80",
    45867: "Skein512-88",
    45868: "Skein512-96",
    45869: "Skein512-104",
    45870: "Skein512-112",
    45871: "Skein512-120",
    45872: "Skein512-128",
    45873: "Skein512-136",
    45874: "Skein512-144",
    45875: "Skein512-152",
    45876: "Skein512-160",
    45877: "Skein512-168",
    45878: "Skein512-176",
    45879: "Skein512-184",
    45880: "Skein512-192",
    45881: "Skein512-200",
    45882: "Skein512-208",
    45883: "Skein512-216",
    45884: "Skein512-224",
    45885: "Skein512-232",
    45886: "Skein512-240",
    45887: "Skein512-248",
    45888: "Skein512-256",
    45889: "Skein512-264",
    45890: "Skein512-272",
    45891: "Skein512-280",
    45892: "Skein512-288",
    45893: "Skein512-296",
    45894: "Skein512-304",
    45895: "Skein512-312",
    45896: "Skein512-320",
    45897: "Skein512-328",
    45898: "Skein512-336",
    45899: "Skein512-344",
    45900: "Skein512-352",
    45901: "Skein512-360",
    45902: "Skein512-368",
    45903: "Skein512-376",
    45904: "Skein512-384",
    45905: "Skein512-392",
    45906: "Skein512-400",
    45907: "Skein512-408",
    45908: "Skein512-416",
    45909: "Skein512-424",
    45910: "Skein512-432",
    45911: "Skein512-440",
    45912: "Skein512-448",
    45913: "Skein512-456",
    45914: "Skein512-464",
    45915: "Skein512-472",
    45916: "Skein512-480",
    45917: "Skein512-488",
    45918: "Skein512-496",
    45919: "Skein512-504",
    45920: "Skein512-512",
    45921: "Skein1024-8",
    45922: "Skein1024-16",
    45923: "Skein1024-24",
    45924: "Skein1024-32",
    45925: "Skein1024-40",
    45926: "Skein1024-48",
    45927: "Skein1024-56",
    45928: "Skein1024-64",
    45929: "Skein1024-72",
    45930: "Skein1024-80",
    45931: "Skein1024-88",
    45932: "Skein1024-96",
    45933: "Skein1024-104",
    45934: "Skein1024-112",
    45935: "Skein1024-120",
    45936: "Skein1024-128",
    45937: "Skein1024-136",
    45938: "Skein1024-144",
    45939: "Skein1024-152",
    45940: "Skein1024-160",
    45941: "Skein1024-168",
    45942: "Skein1024-176",
    45943: "Skein1024-184",
    45944: "Skein1024-192",
    45945: "Skein1024-200",
    45946: "Skein1024-208",
    45947: "Skein1024-216",
    45948: "Skein1024-224",
    45949: "Skein1024-232",
    45950: "Skein1024-240",
    45951: "Skein1024-248",
    45952: "Skein1024-256",
    45953: "Skein1024-264",
    45954: "Skein1024-272",
    45955: "Skein1024-280",
    45956: "Skein1024-288",
    45957: "Skein1024-296",
    45958: "Skein1024-304",
    45959: "Skein1024-312",
    45960: "Skein1024-320",
    45961: "Skein1024-328",
    45962: "Skein1024-336",
    45963: "Skein1024-344",
    45964: "Skein1024-352",
    45965: "Skein1024-360",
    45966: "Skein1024-368",
    45967: "Skein1024-376",
    45968: "Skein1024-384",
    45969: "Skein1024-392",
    45970: "Skein1024-400",
    45971: "Skein1024-408",
    45972: "Skein1024-416",
    45973: "Skein1024-424",
    45974: "Skein1024-432",
    45975: "Skein1024-440",
    45976: "Skein1024-448",
    45977: "Skein1024-456",
    45978: "Skein1024-464",
    45979: "Skein1024-472",
    45980: "Skein1024-480",
    45981: "Skein1024-488",
    45982: "Skein1024-496",
    45983: "Skein1024-504",
    45984: "Skein1024-512",
    45985: "Skein1024-520",
    45986: "Skein1024-528",
    45987: "Skein1024-536",
    45988: "Skein1024-544",
    45989: "Skein1024-552",
    45990: "Skein1024-560",
    45991: "Skein1024-568",
    45992: "Skein1024-576",
    45993: "Skein1024-584",
    45994: "Skein1024-592",
    45995: "Skein1024-600",
    45996: "Skein1024-608",
    45997: "Skein1024-616",
    45998: "Skein1024-624",
    45999: "Skein1024-632",
    46000: "Skein1024-640",
    46001: "Skein1024-648",
    46002: "Skein1024-656",
    46003: "Skein1024-664",
    46004: "Skein1024-672",
    46005: "Skein1024-680",
    46006: "Skein1024-688",
    46007: "Skein1024-696",
    46008: "Skein1024-704",
    46009: "Skein1024-712",
    46010: "Skein1024-720",
    46011: "Skein1024-728",
    46012: "Skein1024-736",
    46013: "Skein1024-744",
    46014: "Skein1024-752",
    46015: "Skein1024-760",
    46016: "Skein1024-768",
    46017: "Skein1024-776",
    46018: "Skein1024-784",
    46019: "Skein1024-792",
    46020: "Skein1024-800",
    46021: "Skein1024-808",
    46022: "Skein1024-816",
    46023: "Skein1024-824",
    46024: "Skein1024-832",
    46025: "Skein1024-840",
    46026: "Skein1024-848",
    46027: "Skein1024-856",
    46028: "Skein1024-864",
    46029: "Skein1024-872",
    46030: "Skein1024-880",
    46031: "Skein1024-888",
    46032: "Skein1024-896",
    46033: "Skein1024-904",
    46034: "Skein1024-912",
    46035: "Skein1024-920",
    46036: "Skein1024-928",
    46037: "Skein1024-936",
    46038: "Skein1024-944",
    46039: "Skein1024-952",
    46040: "Skein1024-960",
    46041: "Skein1024-968",
    46042: "Skein1024-976",
    46043: "Skein1024-984",
    46044: "Skein1024-992",
    46045: "Skein1024-1000",
    46046: "Skein1024-1008",
    46047: "Skein1024-1016",
    46048: "Skein1024-1024"
  }), t.defaultLengths = Object.freeze({
    17: 20,
    18: 32,
    19: 64,
    86: 32,
    23: 28,
    22: 32,
    21: 48,
    20: 64,
    24: 32,
    25: 64,
    26: 28,
    27: 32,
    28: 48,
    29: 64,
    34: 32,
    45569: 1,
    45570: 2,
    45571: 3,
    45572: 4,
    45573: 5,
    45574: 6,
    45575: 7,
    45576: 8,
    45577: 9,
    45578: 10,
    45579: 11,
    45580: 12,
    45581: 13,
    45582: 14,
    45583: 15,
    45584: 16,
    45585: 17,
    45586: 18,
    45587: 19,
    45588: 20,
    45589: 21,
    45590: 22,
    45591: 23,
    45592: 24,
    45593: 25,
    45594: 26,
    45595: 27,
    45596: 28,
    45597: 29,
    45598: 30,
    45599: 31,
    45600: 32,
    45601: 33,
    45602: 34,
    45603: 35,
    45604: 36,
    45605: 37,
    45606: 38,
    45607: 39,
    45608: 40,
    45609: 41,
    45610: 42,
    45611: 43,
    45612: 44,
    45613: 45,
    45614: 46,
    45615: 47,
    45616: 48,
    45617: 49,
    45618: 50,
    45619: 51,
    45620: 52,
    45621: 53,
    45622: 54,
    45623: 55,
    45624: 56,
    45625: 57,
    45626: 58,
    45627: 59,
    45628: 60,
    45629: 61,
    45630: 62,
    45631: 63,
    45632: 64,
    45633: 1,
    45634: 2,
    45635: 3,
    45636: 4,
    45637: 5,
    45638: 6,
    45639: 7,
    45640: 8,
    45641: 9,
    45642: 10,
    45643: 11,
    45644: 12,
    45645: 13,
    45646: 14,
    45647: 15,
    45648: 16,
    45649: 17,
    45650: 18,
    45651: 19,
    45652: 20,
    45653: 21,
    45654: 22,
    45655: 23,
    45656: 24,
    45657: 25,
    45658: 26,
    45659: 27,
    45660: 28,
    45661: 29,
    45662: 30,
    45663: 31,
    45664: 32,
    45825: 1,
    45826: 2,
    45827: 3,
    45828: 4,
    45829: 5,
    45830: 6,
    45831: 7,
    45832: 8,
    45833: 9,
    45834: 10,
    45835: 11,
    45836: 12,
    45837: 13,
    45838: 14,
    45839: 15,
    45840: 16,
    45841: 17,
    45842: 18,
    45843: 19,
    45844: 20,
    45845: 21,
    45846: 22,
    45847: 23,
    45848: 24,
    45849: 25,
    45850: 26,
    45851: 27,
    45852: 28,
    45853: 29,
    45854: 30,
    45855: 31,
    45856: 32,
    45857: 1,
    45858: 2,
    45859: 3,
    45860: 4,
    45861: 5,
    45862: 6,
    45863: 7,
    45864: 8,
    45865: 9,
    45866: 10,
    45867: 11,
    45868: 12,
    45869: 13,
    45870: 14,
    45871: 15,
    45872: 16,
    45873: 17,
    45874: 18,
    45875: 19,
    45876: 20,
    45877: 21,
    45878: 22,
    45879: 23,
    45880: 24,
    45881: 25,
    45882: 26,
    45883: 27,
    45884: 28,
    45885: 29,
    45886: 30,
    45887: 31,
    45888: 32,
    45889: 33,
    45890: 34,
    45891: 35,
    45892: 36,
    45893: 37,
    45894: 38,
    45895: 39,
    45896: 40,
    45897: 41,
    45898: 42,
    45899: 43,
    45900: 44,
    45901: 45,
    45902: 46,
    45903: 47,
    45904: 48,
    45905: 49,
    45906: 50,
    45907: 51,
    45908: 52,
    45909: 53,
    45910: 54,
    45911: 55,
    45912: 56,
    45913: 57,
    45914: 58,
    45915: 59,
    45916: 60,
    45917: 61,
    45918: 62,
    45919: 63,
    45920: 64,
    45921: 1,
    45922: 2,
    45923: 3,
    45924: 4,
    45925: 5,
    45926: 6,
    45927: 7,
    45928: 8,
    45929: 9,
    45930: 10,
    45931: 11,
    45932: 12,
    45933: 13,
    45934: 14,
    45935: 15,
    45936: 16,
    45937: 17,
    45938: 18,
    45939: 19,
    45940: 20,
    45941: 21,
    45942: 22,
    45943: 23,
    45944: 24,
    45945: 25,
    45946: 26,
    45947: 27,
    45948: 28,
    45949: 29,
    45950: 30,
    45951: 31,
    45952: 32,
    45953: 33,
    45954: 34,
    45955: 35,
    45956: 36,
    45957: 37,
    45958: 38,
    45959: 39,
    45960: 40,
    45961: 41,
    45962: 42,
    45963: 43,
    45964: 44,
    45965: 45,
    45966: 46,
    45967: 47,
    45968: 48,
    45969: 49,
    45970: 50,
    45971: 51,
    45972: 52,
    45973: 53,
    45974: 54,
    45975: 55,
    45976: 56,
    45977: 57,
    45978: 58,
    45979: 59,
    45980: 60,
    45981: 61,
    45982: 62,
    45983: 63,
    45984: 64,
    45985: 65,
    45986: 66,
    45987: 67,
    45988: 68,
    45989: 69,
    45990: 70,
    45991: 71,
    45992: 72,
    45993: 73,
    45994: 74,
    45995: 75,
    45996: 76,
    45997: 77,
    45998: 78,
    45999: 79,
    46000: 80,
    46001: 81,
    46002: 82,
    46003: 83,
    46004: 84,
    46005: 85,
    46006: 86,
    46007: 87,
    46008: 88,
    46009: 89,
    46010: 90,
    46011: 91,
    46012: 92,
    46013: 93,
    46014: 94,
    46015: 95,
    46016: 96,
    46017: 97,
    46018: 98,
    46019: 99,
    46020: 100,
    46021: 101,
    46022: 102,
    46023: 103,
    46024: 104,
    46025: 105,
    46026: 106,
    46027: 107,
    46028: 108,
    46029: 109,
    46030: 110,
    46031: 111,
    46032: 112,
    46033: 113,
    46034: 114,
    46035: 115,
    46036: 116,
    46037: 117,
    46038: 118,
    46039: 119,
    46040: 120,
    46041: 121,
    46042: 122,
    46043: 123,
    46044: 124,
    46045: 125,
    46046: 126,
    46047: 127,
    46048: 128
  });
}, function (e, t, r) {
  e.exports = {
    encode: r(103),
    decode: r(104),
    encodingLength: r(105)
  };
}, function (e, t) {
  e.exports = function e(t, o, a) {
    o = o || [];
    a = a || 0;
    var s = a;

    for (; t >= i;) {
      o[a++] = 255 & t | r, t /= 128;
    }

    for (; t & n;) {
      o[a++] = 255 & t | r, t >>>= 7;
    }

    o[a] = 0 | t;
    e.bytes = a - s + 1;
    return o;
  };

  var r = 128,
      n = -128,
      i = Math.pow(2, 31);
}, function (e, t) {
  e.exports = function e(t, i) {
    var o,
        a = 0,
        i = i || 0,
        s = 0,
        f = i,
        c = t.length;

    do {
      if (f >= c) throw e.bytes = 0, new RangeError("Could not decode varint");
      o = t[f++], a += s < 28 ? (o & n) << s : (o & n) * Math.pow(2, s), s += 7;
    } while (o >= r);

    e.bytes = f - i;
    return a;
  };

  var r = 128,
      n = 127;
}, function (e, t) {
  var r = Math.pow(2, 7),
      n = Math.pow(2, 14),
      i = Math.pow(2, 21),
      o = Math.pow(2, 28),
      a = Math.pow(2, 35),
      s = Math.pow(2, 42),
      f = Math.pow(2, 49),
      c = Math.pow(2, 56),
      u = Math.pow(2, 63);

  e.exports = function (e) {
    return e < r ? 1 : e < n ? 2 : e < i ? 3 : e < o ? 4 : e < a ? 5 : e < s ? 6 : e < f ? 7 : e < c ? 8 : e < u ? 9 : 10;
  };
}, function (e, t, r) {
  "use strict";

  var n,
      i,
      o,
      a = r(41),
      s = a(r(15)),
      f = a(r(26)),
      c = r(57).fetchText,
      u = r(107);
  r(188).default(), r(190)(), e.exports = {
    verifyGithub: (o = (0, f.default)(s.default.mark(function e(t, r) {
      var n;
      return s.default.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (r && "" !== r.trim()) {
                e.next = 2;
                break;
              }

              return e.abrupt("return", null);

            case 2:
              return e.next = 4, c(r);

            case 4:
              if (-1 !== e.sent.indexOf(t)) {
                e.next = 7;
                break;
              }

              throw new Error("Gist File provided does not contain the correct DID of the user");

            case 7:
              return n = r.split("/")[3], e.abrupt("return", {
                username: n,
                proof: r
              });

            case 9:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return o.apply(this, arguments);
    }),
    verifyTwitter: (i = (0, f.default)(s.default.mark(function e(t, r) {
      var n, i;
      return s.default.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (r) {
                e.next = 2;
                break;
              }

              return e.abrupt("return", null);

            case 2:
              return e.next = 4, u.verifyJWT(r);

            case 4:
              if ((n = e.sent).payload.sub === t) {
                e.next = 7;
                break;
              }

              throw new Error("Verification not valid for given user");

            case 7:
              if ((i = n.payload.claim).twitter_handle && i.twitter_proof) {
                e.next = 10;
                break;
              }

              throw new Error("The claim for your twitter is not correct");

            case 10:
              return e.abrupt("return", {
                username: i.twitter_handle,
                proof: i.twitter_proof,
                verifiedBy: n.payload.iss
              });

            case 11:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return i.apply(this, arguments);
    }),
    verifyDID: (n = (0, f.default)(s.default.mark(function e(t) {
      var r;
      return s.default.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, u.verifyJWT(t);

            case 2:
              return r = e.sent, e.abrupt("return", r.payload.iss);

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return n.apply(this, arguments);
    })
  };
}, function (e, t, r) {
  "use strict";

  var n,
      i = r(108),
      o = (n = i) && n.__esModule ? n : {
    default: n
  },
      a = r(169);
  e.exports = {
    SimpleSigner: o.default,
    verifyJWT: a.verifyJWT,
    createJWT: a.createJWT,
    decodeJWT: a.decodeJWT
  };
}, function (e, t, r) {
  "use strict";

  var n = s(r(19)),
      i = s(r(20)),
      o = r(2),
      a = r(80);

  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var f = new o.ec("secp256k1");

  function c(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 64;
    return e.length === t ? e : "0".repeat(t - e.length) + e;
  }

  e.exports = function (e) {
    var t,
        r = this,
        o = f.keyFromPrivate(e);
    return t = (0, i.default)(n.default.mark(function e(t) {
      var i, s, f, u;
      return n.default.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return i = o.sign((0, a.sha256)(t)), s = i.r, f = i.s, u = i.recoveryParam, e.abrupt("return", {
                r: c(s.toString("hex")),
                s: c(f.toString("hex")),
                recoveryParam: u
              });

            case 2:
            case "end":
              return e.stop();
          }
        }
      }, e, r);
    })), function (e) {
      return t.apply(this, arguments);
    };
  };
}, function (e, t, r) {
  var n = function () {
    return this;
  }() || Function("return this")(),
      i = n.regeneratorRuntime && Object.getOwnPropertyNames(n).indexOf("regeneratorRuntime") >= 0,
      o = i && n.regeneratorRuntime;

  if (n.regeneratorRuntime = void 0, e.exports = r(110), i) n.regeneratorRuntime = o;else try {
    delete n.regeneratorRuntime;
  } catch (e) {
    n.regeneratorRuntime = void 0;
  }
}, function (e, t) {
  !function (t) {
    "use strict";

    var r,
        n = Object.prototype,
        i = n.hasOwnProperty,
        o = "function" == typeof Symbol ? Symbol : {},
        a = o.iterator || "@@iterator",
        s = o.asyncIterator || "@@asyncIterator",
        f = o.toStringTag || "@@toStringTag",
        c = "object" == typeof e,
        u = t.regeneratorRuntime;
    if (u) c && (e.exports = u);else {
      (u = t.regeneratorRuntime = c ? e.exports : {}).wrap = A;
      var d = "suspendedStart",
          h = "suspendedYield",
          l = "executing",
          p = "completed",
          b = {},
          v = {};

      v[a] = function () {
        return this;
      };

      var m = Object.getPrototypeOf,
          y = m && m(m(R([])));
      y && y !== n && i.call(y, a) && (v = y);
      var g = S.prototype = _.prototype = Object.create(v);
      x.prototype = g.constructor = S, S.constructor = x, S[f] = x.displayName = "GeneratorFunction", u.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === x || "GeneratorFunction" === (t.displayName || t.name));
      }, u.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, S) : (e.__proto__ = S, f in e || (e[f] = "GeneratorFunction")), e.prototype = Object.create(g), e;
      }, u.awrap = function (e) {
        return {
          __await: e
        };
      }, k(E.prototype), E.prototype[s] = function () {
        return this;
      }, u.AsyncIterator = E, u.async = function (e, t, r, n) {
        var i = new E(A(e, t, r, n));
        return u.isGeneratorFunction(t) ? i : i.next().then(function (e) {
          return e.done ? e.value : i.next();
        });
      }, k(g), g[f] = "Generator", g[a] = function () {
        return this;
      }, g.toString = function () {
        return "[object Generator]";
      }, u.keys = function (e) {
        var t = [];

        for (var r in e) {
          t.push(r);
        }

        return t.reverse(), function r() {
          for (; t.length;) {
            var n = t.pop();
            if (n in e) return r.value = n, r.done = !1, r;
          }

          return r.done = !0, r;
        };
      }, u.values = R, P.prototype = {
        constructor: P,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = r, this.done = !1, this.delegate = null, this.method = "next", this.arg = r, this.tryEntries.forEach(B), !e) for (var t in this) {
            "t" === t.charAt(0) && i.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = r);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var t = this;

          function n(n, i) {
            return s.type = "throw", s.arg = e, t.next = n, i && (t.method = "next", t.arg = r), !!i;
          }

          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var a = this.tryEntries[o],
                s = a.completion;
            if ("root" === a.tryLoc) return n("end");

            if (a.tryLoc <= this.prev) {
              var f = i.call(a, "catchLoc"),
                  c = i.call(a, "finallyLoc");

              if (f && c) {
                if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return n(a.finallyLoc);
              } else if (f) {
                if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
              } else {
                if (!c) throw new Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return n(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var n = this.tryEntries[r];

            if (n.tryLoc <= this.prev && i.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
              var o = n;
              break;
            }
          }

          o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
          var a = o ? o.completion : {};
          return a.type = e, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, b) : this.complete(a);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), b;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), B(r), b;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];

            if (r.tryLoc === e) {
              var n = r.completion;

              if ("throw" === n.type) {
                var i = n.arg;
                B(r);
              }

              return i;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, t, n) {
          return this.delegate = {
            iterator: R(e),
            resultName: t,
            nextLoc: n
          }, "next" === this.method && (this.arg = r), b;
        }
      };
    }

    function A(e, t, r, n) {
      var i = t && t.prototype instanceof _ ? t : _,
          o = Object.create(i.prototype),
          a = new P(n || []);
      return o._invoke = function (e, t, r) {
        var n = d;
        return function (i, o) {
          if (n === l) throw new Error("Generator is already running");

          if (n === p) {
            if ("throw" === i) throw o;
            return H();
          }

          for (r.method = i, r.arg = o;;) {
            var a = r.delegate;

            if (a) {
              var s = M(a, r);

              if (s) {
                if (s === b) continue;
                return s;
              }
            }

            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if (n === d) throw n = p, r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            n = l;
            var f = w(e, t, r);

            if ("normal" === f.type) {
              if (n = r.done ? p : h, f.arg === b) continue;
              return {
                value: f.arg,
                done: r.done
              };
            }

            "throw" === f.type && (n = p, r.method = "throw", r.arg = f.arg);
          }
        };
      }(e, r, a), o;
    }

    function w(e, t, r) {
      try {
        return {
          type: "normal",
          arg: e.call(t, r)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }

    function _() {}

    function x() {}

    function S() {}

    function k(e) {
      ["next", "throw", "return"].forEach(function (t) {
        e[t] = function (e) {
          return this._invoke(t, e);
        };
      });
    }

    function E(e) {
      var t;

      this._invoke = function (r, n) {
        function o() {
          return new Promise(function (t, o) {
            !function t(r, n, o, a) {
              var s = w(e[r], e, n);

              if ("throw" !== s.type) {
                var f = s.arg,
                    c = f.value;
                return c && "object" == typeof c && i.call(c, "__await") ? Promise.resolve(c.__await).then(function (e) {
                  t("next", e, o, a);
                }, function (e) {
                  t("throw", e, o, a);
                }) : Promise.resolve(c).then(function (e) {
                  f.value = e, o(f);
                }, a);
              }

              a(s.arg);
            }(r, n, t, o);
          });
        }

        return t = t ? t.then(o, o) : o();
      };
    }

    function M(e, t) {
      var n = e.iterator[t.method];

      if (n === r) {
        if (t.delegate = null, "throw" === t.method) {
          if (e.iterator.return && (t.method = "return", t.arg = r, M(e, t), "throw" === t.method)) return b;
          t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return b;
      }

      var i = w(n, e.iterator, t.arg);
      if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, b;
      var o = i.arg;
      return o ? o.done ? (t[e.resultName] = o.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = r), t.delegate = null, b) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, b);
    }

    function C(e) {
      var t = {
        tryLoc: e[0]
      };
      1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }

    function B(e) {
      var t = e.completion || {};
      t.type = "normal", delete t.arg, e.completion = t;
    }

    function P(e) {
      this.tryEntries = [{
        tryLoc: "root"
      }], e.forEach(C, this), this.reset(!0);
    }

    function R(e) {
      if (e) {
        var t = e[a];
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;

        if (!isNaN(e.length)) {
          var n = -1,
              o = function t() {
            for (; ++n < e.length;) {
              if (i.call(e, n)) return t.value = e[n], t.done = !1, t;
            }

            return t.value = r, t.done = !0, t;
          };

          return o.next = o;
        }
      }

      return {
        next: H
      };
    }

    function H() {
      return {
        value: r,
        done: !0
      };
    }
  }(function () {
    return this;
  }() || Function("return this")());
}, function (e, t, r) {
  r(112), r(113), r(125), r(129), r(141), r(142), e.exports = r(8).Promise;
}, function (e, t) {}, function (e, t, r) {
  "use strict";

  var n = r(114)(!0);
  r(61)(String, "String", function (e) {
    this._t = String(e), this._i = 0;
  }, function () {
    var e,
        t = this._t,
        r = this._i;
    return r >= t.length ? {
      value: void 0,
      done: !0
    } : (e = n(t, r), this._i += e.length, {
      value: e,
      done: !1
    });
  });
}, function (e, t, r) {
  var n = r(42),
      i = r(43);

  e.exports = function (e) {
    return function (t, r) {
      var o,
          a,
          s = String(i(t)),
          f = n(r),
          c = s.length;
      return f < 0 || f >= c ? e ? "" : void 0 : (o = s.charCodeAt(f)) < 55296 || o > 56319 || f + 1 === c || (a = s.charCodeAt(f + 1)) < 56320 || a > 57343 ? e ? s.charAt(f) : o : e ? s.slice(f, f + 2) : a - 56320 + (o - 55296 << 10) + 65536;
    };
  };
}, function (e, t, r) {
  e.exports = !r(23) && !r(45)(function () {
    return 7 != Object.defineProperty(r(46)("div"), "a", {
      get: function get() {
        return 7;
      }
    }).a;
  });
}, function (e, t, r) {
  var n = r(22);

  e.exports = function (e, t) {
    if (!n(e)) return e;
    var r, i;
    if (t && "function" == typeof (r = e.toString) && !n(i = r.call(e))) return i;
    if ("function" == typeof (r = e.valueOf) && !n(i = r.call(e))) return i;
    if (!t && "function" == typeof (r = e.toString) && !n(i = r.call(e))) return i;
    throw TypeError("Can't convert object to primitive value");
  };
}, function (e, t, r) {
  e.exports = r(14);
}, function (e, t, r) {
  "use strict";

  var n = r(119),
      i = r(62),
      o = r(49),
      a = {};
  r(14)(a, r(4)("iterator"), function () {
    return this;
  }), e.exports = function (e, t, r) {
    e.prototype = n(a, {
      next: i(1, r)
    }), o(e, t + " Iterator");
  };
}, function (e, t, r) {
  var n = r(12),
      i = r(120),
      o = r(68),
      a = r(48)("IE_PROTO"),
      s = function s() {},
      _f = function f() {
    var e,
        t = r(46)("iframe"),
        n = o.length;

    for (t.style.display = "none", r(69).appendChild(t), t.src = "javascript:", (e = t.contentWindow.document).open(), e.write("<script>document.F=Object<\/script>"), e.close(), _f = e.F; n--;) {
      delete _f.prototype[o[n]];
    }

    return _f();
  };

  e.exports = Object.create || function (e, t) {
    var r;
    return null !== e ? (s.prototype = n(e), r = new s(), s.prototype = null, r[a] = e) : r = _f(), void 0 === t ? r : i(r, t);
  };
}, function (e, t, r) {
  var n = r(30),
      i = r(12),
      o = r(63);
  e.exports = r(23) ? Object.defineProperties : function (e, t) {
    i(e);

    for (var r, a = o(t), s = a.length, f = 0; s > f;) {
      n.f(e, r = a[f++], t[r]);
    }

    return e;
  };
}, function (e, t, r) {
  var n = r(31),
      i = r(47),
      o = r(122)(!1),
      a = r(48)("IE_PROTO");

  e.exports = function (e, t) {
    var r,
        s = i(e),
        f = 0,
        c = [];

    for (r in s) {
      r != a && n(s, r) && c.push(r);
    }

    for (; t.length > f;) {
      n(s, r = t[f++]) && (~o(c, r) || c.push(r));
    }

    return c;
  };
}, function (e, t, r) {
  var n = r(47),
      i = r(65),
      o = r(123);

  e.exports = function (e) {
    return function (t, r, a) {
      var s,
          f = n(t),
          c = i(f.length),
          u = o(a, c);

      if (e && r != r) {
        for (; c > u;) {
          if ((s = f[u++]) != s) return !0;
        }
      } else for (; c > u; u++) {
        if ((e || u in f) && f[u] === r) return e || u || 0;
      }

      return !e && -1;
    };
  };
}, function (e, t, r) {
  var n = r(42),
      i = Math.max,
      o = Math.min;

  e.exports = function (e, t) {
    return (e = n(e)) < 0 ? i(e + t, 0) : o(e, t);
  };
}, function (e, t, r) {
  var n = r(31),
      i = r(70),
      o = r(48)("IE_PROTO"),
      a = Object.prototype;

  e.exports = Object.getPrototypeOf || function (e) {
    return e = i(e), n(e, o) ? e[o] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? a : null;
  };
}, function (e, t, r) {
  r(126);

  for (var n = r(3), i = r(14), o = r(24), a = r(4)("toStringTag"), s = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), f = 0; f < s.length; f++) {
    var c = s[f],
        u = n[c],
        d = u && u.prototype;
    d && !d[a] && i(d, a, c), o[c] = o.Array;
  }
}, function (e, t, r) {
  "use strict";

  var n = r(127),
      i = r(128),
      o = r(24),
      a = r(47);
  e.exports = r(61)(Array, "Array", function (e, t) {
    this._t = a(e), this._i = 0, this._k = t;
  }, function () {
    var e = this._t,
        t = this._k,
        r = this._i++;
    return !e || r >= e.length ? (this._t = void 0, i(1)) : i(0, "keys" == t ? r : "values" == t ? e[r] : [r, e[r]]);
  }, "values"), o.Arguments = o.Array, n("keys"), n("values"), n("entries");
}, function (e, t) {
  e.exports = function () {};
}, function (e, t) {
  e.exports = function (e, t) {
    return {
      value: t,
      done: !!e
    };
  };
}, function (e, t, r) {
  "use strict";

  var n,
      i,
      o,
      a,
      s = r(44),
      f = r(3),
      c = r(28),
      u = r(71),
      d = r(21),
      h = r(22),
      l = r(29),
      p = r(130),
      b = r(131),
      v = r(72),
      m = r(73).set,
      y = r(136)(),
      g = r(50),
      A = r(74),
      w = r(137),
      _ = r(75),
      x = f.TypeError,
      S = f.process,
      k = S && S.versions,
      E = k && k.v8 || "",
      _M = f.Promise,
      C = "process" == u(S),
      B = function B() {},
      P = i = g.f,
      R = !!function () {
    try {
      var e = _M.resolve(1),
          t = (e.constructor = {})[r(4)("species")] = function (e) {
        e(B, B);
      };

      return (C || "function" == typeof PromiseRejectionEvent) && e.then(B) instanceof t && 0 !== E.indexOf("6.6") && -1 === w.indexOf("Chrome/66");
    } catch (e) {}
  }(),
      H = function H(e) {
    var t;
    return !(!h(e) || "function" != typeof (t = e.then)) && t;
  },
      O = function O(e, t) {
    if (!e._n) {
      e._n = !0;
      var r = e._c;
      y(function () {
        for (var n = e._v, i = 1 == e._s, o = 0, a = function a(t) {
          var r,
              o,
              a,
              s = i ? t.ok : t.fail,
              f = t.resolve,
              c = t.reject,
              u = t.domain;

          try {
            s ? (i || (2 == e._h && j(e), e._h = 1), !0 === s ? r = n : (u && u.enter(), r = s(n), u && (u.exit(), a = !0)), r === t.promise ? c(x("Promise-chain cycle")) : (o = H(r)) ? o.call(r, f, c) : f(r)) : c(n);
          } catch (e) {
            u && !a && u.exit(), c(e);
          }
        }; r.length > o;) {
          a(r[o++]);
        }

        e._c = [], e._n = !1, t && !e._h && T(e);
      });
    }
  },
      T = function T(e) {
    m.call(f, function () {
      var t,
          r,
          n,
          i = e._v,
          o = I(e);
      if (o && (t = A(function () {
        C ? S.emit("unhandledRejection", i, e) : (r = f.onunhandledrejection) ? r({
          promise: e,
          reason: i
        }) : (n = f.console) && n.error && n.error("Unhandled promise rejection", i);
      }), e._h = C || I(e) ? 2 : 1), e._a = void 0, o && t.e) throw t.v;
    });
  },
      I = function I(e) {
    return 1 !== e._h && 0 === (e._a || e._c).length;
  },
      j = function j(e) {
    m.call(f, function () {
      var t;
      C ? S.emit("rejectionHandled", e) : (t = f.onrejectionhandled) && t({
        promise: e,
        reason: e._v
      });
    });
  },
      z = function z(e) {
    var t = this;
    t._d || (t._d = !0, (t = t._w || t)._v = e, t._s = 2, t._a || (t._a = t._c.slice()), O(t, !0));
  },
      L = function L(e) {
    var t,
        r = this;

    if (!r._d) {
      r._d = !0, r = r._w || r;

      try {
        if (r === e) throw x("Promise can't be resolved itself");
        (t = H(e)) ? y(function () {
          var n = {
            _w: r,
            _d: !1
          };

          try {
            t.call(e, c(L, n, 1), c(z, n, 1));
          } catch (e) {
            z.call(n, e);
          }
        }) : (r._v = e, r._s = 1, O(r, !1));
      } catch (e) {
        z.call({
          _w: r,
          _d: !1
        }, e);
      }
    }
  };

  R || (_M = function M(e) {
    p(this, _M, "Promise", "_h"), l(e), n.call(this);

    try {
      e(c(L, this, 1), c(z, this, 1));
    } catch (e) {
      z.call(this, e);
    }
  }, (n = function n(e) {
    this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
  }).prototype = r(138)(_M.prototype, {
    then: function then(e, t) {
      var r = P(v(this, _M));
      return r.ok = "function" != typeof e || e, r.fail = "function" == typeof t && t, r.domain = C ? S.domain : void 0, this._c.push(r), this._a && this._a.push(r), this._s && O(this, !1), r.promise;
    },
    catch: function _catch(e) {
      return this.then(void 0, e);
    }
  }), o = function o() {
    var e = new n();
    this.promise = e, this.resolve = c(L, e, 1), this.reject = c(z, e, 1);
  }, g.f = P = function P(e) {
    return e === _M || e === a ? new o(e) : i(e);
  }), d(d.G + d.W + d.F * !R, {
    Promise: _M
  }), r(49)(_M, "Promise"), r(139)("Promise"), a = r(8).Promise, d(d.S + d.F * !R, "Promise", {
    reject: function reject(e) {
      var t = P(this);
      return (0, t.reject)(e), t.promise;
    }
  }), d(d.S + d.F * (s || !R), "Promise", {
    resolve: function resolve(e) {
      return _(s && this === a ? _M : this, e);
    }
  }), d(d.S + d.F * !(R && r(140)(function (e) {
    _M.all(e).catch(B);
  })), "Promise", {
    all: function all(e) {
      var t = this,
          r = P(t),
          n = r.resolve,
          i = r.reject,
          o = A(function () {
        var r = [],
            o = 0,
            a = 1;
        b(e, !1, function (e) {
          var s = o++,
              f = !1;
          r.push(void 0), a++, t.resolve(e).then(function (e) {
            f || (f = !0, r[s] = e, --a || n(r));
          }, i);
        }), --a || n(r);
      });
      return o.e && i(o.v), r.promise;
    },
    race: function race(e) {
      var t = this,
          r = P(t),
          n = r.reject,
          i = A(function () {
        b(e, !1, function (e) {
          t.resolve(e).then(r.resolve, n);
        });
      });
      return i.e && n(i.v), r.promise;
    }
  });
}, function (e, t) {
  e.exports = function (e, t, r, n) {
    if (!(e instanceof t) || void 0 !== n && n in e) throw TypeError(r + ": incorrect invocation!");
    return e;
  };
}, function (e, t, r) {
  var n = r(28),
      i = r(132),
      o = r(133),
      a = r(12),
      s = r(65),
      f = r(134),
      c = {},
      u = {};
  (t = e.exports = function (e, t, r, d, h) {
    var l,
        p,
        b,
        v,
        m = h ? function () {
      return e;
    } : f(e),
        y = n(r, d, t ? 2 : 1),
        g = 0;
    if ("function" != typeof m) throw TypeError(e + " is not iterable!");

    if (o(m)) {
      for (l = s(e.length); l > g; g++) {
        if ((v = t ? y(a(p = e[g])[0], p[1]) : y(e[g])) === c || v === u) return v;
      }
    } else for (b = m.call(e); !(p = b.next()).done;) {
      if ((v = i(b, y, p.value, t)) === c || v === u) return v;
    }
  }).BREAK = c, t.RETURN = u;
}, function (e, t, r) {
  var n = r(12);

  e.exports = function (e, t, r, i) {
    try {
      return i ? t(n(r)[0], r[1]) : t(r);
    } catch (t) {
      var o = e.return;
      throw void 0 !== o && n(o.call(e)), t;
    }
  };
}, function (e, t, r) {
  var n = r(24),
      i = r(4)("iterator"),
      o = Array.prototype;

  e.exports = function (e) {
    return void 0 !== e && (n.Array === e || o[i] === e);
  };
}, function (e, t, r) {
  var n = r(71),
      i = r(4)("iterator"),
      o = r(24);

  e.exports = r(8).getIteratorMethod = function (e) {
    if (null != e) return e[i] || e["@@iterator"] || o[n(e)];
  };
}, function (e, t) {
  e.exports = function (e, t, r) {
    var n = void 0 === r;

    switch (t.length) {
      case 0:
        return n ? e() : e.call(r);

      case 1:
        return n ? e(t[0]) : e.call(r, t[0]);

      case 2:
        return n ? e(t[0], t[1]) : e.call(r, t[0], t[1]);

      case 3:
        return n ? e(t[0], t[1], t[2]) : e.call(r, t[0], t[1], t[2]);

      case 4:
        return n ? e(t[0], t[1], t[2], t[3]) : e.call(r, t[0], t[1], t[2], t[3]);
    }

    return e.apply(r, t);
  };
}, function (e, t, r) {
  var n = r(3),
      i = r(73).set,
      o = n.MutationObserver || n.WebKitMutationObserver,
      a = n.process,
      s = n.Promise,
      f = "process" == r(32)(a);

  e.exports = function () {
    var e,
        t,
        r,
        c = function c() {
      var n, i;

      for (f && (n = a.domain) && n.exit(); e;) {
        i = e.fn, e = e.next;

        try {
          i();
        } catch (n) {
          throw e ? r() : t = void 0, n;
        }
      }

      t = void 0, n && n.enter();
    };

    if (f) r = function r() {
      a.nextTick(c);
    };else if (!o || n.navigator && n.navigator.standalone) {
      if (s && s.resolve) {
        var u = s.resolve(void 0);

        r = function r() {
          u.then(c);
        };
      } else r = function r() {
        i.call(n, c);
      };
    } else {
      var d = !0,
          h = document.createTextNode("");
      new o(c).observe(h, {
        characterData: !0
      }), r = function r() {
        h.data = d = !d;
      };
    }
    return function (n) {
      var i = {
        fn: n,
        next: void 0
      };
      t && (t.next = i), e || (e = i, r()), t = i;
    };
  };
}, function (e, t, r) {
  var n = r(3).navigator;
  e.exports = n && n.userAgent || "";
}, function (e, t, r) {
  var n = r(14);

  e.exports = function (e, t, r) {
    for (var i in t) {
      r && e[i] ? e[i] = t[i] : n(e, i, t[i]);
    }

    return e;
  };
}, function (e, t, r) {
  "use strict";

  var n = r(3),
      i = r(8),
      o = r(30),
      a = r(23),
      s = r(4)("species");

  e.exports = function (e) {
    var t = "function" == typeof i[e] ? i[e] : n[e];
    a && t && !t[s] && o.f(t, s, {
      configurable: !0,
      get: function get() {
        return this;
      }
    });
  };
}, function (e, t, r) {
  var n = r(4)("iterator"),
      i = !1;

  try {
    var o = [7][n]();
    o.return = function () {
      i = !0;
    }, Array.from(o, function () {
      throw 2;
    });
  } catch (e) {}

  e.exports = function (e, t) {
    if (!t && !i) return !1;
    var r = !1;

    try {
      var o = [7],
          a = o[n]();
      a.next = function () {
        return {
          done: r = !0
        };
      }, o[n] = function () {
        return a;
      }, e(o);
    } catch (e) {}

    return r;
  };
}, function (e, t, r) {
  "use strict";

  var n = r(21),
      i = r(8),
      o = r(3),
      a = r(72),
      s = r(75);
  n(n.P + n.R, "Promise", {
    finally: function _finally(e) {
      var t = a(this, i.Promise || o.Promise),
          r = "function" == typeof e;
      return this.then(r ? function (r) {
        return s(t, e()).then(function () {
          return r;
        });
      } : e, r ? function (r) {
        return s(t, e()).then(function () {
          throw r;
        });
      } : e);
    }
  });
}, function (e, t, r) {
  "use strict";

  var n = r(21),
      i = r(50),
      o = r(74);
  n(n.S, "Promise", {
    try: function _try(e) {
      var t = i.f(this),
          r = o(e);
      return (r.e ? t.reject : t.resolve)(r.v), t.promise;
    }
  });
}, function (e) {
  e.exports = {
    _args: [["elliptic@6.4.1", "/Users/zachferland/profile-hover"]],
    _from: "elliptic@6.4.1",
    _id: "elliptic@6.4.1",
    _inBundle: !1,
    _integrity: "sha512-BsXLz5sqX8OHcsh7CqBMztyXARmGQ3LWPtGjJi6DiJHq5C/qvi9P3OqgswKSDftbu8+IoI/QDTAm2fFnQ9SZSQ==",
    _location: "/elliptic",
    _phantomChildren: {},
    _requested: {
      type: "version",
      registry: !0,
      raw: "elliptic@6.4.1",
      name: "elliptic",
      escapedName: "elliptic",
      rawSpec: "6.4.1",
      saveSpec: null,
      fetchSpec: "6.4.1"
    },
    _requiredBy: ["/browserify-sign", "/create-ecdh", "/did-jwt", "/orbit-db-keystore", "/secp256k1", "/tiny-secp256k1"],
    _resolved: "https://registry.npmjs.org/elliptic/-/elliptic-6.4.1.tgz",
    _spec: "6.4.1",
    _where: "/Users/zachferland/profile-hover",
    author: {
      name: "Fedor Indutny",
      email: "fedor@indutny.com"
    },
    bugs: {
      url: "https://github.com/indutny/elliptic/issues"
    },
    dependencies: {
      "bn.js": "^4.4.0",
      brorand: "^1.0.1",
      "hash.js": "^1.0.0",
      "hmac-drbg": "^1.0.0",
      inherits: "^2.0.1",
      "minimalistic-assert": "^1.0.0",
      "minimalistic-crypto-utils": "^1.0.0"
    },
    description: "EC cryptography",
    devDependencies: {
      brfs: "^1.4.3",
      coveralls: "^2.11.3",
      grunt: "^0.4.5",
      "grunt-browserify": "^5.0.0",
      "grunt-cli": "^1.2.0",
      "grunt-contrib-connect": "^1.0.0",
      "grunt-contrib-copy": "^1.0.0",
      "grunt-contrib-uglify": "^1.0.1",
      "grunt-mocha-istanbul": "^3.0.1",
      "grunt-saucelabs": "^8.6.2",
      istanbul: "^0.4.2",
      jscs: "^2.9.0",
      jshint: "^2.6.0",
      mocha: "^2.1.0"
    },
    files: ["lib"],
    homepage: "https://github.com/indutny/elliptic",
    keywords: ["EC", "Elliptic", "curve", "Cryptography"],
    license: "MIT",
    main: "lib/elliptic.js",
    name: "elliptic",
    repository: {
      type: "git",
      url: "git+ssh://git@github.com/indutny/elliptic.git"
    },
    scripts: {
      jscs: "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
      jshint: "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
      lint: "npm run jscs && npm run jshint",
      test: "npm run lint && npm run unit",
      unit: "istanbul test _mocha --reporter=spec test/index.js",
      version: "grunt dist && git add dist/"
    },
    version: "6.4.1"
  };
}, function (e, t, r) {
  "use strict";

  var n = t,
      i = r(9),
      o = r(13),
      a = r(76);
  n.assert = o, n.toArray = a.toArray, n.zero2 = a.zero2, n.toHex = a.toHex, n.encode = a.encode, n.getNAF = function (e, t) {
    for (var r = [], n = 1 << t + 1, i = e.clone(); i.cmpn(1) >= 0;) {
      var o;

      if (i.isOdd()) {
        var a = i.andln(n - 1);
        o = a > (n >> 1) - 1 ? (n >> 1) - a : a, i.isubn(o);
      } else o = 0;

      r.push(o);

      for (var s = 0 !== i.cmpn(0) && 0 === i.andln(n - 1) ? t + 1 : 1, f = 1; f < s; f++) {
        r.push(0);
      }

      i.iushrn(s);
    }

    return r;
  }, n.getJSF = function (e, t) {
    var r = [[], []];
    e = e.clone(), t = t.clone();

    for (var n = 0, i = 0; e.cmpn(-n) > 0 || t.cmpn(-i) > 0;) {
      var o,
          a,
          s,
          f = e.andln(3) + n & 3,
          c = t.andln(3) + i & 3;
      3 === f && (f = -1), 3 === c && (c = -1), o = 0 == (1 & f) ? 0 : 3 != (s = e.andln(7) + n & 7) && 5 !== s || 2 !== c ? f : -f, r[0].push(o), a = 0 == (1 & c) ? 0 : 3 != (s = t.andln(7) + i & 7) && 5 !== s || 2 !== f ? c : -c, r[1].push(a), 2 * n === o + 1 && (n = 1 - n), 2 * i === a + 1 && (i = 1 - i), e.iushrn(1), t.iushrn(1);
    }

    return r;
  }, n.cachedProperty = function (e, t, r) {
    var n = "_" + t;

    e.prototype[t] = function () {
      return void 0 !== this[n] ? this[n] : this[n] = r.call(this);
    };
  }, n.parseBytes = function (e) {
    return "string" == typeof e ? n.toArray(e, "hex") : e;
  }, n.intFromLE = function (e) {
    return new i(e, "hex", "le");
  };
}, function (e, t) {
  e.exports = function (e) {
    return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
      enumerable: !0,
      get: function get() {
        return e.l;
      }
    }), Object.defineProperty(e, "id", {
      enumerable: !0,
      get: function get() {
        return e.i;
      }
    }), e.webpackPolyfill = 1), e;
  };
}, function (e, t) {}, function (e, t, r) {
  var n;

  function i(e) {
    this.rand = e;
  }

  if (e.exports = function (e) {
    return n || (n = new i(null)), n.generate(e);
  }, e.exports.Rand = i, i.prototype.generate = function (e) {
    return this._rand(e);
  }, i.prototype._rand = function (e) {
    if (this.rand.getBytes) return this.rand.getBytes(e);

    for (var t = new Uint8Array(e), r = 0; r < t.length; r++) {
      t[r] = this.rand.getByte();
    }

    return t;
  }, "object" == typeof self) self.crypto && self.crypto.getRandomValues ? i.prototype._rand = function (e) {
    var t = new Uint8Array(e);
    return self.crypto.getRandomValues(t), t;
  } : self.msCrypto && self.msCrypto.getRandomValues ? i.prototype._rand = function (e) {
    var t = new Uint8Array(e);
    return self.msCrypto.getRandomValues(t), t;
  } : "object" == typeof window && (i.prototype._rand = function () {
    throw new Error("Not implemented yet");
  });else try {
    var o = r(148);
    if ("function" != typeof o.randomBytes) throw new Error("Not supported");

    i.prototype._rand = function (e) {
      return o.randomBytes(e);
    };
  } catch (e) {}
}, function (e, t) {}, function (e, t, r) {
  "use strict";

  var n = r(9),
      i = r(2).utils,
      o = i.getNAF,
      a = i.getJSF,
      s = i.assert;

  function f(e, t) {
    this.type = e, this.p = new n(t.p, 16), this.red = t.prime ? n.red(t.prime) : n.mont(this.p), this.zero = new n(0).toRed(this.red), this.one = new n(1).toRed(this.red), this.two = new n(2).toRed(this.red), this.n = t.n && new n(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4);
    var r = this.n && this.p.div(this.n);
    !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
  }

  function c(e, t) {
    this.curve = e, this.type = t, this.precomputed = null;
  }

  e.exports = f, f.prototype.point = function () {
    throw new Error("Not implemented");
  }, f.prototype.validate = function () {
    throw new Error("Not implemented");
  }, f.prototype._fixedNafMul = function (e, t) {
    s(e.precomputed);

    var r = e._getDoubles(),
        n = o(t, 1),
        i = (1 << r.step + 1) - (r.step % 2 == 0 ? 2 : 1);

    i /= 3;

    for (var a = [], f = 0; f < n.length; f += r.step) {
      var c = 0;

      for (t = f + r.step - 1; t >= f; t--) {
        c = (c << 1) + n[t];
      }

      a.push(c);
    }

    for (var u = this.jpoint(null, null, null), d = this.jpoint(null, null, null), h = i; h > 0; h--) {
      for (f = 0; f < a.length; f++) {
        (c = a[f]) === h ? d = d.mixedAdd(r.points[f]) : c === -h && (d = d.mixedAdd(r.points[f].neg()));
      }

      u = u.add(d);
    }

    return u.toP();
  }, f.prototype._wnafMul = function (e, t) {
    var r = 4,
        n = e._getNAFPoints(r);

    r = n.wnd;

    for (var i = n.points, a = o(t, r), f = this.jpoint(null, null, null), c = a.length - 1; c >= 0; c--) {
      for (t = 0; c >= 0 && 0 === a[c]; c--) {
        t++;
      }

      if (c >= 0 && t++, f = f.dblp(t), c < 0) break;
      var u = a[c];
      s(0 !== u), f = "affine" === e.type ? u > 0 ? f.mixedAdd(i[u - 1 >> 1]) : f.mixedAdd(i[-u - 1 >> 1].neg()) : u > 0 ? f.add(i[u - 1 >> 1]) : f.add(i[-u - 1 >> 1].neg());
    }

    return "affine" === e.type ? f.toP() : f;
  }, f.prototype._wnafMulAdd = function (e, t, r, n, i) {
    for (var s = this._wnafT1, f = this._wnafT2, c = this._wnafT3, u = 0, d = 0; d < n; d++) {
      var h = (k = t[d])._getNAFPoints(e);

      s[d] = h.wnd, f[d] = h.points;
    }

    for (d = n - 1; d >= 1; d -= 2) {
      var l = d - 1,
          p = d;

      if (1 === s[l] && 1 === s[p]) {
        var b = [t[l], null, null, t[p]];
        0 === t[l].y.cmp(t[p].y) ? (b[1] = t[l].add(t[p]), b[2] = t[l].toJ().mixedAdd(t[p].neg())) : 0 === t[l].y.cmp(t[p].y.redNeg()) ? (b[1] = t[l].toJ().mixedAdd(t[p]), b[2] = t[l].add(t[p].neg())) : (b[1] = t[l].toJ().mixedAdd(t[p]), b[2] = t[l].toJ().mixedAdd(t[p].neg()));
        var v = [-3, -1, -5, -7, 0, 7, 5, 1, 3],
            m = a(r[l], r[p]);
        u = Math.max(m[0].length, u), c[l] = new Array(u), c[p] = new Array(u);

        for (var y = 0; y < u; y++) {
          var g = 0 | m[0][y],
              A = 0 | m[1][y];
          c[l][y] = v[3 * (g + 1) + (A + 1)], c[p][y] = 0, f[l] = b;
        }
      } else c[l] = o(r[l], s[l]), c[p] = o(r[p], s[p]), u = Math.max(c[l].length, u), u = Math.max(c[p].length, u);
    }

    var w = this.jpoint(null, null, null),
        _ = this._wnafT4;

    for (d = u; d >= 0; d--) {
      for (var x = 0; d >= 0;) {
        var S = !0;

        for (y = 0; y < n; y++) {
          _[y] = 0 | c[y][d], 0 !== _[y] && (S = !1);
        }

        if (!S) break;
        x++, d--;
      }

      if (d >= 0 && x++, w = w.dblp(x), d < 0) break;

      for (y = 0; y < n; y++) {
        var k,
            E = _[y];
        0 !== E && (E > 0 ? k = f[y][E - 1 >> 1] : E < 0 && (k = f[y][-E - 1 >> 1].neg()), w = "affine" === k.type ? w.mixedAdd(k) : w.add(k));
      }
    }

    for (d = 0; d < n; d++) {
      f[d] = null;
    }

    return i ? w : w.toP();
  }, f.BasePoint = c, c.prototype.eq = function () {
    throw new Error("Not implemented");
  }, c.prototype.validate = function () {
    return this.curve.validate(this);
  }, f.prototype.decodePoint = function (e, t) {
    e = i.toArray(e, t);
    var r = this.p.byteLength();
    if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * r) return 6 === e[0] ? s(e[e.length - 1] % 2 == 0) : 7 === e[0] && s(e[e.length - 1] % 2 == 1), this.point(e.slice(1, 1 + r), e.slice(1 + r, 1 + 2 * r));
    if ((2 === e[0] || 3 === e[0]) && e.length - 1 === r) return this.pointFromX(e.slice(1, 1 + r), 3 === e[0]);
    throw new Error("Unknown point format");
  }, c.prototype.encodeCompressed = function (e) {
    return this.encode(e, !0);
  }, c.prototype._encode = function (e) {
    var t = this.curve.p.byteLength(),
        r = this.getX().toArray("be", t);
    return e ? [this.getY().isEven() ? 2 : 3].concat(r) : [4].concat(r, this.getY().toArray("be", t));
  }, c.prototype.encode = function (e, t) {
    return i.encode(this._encode(t), e);
  }, c.prototype.precompute = function (e) {
    if (this.precomputed) return this;
    var t = {
      doubles: null,
      naf: null,
      beta: null
    };
    return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
  }, c.prototype._hasDoubles = function (e) {
    if (!this.precomputed) return !1;
    var t = this.precomputed.doubles;
    return !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step);
  }, c.prototype._getDoubles = function (e, t) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;

    for (var r = [this], n = this, i = 0; i < t; i += e) {
      for (var o = 0; o < e; o++) {
        n = n.dbl();
      }

      r.push(n);
    }

    return {
      step: e,
      points: r
    };
  }, c.prototype._getNAFPoints = function (e) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;

    for (var t = [this], r = (1 << e) - 1, n = 1 === r ? null : this.dbl(), i = 1; i < r; i++) {
      t[i] = t[i - 1].add(n);
    }

    return {
      wnd: e,
      points: t
    };
  }, c.prototype._getBeta = function () {
    return null;
  }, c.prototype.dblp = function (e) {
    for (var t = this, r = 0; r < e; r++) {
      t = t.dbl();
    }

    return t;
  };
}, function (e, t, r) {
  "use strict";

  var n = r(33),
      i = r(2),
      o = r(9),
      a = r(34),
      s = n.base,
      f = i.utils.assert;

  function c(e) {
    s.call(this, "short", e), this.a = new o(e.a, 16).toRed(this.red), this.b = new o(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
  }

  function u(e, t, r, n) {
    s.BasePoint.call(this, e, "affine"), null === t && null === r ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new o(t, 16), this.y = new o(r, 16), n && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
  }

  function d(e, t, r, n) {
    s.BasePoint.call(this, e, "jacobian"), null === t && null === r && null === n ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new o(0)) : (this.x = new o(t, 16), this.y = new o(r, 16), this.z = new o(n, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
  }

  a(c, s), e.exports = c, c.prototype._getEndomorphism = function (e) {
    if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
      var t, r;
      if (e.beta) t = new o(e.beta, 16).toRed(this.red);else {
        var n = this._getEndoRoots(this.p);

        t = (t = n[0].cmp(n[1]) < 0 ? n[0] : n[1]).toRed(this.red);
      }
      if (e.lambda) r = new o(e.lambda, 16);else {
        var i = this._getEndoRoots(this.n);

        0 === this.g.mul(i[0]).x.cmp(this.g.x.redMul(t)) ? r = i[0] : (r = i[1], f(0 === this.g.mul(r).x.cmp(this.g.x.redMul(t))));
      }
      return {
        beta: t,
        lambda: r,
        basis: e.basis ? e.basis.map(function (e) {
          return {
            a: new o(e.a, 16),
            b: new o(e.b, 16)
          };
        }) : this._getEndoBasis(r)
      };
    }
  }, c.prototype._getEndoRoots = function (e) {
    var t = e === this.p ? this.red : o.mont(e),
        r = new o(2).toRed(t).redInvm(),
        n = r.redNeg(),
        i = new o(3).toRed(t).redNeg().redSqrt().redMul(r);
    return [n.redAdd(i).fromRed(), n.redSub(i).fromRed()];
  }, c.prototype._getEndoBasis = function (e) {
    for (var t, r, n, i, a, s, f, c, u, d = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), h = e, l = this.n.clone(), p = new o(1), b = new o(0), v = new o(0), m = new o(1), y = 0; 0 !== h.cmpn(0);) {
      var g = l.div(h);
      c = l.sub(g.mul(h)), u = v.sub(g.mul(p));
      var A = m.sub(g.mul(b));
      if (!n && c.cmp(d) < 0) t = f.neg(), r = p, n = c.neg(), i = u;else if (n && 2 == ++y) break;
      f = c, l = h, h = c, v = p, p = u, m = b, b = A;
    }

    a = c.neg(), s = u;
    var w = n.sqr().add(i.sqr());
    return a.sqr().add(s.sqr()).cmp(w) >= 0 && (a = t, s = r), n.negative && (n = n.neg(), i = i.neg()), a.negative && (a = a.neg(), s = s.neg()), [{
      a: n,
      b: i
    }, {
      a: a,
      b: s
    }];
  }, c.prototype._endoSplit = function (e) {
    var t = this.endo.basis,
        r = t[0],
        n = t[1],
        i = n.b.mul(e).divRound(this.n),
        o = r.b.neg().mul(e).divRound(this.n),
        a = i.mul(r.a),
        s = o.mul(n.a),
        f = i.mul(r.b),
        c = o.mul(n.b);
    return {
      k1: e.sub(a).sub(s),
      k2: f.add(c).neg()
    };
  }, c.prototype.pointFromX = function (e, t) {
    (e = new o(e, 16)).red || (e = e.toRed(this.red));
    var r = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b),
        n = r.redSqrt();
    if (0 !== n.redSqr().redSub(r).cmp(this.zero)) throw new Error("invalid point");
    var i = n.fromRed().isOdd();
    return (t && !i || !t && i) && (n = n.redNeg()), this.point(e, n);
  }, c.prototype.validate = function (e) {
    if (e.inf) return !0;
    var t = e.x,
        r = e.y,
        n = this.a.redMul(t),
        i = t.redSqr().redMul(t).redIAdd(n).redIAdd(this.b);
    return 0 === r.redSqr().redISub(i).cmpn(0);
  }, c.prototype._endoWnafMulAdd = function (e, t, r) {
    for (var n = this._endoWnafT1, i = this._endoWnafT2, o = 0; o < e.length; o++) {
      var a = this._endoSplit(t[o]),
          s = e[o],
          f = s._getBeta();

      a.k1.negative && (a.k1.ineg(), s = s.neg(!0)), a.k2.negative && (a.k2.ineg(), f = f.neg(!0)), n[2 * o] = s, n[2 * o + 1] = f, i[2 * o] = a.k1, i[2 * o + 1] = a.k2;
    }

    for (var c = this._wnafMulAdd(1, n, i, 2 * o, r), u = 0; u < 2 * o; u++) {
      n[u] = null, i[u] = null;
    }

    return c;
  }, a(u, s.BasePoint), c.prototype.point = function (e, t, r) {
    return new u(this, e, t, r);
  }, c.prototype.pointFromJSON = function (e, t) {
    return u.fromJSON(this, e, t);
  }, u.prototype._getBeta = function () {
    if (this.curve.endo) {
      var e = this.precomputed;
      if (e && e.beta) return e.beta;
      var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);

      if (e) {
        var r = this.curve,
            n = function n(e) {
          return r.point(e.x.redMul(r.endo.beta), e.y);
        };

        e.beta = t, t.precomputed = {
          beta: null,
          naf: e.naf && {
            wnd: e.naf.wnd,
            points: e.naf.points.map(n)
          },
          doubles: e.doubles && {
            step: e.doubles.step,
            points: e.doubles.points.map(n)
          }
        };
      }

      return t;
    }
  }, u.prototype.toJSON = function () {
    return this.precomputed ? [this.x, this.y, this.precomputed && {
      doubles: this.precomputed.doubles && {
        step: this.precomputed.doubles.step,
        points: this.precomputed.doubles.points.slice(1)
      },
      naf: this.precomputed.naf && {
        wnd: this.precomputed.naf.wnd,
        points: this.precomputed.naf.points.slice(1)
      }
    }] : [this.x, this.y];
  }, u.fromJSON = function (e, t, r) {
    "string" == typeof t && (t = JSON.parse(t));
    var n = e.point(t[0], t[1], r);
    if (!t[2]) return n;

    function i(t) {
      return e.point(t[0], t[1], r);
    }

    var o = t[2];
    return n.precomputed = {
      beta: null,
      doubles: o.doubles && {
        step: o.doubles.step,
        points: [n].concat(o.doubles.points.map(i))
      },
      naf: o.naf && {
        wnd: o.naf.wnd,
        points: [n].concat(o.naf.points.map(i))
      }
    }, n;
  }, u.prototype.inspect = function () {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
  }, u.prototype.isInfinity = function () {
    return this.inf;
  }, u.prototype.add = function (e) {
    if (this.inf) return e;
    if (e.inf) return this;
    if (this.eq(e)) return this.dbl();
    if (this.neg().eq(e)) return this.curve.point(null, null);
    if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
    var t = this.y.redSub(e.y);
    0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
    var r = t.redSqr().redISub(this.x).redISub(e.x),
        n = t.redMul(this.x.redSub(r)).redISub(this.y);
    return this.curve.point(r, n);
  }, u.prototype.dbl = function () {
    if (this.inf) return this;
    var e = this.y.redAdd(this.y);
    if (0 === e.cmpn(0)) return this.curve.point(null, null);
    var t = this.curve.a,
        r = this.x.redSqr(),
        n = e.redInvm(),
        i = r.redAdd(r).redIAdd(r).redIAdd(t).redMul(n),
        o = i.redSqr().redISub(this.x.redAdd(this.x)),
        a = i.redMul(this.x.redSub(o)).redISub(this.y);
    return this.curve.point(o, a);
  }, u.prototype.getX = function () {
    return this.x.fromRed();
  }, u.prototype.getY = function () {
    return this.y.fromRed();
  }, u.prototype.mul = function (e) {
    return e = new o(e, 16), this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [e]) : this.curve._wnafMul(this, e);
  }, u.prototype.mulAdd = function (e, t, r) {
    var n = [this, t],
        i = [e, r];
    return this.curve.endo ? this.curve._endoWnafMulAdd(n, i) : this.curve._wnafMulAdd(1, n, i, 2);
  }, u.prototype.jmulAdd = function (e, t, r) {
    var n = [this, t],
        i = [e, r];
    return this.curve.endo ? this.curve._endoWnafMulAdd(n, i, !0) : this.curve._wnafMulAdd(1, n, i, 2, !0);
  }, u.prototype.eq = function (e) {
    return this === e || this.inf === e.inf && (this.inf || 0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y));
  }, u.prototype.neg = function (e) {
    if (this.inf) return this;
    var t = this.curve.point(this.x, this.y.redNeg());

    if (e && this.precomputed) {
      var r = this.precomputed,
          n = function n(e) {
        return e.neg();
      };

      t.precomputed = {
        naf: r.naf && {
          wnd: r.naf.wnd,
          points: r.naf.points.map(n)
        },
        doubles: r.doubles && {
          step: r.doubles.step,
          points: r.doubles.points.map(n)
        }
      };
    }

    return t;
  }, u.prototype.toJ = function () {
    return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
  }, a(d, s.BasePoint), c.prototype.jpoint = function (e, t, r) {
    return new d(this, e, t, r);
  }, d.prototype.toP = function () {
    if (this.isInfinity()) return this.curve.point(null, null);
    var e = this.z.redInvm(),
        t = e.redSqr(),
        r = this.x.redMul(t),
        n = this.y.redMul(t).redMul(e);
    return this.curve.point(r, n);
  }, d.prototype.neg = function () {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  }, d.prototype.add = function (e) {
    if (this.isInfinity()) return e;
    if (e.isInfinity()) return this;
    var t = e.z.redSqr(),
        r = this.z.redSqr(),
        n = this.x.redMul(t),
        i = e.x.redMul(r),
        o = this.y.redMul(t.redMul(e.z)),
        a = e.y.redMul(r.redMul(this.z)),
        s = n.redSub(i),
        f = o.redSub(a);
    if (0 === s.cmpn(0)) return 0 !== f.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
    var c = s.redSqr(),
        u = c.redMul(s),
        d = n.redMul(c),
        h = f.redSqr().redIAdd(u).redISub(d).redISub(d),
        l = f.redMul(d.redISub(h)).redISub(o.redMul(u)),
        p = this.z.redMul(e.z).redMul(s);
    return this.curve.jpoint(h, l, p);
  }, d.prototype.mixedAdd = function (e) {
    if (this.isInfinity()) return e.toJ();
    if (e.isInfinity()) return this;
    var t = this.z.redSqr(),
        r = this.x,
        n = e.x.redMul(t),
        i = this.y,
        o = e.y.redMul(t).redMul(this.z),
        a = r.redSub(n),
        s = i.redSub(o);
    if (0 === a.cmpn(0)) return 0 !== s.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
    var f = a.redSqr(),
        c = f.redMul(a),
        u = r.redMul(f),
        d = s.redSqr().redIAdd(c).redISub(u).redISub(u),
        h = s.redMul(u.redISub(d)).redISub(i.redMul(c)),
        l = this.z.redMul(a);
    return this.curve.jpoint(d, h, l);
  }, d.prototype.dblp = function (e) {
    if (0 === e) return this;
    if (this.isInfinity()) return this;
    if (!e) return this.dbl();

    if (this.curve.zeroA || this.curve.threeA) {
      for (var t = this, r = 0; r < e; r++) {
        t = t.dbl();
      }

      return t;
    }

    var n = this.curve.a,
        i = this.curve.tinv,
        o = this.x,
        a = this.y,
        s = this.z,
        f = s.redSqr().redSqr(),
        c = a.redAdd(a);

    for (r = 0; r < e; r++) {
      var u = o.redSqr(),
          d = c.redSqr(),
          h = d.redSqr(),
          l = u.redAdd(u).redIAdd(u).redIAdd(n.redMul(f)),
          p = o.redMul(d),
          b = l.redSqr().redISub(p.redAdd(p)),
          v = p.redISub(b),
          m = l.redMul(v);
      m = m.redIAdd(m).redISub(h);
      var y = c.redMul(s);
      r + 1 < e && (f = f.redMul(h)), o = b, s = y, c = m;
    }

    return this.curve.jpoint(o, c.redMul(i), s);
  }, d.prototype.dbl = function () {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
  }, d.prototype._zeroDbl = function () {
    var e, t, r;

    if (this.zOne) {
      var n = this.x.redSqr(),
          i = this.y.redSqr(),
          o = i.redSqr(),
          a = this.x.redAdd(i).redSqr().redISub(n).redISub(o);
      a = a.redIAdd(a);
      var s = n.redAdd(n).redIAdd(n),
          f = s.redSqr().redISub(a).redISub(a),
          c = o.redIAdd(o);
      c = (c = c.redIAdd(c)).redIAdd(c), e = f, t = s.redMul(a.redISub(f)).redISub(c), r = this.y.redAdd(this.y);
    } else {
      var u = this.x.redSqr(),
          d = this.y.redSqr(),
          h = d.redSqr(),
          l = this.x.redAdd(d).redSqr().redISub(u).redISub(h);
      l = l.redIAdd(l);
      var p = u.redAdd(u).redIAdd(u),
          b = p.redSqr(),
          v = h.redIAdd(h);
      v = (v = v.redIAdd(v)).redIAdd(v), e = b.redISub(l).redISub(l), t = p.redMul(l.redISub(e)).redISub(v), r = (r = this.y.redMul(this.z)).redIAdd(r);
    }

    return this.curve.jpoint(e, t, r);
  }, d.prototype._threeDbl = function () {
    var e, t, r;

    if (this.zOne) {
      var n = this.x.redSqr(),
          i = this.y.redSqr(),
          o = i.redSqr(),
          a = this.x.redAdd(i).redSqr().redISub(n).redISub(o);
      a = a.redIAdd(a);
      var s = n.redAdd(n).redIAdd(n).redIAdd(this.curve.a),
          f = s.redSqr().redISub(a).redISub(a);
      e = f;
      var c = o.redIAdd(o);
      c = (c = c.redIAdd(c)).redIAdd(c), t = s.redMul(a.redISub(f)).redISub(c), r = this.y.redAdd(this.y);
    } else {
      var u = this.z.redSqr(),
          d = this.y.redSqr(),
          h = this.x.redMul(d),
          l = this.x.redSub(u).redMul(this.x.redAdd(u));
      l = l.redAdd(l).redIAdd(l);
      var p = h.redIAdd(h),
          b = (p = p.redIAdd(p)).redAdd(p);
      e = l.redSqr().redISub(b), r = this.y.redAdd(this.z).redSqr().redISub(d).redISub(u);
      var v = d.redSqr();
      v = (v = (v = v.redIAdd(v)).redIAdd(v)).redIAdd(v), t = l.redMul(p.redISub(e)).redISub(v);
    }

    return this.curve.jpoint(e, t, r);
  }, d.prototype._dbl = function () {
    var e = this.curve.a,
        t = this.x,
        r = this.y,
        n = this.z,
        i = n.redSqr().redSqr(),
        o = t.redSqr(),
        a = r.redSqr(),
        s = o.redAdd(o).redIAdd(o).redIAdd(e.redMul(i)),
        f = t.redAdd(t),
        c = (f = f.redIAdd(f)).redMul(a),
        u = s.redSqr().redISub(c.redAdd(c)),
        d = c.redISub(u),
        h = a.redSqr();
    h = (h = (h = h.redIAdd(h)).redIAdd(h)).redIAdd(h);
    var l = s.redMul(d).redISub(h),
        p = r.redAdd(r).redMul(n);
    return this.curve.jpoint(u, l, p);
  }, d.prototype.trpl = function () {
    if (!this.curve.zeroA) return this.dbl().add(this);
    var e = this.x.redSqr(),
        t = this.y.redSqr(),
        r = this.z.redSqr(),
        n = t.redSqr(),
        i = e.redAdd(e).redIAdd(e),
        o = i.redSqr(),
        a = this.x.redAdd(t).redSqr().redISub(e).redISub(n),
        s = (a = (a = (a = a.redIAdd(a)).redAdd(a).redIAdd(a)).redISub(o)).redSqr(),
        f = n.redIAdd(n);
    f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
    var c = i.redIAdd(a).redSqr().redISub(o).redISub(s).redISub(f),
        u = t.redMul(c);
    u = (u = u.redIAdd(u)).redIAdd(u);
    var d = this.x.redMul(s).redISub(u);
    d = (d = d.redIAdd(d)).redIAdd(d);
    var h = this.y.redMul(c.redMul(f.redISub(c)).redISub(a.redMul(s)));
    h = (h = (h = h.redIAdd(h)).redIAdd(h)).redIAdd(h);
    var l = this.z.redAdd(a).redSqr().redISub(r).redISub(s);
    return this.curve.jpoint(d, h, l);
  }, d.prototype.mul = function (e, t) {
    return e = new o(e, t), this.curve._wnafMul(this, e);
  }, d.prototype.eq = function (e) {
    if ("affine" === e.type) return this.eq(e.toJ());
    if (this === e) return !0;
    var t = this.z.redSqr(),
        r = e.z.redSqr();
    if (0 !== this.x.redMul(r).redISub(e.x.redMul(t)).cmpn(0)) return !1;
    var n = t.redMul(this.z),
        i = r.redMul(e.z);
    return 0 === this.y.redMul(i).redISub(e.y.redMul(n)).cmpn(0);
  }, d.prototype.eqXToP = function (e) {
    var t = this.z.redSqr(),
        r = e.toRed(this.curve.red).redMul(t);
    if (0 === this.x.cmp(r)) return !0;

    for (var n = e.clone(), i = this.curve.redN.redMul(t);;) {
      if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
      if (r.redIAdd(i), 0 === this.x.cmp(r)) return !0;
    }
  }, d.prototype.inspect = function () {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
  }, d.prototype.isInfinity = function () {
    return 0 === this.z.cmpn(0);
  };
}, function (e, t, r) {
  "use strict";

  var n = r(33),
      i = r(9),
      o = r(34),
      a = n.base,
      s = r(2).utils;

  function f(e) {
    a.call(this, "mont", e), this.a = new i(e.a, 16).toRed(this.red), this.b = new i(e.b, 16).toRed(this.red), this.i4 = new i(4).toRed(this.red).redInvm(), this.two = new i(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
  }

  function c(e, t, r) {
    a.BasePoint.call(this, e, "projective"), null === t && null === r ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new i(t, 16), this.z = new i(r, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
  }

  o(f, a), e.exports = f, f.prototype.validate = function (e) {
    var t = e.normalize().x,
        r = t.redSqr(),
        n = r.redMul(t).redAdd(r.redMul(this.a)).redAdd(t);
    return 0 === n.redSqrt().redSqr().cmp(n);
  }, o(c, a.BasePoint), f.prototype.decodePoint = function (e, t) {
    return this.point(s.toArray(e, t), 1);
  }, f.prototype.point = function (e, t) {
    return new c(this, e, t);
  }, f.prototype.pointFromJSON = function (e) {
    return c.fromJSON(this, e);
  }, c.prototype.precompute = function () {}, c.prototype._encode = function () {
    return this.getX().toArray("be", this.curve.p.byteLength());
  }, c.fromJSON = function (e, t) {
    return new c(e, t[0], t[1] || e.one);
  }, c.prototype.inspect = function () {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, c.prototype.isInfinity = function () {
    return 0 === this.z.cmpn(0);
  }, c.prototype.dbl = function () {
    var e = this.x.redAdd(this.z).redSqr(),
        t = this.x.redSub(this.z).redSqr(),
        r = e.redSub(t),
        n = e.redMul(t),
        i = r.redMul(t.redAdd(this.curve.a24.redMul(r)));
    return this.curve.point(n, i);
  }, c.prototype.add = function () {
    throw new Error("Not supported on Montgomery curve");
  }, c.prototype.diffAdd = function (e, t) {
    var r = this.x.redAdd(this.z),
        n = this.x.redSub(this.z),
        i = e.x.redAdd(e.z),
        o = e.x.redSub(e.z).redMul(r),
        a = i.redMul(n),
        s = t.z.redMul(o.redAdd(a).redSqr()),
        f = t.x.redMul(o.redISub(a).redSqr());
    return this.curve.point(s, f);
  }, c.prototype.mul = function (e) {
    for (var t = e.clone(), r = this, n = this.curve.point(null, null), i = []; 0 !== t.cmpn(0); t.iushrn(1)) {
      i.push(t.andln(1));
    }

    for (var o = i.length - 1; o >= 0; o--) {
      0 === i[o] ? (r = r.diffAdd(n, this), n = n.dbl()) : (n = r.diffAdd(n, this), r = r.dbl());
    }

    return n;
  }, c.prototype.mulAdd = function () {
    throw new Error("Not supported on Montgomery curve");
  }, c.prototype.jumlAdd = function () {
    throw new Error("Not supported on Montgomery curve");
  }, c.prototype.eq = function (e) {
    return 0 === this.getX().cmp(e.getX());
  }, c.prototype.normalize = function () {
    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
  }, c.prototype.getX = function () {
    return this.normalize(), this.x.fromRed();
  };
}, function (e, t, r) {
  "use strict";

  var n = r(33),
      i = r(2),
      o = r(9),
      a = r(34),
      s = n.base,
      f = i.utils.assert;

  function c(e) {
    this.twisted = 1 != (0 | e.a), this.mOneA = this.twisted && -1 == (0 | e.a), this.extended = this.mOneA, s.call(this, "edwards", e), this.a = new o(e.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new o(e.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new o(e.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), f(!this.twisted || 0 === this.c.fromRed().cmpn(1)), this.oneC = 1 == (0 | e.c);
  }

  function u(e, t, r, n, i) {
    s.BasePoint.call(this, e, "projective"), null === t && null === r && null === n ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new o(t, 16), this.y = new o(r, 16), this.z = n ? new o(n, 16) : this.curve.one, this.t = i && new o(i, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
  }

  a(c, s), e.exports = c, c.prototype._mulA = function (e) {
    return this.mOneA ? e.redNeg() : this.a.redMul(e);
  }, c.prototype._mulC = function (e) {
    return this.oneC ? e : this.c.redMul(e);
  }, c.prototype.jpoint = function (e, t, r, n) {
    return this.point(e, t, r, n);
  }, c.prototype.pointFromX = function (e, t) {
    (e = new o(e, 16)).red || (e = e.toRed(this.red));
    var r = e.redSqr(),
        n = this.c2.redSub(this.a.redMul(r)),
        i = this.one.redSub(this.c2.redMul(this.d).redMul(r)),
        a = n.redMul(i.redInvm()),
        s = a.redSqrt();
    if (0 !== s.redSqr().redSub(a).cmp(this.zero)) throw new Error("invalid point");
    var f = s.fromRed().isOdd();
    return (t && !f || !t && f) && (s = s.redNeg()), this.point(e, s);
  }, c.prototype.pointFromY = function (e, t) {
    (e = new o(e, 16)).red || (e = e.toRed(this.red));
    var r = e.redSqr(),
        n = r.redSub(this.c2),
        i = r.redMul(this.d).redMul(this.c2).redSub(this.a),
        a = n.redMul(i.redInvm());

    if (0 === a.cmp(this.zero)) {
      if (t) throw new Error("invalid point");
      return this.point(this.zero, e);
    }

    var s = a.redSqrt();
    if (0 !== s.redSqr().redSub(a).cmp(this.zero)) throw new Error("invalid point");
    return s.fromRed().isOdd() !== t && (s = s.redNeg()), this.point(s, e);
  }, c.prototype.validate = function (e) {
    if (e.isInfinity()) return !0;
    e.normalize();
    var t = e.x.redSqr(),
        r = e.y.redSqr(),
        n = t.redMul(this.a).redAdd(r),
        i = this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(r)));
    return 0 === n.cmp(i);
  }, a(u, s.BasePoint), c.prototype.pointFromJSON = function (e) {
    return u.fromJSON(this, e);
  }, c.prototype.point = function (e, t, r, n) {
    return new u(this, e, t, r, n);
  }, u.fromJSON = function (e, t) {
    return new u(e, t[0], t[1], t[2]);
  }, u.prototype.inspect = function () {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, u.prototype.isInfinity = function () {
    return 0 === this.x.cmpn(0) && (0 === this.y.cmp(this.z) || this.zOne && 0 === this.y.cmp(this.curve.c));
  }, u.prototype._extDbl = function () {
    var e = this.x.redSqr(),
        t = this.y.redSqr(),
        r = this.z.redSqr();
    r = r.redIAdd(r);

    var n = this.curve._mulA(e),
        i = this.x.redAdd(this.y).redSqr().redISub(e).redISub(t),
        o = n.redAdd(t),
        a = o.redSub(r),
        s = n.redSub(t),
        f = i.redMul(a),
        c = o.redMul(s),
        u = i.redMul(s),
        d = a.redMul(o);

    return this.curve.point(f, c, d, u);
  }, u.prototype._projDbl = function () {
    var e,
        t,
        r,
        n = this.x.redAdd(this.y).redSqr(),
        i = this.x.redSqr(),
        o = this.y.redSqr();

    if (this.curve.twisted) {
      var a = (c = this.curve._mulA(i)).redAdd(o);

      if (this.zOne) e = n.redSub(i).redSub(o).redMul(a.redSub(this.curve.two)), t = a.redMul(c.redSub(o)), r = a.redSqr().redSub(a).redSub(a);else {
        var s = this.z.redSqr(),
            f = a.redSub(s).redISub(s);
        e = n.redSub(i).redISub(o).redMul(f), t = a.redMul(c.redSub(o)), r = a.redMul(f);
      }
    } else {
      var c = i.redAdd(o);
      s = this.curve._mulC(this.z).redSqr(), f = c.redSub(s).redSub(s);
      e = this.curve._mulC(n.redISub(c)).redMul(f), t = this.curve._mulC(c).redMul(i.redISub(o)), r = c.redMul(f);
    }

    return this.curve.point(e, t, r);
  }, u.prototype.dbl = function () {
    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
  }, u.prototype._extAdd = function (e) {
    var t = this.y.redSub(this.x).redMul(e.y.redSub(e.x)),
        r = this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)),
        n = this.t.redMul(this.curve.dd).redMul(e.t),
        i = this.z.redMul(e.z.redAdd(e.z)),
        o = r.redSub(t),
        a = i.redSub(n),
        s = i.redAdd(n),
        f = r.redAdd(t),
        c = o.redMul(a),
        u = s.redMul(f),
        d = o.redMul(f),
        h = a.redMul(s);
    return this.curve.point(c, u, h, d);
  }, u.prototype._projAdd = function (e) {
    var t,
        r,
        n = this.z.redMul(e.z),
        i = n.redSqr(),
        o = this.x.redMul(e.x),
        a = this.y.redMul(e.y),
        s = this.curve.d.redMul(o).redMul(a),
        f = i.redSub(s),
        c = i.redAdd(s),
        u = this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(o).redISub(a),
        d = n.redMul(f).redMul(u);
    return this.curve.twisted ? (t = n.redMul(c).redMul(a.redSub(this.curve._mulA(o))), r = f.redMul(c)) : (t = n.redMul(c).redMul(a.redSub(o)), r = this.curve._mulC(f).redMul(c)), this.curve.point(d, t, r);
  }, u.prototype.add = function (e) {
    return this.isInfinity() ? e : e.isInfinity() ? this : this.curve.extended ? this._extAdd(e) : this._projAdd(e);
  }, u.prototype.mul = function (e) {
    return this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve._wnafMul(this, e);
  }, u.prototype.mulAdd = function (e, t, r) {
    return this.curve._wnafMulAdd(1, [this, t], [e, r], 2, !1);
  }, u.prototype.jmulAdd = function (e, t, r) {
    return this.curve._wnafMulAdd(1, [this, t], [e, r], 2, !0);
  }, u.prototype.normalize = function () {
    if (this.zOne) return this;
    var e = this.z.redInvm();
    return this.x = this.x.redMul(e), this.y = this.y.redMul(e), this.t && (this.t = this.t.redMul(e)), this.z = this.curve.one, this.zOne = !0, this;
  }, u.prototype.neg = function () {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
  }, u.prototype.getX = function () {
    return this.normalize(), this.x.fromRed();
  }, u.prototype.getY = function () {
    return this.normalize(), this.y.fromRed();
  }, u.prototype.eq = function (e) {
    return this === e || 0 === this.getX().cmp(e.getX()) && 0 === this.getY().cmp(e.getY());
  }, u.prototype.eqXToP = function (e) {
    var t = e.toRed(this.curve.red).redMul(this.z);
    if (0 === this.x.cmp(t)) return !0;

    for (var r = e.clone(), n = this.curve.redN.redMul(this.z);;) {
      if (r.iadd(this.curve.n), r.cmp(this.curve.p) >= 0) return !1;
      if (t.redIAdd(n), 0 === this.x.cmp(t)) return !0;
    }
  }, u.prototype.toP = u.prototype.normalize, u.prototype.mixedAdd = u.prototype.add;
}, function (e, t, r) {
  "use strict";

  var n,
      i = t,
      o = r(51),
      a = r(2),
      s = a.utils.assert;

  function f(e) {
    "short" === e.type ? this.curve = new a.curve.short(e) : "edwards" === e.type ? this.curve = new a.curve.edwards(e) : this.curve = new a.curve.mont(e), this.g = this.curve.g, this.n = this.curve.n, this.hash = e.hash, s(this.g.validate(), "Invalid curve"), s(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
  }

  function c(e, t) {
    Object.defineProperty(i, e, {
      configurable: !0,
      enumerable: !0,
      get: function get() {
        var r = new f(t);
        return Object.defineProperty(i, e, {
          configurable: !0,
          enumerable: !0,
          value: r
        }), r;
      }
    });
  }

  i.PresetCurve = f, c("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: o.sha256,
    gRed: !1,
    g: ["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012", "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]
  }), c("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: o.sha256,
    gRed: !1,
    g: ["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21", "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]
  }), c("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: o.sha256,
    gRed: !1,
    g: ["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296", "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]
  }), c("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: o.sha384,
    gRed: !1,
    g: ["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7", "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]
  }), c("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: o.sha512,
    gRed: !1,
    g: ["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66", "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"]
  }), c("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: o.sha256,
    gRed: !1,
    g: ["9"]
  }), c("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: o.sha256,
    gRed: !1,
    g: ["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a", "6666666666666666666666666666666666666666666666666666666666666658"]
  });

  try {
    n = r(160);
  } catch (e) {
    n = void 0;
  }

  c("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: o.sha256,
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [{
      a: "3086d221a7d46bcde86c90e49284eb15",
      b: "-e4437ed6010e88286f547fa90abfe4c3"
    }, {
      a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
      b: "3086d221a7d46bcde86c90e49284eb15"
    }],
    gRed: !1,
    g: ["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798", "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8", n]
  });
}, function (e, t, r) {
  "use strict";

  t.sha1 = r(155), t.sha224 = r(156), t.sha256 = r(78), t.sha384 = r(157), t.sha512 = r(79);
}, function (e, t, r) {
  "use strict";

  var n = r(5),
      i = r(25),
      o = r(77),
      a = n.rotl32,
      s = n.sum32,
      f = n.sum32_5,
      c = o.ft_1,
      u = i.BlockHash,
      d = [1518500249, 1859775393, 2400959708, 3395469782];

  function h() {
    if (!(this instanceof h)) return new h();
    u.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.W = new Array(80);
  }

  n.inherits(h, u), e.exports = h, h.blockSize = 512, h.outSize = 160, h.hmacStrength = 80, h.padLength = 64, h.prototype._update = function (e, t) {
    for (var r = this.W, n = 0; n < 16; n++) {
      r[n] = e[t + n];
    }

    for (; n < r.length; n++) {
      r[n] = a(r[n - 3] ^ r[n - 8] ^ r[n - 14] ^ r[n - 16], 1);
    }

    var i = this.h[0],
        o = this.h[1],
        u = this.h[2],
        h = this.h[3],
        l = this.h[4];

    for (n = 0; n < r.length; n++) {
      var p = ~~(n / 20),
          b = f(a(i, 5), c(p, o, u, h), l, r[n], d[p]);
      l = h, h = u, u = a(o, 30), o = i, i = b;
    }

    this.h[0] = s(this.h[0], i), this.h[1] = s(this.h[1], o), this.h[2] = s(this.h[2], u), this.h[3] = s(this.h[3], h), this.h[4] = s(this.h[4], l);
  }, h.prototype._digest = function (e) {
    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
  };
}, function (e, t, r) {
  "use strict";

  var n = r(5),
      i = r(78);

  function o() {
    if (!(this instanceof o)) return new o();
    i.call(this), this.h = [3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428];
  }

  n.inherits(o, i), e.exports = o, o.blockSize = 512, o.outSize = 224, o.hmacStrength = 192, o.padLength = 64, o.prototype._digest = function (e) {
    return "hex" === e ? n.toHex32(this.h.slice(0, 7), "big") : n.split32(this.h.slice(0, 7), "big");
  };
}, function (e, t, r) {
  "use strict";

  var n = r(5),
      i = r(79);

  function o() {
    if (!(this instanceof o)) return new o();
    i.call(this), this.h = [3418070365, 3238371032, 1654270250, 914150663, 2438529370, 812702999, 355462360, 4144912697, 1731405415, 4290775857, 2394180231, 1750603025, 3675008525, 1694076839, 1203062813, 3204075428];
  }

  n.inherits(o, i), e.exports = o, o.blockSize = 1024, o.outSize = 384, o.hmacStrength = 192, o.padLength = 128, o.prototype._digest = function (e) {
    return "hex" === e ? n.toHex32(this.h.slice(0, 12), "big") : n.split32(this.h.slice(0, 12), "big");
  };
}, function (e, t, r) {
  "use strict";

  var n = r(5),
      i = r(25),
      o = n.rotl32,
      a = n.sum32,
      s = n.sum32_3,
      f = n.sum32_4,
      c = i.BlockHash;

  function u() {
    if (!(this instanceof u)) return new u();
    c.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
  }

  function d(e, t, r, n) {
    return e <= 15 ? t ^ r ^ n : e <= 31 ? t & r | ~t & n : e <= 47 ? (t | ~r) ^ n : e <= 63 ? t & n | r & ~n : t ^ (r | ~n);
  }

  function h(e) {
    return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
  }

  function l(e) {
    return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
  }

  n.inherits(u, c), t.ripemd160 = u, u.blockSize = 512, u.outSize = 160, u.hmacStrength = 192, u.padLength = 64, u.prototype._update = function (e, t) {
    for (var r = this.h[0], n = this.h[1], i = this.h[2], c = this.h[3], u = this.h[4], y = r, g = n, A = i, w = c, _ = u, x = 0; x < 80; x++) {
      var S = a(o(f(r, d(x, n, i, c), e[p[x] + t], h(x)), v[x]), u);
      r = u, u = c, c = o(i, 10), i = n, n = S, S = a(o(f(y, d(79 - x, g, A, w), e[b[x] + t], l(x)), m[x]), _), y = _, _ = w, w = o(A, 10), A = g, g = S;
    }

    S = s(this.h[1], i, w), this.h[1] = s(this.h[2], c, _), this.h[2] = s(this.h[3], u, y), this.h[3] = s(this.h[4], r, g), this.h[4] = s(this.h[0], n, A), this.h[0] = S;
  }, u.prototype._digest = function (e) {
    return "hex" === e ? n.toHex32(this.h, "little") : n.split32(this.h, "little");
  };
  var p = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
      b = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
      v = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
      m = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];
}, function (e, t, r) {
  "use strict";

  var n = r(5),
      i = r(13);

  function o(e, t, r) {
    if (!(this instanceof o)) return new o(e, t, r);
    this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(n.toArray(t, r));
  }

  e.exports = o, o.prototype._init = function (e) {
    e.length > this.blockSize && (e = new this.Hash().update(e).digest()), i(e.length <= this.blockSize);

    for (var t = e.length; t < this.blockSize; t++) {
      e.push(0);
    }

    for (t = 0; t < e.length; t++) {
      e[t] ^= 54;
    }

    for (this.inner = new this.Hash().update(e), t = 0; t < e.length; t++) {
      e[t] ^= 106;
    }

    this.outer = new this.Hash().update(e);
  }, o.prototype.update = function (e, t) {
    return this.inner.update(e, t), this;
  }, o.prototype.digest = function (e) {
    return this.outer.update(this.inner.digest()), this.outer.digest(e);
  };
}, function (e, t) {
  e.exports = {
    doubles: {
      step: 4,
      points: [["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a", "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"], ["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508", "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"], ["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739", "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"], ["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640", "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"], ["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c", "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"], ["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda", "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"], ["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa", "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"], ["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0", "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"], ["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d", "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"], ["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d", "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"], ["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1", "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"], ["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0", "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"], ["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047", "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"], ["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862", "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"], ["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7", "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"], ["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd", "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"], ["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83", "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"], ["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a", "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"], ["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8", "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"], ["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d", "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"], ["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725", "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"], ["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754", "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"], ["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c", "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"], ["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6", "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"], ["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39", "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"], ["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891", "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"], ["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b", "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"], ["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03", "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"], ["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d", "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"], ["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070", "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"], ["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4", "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"], ["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da", "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"], ["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11", "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"], ["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e", "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"], ["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41", "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"], ["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef", "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"], ["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8", "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"], ["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d", "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"], ["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96", "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"], ["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd", "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"], ["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5", "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"], ["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266", "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"], ["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71", "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"], ["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac", "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"], ["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751", "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"], ["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e", "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"], ["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241", "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"], ["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3", "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"], ["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f", "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"], ["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19", "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"], ["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be", "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"], ["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9", "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"], ["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2", "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"], ["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13", "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"], ["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c", "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"], ["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba", "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"], ["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151", "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"], ["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073", "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"], ["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458", "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"], ["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b", "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"], ["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366", "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"], ["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa", "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"], ["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0", "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"], ["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787", "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"], ["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e", "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]]
    },
    naf: {
      wnd: 7,
      points: [["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9", "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"], ["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4", "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"], ["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc", "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"], ["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe", "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"], ["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb", "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"], ["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8", "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"], ["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e", "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"], ["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34", "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"], ["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c", "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"], ["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5", "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"], ["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f", "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"], ["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714", "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"], ["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729", "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"], ["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db", "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"], ["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4", "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"], ["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5", "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"], ["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479", "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"], ["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d", "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"], ["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f", "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"], ["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb", "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"], ["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9", "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"], ["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963", "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"], ["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74", "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"], ["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530", "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"], ["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b", "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"], ["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247", "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"], ["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1", "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"], ["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120", "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"], ["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435", "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"], ["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18", "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"], ["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8", "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"], ["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb", "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"], ["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f", "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"], ["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143", "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"], ["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba", "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"], ["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45", "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"], ["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a", "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"], ["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e", "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"], ["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8", "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"], ["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c", "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"], ["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519", "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"], ["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab", "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"], ["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca", "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"], ["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf", "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"], ["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610", "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"], ["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4", "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"], ["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c", "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"], ["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940", "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"], ["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980", "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"], ["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3", "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"], ["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf", "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"], ["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63", "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"], ["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448", "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"], ["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf", "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"], ["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5", "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"], ["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6", "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"], ["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5", "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"], ["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99", "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"], ["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51", "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"], ["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5", "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"], ["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5", "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"], ["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997", "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"], ["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881", "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"], ["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5", "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"], ["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66", "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"], ["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726", "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"], ["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede", "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"], ["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94", "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"], ["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31", "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"], ["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51", "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"], ["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252", "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"], ["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5", "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"], ["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b", "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"], ["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4", "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"], ["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f", "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"], ["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889", "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"], ["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246", "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"], ["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984", "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"], ["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a", "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"], ["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030", "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"], ["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197", "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"], ["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593", "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"], ["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef", "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"], ["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38", "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"], ["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a", "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"], ["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111", "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"], ["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502", "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"], ["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea", "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"], ["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26", "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"], ["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986", "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"], ["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e", "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"], ["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4", "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"], ["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda", "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"], ["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859", "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"], ["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f", "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"], ["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c", "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"], ["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942", "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"], ["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a", "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"], ["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80", "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"], ["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d", "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"], ["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1", "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"], ["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63", "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"], ["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352", "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"], ["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193", "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"], ["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00", "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"], ["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58", "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"], ["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7", "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"], ["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8", "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"], ["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e", "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"], ["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d", "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"], ["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b", "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"], ["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f", "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"], ["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6", "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"], ["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297", "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"], ["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a", "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"], ["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c", "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"], ["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52", "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"], ["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb", "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"], ["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065", "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"], ["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917", "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"], ["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9", "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"], ["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3", "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"], ["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57", "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"], ["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66", "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"], ["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8", "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"], ["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721", "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"], ["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180", "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]]
    }
  };
}, function (e, t, r) {
  "use strict";

  var n = r(9),
      i = r(162),
      o = r(2),
      a = o.utils.assert,
      s = r(163),
      f = r(164);

  function c(e) {
    if (!(this instanceof c)) return new c(e);
    "string" == typeof e && (a(o.curves.hasOwnProperty(e), "Unknown curve " + e), e = o.curves[e]), e instanceof o.curves.PresetCurve && (e = {
      curve: e
    }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
  }

  e.exports = c, c.prototype.keyPair = function (e) {
    return new s(this, e);
  }, c.prototype.keyFromPrivate = function (e, t) {
    return s.fromPrivate(this, e, t);
  }, c.prototype.keyFromPublic = function (e, t) {
    return s.fromPublic(this, e, t);
  }, c.prototype.genKeyPair = function (e) {
    e || (e = {});

    for (var t = new i({
      hash: this.hash,
      pers: e.pers,
      persEnc: e.persEnc || "utf8",
      entropy: e.entropy || o.rand(this.hash.hmacStrength),
      entropyEnc: e.entropy && e.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), r = this.n.byteLength(), a = this.n.sub(new n(2));;) {
      var s = new n(t.generate(r));
      if (!(s.cmp(a) > 0)) return s.iaddn(1), this.keyFromPrivate(s);
    }
  }, c.prototype._truncateToN = function (e, t) {
    var r = 8 * e.byteLength() - this.n.bitLength();
    return r > 0 && (e = e.ushrn(r)), !t && e.cmp(this.n) >= 0 ? e.sub(this.n) : e;
  }, c.prototype.sign = function (e, t, r, o) {
    "object" == typeof r && (o = r, r = null), o || (o = {}), t = this.keyFromPrivate(t, r), e = this._truncateToN(new n(e, 16));

    for (var a = this.n.byteLength(), s = t.getPrivate().toArray("be", a), c = e.toArray("be", a), u = new i({
      hash: this.hash,
      entropy: s,
      nonce: c,
      pers: o.pers,
      persEnc: o.persEnc || "utf8"
    }), d = this.n.sub(new n(1)), h = 0;; h++) {
      var l = o.k ? o.k(h) : new n(u.generate(this.n.byteLength()));

      if (!((l = this._truncateToN(l, !0)).cmpn(1) <= 0 || l.cmp(d) >= 0)) {
        var p = this.g.mul(l);

        if (!p.isInfinity()) {
          var b = p.getX(),
              v = b.umod(this.n);

          if (0 !== v.cmpn(0)) {
            var m = l.invm(this.n).mul(v.mul(t.getPrivate()).iadd(e));

            if (0 !== (m = m.umod(this.n)).cmpn(0)) {
              var y = (p.getY().isOdd() ? 1 : 0) | (0 !== b.cmp(v) ? 2 : 0);
              return o.canonical && m.cmp(this.nh) > 0 && (m = this.n.sub(m), y ^= 1), new f({
                r: v,
                s: m,
                recoveryParam: y
              });
            }
          }
        }
      }
    }
  }, c.prototype.verify = function (e, t, r, i) {
    e = this._truncateToN(new n(e, 16)), r = this.keyFromPublic(r, i);
    var o = (t = new f(t, "hex")).r,
        a = t.s;
    if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0) return !1;
    if (a.cmpn(1) < 0 || a.cmp(this.n) >= 0) return !1;
    var s,
        c = a.invm(this.n),
        u = c.mul(e).umod(this.n),
        d = c.mul(o).umod(this.n);
    return this.curve._maxwellTrick ? !(s = this.g.jmulAdd(u, r.getPublic(), d)).isInfinity() && s.eqXToP(o) : !(s = this.g.mulAdd(u, r.getPublic(), d)).isInfinity() && 0 === s.getX().umod(this.n).cmp(o);
  }, c.prototype.recoverPubKey = function (e, t, r, i) {
    a((3 & r) === r, "The recovery param is more than two bits"), t = new f(t, i);
    var o = this.n,
        s = new n(e),
        c = t.r,
        u = t.s,
        d = 1 & r,
        h = r >> 1;
    if (c.cmp(this.curve.p.umod(this.curve.n)) >= 0 && h) throw new Error("Unable to find sencond key candinate");
    c = h ? this.curve.pointFromX(c.add(this.curve.n), d) : this.curve.pointFromX(c, d);
    var l = t.r.invm(o),
        p = o.sub(s).mul(l).umod(o),
        b = u.mul(l).umod(o);
    return this.g.mulAdd(p, c, b);
  }, c.prototype.getKeyRecoveryParam = function (e, t, r, n) {
    if (null !== (t = new f(t, n)).recoveryParam) return t.recoveryParam;

    for (var i = 0; i < 4; i++) {
      var o;

      try {
        o = this.recoverPubKey(e, t, i);
      } catch (e) {
        continue;
      }

      if (o.eq(r)) return i;
    }

    throw new Error("Unable to find valid recovery factor");
  };
}, function (e, t, r) {
  "use strict";

  var n = r(51),
      i = r(76),
      o = r(13);

  function a(e) {
    if (!(this instanceof a)) return new a(e);
    this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
    var t = i.toArray(e.entropy, e.entropyEnc || "hex"),
        r = i.toArray(e.nonce, e.nonceEnc || "hex"),
        n = i.toArray(e.pers, e.persEnc || "hex");
    o(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, r, n);
  }

  e.exports = a, a.prototype._init = function (e, t, r) {
    var n = e.concat(t).concat(r);
    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);

    for (var i = 0; i < this.V.length; i++) {
      this.K[i] = 0, this.V[i] = 1;
    }

    this._update(n), this._reseed = 1, this.reseedInterval = 281474976710656;
  }, a.prototype._hmac = function () {
    return new n.hmac(this.hash, this.K);
  }, a.prototype._update = function (e) {
    var t = this._hmac().update(this.V).update([0]);

    e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([1]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
  }, a.prototype.reseed = function (e, t, r, n) {
    "string" != typeof t && (n = r, r = t, t = null), e = i.toArray(e, t), r = i.toArray(r, n), o(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(e.concat(r || [])), this._reseed = 1;
  }, a.prototype.generate = function (e, t, r, n) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    "string" != typeof t && (n = r, r = t, t = null), r && (r = i.toArray(r, n || "hex"), this._update(r));

    for (var o = []; o.length < e;) {
      this.V = this._hmac().update(this.V).digest(), o = o.concat(this.V);
    }

    var a = o.slice(0, e);
    return this._update(r), this._reseed++, i.encode(a, t);
  };
}, function (e, t, r) {
  "use strict";

  var n = r(9),
      i = r(2).utils.assert;

  function o(e, t) {
    this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
  }

  e.exports = o, o.fromPublic = function (e, t, r) {
    return t instanceof o ? t : new o(e, {
      pub: t,
      pubEnc: r
    });
  }, o.fromPrivate = function (e, t, r) {
    return t instanceof o ? t : new o(e, {
      priv: t,
      privEnc: r
    });
  }, o.prototype.validate = function () {
    var e = this.getPublic();
    return e.isInfinity() ? {
      result: !1,
      reason: "Invalid public key"
    } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? {
      result: !0,
      reason: null
    } : {
      result: !1,
      reason: "Public key * N != O"
    } : {
      result: !1,
      reason: "Public key is not a point"
    };
  }, o.prototype.getPublic = function (e, t) {
    return "string" == typeof e && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
  }, o.prototype.getPrivate = function (e) {
    return "hex" === e ? this.priv.toString(16, 2) : this.priv;
  }, o.prototype._importPrivate = function (e, t) {
    this.priv = new n(e, t || 16), this.priv = this.priv.umod(this.ec.curve.n);
  }, o.prototype._importPublic = function (e, t) {
    if (e.x || e.y) return "mont" === this.ec.curve.type ? i(e.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || i(e.x && e.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(e.x, e.y));
    this.pub = this.ec.curve.decodePoint(e, t);
  }, o.prototype.derive = function (e) {
    return e.mul(this.priv).getX();
  }, o.prototype.sign = function (e, t, r) {
    return this.ec.sign(e, this, t, r);
  }, o.prototype.verify = function (e, t) {
    return this.ec.verify(e, t, this);
  }, o.prototype.inspect = function () {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
  };
}, function (e, t, r) {
  "use strict";

  var n = r(9),
      i = r(2).utils,
      o = i.assert;

  function a(e, t) {
    if (e instanceof a) return e;
    this._importDER(e, t) || (o(e.r && e.s, "Signature without r or s"), this.r = new n(e.r, 16), this.s = new n(e.s, 16), void 0 === e.recoveryParam ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
  }

  function s() {
    this.place = 0;
  }

  function f(e, t) {
    var r = e[t.place++];
    if (!(128 & r)) return r;

    for (var n = 15 & r, i = 0, o = 0, a = t.place; o < n; o++, a++) {
      i <<= 8, i |= e[a];
    }

    return t.place = a, i;
  }

  function c(e) {
    for (var t = 0, r = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < r;) {
      t++;
    }

    return 0 === t ? e : e.slice(t);
  }

  function u(e, t) {
    if (t < 128) e.push(t);else {
      var r = 1 + (Math.log(t) / Math.LN2 >>> 3);

      for (e.push(128 | r); --r;) {
        e.push(t >>> (r << 3) & 255);
      }

      e.push(t);
    }
  }

  e.exports = a, a.prototype._importDER = function (e, t) {
    e = i.toArray(e, t);
    var r = new s();
    if (48 !== e[r.place++]) return !1;
    if (f(e, r) + r.place !== e.length) return !1;
    if (2 !== e[r.place++]) return !1;
    var o = f(e, r),
        a = e.slice(r.place, o + r.place);
    if (r.place += o, 2 !== e[r.place++]) return !1;
    var c = f(e, r);
    if (e.length !== c + r.place) return !1;
    var u = e.slice(r.place, c + r.place);
    return 0 === a[0] && 128 & a[1] && (a = a.slice(1)), 0 === u[0] && 128 & u[1] && (u = u.slice(1)), this.r = new n(a), this.s = new n(u), this.recoveryParam = null, !0;
  }, a.prototype.toDER = function (e) {
    var t = this.r.toArray(),
        r = this.s.toArray();

    for (128 & t[0] && (t = [0].concat(t)), 128 & r[0] && (r = [0].concat(r)), t = c(t), r = c(r); !(r[0] || 128 & r[1]);) {
      r = r.slice(1);
    }

    var n = [2];
    u(n, t.length), (n = n.concat(t)).push(2), u(n, r.length);
    var o = n.concat(r),
        a = [48];
    return u(a, o.length), a = a.concat(o), i.encode(a, e);
  };
}, function (e, t, r) {
  "use strict";

  var n = r(51),
      i = r(2),
      o = i.utils,
      a = o.assert,
      s = o.parseBytes,
      f = r(166),
      c = r(167);

  function u(e) {
    if (a("ed25519" === e, "only tested with ed25519 so far"), !(this instanceof u)) return new u(e);
    e = i.curves[e].curve;
    this.curve = e, this.g = e.g, this.g.precompute(e.n.bitLength() + 1), this.pointClass = e.point().constructor, this.encodingLength = Math.ceil(e.n.bitLength() / 8), this.hash = n.sha512;
  }

  e.exports = u, u.prototype.sign = function (e, t) {
    e = s(e);
    var r = this.keyFromSecret(t),
        n = this.hashInt(r.messagePrefix(), e),
        i = this.g.mul(n),
        o = this.encodePoint(i),
        a = this.hashInt(o, r.pubBytes(), e).mul(r.priv()),
        f = n.add(a).umod(this.curve.n);
    return this.makeSignature({
      R: i,
      S: f,
      Rencoded: o
    });
  }, u.prototype.verify = function (e, t, r) {
    e = s(e), t = this.makeSignature(t);
    var n = this.keyFromPublic(r),
        i = this.hashInt(t.Rencoded(), n.pubBytes(), e),
        o = this.g.mul(t.S());
    return t.R().add(n.pub().mul(i)).eq(o);
  }, u.prototype.hashInt = function () {
    for (var e = this.hash(), t = 0; t < arguments.length; t++) {
      e.update(arguments[t]);
    }

    return o.intFromLE(e.digest()).umod(this.curve.n);
  }, u.prototype.keyFromPublic = function (e) {
    return f.fromPublic(this, e);
  }, u.prototype.keyFromSecret = function (e) {
    return f.fromSecret(this, e);
  }, u.prototype.makeSignature = function (e) {
    return e instanceof c ? e : new c(this, e);
  }, u.prototype.encodePoint = function (e) {
    var t = e.getY().toArray("le", this.encodingLength);
    return t[this.encodingLength - 1] |= e.getX().isOdd() ? 128 : 0, t;
  }, u.prototype.decodePoint = function (e) {
    var t = (e = o.parseBytes(e)).length - 1,
        r = e.slice(0, t).concat(-129 & e[t]),
        n = 0 != (128 & e[t]),
        i = o.intFromLE(r);
    return this.curve.pointFromY(i, n);
  }, u.prototype.encodeInt = function (e) {
    return e.toArray("le", this.encodingLength);
  }, u.prototype.decodeInt = function (e) {
    return o.intFromLE(e);
  }, u.prototype.isPoint = function (e) {
    return e instanceof this.pointClass;
  };
}, function (e, t, r) {
  "use strict";

  var n = r(2).utils,
      i = n.assert,
      o = n.parseBytes,
      a = n.cachedProperty;

  function s(e, t) {
    this.eddsa = e, this._secret = o(t.secret), e.isPoint(t.pub) ? this._pub = t.pub : this._pubBytes = o(t.pub);
  }

  s.fromPublic = function (e, t) {
    return t instanceof s ? t : new s(e, {
      pub: t
    });
  }, s.fromSecret = function (e, t) {
    return t instanceof s ? t : new s(e, {
      secret: t
    });
  }, s.prototype.secret = function () {
    return this._secret;
  }, a(s, "pubBytes", function () {
    return this.eddsa.encodePoint(this.pub());
  }), a(s, "pub", function () {
    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
  }), a(s, "privBytes", function () {
    var e = this.eddsa,
        t = this.hash(),
        r = e.encodingLength - 1,
        n = t.slice(0, e.encodingLength);
    return n[0] &= 248, n[r] &= 127, n[r] |= 64, n;
  }), a(s, "priv", function () {
    return this.eddsa.decodeInt(this.privBytes());
  }), a(s, "hash", function () {
    return this.eddsa.hash().update(this.secret()).digest();
  }), a(s, "messagePrefix", function () {
    return this.hash().slice(this.eddsa.encodingLength);
  }), s.prototype.sign = function (e) {
    return i(this._secret, "KeyPair can only verify"), this.eddsa.sign(e, this);
  }, s.prototype.verify = function (e, t) {
    return this.eddsa.verify(e, t, this);
  }, s.prototype.getSecret = function (e) {
    return i(this._secret, "KeyPair is public only"), n.encode(this.secret(), e);
  }, s.prototype.getPublic = function (e) {
    return n.encode(this.pubBytes(), e);
  }, e.exports = s;
}, function (e, t, r) {
  "use strict";

  var n = r(9),
      i = r(2).utils,
      o = i.assert,
      a = i.cachedProperty,
      s = i.parseBytes;

  function f(e, t) {
    this.eddsa = e, "object" != typeof t && (t = s(t)), Array.isArray(t) && (t = {
      R: t.slice(0, e.encodingLength),
      S: t.slice(e.encodingLength)
    }), o(t.R && t.S, "Signature without R or S"), e.isPoint(t.R) && (this._R = t.R), t.S instanceof n && (this._S = t.S), this._Rencoded = Array.isArray(t.R) ? t.R : t.Rencoded, this._Sencoded = Array.isArray(t.S) ? t.S : t.Sencoded;
  }

  a(f, "S", function () {
    return this.eddsa.decodeInt(this.Sencoded());
  }), a(f, "R", function () {
    return this.eddsa.decodePoint(this.Rencoded());
  }), a(f, "Rencoded", function () {
    return this.eddsa.encodePoint(this.R());
  }), a(f, "Sencoded", function () {
    return this.eddsa.encodeInt(this.S());
  }), f.prototype.toBytes = function () {
    return this.Rencoded().concat(this.Sencoded());
  }, f.prototype.toHex = function () {
    return i.encode(this.toBytes(), "hex").toUpperCase();
  }, e.exports = f;
}, function (e, t, r) {
  (function (n, i) {
    var o;
    /**
     * [js-sha3]{@link https://github.com/emn178/js-sha3}
     *
     * @version 0.7.0
     * @author Chen, Yi-Cyuan [emn178@gmail.com]
     * @copyright Chen, Yi-Cyuan 2015-2017
     * @license MIT
     */

    /**
     * [js-sha3]{@link https://github.com/emn178/js-sha3}
     *
     * @version 0.7.0
     * @author Chen, Yi-Cyuan [emn178@gmail.com]
     * @copyright Chen, Yi-Cyuan 2015-2017
     * @license MIT
     */

    !function () {
      "use strict";

      var a = "input is invalid type",
          s = "object" == typeof window,
          f = s ? window : {};
      f.JS_SHA3_NO_WINDOW && (s = !1);
      var c = !s && "object" == typeof self;
      !f.JS_SHA3_NO_NODE_JS && "object" == typeof n && n.versions && n.versions.node ? f = i : c && (f = self);
      var u = !f.JS_SHA3_NO_COMMON_JS && "object" == typeof e && e.exports,
          d = r(59),
          h = !f.JS_SHA3_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer,
          l = "0123456789abcdef".split(""),
          p = [4, 1024, 262144, 67108864],
          b = [0, 8, 16, 24],
          v = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648],
          m = [224, 256, 384, 512],
          y = [128, 256],
          g = ["hex", "buffer", "arrayBuffer", "array", "digest"],
          A = {
        128: 168,
        256: 136
      };
      !f.JS_SHA3_NO_NODE_JS && Array.isArray || (Array.isArray = function (e) {
        return "[object Array]" === Object.prototype.toString.call(e);
      }), !h || !f.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function (e) {
        return "object" == typeof e && e.buffer && e.buffer.constructor === ArrayBuffer;
      });

      for (var w = function w(e, t, r) {
        return function (n) {
          return new j(e, t, e).update(n)[r]();
        };
      }, _ = function _(e, t, r) {
        return function (n, i) {
          return new j(e, t, i).update(n)[r]();
        };
      }, x = function x(e, t, r) {
        return function (t, n, i, o) {
          return C["cshake" + e].update(t, n, i, o)[r]();
        };
      }, S = function S(e, t, r) {
        return function (t, n, i, o) {
          return C["kmac" + e].update(t, n, i, o)[r]();
        };
      }, k = function k(e, t, r, n) {
        for (var i = 0; i < g.length; ++i) {
          var o = g[i];
          e[o] = t(r, n, o);
        }

        return e;
      }, E = function E(e, t) {
        var r = w(e, t, "hex");
        return r.create = function () {
          return new j(e, t, e);
        }, r.update = function (e) {
          return r.create().update(e);
        }, k(r, w, e, t);
      }, M = [{
        name: "keccak",
        padding: [1, 256, 65536, 16777216],
        bits: m,
        createMethod: E
      }, {
        name: "sha3",
        padding: [6, 1536, 393216, 100663296],
        bits: m,
        createMethod: E
      }, {
        name: "shake",
        padding: [31, 7936, 2031616, 520093696],
        bits: y,
        createMethod: function createMethod(e, t) {
          var r = _(e, t, "hex");

          return r.create = function (r) {
            return new j(e, t, r);
          }, r.update = function (e, t) {
            return r.create(t).update(e);
          }, k(r, _, e, t);
        }
      }, {
        name: "cshake",
        padding: p,
        bits: y,
        createMethod: function createMethod(e, t) {
          var r = A[e],
              n = x(e, 0, "hex");
          return n.create = function (n, i, o) {
            return i || o ? new j(e, t, n).bytepad([i, o], r) : C["shake" + e].create(n);
          }, n.update = function (e, t, r, i) {
            return n.create(t, r, i).update(e);
          }, k(n, x, e, t);
        }
      }, {
        name: "kmac",
        padding: p,
        bits: y,
        createMethod: function createMethod(e, t) {
          var r = A[e],
              n = S(e, 0, "hex");
          return n.create = function (n, i, o) {
            return new z(e, t, i).bytepad(["KMAC", o], r).bytepad([n], r);
          }, n.update = function (e, t, r, i) {
            return n.create(e, r, i).update(t);
          }, k(n, S, e, t);
        }
      }], C = {}, B = [], P = 0; P < M.length; ++P) {
        for (var R = M[P], H = R.bits, O = 0; O < H.length; ++O) {
          var T = R.name + "_" + H[O];

          if (B.push(T), C[T] = R.createMethod(H[O], R.padding), "sha3" !== R.name) {
            var I = R.name + H[O];
            B.push(I), C[I] = C[T];
          }
        }
      }

      function j(e, t, r) {
        this.blocks = [], this.s = [], this.padding = t, this.outputBits = r, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (e << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = r >> 5, this.extraBytes = (31 & r) >> 3;

        for (var n = 0; n < 50; ++n) {
          this.s[n] = 0;
        }
      }

      function z(e, t, r) {
        j.call(this, e, t, r);
      }

      j.prototype.update = function (e) {
        if (!this.finalized) {
          var t,
              r = typeof e;

          if ("string" !== r) {
            if ("object" !== r) throw a;
            if (null === e) throw a;
            if (h && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || h && ArrayBuffer.isView(e))) throw a;
            t = !0;
          }

          for (var n, i, o = this.blocks, s = this.byteCount, f = e.length, c = this.blockCount, u = 0, d = this.s; u < f;) {
            if (this.reset) for (this.reset = !1, o[0] = this.block, n = 1; n < c + 1; ++n) {
              o[n] = 0;
            }
            if (t) for (n = this.start; u < f && n < s; ++u) {
              o[n >> 2] |= e[u] << b[3 & n++];
            } else for (n = this.start; u < f && n < s; ++u) {
              (i = e.charCodeAt(u)) < 128 ? o[n >> 2] |= i << b[3 & n++] : i < 2048 ? (o[n >> 2] |= (192 | i >> 6) << b[3 & n++], o[n >> 2] |= (128 | 63 & i) << b[3 & n++]) : i < 55296 || i >= 57344 ? (o[n >> 2] |= (224 | i >> 12) << b[3 & n++], o[n >> 2] |= (128 | i >> 6 & 63) << b[3 & n++], o[n >> 2] |= (128 | 63 & i) << b[3 & n++]) : (i = 65536 + ((1023 & i) << 10 | 1023 & e.charCodeAt(++u)), o[n >> 2] |= (240 | i >> 18) << b[3 & n++], o[n >> 2] |= (128 | i >> 12 & 63) << b[3 & n++], o[n >> 2] |= (128 | i >> 6 & 63) << b[3 & n++], o[n >> 2] |= (128 | 63 & i) << b[3 & n++]);
            }

            if (this.lastByteIndex = n, n >= s) {
              for (this.start = n - s, this.block = o[c], n = 0; n < c; ++n) {
                d[n] ^= o[n];
              }

              L(d), this.reset = !0;
            } else this.start = n;
          }

          return this;
        }
      }, j.prototype.encode = function (e, t) {
        var r = 255 & e,
            n = 1,
            i = [r];

        for (r = 255 & (e >>= 8); r > 0;) {
          i.unshift(r), r = 255 & (e >>= 8), ++n;
        }

        return t ? i.push(n) : i.unshift(n), this.update(i), i.length;
      }, j.prototype.encodeString = function (e) {
        var t,
            r = typeof e;

        if ("string" !== r) {
          if ("object" !== r) throw a;
          if (null === e) throw a;
          if (h && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || h && ArrayBuffer.isView(e))) throw a;
          t = !0;
        }

        var n = 0,
            i = e.length;
        if (t) n = i;else for (var o = 0; o < e.length; ++o) {
          var s = e.charCodeAt(o);
          s < 128 ? n += 1 : s < 2048 ? n += 2 : s < 55296 || s >= 57344 ? n += 3 : (s = 65536 + ((1023 & s) << 10 | 1023 & e.charCodeAt(++o)), n += 4);
        }
        return n += this.encode(8 * n), this.update(e), n;
      }, j.prototype.bytepad = function (e, t) {
        for (var r = this.encode(t), n = 0; n < e.length; ++n) {
          r += this.encodeString(e[n]);
        }

        var i = t - r % t,
            o = [];
        return o.length = i, this.update(o), this;
      }, j.prototype.finalize = function () {
        if (!this.finalized) {
          this.finalized = !0;
          var e = this.blocks,
              t = this.lastByteIndex,
              r = this.blockCount,
              n = this.s;
          if (e[t >> 2] |= this.padding[3 & t], this.lastByteIndex === this.byteCount) for (e[0] = e[r], t = 1; t < r + 1; ++t) {
            e[t] = 0;
          }

          for (e[r - 1] |= 2147483648, t = 0; t < r; ++t) {
            n[t] ^= e[t];
          }

          L(n);
        }
      }, j.prototype.toString = j.prototype.hex = function () {
        this.finalize();

        for (var e, t = this.blockCount, r = this.s, n = this.outputBlocks, i = this.extraBytes, o = 0, a = 0, s = ""; a < n;) {
          for (o = 0; o < t && a < n; ++o, ++a) {
            e = r[o], s += l[e >> 4 & 15] + l[15 & e] + l[e >> 12 & 15] + l[e >> 8 & 15] + l[e >> 20 & 15] + l[e >> 16 & 15] + l[e >> 28 & 15] + l[e >> 24 & 15];
          }

          a % t == 0 && (L(r), o = 0);
        }

        return i && (e = r[o], s += l[e >> 4 & 15] + l[15 & e], i > 1 && (s += l[e >> 12 & 15] + l[e >> 8 & 15]), i > 2 && (s += l[e >> 20 & 15] + l[e >> 16 & 15])), s;
      }, j.prototype.arrayBuffer = function () {
        this.finalize();
        var e,
            t = this.blockCount,
            r = this.s,
            n = this.outputBlocks,
            i = this.extraBytes,
            o = 0,
            a = 0,
            s = this.outputBits >> 3;
        e = i ? new ArrayBuffer(n + 1 << 2) : new ArrayBuffer(s);

        for (var f = new Uint32Array(e); a < n;) {
          for (o = 0; o < t && a < n; ++o, ++a) {
            f[a] = r[o];
          }

          a % t == 0 && L(r);
        }

        return i && (f[o] = r[o], e = e.slice(0, s)), e;
      }, j.prototype.buffer = j.prototype.arrayBuffer, j.prototype.digest = j.prototype.array = function () {
        this.finalize();

        for (var e, t, r = this.blockCount, n = this.s, i = this.outputBlocks, o = this.extraBytes, a = 0, s = 0, f = []; s < i;) {
          for (a = 0; a < r && s < i; ++a, ++s) {
            e = s << 2, t = n[a], f[e] = 255 & t, f[e + 1] = t >> 8 & 255, f[e + 2] = t >> 16 & 255, f[e + 3] = t >> 24 & 255;
          }

          s % r == 0 && L(n);
        }

        return o && (e = s << 2, t = n[a], f[e] = 255 & t, o > 1 && (f[e + 1] = t >> 8 & 255), o > 2 && (f[e + 2] = t >> 16 & 255)), f;
      }, z.prototype = new j(), z.prototype.finalize = function () {
        return this.encode(this.outputBits, !0), j.prototype.finalize.call(this);
      };

      var L = function L(e) {
        var t, r, n, i, o, a, s, f, c, u, d, h, l, p, b, m, y, g, A, w, _, x, S, k, E, M, C, B, P, R, H, O, T, I, j, z, L, N, W, U, D, q, F, X, Y, V, K, J, G, Z, Q, $, ee, te, re, ne, ie, oe, ae, se, fe, ce, ue;

        for (n = 0; n < 48; n += 2) {
          i = e[0] ^ e[10] ^ e[20] ^ e[30] ^ e[40], o = e[1] ^ e[11] ^ e[21] ^ e[31] ^ e[41], a = e[2] ^ e[12] ^ e[22] ^ e[32] ^ e[42], s = e[3] ^ e[13] ^ e[23] ^ e[33] ^ e[43], f = e[4] ^ e[14] ^ e[24] ^ e[34] ^ e[44], c = e[5] ^ e[15] ^ e[25] ^ e[35] ^ e[45], u = e[6] ^ e[16] ^ e[26] ^ e[36] ^ e[46], d = e[7] ^ e[17] ^ e[27] ^ e[37] ^ e[47], t = (h = e[8] ^ e[18] ^ e[28] ^ e[38] ^ e[48]) ^ (a << 1 | s >>> 31), r = (l = e[9] ^ e[19] ^ e[29] ^ e[39] ^ e[49]) ^ (s << 1 | a >>> 31), e[0] ^= t, e[1] ^= r, e[10] ^= t, e[11] ^= r, e[20] ^= t, e[21] ^= r, e[30] ^= t, e[31] ^= r, e[40] ^= t, e[41] ^= r, t = i ^ (f << 1 | c >>> 31), r = o ^ (c << 1 | f >>> 31), e[2] ^= t, e[3] ^= r, e[12] ^= t, e[13] ^= r, e[22] ^= t, e[23] ^= r, e[32] ^= t, e[33] ^= r, e[42] ^= t, e[43] ^= r, t = a ^ (u << 1 | d >>> 31), r = s ^ (d << 1 | u >>> 31), e[4] ^= t, e[5] ^= r, e[14] ^= t, e[15] ^= r, e[24] ^= t, e[25] ^= r, e[34] ^= t, e[35] ^= r, e[44] ^= t, e[45] ^= r, t = f ^ (h << 1 | l >>> 31), r = c ^ (l << 1 | h >>> 31), e[6] ^= t, e[7] ^= r, e[16] ^= t, e[17] ^= r, e[26] ^= t, e[27] ^= r, e[36] ^= t, e[37] ^= r, e[46] ^= t, e[47] ^= r, t = u ^ (i << 1 | o >>> 31), r = d ^ (o << 1 | i >>> 31), e[8] ^= t, e[9] ^= r, e[18] ^= t, e[19] ^= r, e[28] ^= t, e[29] ^= r, e[38] ^= t, e[39] ^= r, e[48] ^= t, e[49] ^= r, p = e[0], b = e[1], V = e[11] << 4 | e[10] >>> 28, K = e[10] << 4 | e[11] >>> 28, B = e[20] << 3 | e[21] >>> 29, P = e[21] << 3 | e[20] >>> 29, se = e[31] << 9 | e[30] >>> 23, fe = e[30] << 9 | e[31] >>> 23, q = e[40] << 18 | e[41] >>> 14, F = e[41] << 18 | e[40] >>> 14, I = e[2] << 1 | e[3] >>> 31, j = e[3] << 1 | e[2] >>> 31, m = e[13] << 12 | e[12] >>> 20, y = e[12] << 12 | e[13] >>> 20, J = e[22] << 10 | e[23] >>> 22, G = e[23] << 10 | e[22] >>> 22, R = e[33] << 13 | e[32] >>> 19, H = e[32] << 13 | e[33] >>> 19, ce = e[42] << 2 | e[43] >>> 30, ue = e[43] << 2 | e[42] >>> 30, te = e[5] << 30 | e[4] >>> 2, re = e[4] << 30 | e[5] >>> 2, z = e[14] << 6 | e[15] >>> 26, L = e[15] << 6 | e[14] >>> 26, g = e[25] << 11 | e[24] >>> 21, A = e[24] << 11 | e[25] >>> 21, Z = e[34] << 15 | e[35] >>> 17, Q = e[35] << 15 | e[34] >>> 17, O = e[45] << 29 | e[44] >>> 3, T = e[44] << 29 | e[45] >>> 3, k = e[6] << 28 | e[7] >>> 4, E = e[7] << 28 | e[6] >>> 4, ne = e[17] << 23 | e[16] >>> 9, ie = e[16] << 23 | e[17] >>> 9, N = e[26] << 25 | e[27] >>> 7, W = e[27] << 25 | e[26] >>> 7, w = e[36] << 21 | e[37] >>> 11, _ = e[37] << 21 | e[36] >>> 11, $ = e[47] << 24 | e[46] >>> 8, ee = e[46] << 24 | e[47] >>> 8, X = e[8] << 27 | e[9] >>> 5, Y = e[9] << 27 | e[8] >>> 5, M = e[18] << 20 | e[19] >>> 12, C = e[19] << 20 | e[18] >>> 12, oe = e[29] << 7 | e[28] >>> 25, ae = e[28] << 7 | e[29] >>> 25, U = e[38] << 8 | e[39] >>> 24, D = e[39] << 8 | e[38] >>> 24, x = e[48] << 14 | e[49] >>> 18, S = e[49] << 14 | e[48] >>> 18, e[0] = p ^ ~m & g, e[1] = b ^ ~y & A, e[10] = k ^ ~M & B, e[11] = E ^ ~C & P, e[20] = I ^ ~z & N, e[21] = j ^ ~L & W, e[30] = X ^ ~V & J, e[31] = Y ^ ~K & G, e[40] = te ^ ~ne & oe, e[41] = re ^ ~ie & ae, e[2] = m ^ ~g & w, e[3] = y ^ ~A & _, e[12] = M ^ ~B & R, e[13] = C ^ ~P & H, e[22] = z ^ ~N & U, e[23] = L ^ ~W & D, e[32] = V ^ ~J & Z, e[33] = K ^ ~G & Q, e[42] = ne ^ ~oe & se, e[43] = ie ^ ~ae & fe, e[4] = g ^ ~w & x, e[5] = A ^ ~_ & S, e[14] = B ^ ~R & O, e[15] = P ^ ~H & T, e[24] = N ^ ~U & q, e[25] = W ^ ~D & F, e[34] = J ^ ~Z & $, e[35] = G ^ ~Q & ee, e[44] = oe ^ ~se & ce, e[45] = ae ^ ~fe & ue, e[6] = w ^ ~x & p, e[7] = _ ^ ~S & b, e[16] = R ^ ~O & k, e[17] = H ^ ~T & E, e[26] = U ^ ~q & I, e[27] = D ^ ~F & j, e[36] = Z ^ ~$ & X, e[37] = Q ^ ~ee & Y, e[46] = se ^ ~ce & te, e[47] = fe ^ ~ue & re, e[8] = x ^ ~p & m, e[9] = S ^ ~b & y, e[18] = O ^ ~k & M, e[19] = T ^ ~E & C, e[28] = q ^ ~I & z, e[29] = F ^ ~j & L, e[38] = $ ^ ~X & V, e[39] = ee ^ ~Y & K, e[48] = ce ^ ~te & ne, e[49] = ue ^ ~re & ie, e[0] ^= v[n], e[1] ^= v[n + 1];
        }
      };

      if (u) e.exports = C;else {
        for (P = 0; P < B.length; ++P) {
          f[B[P]] = C[B[P]];
        }

        d && (void 0 === (o = function () {
          return C;
        }.call(t, r, t, e)) || (e.exports = o));
      }
    }();
  }).call(this, r(18), r(7));
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.resolveAuthenticator = t.verifyJWT = t.createJWT = t.IAT_SKEW = void 0;
  var n,
      i,
      o,
      a = y(r(19)),
      s = y(r(170)),
      f = y(r(20)),
      c = y(r(177)),
      u = t.createJWT = (n = (0, f.default)(a.default.mark(function e(t, r) {
    var n,
        i,
        o,
        f,
        c,
        u = r.issuer,
        d = r.signer,
        h = r.alg,
        l = r.expiresIn;
    return a.default.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (d) {
              e.next = 2;
              break;
            }

            throw new Error("No Signer functionality has been configured");

          case 2:
            if (u) {
              e.next = 4;
              break;
            }

            throw new Error("No issuing DID has been configured");

          case 4:
            if (n = (0, s.default)({}, A, {
              alg: h || w
            }), i = {
              iat: Math.floor(Date.now() / 1e3)
            }, !l) {
              e.next = 12;
              break;
            }

            if ("number" != typeof l) {
              e.next = 11;
              break;
            }

            i.exp = i.iat + Math.floor(l), e.next = 12;
            break;

          case 11:
            throw new Error("JWT expiresIn is not a number");

          case 12:
            return o = [_(n), _((0, s.default)({}, i, t, {
              iss: u
            }))].join("."), f = (0, b.default)(n.alg), e.next = 16, f(o, d);

          case 16:
            return c = e.sent, e.abrupt("return", [o, c].join("."));

          case 18:
          case "end":
            return e.stop();
        }
      }
    }, e, this);
  })), function (e, t) {
    return n.apply(this, arguments);
  }),
      d = t.verifyJWT = (i = (0, f.default)(a.default.mark(function e(t) {
    var r,
        n,
        i,
        o,
        s,
        f,
        c,
        u,
        d,
        b,
        v,
        m,
        y = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    return a.default.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return r = y.audience ? S(y.audience) : void 0, n = k(t), i = n.payload, o = n.header, s = n.signature, f = n.data, e.next = 4, h(o.alg, i.iss, y.auth);

          case 4:
            if (c = e.sent, u = c.doc, d = c.authenticators, b = c.issuer, v = (0, p.default)(o.alg)(f, s, d), m = Math.floor(Date.now() / 1e3), !v) {
              e.next = 30;
              break;
            }

            if (!(i.iat && i.iat > m + x)) {
              e.next = 13;
              break;
            }

            throw new Error("JWT not valid yet (issued in the future): iat: " + i.iat + " > now: " + m);

          case 13:
            if (!(i.exp && i.exp <= m - x)) {
              e.next = 15;
              break;
            }

            throw new Error("JWT has expired: exp: " + i.exp + " < now: " + m);

          case 15:
            if (!i.aud) {
              e.next = 27;
              break;
            }

            if (!(a = i.aud) || !a.match(/^did:/) && !(0, l.isMNID)(a)) {
              e.next = 23;
              break;
            }

            if (r) {
              e.next = 19;
              break;
            }

            throw new Error("JWT audience is required but your app address has not been configured");

          case 19:
            if (r === S(i.aud)) {
              e.next = 21;
              break;
            }

            throw new Error("JWT audience does not match your DID: aud: " + i.aud + " !== yours: " + r);

          case 21:
            e.next = 27;
            break;

          case 23:
            if (y.callbackUrl) {
              e.next = 25;
              break;
            }

            throw new Error("JWT audience matching your callback url is required but one wasn't passed in");

          case 25:
            if (i.aud === y.callbackUrl) {
              e.next = 27;
              break;
            }

            throw new Error("JWT audience does not match the callback url: aud: " + i.aud + " !== url: " + y.callbackUrl);

          case 27:
            return e.abrupt("return", {
              payload: i,
              doc: u,
              issuer: b,
              signer: v,
              jwt: t
            });

          case 30:
          case "end":
            return e.stop();
        }
      }

      var a;
    }, e, this);
  })), function (e) {
    return i.apply(this, arguments);
  }),
      h = t.resolveAuthenticator = (o = (0, f.default)(a.default.mark(function e(t, r, n) {
    var i, o, s, f, c;
    return a.default.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if ((i = g[t]) && 0 !== i.length) {
              e.next = 3;
              break;
            }

            throw new Error("No supported signature types for algorithm " + t);

          case 3:
            return o = S(r), e.next = 6, (0, m.default)(o);

          case 6:
            if (s = e.sent) {
              e.next = 9;
              break;
            }

            throw new Error("Unable to resolve DID document for " + o);

          case 9:
            if (f = !n || (s.authentication || []).map(function (e) {
              return e.publicKey;
            }), c = (s.publicKey || []).filter(function (e) {
              var t = e.type,
                  r = e.id;
              return i.find(function (e) {
                return e === t && (!n || f.indexOf(r) >= 0);
              });
            }), !n || c && 0 !== c.length) {
              e.next = 13;
              break;
            }

            throw new Error("DID document for " + o + " does not have public keys suitable for authenticationg user");

          case 13:
            if (c && 0 !== c.length) {
              e.next = 15;
              break;
            }

            throw new Error("DID document for " + o + " does not have public keys for " + t);

          case 15:
            return e.abrupt("return", {
              authenticators: c,
              issuer: o,
              doc: s
            });

          case 16:
          case "end":
            return e.stop();
        }
      }
    }, e, this);
  })), function (e, t, r) {
    return o.apply(this, arguments);
  });
  t.normalizeDID = S, t.decodeJWT = k;
  var l = r(179),
      p = y(r(181)),
      b = y(r(184)),
      v = y(r(52)),
      m = y(r(35));

  function y(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  (0, y(r(185)).default)();
  var g = {
    ES256K: ["Secp256k1VerificationKey2018", "Secp256k1SignatureVerificationKey2018", "EcdsaPublicKeySecp256k1"],
    "ES256K-R": ["Secp256k1VerificationKey2018", "Secp256k1SignatureVerificationKey2018", "EcdsaPublicKeySecp256k1"]
  },
      A = {
    typ: "JWT"
  },
      w = "ES256K";

  function _(e) {
    return v.default.encode((0, c.default)(e));
  }

  var x = t.IAT_SKEW = 300;

  function S(e) {
    if (e.match(/^did:/)) return e;
    if ((0, l.isMNID)(e)) return "did:uport:" + e;
    throw new Error("Not a valid DID '" + e + "'");
  }

  function k(e) {
    if (!e) throw new Error("no JWT passed into decodeJWT");
    var t = e.match(/^([a-zA-Z0-9_-]+)\.([a-zA-Z0-9_-]+)\.([a-zA-Z0-9_-]+)$/);
    if (t) return {
      header: JSON.parse(v.default.decode(t[1])),
      payload: JSON.parse(v.default.decode(t[2])),
      signature: t[3],
      data: t[1] + "." + t[2]
    };
    throw new Error("Incorrect format JWT");
  }

  t.default = {
    decodeJWT: k,
    createJWT: u,
    verifyJWT: d,
    resolveAuthenticator: h
  };
}, function (e, t, r) {
  "use strict";

  t.__esModule = !0;
  var n,
      i = r(171),
      o = (n = i) && n.__esModule ? n : {
    default: n
  };

  t.default = o.default || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  };
}, function (e, t, r) {
  e.exports = {
    default: r(172),
    __esModule: !0
  };
}, function (e, t, r) {
  r(173), e.exports = r(8).Object.assign;
}, function (e, t, r) {
  var n = r(21);
  n(n.S + n.F, "Object", {
    assign: r(174)
  });
}, function (e, t, r) {
  "use strict";

  var n = r(63),
      i = r(175),
      o = r(176),
      a = r(70),
      s = r(64),
      f = Object.assign;
  e.exports = !f || r(45)(function () {
    var e = {},
        t = {},
        r = Symbol(),
        n = "abcdefghijklmnopqrst";
    return e[r] = 7, n.split("").forEach(function (e) {
      t[e] = e;
    }), 7 != f({}, e)[r] || Object.keys(f({}, t)).join("") != n;
  }) ? function (e, t) {
    for (var r = a(e), f = arguments.length, c = 1, u = i.f, d = o.f; f > c;) {
      for (var h, l = s(arguments[c++]), p = u ? n(l).concat(u(l)) : n(l), b = p.length, v = 0; b > v;) {
        d.call(l, h = p[v++]) && (r[h] = l[h]);
      }
    }

    return r;
  } : f;
}, function (e, t) {
  t.f = Object.getOwnPropertySymbols;
}, function (e, t) {
  t.f = {}.propertyIsEnumerable;
}, function (e, t, r) {
  e.exports = {
    default: r(178),
    __esModule: !0
  };
}, function (e, t, r) {
  var n = r(8),
      i = n.JSON || (n.JSON = {
    stringify: JSON.stringify
  });

  e.exports = function (e) {
    return i.stringify.apply(i, arguments);
  };
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.encode = function (e) {
    var t = e.network,
        r = e.address,
        n = [new i.Buffer("01", "hex"), a.decode(t.slice(2)), new i.Buffer(r.slice(2), "hex")];
    return n.push(s(n)), o.encode(i.Buffer.concat(n));
  }, t.decode = function (e) {
    var t = i.Buffer.from(o.decode(e)),
        r = t.length - 24,
        n = t.slice(0, 1),
        f = t.slice(1, r),
        c = t.slice(r, 20 + r);
    if (t.slice(r + 20).equals(s([n, f, c]))) return {
      network: "0x" + a.encode(f),
      address: "0x" + c.toString("hex")
    };
    throw new Error("Invalid address checksum");
  }, t.isMNID = function (e) {
    try {
      var t = i.Buffer.from(o.decode(e));
      return t.length > 24 && 1 === t[0];
    } catch (e) {
      return !1;
    }
  };
  var n = r(180),
      i = r(11),
      o = r(17)("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"),
      a = r(17)("0123456789abcdef");

  function s(e) {
    return new i.Buffer((0, n.sha3_256)(i.Buffer.concat(e)), "hex").slice(0, 4);
  }
}, function (e, t, r) {
  (function (t, r) {
    /**
     * [js-sha3]{@link https://github.com/emn178/js-sha3}
     *
     * @version 0.5.7
     * @author Chen, Yi-Cyuan [emn178@gmail.com]
     * @copyright Chen, Yi-Cyuan 2015-2016
     * @license MIT
     */
    !function () {
      "use strict";

      var n = "object" == typeof window ? window : {};
      !n.JS_SHA3_NO_NODE_JS && "object" == typeof t && t.versions && t.versions.node && (n = r);

      for (var i = !n.JS_SHA3_NO_COMMON_JS && "object" == typeof e && e.exports, o = "0123456789abcdef".split(""), a = [0, 8, 16, 24], s = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648], f = [224, 256, 384, 512], c = ["hex", "buffer", "arrayBuffer", "array"], u = function u(e, t, r) {
        return function (n) {
          return new w(e, t, e).update(n)[r]();
        };
      }, d = function d(e, t, r) {
        return function (n, i) {
          return new w(e, t, i).update(n)[r]();
        };
      }, h = function h(e, t) {
        var r = u(e, t, "hex");
        r.create = function () {
          return new w(e, t, e);
        }, r.update = function (e) {
          return r.create().update(e);
        };

        for (var n = 0; n < c.length; ++n) {
          var i = c[n];
          r[i] = u(e, t, i);
        }

        return r;
      }, l = [{
        name: "keccak",
        padding: [1, 256, 65536, 16777216],
        bits: f,
        createMethod: h
      }, {
        name: "sha3",
        padding: [6, 1536, 393216, 100663296],
        bits: f,
        createMethod: h
      }, {
        name: "shake",
        padding: [31, 7936, 2031616, 520093696],
        bits: [128, 256],
        createMethod: function createMethod(e, t) {
          var r = d(e, t, "hex");
          r.create = function (r) {
            return new w(e, t, r);
          }, r.update = function (e, t) {
            return r.create(t).update(e);
          };

          for (var n = 0; n < c.length; ++n) {
            var i = c[n];
            r[i] = d(e, t, i);
          }

          return r;
        }
      }], p = {}, b = [], v = 0; v < l.length; ++v) {
        for (var m = l[v], y = m.bits, g = 0; g < y.length; ++g) {
          var A = m.name + "_" + y[g];
          b.push(A), p[A] = m.createMethod(y[g], m.padding);
        }
      }

      function w(e, t, r) {
        this.blocks = [], this.s = [], this.padding = t, this.outputBits = r, this.reset = !0, this.block = 0, this.start = 0, this.blockCount = 1600 - (e << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = r >> 5, this.extraBytes = (31 & r) >> 3;

        for (var n = 0; n < 50; ++n) {
          this.s[n] = 0;
        }
      }

      w.prototype.update = function (e) {
        var t = "string" != typeof e;
        t && e.constructor === ArrayBuffer && (e = new Uint8Array(e));

        for (var r, n, i = e.length, o = this.blocks, s = this.byteCount, f = this.blockCount, c = 0, u = this.s; c < i;) {
          if (this.reset) for (this.reset = !1, o[0] = this.block, r = 1; r < f + 1; ++r) {
            o[r] = 0;
          }
          if (t) for (r = this.start; c < i && r < s; ++c) {
            o[r >> 2] |= e[c] << a[3 & r++];
          } else for (r = this.start; c < i && r < s; ++c) {
            (n = e.charCodeAt(c)) < 128 ? o[r >> 2] |= n << a[3 & r++] : n < 2048 ? (o[r >> 2] |= (192 | n >> 6) << a[3 & r++], o[r >> 2] |= (128 | 63 & n) << a[3 & r++]) : n < 55296 || n >= 57344 ? (o[r >> 2] |= (224 | n >> 12) << a[3 & r++], o[r >> 2] |= (128 | n >> 6 & 63) << a[3 & r++], o[r >> 2] |= (128 | 63 & n) << a[3 & r++]) : (n = 65536 + ((1023 & n) << 10 | 1023 & e.charCodeAt(++c)), o[r >> 2] |= (240 | n >> 18) << a[3 & r++], o[r >> 2] |= (128 | n >> 12 & 63) << a[3 & r++], o[r >> 2] |= (128 | n >> 6 & 63) << a[3 & r++], o[r >> 2] |= (128 | 63 & n) << a[3 & r++]);
          }

          if (this.lastByteIndex = r, r >= s) {
            for (this.start = r - s, this.block = o[f], r = 0; r < f; ++r) {
              u[r] ^= o[r];
            }

            _(u), this.reset = !0;
          } else this.start = r;
        }

        return this;
      }, w.prototype.finalize = function () {
        var e = this.blocks,
            t = this.lastByteIndex,
            r = this.blockCount,
            n = this.s;
        if (e[t >> 2] |= this.padding[3 & t], this.lastByteIndex === this.byteCount) for (e[0] = e[r], t = 1; t < r + 1; ++t) {
          e[t] = 0;
        }

        for (e[r - 1] |= 2147483648, t = 0; t < r; ++t) {
          n[t] ^= e[t];
        }

        _(n);
      }, w.prototype.toString = w.prototype.hex = function () {
        this.finalize();

        for (var e, t = this.blockCount, r = this.s, n = this.outputBlocks, i = this.extraBytes, a = 0, s = 0, f = ""; s < n;) {
          for (a = 0; a < t && s < n; ++a, ++s) {
            e = r[a], f += o[e >> 4 & 15] + o[15 & e] + o[e >> 12 & 15] + o[e >> 8 & 15] + o[e >> 20 & 15] + o[e >> 16 & 15] + o[e >> 28 & 15] + o[e >> 24 & 15];
          }

          s % t == 0 && (_(r), a = 0);
        }

        return i && (e = r[a], i > 0 && (f += o[e >> 4 & 15] + o[15 & e]), i > 1 && (f += o[e >> 12 & 15] + o[e >> 8 & 15]), i > 2 && (f += o[e >> 20 & 15] + o[e >> 16 & 15])), f;
      }, w.prototype.arrayBuffer = function () {
        this.finalize();
        var e,
            t = this.blockCount,
            r = this.s,
            n = this.outputBlocks,
            i = this.extraBytes,
            o = 0,
            a = 0,
            s = this.outputBits >> 3;
        e = i ? new ArrayBuffer(n + 1 << 2) : new ArrayBuffer(s);

        for (var f = new Uint32Array(e); a < n;) {
          for (o = 0; o < t && a < n; ++o, ++a) {
            f[a] = r[o];
          }

          a % t == 0 && _(r);
        }

        return i && (f[o] = r[o], e = e.slice(0, s)), e;
      }, w.prototype.buffer = w.prototype.arrayBuffer, w.prototype.digest = w.prototype.array = function () {
        this.finalize();

        for (var e, t, r = this.blockCount, n = this.s, i = this.outputBlocks, o = this.extraBytes, a = 0, s = 0, f = []; s < i;) {
          for (a = 0; a < r && s < i; ++a, ++s) {
            e = s << 2, t = n[a], f[e] = 255 & t, f[e + 1] = t >> 8 & 255, f[e + 2] = t >> 16 & 255, f[e + 3] = t >> 24 & 255;
          }

          s % r == 0 && _(n);
        }

        return o && (e = s << 2, t = n[a], o > 0 && (f[e] = 255 & t), o > 1 && (f[e + 1] = t >> 8 & 255), o > 2 && (f[e + 2] = t >> 16 & 255)), f;
      };

      var _ = function _(e) {
        var t, r, n, i, o, a, f, c, u, d, h, l, p, b, v, m, y, g, A, w, _, x, S, k, E, M, C, B, P, R, H, O, T, I, j, z, L, N, W, U, D, q, F, X, Y, V, K, J, G, Z, Q, $, ee, te, re, ne, ie, oe, ae, se, fe, ce, ue;

        for (n = 0; n < 48; n += 2) {
          i = e[0] ^ e[10] ^ e[20] ^ e[30] ^ e[40], o = e[1] ^ e[11] ^ e[21] ^ e[31] ^ e[41], a = e[2] ^ e[12] ^ e[22] ^ e[32] ^ e[42], f = e[3] ^ e[13] ^ e[23] ^ e[33] ^ e[43], c = e[4] ^ e[14] ^ e[24] ^ e[34] ^ e[44], u = e[5] ^ e[15] ^ e[25] ^ e[35] ^ e[45], d = e[6] ^ e[16] ^ e[26] ^ e[36] ^ e[46], h = e[7] ^ e[17] ^ e[27] ^ e[37] ^ e[47], t = (l = e[8] ^ e[18] ^ e[28] ^ e[38] ^ e[48]) ^ (a << 1 | f >>> 31), r = (p = e[9] ^ e[19] ^ e[29] ^ e[39] ^ e[49]) ^ (f << 1 | a >>> 31), e[0] ^= t, e[1] ^= r, e[10] ^= t, e[11] ^= r, e[20] ^= t, e[21] ^= r, e[30] ^= t, e[31] ^= r, e[40] ^= t, e[41] ^= r, t = i ^ (c << 1 | u >>> 31), r = o ^ (u << 1 | c >>> 31), e[2] ^= t, e[3] ^= r, e[12] ^= t, e[13] ^= r, e[22] ^= t, e[23] ^= r, e[32] ^= t, e[33] ^= r, e[42] ^= t, e[43] ^= r, t = a ^ (d << 1 | h >>> 31), r = f ^ (h << 1 | d >>> 31), e[4] ^= t, e[5] ^= r, e[14] ^= t, e[15] ^= r, e[24] ^= t, e[25] ^= r, e[34] ^= t, e[35] ^= r, e[44] ^= t, e[45] ^= r, t = c ^ (l << 1 | p >>> 31), r = u ^ (p << 1 | l >>> 31), e[6] ^= t, e[7] ^= r, e[16] ^= t, e[17] ^= r, e[26] ^= t, e[27] ^= r, e[36] ^= t, e[37] ^= r, e[46] ^= t, e[47] ^= r, t = d ^ (i << 1 | o >>> 31), r = h ^ (o << 1 | i >>> 31), e[8] ^= t, e[9] ^= r, e[18] ^= t, e[19] ^= r, e[28] ^= t, e[29] ^= r, e[38] ^= t, e[39] ^= r, e[48] ^= t, e[49] ^= r, b = e[0], v = e[1], V = e[11] << 4 | e[10] >>> 28, K = e[10] << 4 | e[11] >>> 28, B = e[20] << 3 | e[21] >>> 29, P = e[21] << 3 | e[20] >>> 29, se = e[31] << 9 | e[30] >>> 23, fe = e[30] << 9 | e[31] >>> 23, q = e[40] << 18 | e[41] >>> 14, F = e[41] << 18 | e[40] >>> 14, I = e[2] << 1 | e[3] >>> 31, j = e[3] << 1 | e[2] >>> 31, m = e[13] << 12 | e[12] >>> 20, y = e[12] << 12 | e[13] >>> 20, J = e[22] << 10 | e[23] >>> 22, G = e[23] << 10 | e[22] >>> 22, R = e[33] << 13 | e[32] >>> 19, H = e[32] << 13 | e[33] >>> 19, ce = e[42] << 2 | e[43] >>> 30, ue = e[43] << 2 | e[42] >>> 30, te = e[5] << 30 | e[4] >>> 2, re = e[4] << 30 | e[5] >>> 2, z = e[14] << 6 | e[15] >>> 26, L = e[15] << 6 | e[14] >>> 26, g = e[25] << 11 | e[24] >>> 21, A = e[24] << 11 | e[25] >>> 21, Z = e[34] << 15 | e[35] >>> 17, Q = e[35] << 15 | e[34] >>> 17, O = e[45] << 29 | e[44] >>> 3, T = e[44] << 29 | e[45] >>> 3, k = e[6] << 28 | e[7] >>> 4, E = e[7] << 28 | e[6] >>> 4, ne = e[17] << 23 | e[16] >>> 9, ie = e[16] << 23 | e[17] >>> 9, N = e[26] << 25 | e[27] >>> 7, W = e[27] << 25 | e[26] >>> 7, w = e[36] << 21 | e[37] >>> 11, _ = e[37] << 21 | e[36] >>> 11, $ = e[47] << 24 | e[46] >>> 8, ee = e[46] << 24 | e[47] >>> 8, X = e[8] << 27 | e[9] >>> 5, Y = e[9] << 27 | e[8] >>> 5, M = e[18] << 20 | e[19] >>> 12, C = e[19] << 20 | e[18] >>> 12, oe = e[29] << 7 | e[28] >>> 25, ae = e[28] << 7 | e[29] >>> 25, U = e[38] << 8 | e[39] >>> 24, D = e[39] << 8 | e[38] >>> 24, x = e[48] << 14 | e[49] >>> 18, S = e[49] << 14 | e[48] >>> 18, e[0] = b ^ ~m & g, e[1] = v ^ ~y & A, e[10] = k ^ ~M & B, e[11] = E ^ ~C & P, e[20] = I ^ ~z & N, e[21] = j ^ ~L & W, e[30] = X ^ ~V & J, e[31] = Y ^ ~K & G, e[40] = te ^ ~ne & oe, e[41] = re ^ ~ie & ae, e[2] = m ^ ~g & w, e[3] = y ^ ~A & _, e[12] = M ^ ~B & R, e[13] = C ^ ~P & H, e[22] = z ^ ~N & U, e[23] = L ^ ~W & D, e[32] = V ^ ~J & Z, e[33] = K ^ ~G & Q, e[42] = ne ^ ~oe & se, e[43] = ie ^ ~ae & fe, e[4] = g ^ ~w & x, e[5] = A ^ ~_ & S, e[14] = B ^ ~R & O, e[15] = P ^ ~H & T, e[24] = N ^ ~U & q, e[25] = W ^ ~D & F, e[34] = J ^ ~Z & $, e[35] = G ^ ~Q & ee, e[44] = oe ^ ~se & ce, e[45] = ae ^ ~fe & ue, e[6] = w ^ ~x & b, e[7] = _ ^ ~S & v, e[16] = R ^ ~O & k, e[17] = H ^ ~T & E, e[26] = U ^ ~q & I, e[27] = D ^ ~F & j, e[36] = Z ^ ~$ & X, e[37] = Q ^ ~ee & Y, e[46] = se ^ ~ce & te, e[47] = fe ^ ~ue & re, e[8] = x ^ ~b & m, e[9] = S ^ ~v & y, e[18] = O ^ ~k & M, e[19] = T ^ ~E & C, e[28] = q ^ ~I & z, e[29] = F ^ ~j & L, e[38] = $ ^ ~X & V, e[39] = ee ^ ~Y & K, e[48] = ce ^ ~te & ne, e[49] = ue ^ ~re & ie, e[0] ^= s[n], e[1] ^= s[n + 1];
        }
      };

      if (i) e.exports = p;else for (v = 0; v < b.length; ++v) {
        n[b[v]] = p[b[v]];
      }
    }();
  }).call(this, r(18), r(7));
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.toSignatureObject = c, t.verifyES256K = u, t.verifyRecoverableES256K = d;
  var n,
      i = r(2),
      o = r(80),
      a = r(52),
      s = (n = a) && n.__esModule ? n : {
    default: n
  };
  var f = new i.ec("secp256k1");

  function c(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
        r = s.default.toBuffer(e);
    if (r.length !== (t ? 65 : 64)) throw new Error("wrong signature length");
    var n = {
      r: r.slice(0, 32).toString("hex"),
      s: r.slice(32, 64).toString("hex")
    };
    return t && (n.recoveryParam = r[64]), n;
  }

  function u(e, t, r) {
    var n = (0, o.sha256)(e),
        i = c(t),
        a = r.find(function (e) {
      var t = e.publicKeyHex;
      return f.keyFromPublic(t, "hex").verify(n, i);
    });
    if (!a) throw new Error("Signature invalid for JWT");
    return a;
  }

  function d(e, t, r) {
    var n = c(t, !0),
        i = (0, o.sha256)(e),
        a = f.recoverPubKey(i, n, n.recoveryParam),
        s = a.encode("hex"),
        u = a.encode("hex", !0),
        d = (0, o.toEthereumAddress)(s),
        h = r.find(function (e) {
      var t = e.publicKeyHex,
          r = e.ethereumAddress;
      return t === s || t === u || r === d;
    });
    if (!h) throw new Error("Signature invalid for JWT");
    return h;
  }

  var h = {
    ES256K: u,
    "ES256K-R": d
  };

  function l(e) {
    var t = h[e];
    if (!t) throw new Error("Unsupported algorithm " + e);
    return t;
  }

  l.toSignatureObject = c, e.exports = l;
}, function (e, t, r) {
  "use strict";

  (function (e) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(183);

    function i(t, r) {
      return void 0 === r && (r = "utf8"), e.isBuffer(t) ? a(t.toString("base64")) : a(e.from(t, r).toString("base64"));
    }

    function o(e) {
      return e = e.toString(), n.default(e).replace(/\-/g, "+").replace(/_/g, "/");
    }

    function a(e) {
      return e.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    }

    var s = i;
    s.encode = i, s.decode = function (t, r) {
      return void 0 === r && (r = "utf8"), e.from(o(t), "base64").toString(r);
    }, s.toBase64 = o, s.fromBase64 = a, s.toBuffer = function (t) {
      return e.from(o(t), "base64");
    }, t.default = s;
  }).call(this, r(11).Buffer);
}, function (e, t, r) {
  "use strict";

  (function (e) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function (t) {
      var r = t.length,
          n = r % 4;
      if (!n) return t;
      var i = r,
          o = 4 - n,
          a = r + o,
          s = e.alloc(a);

      for (s.write(t); o--;) {
        s.write("=", i++);
      }

      return s.toString();
    };
  }).call(this, r(11).Buffer);
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = s(r(19)),
      i = s(r(20));
  t.ES256KSigner = f;
  var o = s(r(52)),
      a = r(11);

  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function f() {
    var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];

    function t(t) {
      var r = t.r,
          n = t.s,
          i = t.recoveryParam,
          s = a.Buffer.alloc(e ? 65 : 64);

      if (a.Buffer.from(r, "hex").copy(s, 0), a.Buffer.from(n, "hex").copy(s, 32), e) {
        if (void 0 === i) throw new Error("Signer did not return a recoveryParam");
        s[64] = i;
      }

      return o.default.encode(s);
    }

    return function () {
      var e = (0, i.default)(n.default.mark(function e(r, i) {
        var o;
        return n.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, i(r);

              case 2:
                return o = e.sent, e.abrupt("return", t(o));

              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      }));
      return function (t, r) {
        return e.apply(this, arguments);
      };
    }();
  }

  var c = {
    ES256K: f(),
    "ES256K-R": f(!0)
  };

  e.exports = function (e) {
    var t = c[e];
    if (!t) throw new Error("Unsupported algorithm " + e);
    return t;
  };
}, function (e, t, r) {
  "use strict";

  var n = this && this.__awaiter || function (e, t, r, n) {
    return new (r || (r = Promise))(function (i, o) {
      function a(e) {
        try {
          f(n.next(e));
        } catch (e) {
          o(e);
        }
      }

      function s(e) {
        try {
          f(n.throw(e));
        } catch (e) {
          o(e);
        }
      }

      function f(e) {
        e.done ? i(e.value) : new r(function (t) {
          t(e.value);
        }).then(a, s);
      }

      f((n = n.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var r,
        n,
        i,
        o,
        a = {
      label: 0,
      sent: function sent() {
        if (1 & i[0]) throw i[1];
        return i[1];
      },
      trys: [],
      ops: []
    };
    return o = {
      next: s(0),
      throw: s(1),
      return: s(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
      return this;
    }), o;

    function s(o) {
      return function (s) {
        return function (o) {
          if (r) throw new TypeError("Generator is already executing.");

          for (; a;) {
            try {
              if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

              switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                case 0:
                case 1:
                  i = o;
                  break;

                case 4:
                  return a.label++, {
                    value: o[1],
                    done: !1
                  };

                case 5:
                  a.label++, n = o[1], o = [0];
                  continue;

                case 7:
                  o = a.ops.pop(), a.trys.pop();
                  continue;

                default:
                  if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                    a = 0;
                    continue;
                  }

                  if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                    a.label = o[1];
                    break;
                  }

                  if (6 === o[0] && a.label < i[1]) {
                    a.label = i[1], i = o;
                    break;
                  }

                  if (i && a.label < i[2]) {
                    a.label = i[2], a.ops.push(o);
                    break;
                  }

                  i[2] && a.ops.pop(), a.trys.pop();
                  continue;
              }

              o = t.call(e, a);
            } catch (e) {
              o = [6, e], n = 0;
            } finally {
              r = i = 0;
            }
          }

          if (5 & o[0]) throw o[1];
          return {
            value: o[0] ? o[1] : void 0,
            done: !0
          };
        }([o, s]);
      };
    }
  },
      o = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = r(35),
      s = o(r(186));

  function f(e, t) {
    var r = [{
      id: e + "#keys-1",
      type: "Secp256k1VerificationKey2018",
      owner: e,
      publicKeyHex: t.publicKey.match(/^0x/) ? t.publicKey.slice(2) : t.publicKey
    }];
    t.publicEncKey && r.push({
      id: e + "#keys-2",
      type: "Curve25519EncryptionPublicKey",
      owner: e,
      publicKeyBase64: t.publicEncKey
    });
    var n = {
      "@context": "https://w3id.org/did/v1",
      id: e,
      publicKey: r,
      authentication: [{
        type: "Secp256k1SignatureAuthentication2018",
        publicKey: e + "#keys-1"
      }]
    };

    if (t.name || t.description || t.image) {
      var i = Object.assign({}, t);
      delete i.publicKey, delete i.publicEncKey, n.uportProfile = i;
    }

    return n;
  }

  t.convertToDid = f, t.default = function (e) {
    var t = e || s.default(),
        r = function r(e) {
      return new Promise(function (r, n) {
        t(e, function (e, t) {
          return e ? n(e) : r(t);
        });
      });
    };

    a.registerMethod("uport", function (e, t) {
      return n(this, void 0, void 0, function () {
        var n;
        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return [4, r(t.id)];

            case 1:
              return (n = i.sent()) ? "https://w3id.org/did/v1" === n["@context"] ? [2, n] : "string" == typeof n.publicKey ? [2, f(e, n)] : [2, null] : [2, null];
          }
        });
      });
    });
  };
}, function (e, t, r) {
  "use strict";

  var n = r(17)("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"),
      i = r(17)("0123456789abcdef"),
      o = "undefined" != typeof window ? window.XMLHttpRequest : r(187).XMLHttpRequest,
      a = "0x447885f0",
      s = "0x446d5aa4000000000000000000000000";

  function f(e, t) {
    var r = new o(),
        n = e || {};
    r.onreadystatechange = function () {
      if (4 === r.readyState && 1 !== r.timeout) if (200 !== r.status) t(new Error("[uport-lite] status " + r.status + ": " + r.responseText));else try {
        t(null, JSON.parse(r.responseText));
      } catch (e) {
        t(new Error("[uport-lite] while parsing data: '" + String(r.responseText) + "', error: " + String(e)));
      }
    }, n.data ? r.open("POST", e.uri) : r.open("GET", e.uri), n.accept && r.setRequestHeader("accept", n.accept), n.data ? (r.setRequestHeader("Content-Type", "application/json"), r.send(JSON.stringify(n.data))) : r.send();
  }

  function c(e) {
    var t = n.decode(e),
        r = t.length - 24,
        o = t.slice(1, r),
        a = t.slice(r, 20 + r);
    return {
      network: "0x" + i.encode(o),
      address: "0x" + i.encode(a)
    };
  }

  var u = {
    "0x1": {
      registry: "0xab5c8051b9a1df1aab0149f8b0630848b7ecabf6",
      rpcUrl: "https://mainnet.infura.io"
    },
    "0x3": {
      registry: "0x41566e3a081f5032bdcad470adb797635ddfe1f0",
      rpcUrl: "https://ropsten.infura.io"
    },
    "0x2a": {
      registry: "0x5f8e9351dc2d238fb878b6ae43aa740d62fc9758",
      rpcUrl: "https://kovan.infura.io"
    },
    "0x4": {
      registry: "0x2cc31912b2b0f3075a87b3640923d45a26cef3ee",
      rpcUrl: "https://rinkeby.infura.io"
    }
  };

  e.exports = function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.infuraKey || "uport-lite-library",
        r = e.ipfsGw || "https://ipfs.infura.io/ipfs/",
        o = e.networks ? Object.assign({}, u, e.networks) : u;

    function d(e, t, r) {
      return void 0 === t ? e : r ? (e + t).slice(-e.length) : (t + e).substring(0, e.length);
    }

    function h(e, r) {
      return e ? f({
        uri: "https://ropsten.infura.io/" + t,
        accept: "application/json",
        data: {
          method: "eth_call",
          params: [{
            to: "0xb9C1598e24650437a3055F7f66AC1820c419a679",
            data: s + e.slice(2)
          }, "latest"],
          id: 1,
          jsonrpc: "2.0"
        }
      }, function (e, t) {
        if (e) return r(e);
        if (t.error) return r(t.error);
        var o,
            a = t.result.slice(130).slice(0, 68);
        return r(null, (o = a, n.encode(i.decode(o))));
      }) : r(null);
    }

    function l(e, r, s, u) {
      var h = c(r),
          l = c(s);

      if (h.network === l.network) {
        if (o[h.network]) {
          var p = o[h.network].rpcUrl,
              b = o[h.network].registry,
              v = function (e, t, r, n) {
            var i,
                o = e;
            return o += d("0000000000000000000000000000000000000000000000000000000000000000", t.split("").map(function (e) {
              return ("0" + e.charCodeAt(0).toString(16)).slice(-2);
            }).join(i || "")), o += d("0000000000000000000000000000000000000000000000000000000000000000", r.slice(2), !0), o += d("0000000000000000000000000000000000000000000000000000000000000000", n.slice(2), !0);
          }(a, e, h.address, l.address);

          return f({
            uri: p + "/" + t,
            accept: "application/json",
            data: {
              method: "eth_call",
              params: [{
                to: b,
                data: v
              }, "latest"],
              id: 1,
              jsonrpc: "2.0"
            }
          }, function (e, t) {
            return e ? u(e) : t.error ? u(t.error) : 0 == t.result ? u(e) : u(null, (r = t.result, n.encode(i.decode("1220" + r.slice(2)))));
            var r;
          });
        }

        u(new Error("Network id " + h.network + " is not configured"));
      } else u(new Error("Issuer and subject must be on the same network"));
    }

    function p(e, t) {
      return e && "0x" !== e ? f({
        uri: "" + r + e
      }, t) : t();
    }

    return function (e, t, r) {
      var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "uPortProfileIPFS1220";
      if (!e) return t(null);
      var i = r || e;
      return e.match(/0x[0-9a-fA-F]{40}/) ? h(e, function (e, r) {
        if (e) return t(e);
        p(r, t);
      }) : l(n, e, i, function (e, r) {
        if (e) return t(e);
        p(r, t);
      });
    };
  };
}, function (e, t) {}, function (e, t, r) {
  "use strict";

  var n = this && this.__awaiter || function (e, t, r, n) {
    return new (r || (r = Promise))(function (i, o) {
      function a(e) {
        try {
          f(n.next(e));
        } catch (e) {
          o(e);
        }
      }

      function s(e) {
        try {
          f(n.throw(e));
        } catch (e) {
          o(e);
        }
      }

      function f(e) {
        e.done ? i(e.value) : new r(function (t) {
          t(e.value);
        }).then(a, s);
      }

      f((n = n.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var r,
        n,
        i,
        o,
        a = {
      label: 0,
      sent: function sent() {
        if (1 & i[0]) throw i[1];
        return i[1];
      },
      trys: [],
      ops: []
    };
    return o = {
      next: s(0),
      throw: s(1),
      return: s(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
      return this;
    }), o;

    function s(o) {
      return function (s) {
        return function (o) {
          if (r) throw new TypeError("Generator is already executing.");

          for (; a;) {
            try {
              if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

              switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                case 0:
                case 1:
                  i = o;
                  break;

                case 4:
                  return a.label++, {
                    value: o[1],
                    done: !1
                  };

                case 5:
                  a.label++, n = o[1], o = [0];
                  continue;

                case 7:
                  o = a.ops.pop(), a.trys.pop();
                  continue;

                default:
                  if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                    a = 0;
                    continue;
                  }

                  if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                    a.label = o[1];
                    break;
                  }

                  if (6 === o[0] && a.label < i[1]) {
                    a.label = i[1], i = o;
                    break;
                  }

                  if (i && a.label < i[2]) {
                    a.label = i[2], a.ops.push(o);
                    break;
                  }

                  i[2] && a.ops.pop(), a.trys.pop();
                  continue;
              }

              o = t.call(e, a);
            } catch (e) {
              o = [6, e], n = 0;
            } finally {
              r = i = 0;
            }
          }

          if (5 & o[0]) throw o[1];
          return {
            value: o[0] ? o[1] : void 0,
            done: !0
          };
        }([o, s]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = r(35),
      a = "/.well-known/did.json";

  function s(e) {
    return new Promise(function (t, n) {
      var i = new ("undefined" != typeof window ? window.XMLHttpRequest : r(189).XMLHttpRequest)();
      i.open("GET", e), i.onreadystatechange = function () {
        i && 4 === i.readyState && (200 === i.status ? t(i.responseText) : n(new Error(("Invalid http response status " + i.status + " " + i.responseText).trim())));
      }, i.setRequestHeader("accept", "application/json"), i.send();
    });
  }

  t.default = function () {
    o.registerMethod("https", function (e, t) {
      return n(this, void 0, void 0, function () {
        var r, n, o, f;
        return i(this, function (i) {
          switch (i.label) {
            case 0:
              r = "https://" + t.id + a, n = null, i.label = 1;

            case 1:
              return i.trys.push([1, 3,, 4]), [4, s(r)];

            case 2:
              return n = i.sent(), [3, 4];

            case 3:
              throw o = i.sent(), new Error("DID must resolve to a valid https URL: " + o.message);

            case 4:
              f = null;

              try {
                f = JSON.parse(n);
              } catch (e) {
                throw new Error("DID must resolve to a JSON document");
              }

              if ("https://w3id.org/did/v1" !== f["@context"]) throw new Error("DID document missing context");
              if (f.id !== e) throw new Error("DID document id does not match requested did");
              if (!(Array.isArray(f.publicKey) && f.publicKey.length > 0)) throw new Error("DID document has no public keys");
              return [2, f];
          }
        });
      });
    });
  };
}, function (e, t) {}, function (e, t, r) {
  "use strict";

  var n,
      i = c(r(19)),
      o = c(r(20)),
      a = (n = (0, o.default)(i.default.mark(function e(t, r) {
    var n;
    return i.default.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return n = void 0, e.prev = 1, e.next = 4, (0, f.ipfsLookup)(t, r);

          case 4:
            n = e.sent, e.next = 9;
            break;

          case 7:
            e.prev = 7, e.t0 = e.catch(1);

          case 9:
            if (n && n.signingKey) {
              e.next = 11;
              break;
            }

            throw new Error("Invalid muport did");

          case 11:
            return e.abrupt("return", n);

          case 12:
          case "end":
            return e.stop();
        }
      }
    }, e, this, [[1, 7]]);
  })), function (e, t) {
    return n.apply(this, arguments);
  }),
      s = r(35),
      f = r(191);

  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function u(e, t) {
    if (1 !== t.version) throw new Error("Unsupported muportDocument version");
    var r = {
      "@context": "https://w3id.org/did/v1",
      id: e,
      publicKey: [{
        id: e + "#signingKey",
        type: "Secp256k1VerificationKey2018",
        owner: e,
        publicKeyHex: t.signingKey
      }, {
        id: e + "#managementKey",
        type: "Secp256k1VerificationKey2018",
        owner: e
      }, {
        id: e + "#encryptionKey",
        type: "Curve25519EncryptionPublicKey",
        owner: e,
        publicKeyBase64: t.asymEncryptionKey
      }],
      authentication: [{
        type: "Secp256k1SignatureAuthentication2018",
        publicKey: e + "#signingKey"
      }],
      muportData: {}
    };
    return 42 === t.managementKey.length ? r.publicKey[1].ethereumAddress = t.managementKey : r.publicKey[1].publicKeyHex = t.managementKey, t.publicProfile && (r.uportProfile = t.publicProfile), t.symEncryptedData && (r.muportData.symEncryptedData = t.symEncryptedData), t.recoveryNetwork && (r.muportData.recoveryNetwork = t.recoveryNetwork), r;
  }

  e.exports = function () {
    var e,
        t = (e = (0, o.default)(i.default.mark(function e(t, n) {
      var o;
      return i.default.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, a(n.id, r.ipfsConf);

            case 2:
              return o = e.sent, e.abrupt("return", u(t, o));

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (t, r) {
      return e.apply(this, arguments);
    }),
        r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    (0, s.registerMethod)("muport", t);
  };
}, function (e, t, r) {
  "use strict";

  var n,
      i = f(r(60)),
      o = f(r(19)),
      a = f(r(20)),
      s = (n = (0, a.default)(o.default.mark(function e(t, r) {
    var n;
    return o.default.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return n = (r = r || u).protocol + "://" + r.host + "/ipfs/" + t, e.abrupt("return", d(n));

          case 3:
          case "end":
            return e.stop();
        }
      }
    }, e, this);
  })), function (e, t) {
    return n.apply(this, arguments);
  });

  function f(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = "undefined" != typeof window ? window.XMLHttpRequest : r(192).XMLHttpRequest,
      u = {
    host: "ipfs.infura.io",
    port: 5001,
    protocol: "https"
  };

  function d(e, t) {
    var r = new c();
    return new i.default(function (n, i) {
      r.onreadystatechange = function () {
        if (4 === r.readyState && 1 !== r.timeout) if (200 !== r.status) i("[muport-did-resolver] status " + r.status + ": " + r.responseText);else try {
          n(JSON.parse(r.responseText));
        } catch (e) {
          i("[muport-did-resolver] while parsing data: '" + String(r.responseText) + "', error: " + String(e));
        }
      }, t ? (r.open("POST", e), r.setRequestHeader("Content-Type", "application/json")) : r.open("GET", e), r.setRequestHeader("accept", "application/json"), r.send(t);
    });
  }

  e.exports = {
    ipfsLookup: s
  };
}, function (e, t) {}, function (e, t, r) {
  "use strict";

  (function (t) {
    e.exports = {
      address_server_url: t.env.ADDRESS_SERVER_URL || "https://beta.3box.io/address-server",
      pinning_node: t.env.PINNING_NODE || "/dnsaddr/ipfs.3box.io/tcp/443/wss/ipfs/QmZvxEpiVNjmNbEKyQGvFzAY1BwmGuuvdUTmcTstQPhyVC",
      pinning_room: t.env.PINNING_ROOM || "3box-pinning",
      iframe_store_version: t.env.IFRAME_STORE_VERSION || "0.0.3",
      iframe_store_url: t.env.IFRAME_STORE_URL || "https://iframe.3box.io/".concat("0.0.3", "/iframe.html"),
      ipfs_options: {
        EXPERIMENTAL: {
          pubsub: !0
        },
        preload: {
          enabled: !1
        },
        config: {
          Bootstrap: []
        }
      },
      graphql_server_url: t.env.GRAPHQL_SERVER_URL || "https://aic67onptg.execute-api.us-west-2.amazonaws.com/develop/graphql",
      profile_server_url: t.env.PROFILE_SERVER_URL || "https://ipfs.3box.io",
      muport_ipfs_host: t.env.MUPORT_IPFS_HOST || "ipfs.infura.io",
      muport_ipfs_port: t.env.MUPORT_IPFS_PORT || 5001,
      muport_ipfs_protocol: t.env.MUPORT_IPFS_PROTOCOL || "https"
    };
  }).call(this, r(18));
}, function (e, t, r) {
  (function (e) {
    var n = void 0 !== e && e || "undefined" != typeof self && self || window,
        i = Function.prototype.apply;

    function o(e, t) {
      this._id = e, this._clearFn = t;
    }

    t.setTimeout = function () {
      return new o(i.call(setTimeout, n, arguments), clearTimeout);
    }, t.setInterval = function () {
      return new o(i.call(setInterval, n, arguments), clearInterval);
    }, t.clearTimeout = t.clearInterval = function (e) {
      e && e.close();
    }, o.prototype.unref = o.prototype.ref = function () {}, o.prototype.close = function () {
      this._clearFn.call(n, this._id);
    }, t.enroll = function (e, t) {
      clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
    }, t.unenroll = function (e) {
      clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
    }, t._unrefActive = t.active = function (e) {
      clearTimeout(e._idleTimeoutId);
      var t = e._idleTimeout;
      t >= 0 && (e._idleTimeoutId = setTimeout(function () {
        e._onTimeout && e._onTimeout();
      }, t));
    }, r(195), t.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== e && e.setImmediate || this && this.setImmediate, t.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== e && e.clearImmediate || this && this.clearImmediate;
  }).call(this, r(7));
}, function (e, t, r) {
  (function (e, t) {
    !function (e, r) {
      "use strict";

      if (!e.setImmediate) {
        var n,
            i,
            o,
            a,
            s,
            f = 1,
            c = {},
            u = !1,
            d = e.document,
            h = Object.getPrototypeOf && Object.getPrototypeOf(e);
        h = h && h.setTimeout ? h : e, "[object process]" === {}.toString.call(e.process) ? n = function n() {
          var e = l(arguments);
          return t.nextTick(p(b, e)), e;
        } : !function () {
          if (e.postMessage && !e.importScripts) {
            var t = !0,
                r = e.onmessage;
            return e.onmessage = function () {
              t = !1;
            }, e.postMessage("", "*"), e.onmessage = r, t;
          }
        }() ? e.MessageChannel ? ((o = new MessageChannel()).port1.onmessage = function (e) {
          b(e.data);
        }, n = function n() {
          var e = l(arguments);
          return o.port2.postMessage(e), e;
        }) : d && "onreadystatechange" in d.createElement("script") ? (i = d.documentElement, n = function n() {
          var e = l(arguments),
              t = d.createElement("script");
          return t.onreadystatechange = function () {
            b(e), t.onreadystatechange = null, i.removeChild(t), t = null;
          }, i.appendChild(t), e;
        }) : n = function n() {
          var e = l(arguments);
          return setTimeout(p(b, e), 0), e;
        } : (a = "setImmediate$" + Math.random() + "$", s = function s(t) {
          t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(a) && b(+t.data.slice(a.length));
        }, e.addEventListener ? e.addEventListener("message", s, !1) : e.attachEvent("onmessage", s), n = function n() {
          var t = l(arguments);
          return e.postMessage(a + t, "*"), t;
        }), h.setImmediate = n, h.clearImmediate = v;
      }

      function l(e) {
        return c[f] = p.apply(r, e), f++;
      }

      function p(e) {
        var t = [].slice.call(arguments, 1);
        return function () {
          "function" == typeof e ? e.apply(r, t) : new Function("" + e)();
        };
      }

      function b(e) {
        if (u) setTimeout(p(b, e), 0);else {
          var t = c[e];

          if (t) {
            u = !0;

            try {
              t();
            } finally {
              v(e), u = !1;
            }
          }
        }
      }

      function v(e) {
        delete c[e];
      }
    }("undefined" == typeof self ? void 0 === e ? this : e : self);
  }).call(this, r(7), r(18));
}, function (e, t, r) {
  var n = r(197).CopyButton,
      i = r(10).addToClipBoardLinks,
      o = r(53).FontAwesomeIcon,
      a = r(27).faCheck,
      s = r(81);

  e.exports = function (e) {
    e.dom;

    var t = e.React,
        r = e.Fragment,
        f = function f(e, n) {
      var i = e.data,
          o = void 0 === i ? {} : i,
          a = e.opts,
          f = void 0 === a ? {} : a,
          u = e.checkWindowSize,
          d = e.showHover,
          h = e.isMobile,
          l = e.handleShowHover,
          b = e.hasWeb3Mobile,
          v = e.handleCopySuccessful,
          m = e.copySuccessful;
      return t.createElement("div", {
        className: "".concat(s.boxAddressWrap, " ").concat(h ? "" : s.isDesktop),
        onMouseEnter: function onMouseEnter() {
          return u(!h);
        }
      }, f.html ? t.createElement(r, null, f.html, t.createElement(c, {
        data: o,
        opts: f,
        ref: n,
        showHover: d,
        hasWeb3Mobile: b,
        handleCopySuccessful: v,
        copySuccessful: m
      })) : t.createElement(p, {
        data: o,
        opts: f,
        ref: n,
        showHover: d,
        isMobile: h,
        handleShowHover: l,
        handleCopySuccessful: v,
        hasWeb3Mobile: b,
        copySuccessful: m
      }), d && t.createElement("div", {
        className: s.onClickOutsideMobile,
        onClick: function onClick() {
          return l(!0);
        }
      }));
    };

    t && (f = t.forwardRef(f));

    var c = function c(e, r) {
      var n = e.data,
          i = void 0 === n ? {} : n,
          o = e.opts,
          a = void 0 === o ? {} : o,
          f = e.showHover,
          c = e.hasWeb3Mobile,
          d = e.handleCopySuccessful,
          h = e.copySuccessful,
          p = e.loading;
      return t.createElement("div", {
        className: "".concat(s.hoverWrap, " ").concat(s[a.orientation || "right"], " ").concat(f ? s.showHoverMobile : "")
      }, t.createElement("div", {
        className: s.hoverProfile,
        ref: r
      }, p && t.createElement("div", {
        className: s.loadingText
      }, " Loading ... "), i.coverPhoto && t.createElement(l, {
        data: i,
        opts: a
      }), i.imgSrc && t.createElement(b, {
        data: i,
        opts: a
      }), i.name && t.createElement(m, {
        data: i,
        hasWeb3Mobile: c,
        handleCopySuccessful: d,
        copySuccessful: h
      }), i.description && t.createElement(v, {
        data: i
      }), (i.twitter || i.github || i.website) && t.createElement("div", {
        className: s.profileDetails
      }, i.twitter && t.createElement(A, {
        data: i,
        hasWeb3Mobile: c,
        handleCopySuccessful: d,
        copySuccessful: h
      }), i.github && t.createElement(g, {
        data: i,
        hasWeb3Mobile: c,
        handleCopySuccessful: d,
        copySuccessful: h
      }), i.website && t.createElement(y, {
        data: i,
        hasWeb3Mobile: c,
        handleCopySuccessful: d,
        copySuccessful: h
      })), t.createElement(u, {
        data: i,
        hasWeb3Mobile: c,
        handleCopySuccessful: d,
        copySuccessful: h
      })));
    };

    t && (c = t.forwardRef(c));

    var u = function u(e) {
      var r = e.data,
          i = void 0 === r ? {} : r,
          f = e.hasWeb3Mobile,
          c = e.handleCopySuccessful,
          u = e.copySuccessful;
      return t.createElement("div", {
        className: s.boxLink
      }, t.createElement(n, {
        address: i.address
      }), f ? t.createElement(d, {
        data: i,
        handleCopySuccessful: c
      }) : t.createElement(h, {
        data: i
      }), "footer" === u && t.createElement(o, {
        icon: a,
        className: s.profileCheck
      }));
    },
        d = function d(e) {
      var r = e.data,
          n = e.handleCopySuccessful;
      return t.createElement("p", {
        onClick: function onClick() {
          return i("https://3box.io/".concat(r.address), n, "footer");
        },
        className: s.boxLinkText
      }, "View 3Box", t.createElement("img", {
        src: "https://i.imgur.com/bT9PQlL.png",
        className: s.logo
      }));
    },
        h = function h(e) {
      var r = e.data;
      return t.createElement("a", {
        className: s.boxLinkText,
        href: "https://3box.io/".concat(r.address),
        target: "_blank",
        rel: "noopener noreferrer"
      }, "View 3Box", t.createElement("img", {
        src: "https://i.imgur.com/bT9PQlL.png",
        className: s.logo
      }));
    },
        l = function l(e) {
      var n = e.data,
          i = void 0 === n ? {} : n,
          o = e.opts,
          a = void 0 === o ? {} : o;
      return t.createElement(r, null, !a.noCoverImg && !a.noImgs && t.createElement("div", {
        className: s.coverPicture
      }, i.coverPhoto ? t.createElement("img", {
        src: i.coverPhoto,
        className: s.coverPicture_image
      }) : t.createElement("div", {
        className: s.coverPicture_image
      })));
    },
        p = function p(e, r) {
      var n = e.data,
          i = void 0 === n ? {} : n,
          o = e.opts,
          a = void 0 === o ? {} : o,
          f = e.showHover,
          u = e.isMobile,
          d = e.handleShowHover,
          h = e.hasWeb3Mobile,
          l = e.handleCopySuccessful,
          p = e.copySuccessful,
          b = e.loading;
      return t.createElement("div", {
        className: "".concat(s.boxAddress, " ").concat(i.addressDisplay.length >= 15 ? s.boxAddressFull : "", " ").concat(a.tileStyle ? s.tileStyle : "")
      }, t.createElement("div", {
        className: "".concat(s.boxAddressContentWrapper, " ").concat(a.url ? s.boxAddressLink : ""),
        onClick: function onClick() {
          a.url && (window.location = "".concat(a.url));
        }
      }, t.createElement("div", {
        className: s.boxImg
      }, i.imgSrc && t.createElement("img", {
        src: i.imgSrc
      })), t.createElement("div", {
        className: s.boxShortAddress
      }, a.showName && i.name ? i.name : i.addressDisplay)), u && t.createElement("button", {
        className: s.openHover_mobile,
        onClick: function onClick() {
          return d(!0);
        }
      }, t.createElement("div", {
        className: "far fa-clone clone"
      })), t.createElement(c, {
        data: i,
        opts: a,
        ref: r,
        showHover: f,
        hasWeb3Mobile: h,
        handleCopySuccessful: l,
        copySuccessful: p,
        loading: b
      }));
    };

    t && (p = t.forwardRef(p));

    var b = function b(e) {
      var n = e.data,
          i = void 0 === n ? {} : n,
          o = e.opts,
          a = void 0 === o ? {} : o;
      return t.createElement(r, null, !a.noProfileImg && !a.noImgs && t.createElement("div", {
        className: "".concat(s.profileValuePicture, " ").concat(a.noCoverImg || !i.coverPhoto ? s.noMargin : "")
      }, t.createElement("img", {
        className: "".concat(s.profileValuePicture_image),
        src: i.imgSrc,
        height: "32px",
        width: "32px"
      })), a.noProfileImg && !a.noImgs && t.createElement("div", {
        className: s.noProfileImgSpacer
      }));
    },
        v = function v(e) {
      var r = e.data,
          n = void 0 === r ? {} : r;
      return t.createElement("div", {
        className: s.profileDescription
      }, t.createElement("p", {
        className: s.profileDescription_text
      }, n.description));
    },
        m = function m(e) {
      var r = e.data,
          n = void 0 === r ? {} : r,
          f = e.hasWeb3Mobile,
          c = e.handleCopySuccessful,
          u = e.copySuccessful;
      return t.createElement("div", {
        className: "\n      ".concat(s.profileValueName, " \n      ").concat(n.description || n.twitter || n.github || n.website ? "" : s.noContent, "\n      ")
      }, f ? t.createElement("p", {
        onClick: function onClick() {
          return i("https://3box.io/".concat(n.address), c, "threeBoxProfile");
        },
        className: s.profileText
      }, n.name) : t.createElement("a", {
        href: "https://3box.io/".concat(n.address),
        className: s.profileText,
        target: "_blank",
        rel: "noopener noreferrer"
      }, n.name), n.emoji && t.createElement("span", null, n.emoji), "threeBoxProfile" === u && t.createElement(o, {
        icon: a
      }));
    },
        y = function y(e) {
      var r = e.data,
          n = void 0 === r ? {} : r,
          i = e.hasWeb3Mobile,
          f = e.handleCopySuccessful,
          c = e.copySuccessful;
      return t.createElement("div", {
        className: s.profileValue
      }, t.createElement("p", {
        className: s.profileValueKey
      }, "Website"), t.createElement("span", {
        className: s.profileText
      }, i ? t.createElement(w, {
        handleCopySuccessful: f,
        link: n.websiteUrl,
        field: "website",
        handle: n.website
      }) : t.createElement("a", {
        href: n.websiteUrl,
        target: "_blank"
      }, n.website)), "website" === c && t.createElement(o, {
        icon: a
      }));
    },
        g = function g(e) {
      var r = e.data,
          n = void 0 === r ? {} : r,
          i = e.hasWeb3Mobile,
          f = e.handleCopySuccessful,
          c = e.copySuccessful;
      return t.createElement("div", {
        className: s.profileValue
      }, t.createElement("p", {
        className: s.profileValueKey
      }, "Github"), t.createElement("span", {
        className: s.profileText
      }, i ? t.createElement(w, {
        handleCopySuccessful: f,
        link: "https://www.github.com/" + n.github,
        field: "github",
        handle: n.github
      }) : t.createElement("a", {
        href: "https://www.github.com/" + n.github,
        target: "_blank"
      }, n.github)), "github" === c && t.createElement(o, {
        icon: a
      }));
    },
        A = function A(e) {
      var r = e.data,
          n = void 0 === r ? {} : r,
          i = e.hasWeb3Mobile,
          f = e.copySuccessful,
          c = e.handleCopySuccessful;
      return t.createElement("div", {
        className: s.profileValue
      }, t.createElement("p", {
        className: s.profileValueKey
      }, "Twitter"), t.createElement("span", {
        className: s.profileText
      }, i ? t.createElement(w, {
        handleCopySuccessful: c,
        link: "https://www.twitter.com/".concat(n.twitter),
        field: "twitter",
        handle: "@".concat(n.twitter)
      }) : t.createElement("a", {
        href: "https://www.twitter.com/" + n.twitter,
        target: "_blank"
      }, "@".concat(n.twitter))), "twitter" === f && t.createElement(o, {
        icon: a
      }));
    },
        w = function w(e) {
      var r = e.handleCopySuccessful,
          n = e.link,
          o = e.field,
          a = e.handle;
      return t.createElement("p", {
        onClick: function onClick() {
          return i(n, r, o);
        }
      }, a);
    },
        _ = function _(e, n) {
      var i = e.data,
          o = void 0 === i ? {} : i,
          a = e.opts,
          f = void 0 === a ? {} : a,
          u = e.showHover,
          d = e.isMobile,
          h = e.checkWindowSize;
      return t.createElement("div", {
        className: "".concat(s.boxAddressWrap, " ").concat(d ? "" : s.isDesktop),
        onMouseEnter: function onMouseEnter() {
          return h(!d);
        }
      }, f.html ? t.createElement(r, null, t.createElement("div", {
        id: "orginal_html_f1kx"
      }, f.html), t.createElement(c, {
        data: o,
        opts: f,
        showHover: u,
        loading: !0,
        ref: n
      })) : t.createElement(p, {
        data: o,
        opts: f,
        isMobile: d,
        loading: !0,
        ref: n
      }));
    };

    return t && (_ = t.forwardRef(_)), {
      BaseTemplate: f,
      LoadingTemplate: _
    };
  };
}, function (e, t, r) {
  "use strict";

  r.r(t), r.d(t, "CopyButton", function () {
    return g;
  });

  var n = r(36),
      i = r.n(n),
      o = r(37),
      a = r.n(o),
      s = r(38),
      f = r.n(s),
      c = r(39),
      u = r.n(c),
      d = r(40),
      h = r.n(d),
      l = r(1),
      p = r.n(l),
      b = r(53),
      v = r(27),
      m = r(10),
      y = r(81),
      g = function (e) {
    function t(e) {
      var r;
      return i()(this, t), (r = f()(this, u()(t).call(this, e))).state = {
        showCheck: !1
      }, r;
    }

    return h()(t, e), a()(t, [{
      key: "_onClick",
      value: function value() {
        var e = this;
        Object(m.addToClipboard)(this.props.address), this.setState({
          showCheck: !0
        }), setTimeout(function () {
          e.setState({
            showCheck: !1
          });
        }, 2e3);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
            t = this.state.showCheck ? v.faCheck : null;
        return p.a.createElement("div", {
          className: y.addressAndCheck
        }, p.a.createElement("div", {
          className: y.addressWrapper,
          onClick: function onClick() {
            return e._onClick();
          }
        }, p.a.createElement("img", {
          src: "https://i.imgur.com/zs8M8dg.png",
          alt: "Wallet"
        }), p.a.createElement("p", {
          className: y.address
        }, "".concat(this.props.address.substr(0, 5), "...").concat(this.props.address.substr(-5)))), t && p.a.createElement(b.FontAwesomeIcon, {
          icon: t
        }));
      }
    }]), t;
  }(p.a.Component);
}, function (e, t, r) {
  "use strict";

  var n = r(199);

  function i() {}

  e.exports = function () {
    function e(e, t, r, i, o, a) {
      if (a !== n) {
        var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw s.name = "Invariant Violation", s;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var r = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t
    };
    return r.checkPropTypes = i, r.PropTypes = r, r;
  };
}, function (e, t, r) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, t, r) {
  (t = e.exports = r(201)(!0)).push([e.i, ".threeboxProfileHover__style_boxAddress {\n  background: transparent;\n  height: fit-content;\n  padding: 0px;\n  font-family: Arial, sans-serif;\n  position: relative;\n  display: block;\n  width: fit-content;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.threeboxProfileHover__style_boxAddress.threeboxProfileHover__style_tileStyle {\n  border: 1px solid #edf2fb;\n  background: white;\n  border-radius: 5px;\n}\n.threeboxProfileHover__style_boxAddressContentWrapper {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n.threeboxProfileHover__style_boxAddressContentWrapper.threeboxProfileHover__style_boxAddressLink {\n  cursor: pointer;\n}\n.threeboxProfileHover__style_tileStyle .threeboxProfileHover__style_boxAddressContentWrapper {\n  max-width: calc(200px + 50px + 40px);\n  min-width: calc(92px + 50px + 40px);\n}\n.threeboxProfileHover__style_boxAddressContentWrapper {\n  max-width: calc(200px + 50px + 40px);\n}\n.threeboxProfileHover__style_boxAddressFull {\n  width: fit-content;\n}\n.threeboxProfileHover__style_boxAddressWrap {\n  display: block;\n  float: left;\n  position: relative;\n  font-family: Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  background-clip: padding-box;\n}\n.threeboxProfileHover__style_boxAddress .threeboxProfileHover__style_boxImg {\n  background: #074988;\n  height: 50px;\n  width: 50px;\n  border-radius: 50%;\n  overflow: hidden;\n}\n.threeboxProfileHover__style_boxAddress.threeboxProfileHover__style_tileStyle .threeboxProfileHover__style_boxImg {\n  border-radius: 5px 0px 0px 5px;\n}\n.threeboxProfileHover__style_boxAddress .threeboxProfileHover__style_boxImg img {\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  background-color: white;\n}\n.threeboxProfileHover__style_boxShortAddress {\n  color: #636668;\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: 0.015em;\n  display: block;\n  padding: 0 16px;\n  max-width: 200px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.threeboxProfileHover__style_tileStyle .threeboxProfileHover__style_boxShortAddress {\n  min-width: 100px;\n}\n.threeboxProfileHover__style_openHover_mobile {\n  width: fit-content;\n  height: fit-content;\n  color: #b7bece;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n}\n.threeboxProfileHover__style_tileStyle .threeboxProfileHover__style_openHover_mobile {\n  background-color: #f9f9f9;\n  border-left: 1px solid #edf2fb;\n  border-radius: 0 5px 5px 0;\n  width: 50px;\n  height: 50px;\n}\n.threeboxProfileHover__style_openHover_mobile svg {\n  height: 14px !important;\n  width: 14px !important;\n}\n.threeboxProfileHover__style_addressCopy {\n  position: relative;\n  color: #b7bece;\n  border-left: 1px solid #edf2fb;\n  padding: 9px 4px 4px 9px;\n  width: 16px;\n  font-size: 12px;\n  height: 20px;\n  display: inline-block;\n}\n.threeboxProfileHover__style_addressCopy:hover {\n  cursor: pointer;\n  color: #7c8aa7;\n}\n.threeboxProfileHover__style_addressCopy:active {\n  background-color: #f7f7fb;\n}\n.threeboxProfileHover__style_addressAndCheck svg {\n  margin-left: 6px;\n}\n.threeboxProfileHover__style_boxAddressWrap .threeboxProfileHover__style_hoverWrap {\n  height: fit-content;\n  width: fit-content;\n  position: absolute;\n  z-index: 2;\n}\n.threeboxProfileHover__style_boxAddressWrap .threeboxProfileHover__style_hoverWrap.threeboxProfileHover__style_top {\n  padding-bottom: 20px;\n  bottom: 90%;\n  left: -10px;\n}\n.threeboxProfileHover__style_boxAddressWrap .threeboxProfileHover__style_hoverWrap.threeboxProfileHover__style_bottom {\n  padding-top: 20px;\n  top: 90%;\n  left: -10px;\n}\n.threeboxProfileHover__style_boxAddressWrap .threeboxProfileHover__style_hoverWrap.threeboxProfileHover__style_right {\n  padding-left: 20px;\n  top: calc(50% - 33px);\n  left: calc(100% + -5px);\n}\n.threeboxProfileHover__style_boxAddressWrap .threeboxProfileHover__style_hoverWrap.threeboxProfileHover__style_left {\n  padding-right: 20px;\n  top: calc(50% - 33px);\n  right: calc(100% + -5px);\n}\n.threeboxProfileHover__style_boxAddressWrap .threeboxProfileHover__style_hoverProfile {\n  border-radius: 10px;\n  border: 1px solid #edf2fb;\n  box-shadow: 0 3px 8px 0 rgba(87, 87, 87, 0.15);\n  background: white;\n  color: #181F21;\n  width: 230px;\n  z-index: 1111;\n  display: none;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding: 20px 20px 20px 20px;\n  position: relative;\n}\n.threeboxProfileHover__style_boxAddressWrap.threeboxProfileHover__style_isDesktop:hover .threeboxProfileHover__style_hoverWrap .threeboxProfileHover__style_hoverProfile {\n  display: flex;\n}\n.threeboxProfileHover__style_boxAddressWrap .threeboxProfileHover__style_hoverWrap.threeboxProfileHover__style_showHoverMobile .threeboxProfileHover__style_hoverProfile {\n  display: flex;\n  box-sizing: border-box;\n  min-width: 270px;\n}\n.threeboxProfileHover__style_hoverProfileEmpty {\n  padding: 20px;\n}\n.threeboxProfileHover__style_hoverProfile p {\n  letter-spacing: 0.4px;\n}\n.threeboxProfileHover__style_hoverProfile textarea {\n  font-size: 18px;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_coverPicture {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 70px;\n  z-index: 1;\n  margin-left: -20px;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_coverPicture_image {\n  min-width: 100%;\n  min-height: 70px;\n  max-width: 100%;\n  max-height: 70px;\n  object-fit: cover;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  background-color: #f5f5f5;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_profileValue {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  height: 18px;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_profileValue a {\n  text-decoration: none;\n  color: #487dec;\n  font-size: 14px;\n  width: 80%;\n  white-space: nowrap;\n}\n.threeboxProfileHover__style_hoverProfile p {\n  margin: 0;\n  color: #ababab;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_profileValuePicture {\n  z-index: 2;\n  margin-top: 10px;\n  display: flex;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_profileValuePicture .threeboxProfileHover__style_profileValuePicture_image {\n  background: white;\n  height: 60px;\n  width: 60px;\n  border-radius: 50%;\n  object-fit: cover;\n  margin-bottom: 14px;\n  border: 3px solid white;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_noProfileImgSpacer {\n  margin-top: 65px;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_profileDescription .threeboxProfileHover__style_profileDescription_text {\n  font-size: 14px;\n  margin-top: 4px;\n  color: #949494;\n  line-height: 18px;\n  text-align: left;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_profileValue .threeboxProfileHover__style_profileText {\n  padding-left: 6px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  color: #487dec;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_profileValue svg {\n  margin-left: 8px;\n  color: #487dec;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_profileValueName {\n  letter-spacing: 1px;\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_profileValueName.threeboxProfileHover__style_noContent {\n  margin-bottom: 20px;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_profileValueName span {\n  margin-left: 5px;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_profileValueName svg {\n  margin-left: 8px;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_profileValueName .threeboxProfileHover__style_profileText {\n  text-decoration: none;\n  color: #181F21;\n  font-weight: 600;\n  font-size: 20px;\n  text-align: left;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_profileText p {\n  color: #487dec !important;\n  font-size: 14px !important;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_profileValueName .threeboxProfileHover__style_profileText:hover {\n  text-decoration: underline;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_profileValueName .threeboxProfileHover__style_profileText:visited {\n  color: #181F21;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_boxLink {\n  font-size: 12px;\n  border-radius: 0px 0px 3px 3px;\n  color: #ababab;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  position: relative;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_boxLink .threeboxProfileHover__style_boxLinkText {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  transition: 0.3s all ease-in-out;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_boxLink .threeboxProfileHover__style_boxLinkText:hover {\n  color: #1168df !important;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_boxLink .threeboxProfileHover__style_boxLinkText:hover .threeboxProfileHover__style_logo {\n  opacity: 1 !important;\n  filter: saturate(100%);\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_boxLink .threeboxProfileHover__style_boxLinkText img {\n  margin-left: 12px;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_boxLink .threeboxProfileHover__style_profileCheck {\n  position: absolute;\n  right: -16px;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_logo {\n  opacity: 0.1 !important;\n  height: 18px;\n  width: 18px;\n  filter: saturate(0%);\n  transition: 0.3s all ease-in-out;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_boxLink a {\n  color: #ababab !important;\n  font-weight: 300 !important;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_BoxLinkText {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_boxLinkEmpty {\n  font-size: 12px;\n  text-align: center;\n  border-radius: 0px 0px 3px 3px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_boxLink a {\n  text-decoration: none;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_boxLink svg {\n  color: #487dec;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_boxLinkEmpty_text {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_boxLinkEmpty a {\n  text-decoration: none;\n  color: #487dec;\n  font-weight: 600;\n  margin-right: 5px;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_boxLinkEmpty span {\n  color: #ababab;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_boxLinkEmpty svg {\n  color: #487dec;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_profileDetails {\n  margin: 24px 0;\n  width: 100%;\n  overflow: hidden;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_profileValueKey {\n  font-size: 12px;\n  width: 20%;\n  text-align: left;\n}\n.threeboxProfileHover__style_hoverProfile:after {\n  content: '';\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  border-bottom: 1px solid #edf2fb;\n  border-right: 1px solid #edf2fb;\n  background: white;\n  z-index: 0;\n}\n.threeboxProfileHover__style_hoverWrap.threeboxProfileHover__style_bottom .threeboxProfileHover__style_hoverProfile:after {\n  top: -6px;\n  left: 14%;\n  margin-left: -10px;\n  -moz-transform: rotate(225deg);\n  -webkit-transform: rotate(225deg);\n  transform: rotate(225deg);\n}\n.threeboxProfileHover__style_hoverWrap.threeboxProfileHover__style_top .threeboxProfileHover__style_hoverProfile:after {\n  bottom: -6px;\n  left: 14%;\n  margin-left: -10px;\n  -moz-transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n.threeboxProfileHover__style_hoverWrap.threeboxProfileHover__style_right .threeboxProfileHover__style_hoverProfile:after {\n  top: 37px;\n  left: -6px;\n  margin-top: -10px;\n  -moz-transform: rotate(135deg);\n  -webkit-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n.threeboxProfileHover__style_hoverWrap.threeboxProfileHover__style_left .threeboxProfileHover__style_hoverProfile:after {\n  top: 37px;\n  right: -6px;\n  margin-top: -10px;\n  -moz-transform: rotate(315deg);\n  -webkit-transform: rotate(315deg);\n  transform: rotate(315deg);\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_addressAndCheck {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: fit-content;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_addressWrapper {\n  background-color: #f9f9f9;\n  padding: 4px 6px;\n  border-radius: 3px;\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_addressWrapper img {\n  width: 13px;\n  height: 13px;\n  opacity: 0.3;\n  margin-right: 6px;\n}\n.threeboxProfileHover__style_hoverProfile .threeboxProfileHover__style_address {\n  font-size: 12px;\n  color: #ababab;\n}\n.threeboxProfileHover__style_loadingText {\n  text-align: center;\n  padding: 2px;\n  font-size: 13px;\n}\n.threeboxProfileHover__style_noMargin {\n  margin: 0 !important;\n}\n.threeboxProfileHover__style_onClickOutsideMobile {\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n", "", {
    version: 3,
    sources: ["/Users/zachferland/profile-hover/src/style.less"],
    names: [],
    mappings: "AAAA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,mCAAmC;EACnC,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,WAAW;EACX,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,wBAAwB;EACxB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,QAAQ;EACR,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,cAAc;AAChB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,+BAA+B;EAC/B,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,8BAA8B;EAC9B,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,8BAA8B;EAC9B,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ",
    file: "style.less",
    sourcesContent: [".boxAddress {\n  background: transparent;\n  height: fit-content;\n  padding: 0px;\n  font-family: Arial, sans-serif;\n  position: relative;\n  display: block;\n  width: fit-content;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.boxAddress.tileStyle {\n  border: 1px solid #edf2fb;\n  background: white;\n  border-radius: 5px;\n}\n.boxAddressContentWrapper {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n.boxAddressContentWrapper.boxAddressLink {\n  cursor: pointer;\n}\n.tileStyle .boxAddressContentWrapper {\n  max-width: calc(200px + 50px + 40px);\n  min-width: calc(92px + 50px + 40px);\n}\n.boxAddressContentWrapper {\n  max-width: calc(200px + 50px + 40px);\n}\n.boxAddressFull {\n  width: fit-content;\n}\n.boxAddressWrap {\n  display: block;\n  float: left;\n  position: relative;\n  font-family: Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  background-clip: padding-box;\n}\n.boxAddress .boxImg {\n  background: #074988;\n  height: 50px;\n  width: 50px;\n  border-radius: 50%;\n  overflow: hidden;\n}\n.boxAddress.tileStyle .boxImg {\n  border-radius: 5px 0px 0px 5px;\n}\n.boxAddress .boxImg img {\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  background-color: white;\n}\n.boxShortAddress {\n  color: #636668;\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: 0.015em;\n  display: block;\n  padding: 0 16px;\n  max-width: 200px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.tileStyle .boxShortAddress {\n  min-width: 100px;\n}\n.openHover_mobile {\n  width: fit-content;\n  height: fit-content;\n  color: #b7bece;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n}\n.tileStyle .openHover_mobile {\n  background-color: #f9f9f9;\n  border-left: 1px solid #edf2fb;\n  border-radius: 0 5px 5px 0;\n  width: 50px;\n  height: 50px;\n}\n.openHover_mobile svg {\n  height: 14px !important;\n  width: 14px !important;\n}\n.addressCopy {\n  position: relative;\n  color: #b7bece;\n  border-left: 1px solid #edf2fb;\n  padding: 9px 4px 4px 9px;\n  width: 16px;\n  font-size: 12px;\n  height: 20px;\n  display: inline-block;\n}\n.addressCopy:hover {\n  cursor: pointer;\n  color: #7c8aa7;\n}\n.addressCopy:active {\n  background-color: #f7f7fb;\n}\n.addressAndCheck svg {\n  margin-left: 6px;\n}\n.boxAddressWrap .hoverWrap {\n  height: fit-content;\n  width: fit-content;\n  position: absolute;\n  z-index: 2;\n}\n.boxAddressWrap .hoverWrap.top {\n  padding-bottom: 20px;\n  bottom: 90%;\n  left: -10px;\n}\n.boxAddressWrap .hoverWrap.bottom {\n  padding-top: 20px;\n  top: 90%;\n  left: -10px;\n}\n.boxAddressWrap .hoverWrap.right {\n  padding-left: 20px;\n  top: calc(50% - 33px);\n  left: calc(100% + -5px);\n}\n.boxAddressWrap .hoverWrap.left {\n  padding-right: 20px;\n  top: calc(50% - 33px);\n  right: calc(100% + -5px);\n}\n.boxAddressWrap .hoverProfile {\n  border-radius: 10px;\n  border: 1px solid #edf2fb;\n  box-shadow: 0 3px 8px 0 rgba(87, 87, 87, 0.15);\n  background: white;\n  color: #181F21;\n  width: 230px;\n  z-index: 1111;\n  display: none;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding: 20px 20px 20px 20px;\n  position: relative;\n}\n.boxAddressWrap.isDesktop:hover .hoverWrap .hoverProfile {\n  display: flex;\n}\n.boxAddressWrap .hoverWrap.showHoverMobile .hoverProfile {\n  display: flex;\n  box-sizing: border-box;\n  min-width: 270px;\n}\n.hoverProfileEmpty {\n  padding: 20px;\n}\n.hoverProfile p {\n  letter-spacing: 0.4px;\n}\n.hoverProfile textarea {\n  font-size: 18px;\n}\n.hoverProfile .coverPicture {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 70px;\n  z-index: 1;\n  margin-left: -20px;\n}\n.hoverProfile .coverPicture_image {\n  min-width: 100%;\n  min-height: 70px;\n  max-width: 100%;\n  max-height: 70px;\n  object-fit: cover;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  background-color: #f5f5f5;\n}\n.hoverProfile .profileValue {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  height: 18px;\n}\n.hoverProfile .profileValue a {\n  text-decoration: none;\n  color: #487dec;\n  font-size: 14px;\n  width: 80%;\n  white-space: nowrap;\n}\n.hoverProfile p {\n  margin: 0;\n  color: #ababab;\n}\n.hoverProfile .profileValuePicture {\n  z-index: 2;\n  margin-top: 10px;\n  display: flex;\n}\n.hoverProfile .profileValuePicture .profileValuePicture_image {\n  background: white;\n  height: 60px;\n  width: 60px;\n  border-radius: 50%;\n  object-fit: cover;\n  margin-bottom: 14px;\n  border: 3px solid white;\n}\n.hoverProfile .noProfileImgSpacer {\n  margin-top: 65px;\n}\n.hoverProfile .profileDescription .profileDescription_text {\n  font-size: 14px;\n  margin-top: 4px;\n  color: #949494;\n  line-height: 18px;\n  text-align: left;\n}\n.hoverProfile .profileValue .profileText {\n  padding-left: 6px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  color: #487dec;\n}\n.hoverProfile .profileValue svg {\n  margin-left: 8px;\n  color: #487dec;\n}\n.hoverProfile .profileValueName {\n  letter-spacing: 1px;\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.hoverProfile .profileValueName.noContent {\n  margin-bottom: 20px;\n}\n.hoverProfile .profileValueName span {\n  margin-left: 5px;\n}\n.hoverProfile .profileValueName svg {\n  margin-left: 8px;\n}\n.hoverProfile .profileValueName .profileText {\n  text-decoration: none;\n  color: #181F21;\n  font-weight: 600;\n  font-size: 20px;\n  text-align: left;\n}\n.hoverProfile .profileText p {\n  color: #487dec !important;\n  font-size: 14px !important;\n}\n.hoverProfile .profileValueName .profileText:hover {\n  text-decoration: underline;\n}\n.hoverProfile .profileValueName .profileText:visited {\n  color: #181F21;\n}\n.hoverProfile .boxLink {\n  font-size: 12px;\n  border-radius: 0px 0px 3px 3px;\n  color: #ababab;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  position: relative;\n}\n.hoverProfile .boxLink .boxLinkText {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  transition: 0.3s all ease-in-out;\n}\n.hoverProfile .boxLink .boxLinkText:hover {\n  color: #1168df !important;\n}\n.hoverProfile .boxLink .boxLinkText:hover .logo {\n  opacity: 1 !important;\n  filter: saturate(100%);\n}\n.hoverProfile .boxLink .boxLinkText img {\n  margin-left: 12px;\n}\n.hoverProfile .boxLink .profileCheck {\n  position: absolute;\n  right: -16px;\n}\n.hoverProfile .logo {\n  opacity: 0.1 !important;\n  height: 18px;\n  width: 18px;\n  filter: saturate(0%);\n  transition: 0.3s all ease-in-out;\n}\n.hoverProfile .boxLink a {\n  color: #ababab !important;\n  font-weight: 300 !important;\n}\n.hoverProfile .BoxLinkText {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.hoverProfile .boxLinkEmpty {\n  font-size: 12px;\n  text-align: center;\n  border-radius: 0px 0px 3px 3px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.hoverProfile .boxLink a {\n  text-decoration: none;\n}\n.hoverProfile .boxLink svg {\n  color: #487dec;\n}\n.hoverProfile .boxLinkEmpty_text {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.hoverProfile .boxLinkEmpty a {\n  text-decoration: none;\n  color: #487dec;\n  font-weight: 600;\n  margin-right: 5px;\n}\n.hoverProfile .boxLinkEmpty span {\n  color: #ababab;\n}\n.hoverProfile .boxLinkEmpty svg {\n  color: #487dec;\n}\n.hoverProfile .profileDetails {\n  margin: 24px 0;\n  width: 100%;\n  overflow: hidden;\n}\n.hoverProfile .profileValueKey {\n  font-size: 12px;\n  width: 20%;\n  text-align: left;\n}\n.hoverProfile:after {\n  content: '';\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  border-bottom: 1px solid #edf2fb;\n  border-right: 1px solid #edf2fb;\n  background: white;\n  z-index: 0;\n}\n.hoverWrap.bottom .hoverProfile:after {\n  top: -6px;\n  left: 14%;\n  margin-left: -10px;\n  -moz-transform: rotate(225deg);\n  -webkit-transform: rotate(225deg);\n  transform: rotate(225deg);\n}\n.hoverWrap.top .hoverProfile:after {\n  bottom: -6px;\n  left: 14%;\n  margin-left: -10px;\n  -moz-transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n.hoverWrap.right .hoverProfile:after {\n  top: 37px;\n  left: -6px;\n  margin-top: -10px;\n  -moz-transform: rotate(135deg);\n  -webkit-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n.hoverWrap.left .hoverProfile:after {\n  top: 37px;\n  right: -6px;\n  margin-top: -10px;\n  -moz-transform: rotate(315deg);\n  -webkit-transform: rotate(315deg);\n  transform: rotate(315deg);\n}\n.hoverProfile .addressAndCheck {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: fit-content;\n}\n.hoverProfile .addressWrapper {\n  background-color: #f9f9f9;\n  padding: 4px 6px;\n  border-radius: 3px;\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.hoverProfile .addressWrapper img {\n  width: 13px;\n  height: 13px;\n  opacity: 0.3;\n  margin-right: 6px;\n}\n.hoverProfile .address {\n  font-size: 12px;\n  color: #ababab;\n}\n.loadingText {\n  text-align: center;\n  padding: 2px;\n  font-size: 13px;\n}\n.noMargin {\n  margin: 0 !important;\n}\n.onClickOutsideMobile {\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n"],
    sourceRoot: ""
  }]), t.locals = {
    boxAddress: "threeboxProfileHover__style_boxAddress",
    tileStyle: "threeboxProfileHover__style_tileStyle",
    boxAddressContentWrapper: "threeboxProfileHover__style_boxAddressContentWrapper",
    boxAddressLink: "threeboxProfileHover__style_boxAddressLink",
    boxAddressFull: "threeboxProfileHover__style_boxAddressFull",
    boxAddressWrap: "threeboxProfileHover__style_boxAddressWrap",
    boxImg: "threeboxProfileHover__style_boxImg",
    boxShortAddress: "threeboxProfileHover__style_boxShortAddress",
    openHover_mobile: "threeboxProfileHover__style_openHover_mobile",
    addressCopy: "threeboxProfileHover__style_addressCopy",
    addressAndCheck: "threeboxProfileHover__style_addressAndCheck",
    hoverWrap: "threeboxProfileHover__style_hoverWrap",
    top: "threeboxProfileHover__style_top",
    bottom: "threeboxProfileHover__style_bottom",
    right: "threeboxProfileHover__style_right",
    left: "threeboxProfileHover__style_left",
    hoverProfile: "threeboxProfileHover__style_hoverProfile",
    isDesktop: "threeboxProfileHover__style_isDesktop",
    showHoverMobile: "threeboxProfileHover__style_showHoverMobile",
    hoverProfileEmpty: "threeboxProfileHover__style_hoverProfileEmpty",
    coverPicture: "threeboxProfileHover__style_coverPicture",
    coverPicture_image: "threeboxProfileHover__style_coverPicture_image",
    profileValue: "threeboxProfileHover__style_profileValue",
    profileValuePicture: "threeboxProfileHover__style_profileValuePicture",
    profileValuePicture_image: "threeboxProfileHover__style_profileValuePicture_image",
    noProfileImgSpacer: "threeboxProfileHover__style_noProfileImgSpacer",
    profileDescription: "threeboxProfileHover__style_profileDescription",
    profileDescription_text: "threeboxProfileHover__style_profileDescription_text",
    profileText: "threeboxProfileHover__style_profileText",
    profileValueName: "threeboxProfileHover__style_profileValueName",
    noContent: "threeboxProfileHover__style_noContent",
    boxLink: "threeboxProfileHover__style_boxLink",
    boxLinkText: "threeboxProfileHover__style_boxLinkText",
    logo: "threeboxProfileHover__style_logo",
    profileCheck: "threeboxProfileHover__style_profileCheck",
    BoxLinkText: "threeboxProfileHover__style_BoxLinkText",
    boxLinkEmpty: "threeboxProfileHover__style_boxLinkEmpty",
    boxLinkEmpty_text: "threeboxProfileHover__style_boxLinkEmpty_text",
    profileDetails: "threeboxProfileHover__style_profileDetails",
    profileValueKey: "threeboxProfileHover__style_profileValueKey",
    addressWrapper: "threeboxProfileHover__style_addressWrapper",
    address: "threeboxProfileHover__style_address",
    loadingText: "threeboxProfileHover__style_loadingText",
    noMargin: "threeboxProfileHover__style_noMargin",
    onClickOutsideMobile: "threeboxProfileHover__style_onClickOutsideMobile"
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    var t = [];
    return t.toString = function () {
      return this.map(function (t) {
        var r = function (e, t) {
          var r = e[1] || "",
              n = e[3];
          if (!n) return r;

          if (t && "function" == typeof btoa) {
            var i = (a = n, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(a)))) + " */"),
                o = n.sources.map(function (e) {
              return "/*# sourceURL=" + n.sourceRoot + e + " */";
            });
            return [r].concat(o).concat([i]).join("\n");
          }

          var a;
          return [r].join("\n");
        }(t, e);

        return t[2] ? "@media " + t[2] + "{" + r + "}" : r;
      }).join("");
    }, t.i = function (e, r) {
      "string" == typeof e && (e = [[null, e, ""]]);

      for (var n = {}, i = 0; i < this.length; i++) {
        var o = this[i][0];
        null != o && (n[o] = !0);
      }

      for (i = 0; i < e.length; i++) {
        var a = e[i];
        null != a[0] && n[a[0]] || (r && !a[2] ? a[2] = r : r && (a[2] = "(" + a[2] + ") and (" + r + ")"), t.push(a));
      }
    }, t;
  };
}, function (e, t, r) {
  var n,
      i,
      o = {},
      a = (n = function n() {
    return window && document && document.all && !window.atob;
  }, function () {
    return void 0 === i && (i = n.apply(this, arguments)), i;
  }),
      s = function (e) {
    var t = {};
    return function (e, r) {
      if ("function" == typeof e) return e();

      if (void 0 === t[e]) {
        var n = function (e, t) {
          return t ? t.querySelector(e) : document.querySelector(e);
        }.call(this, e, r);

        if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
          n = n.contentDocument.head;
        } catch (e) {
          n = null;
        }
        t[e] = n;
      }

      return t[e];
    };
  }(),
      f = null,
      c = 0,
      u = [],
      d = r(203);

  function h(e, t) {
    for (var r = 0; r < e.length; r++) {
      var n = e[r],
          i = o[n.id];

      if (i) {
        i.refs++;

        for (var a = 0; a < i.parts.length; a++) {
          i.parts[a](n.parts[a]);
        }

        for (; a < n.parts.length; a++) {
          i.parts.push(y(n.parts[a], t));
        }
      } else {
        var s = [];

        for (a = 0; a < n.parts.length; a++) {
          s.push(y(n.parts[a], t));
        }

        o[n.id] = {
          id: n.id,
          refs: 1,
          parts: s
        };
      }
    }
  }

  function l(e, t) {
    for (var r = [], n = {}, i = 0; i < e.length; i++) {
      var o = e[i],
          a = t.base ? o[0] + t.base : o[0],
          s = {
        css: o[1],
        media: o[2],
        sourceMap: o[3]
      };
      n[a] ? n[a].parts.push(s) : r.push(n[a] = {
        id: a,
        parts: [s]
      });
    }

    return r;
  }

  function p(e, t) {
    var r = s(e.insertInto);
    if (!r) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
    var n = u[u.length - 1];
    if ("top" === e.insertAt) n ? n.nextSibling ? r.insertBefore(t, n.nextSibling) : r.appendChild(t) : r.insertBefore(t, r.firstChild), u.push(t);else if ("bottom" === e.insertAt) r.appendChild(t);else {
      if ("object" != typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
      var i = s(e.insertAt.before, r);
      r.insertBefore(t, i);
    }
  }

  function b(e) {
    if (null === e.parentNode) return !1;
    e.parentNode.removeChild(e);
    var t = u.indexOf(e);
    t >= 0 && u.splice(t, 1);
  }

  function v(e) {
    var t = document.createElement("style");

    if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
      var n = function () {
        0;
        return r.nc;
      }();

      n && (e.attrs.nonce = n);
    }

    return m(t, e.attrs), p(e, t), t;
  }

  function m(e, t) {
    Object.keys(t).forEach(function (r) {
      e.setAttribute(r, t[r]);
    });
  }

  function y(e, t) {
    var r, n, i, o;

    if (t.transform && e.css) {
      if (!(o = "function" == typeof t.transform ? t.transform(e.css) : t.transform.default(e.css))) return function () {};
      e.css = o;
    }

    if (t.singleton) {
      var a = c++;
      r = f || (f = v(t)), n = w.bind(null, r, a, !1), i = w.bind(null, r, a, !0);
    } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (r = function (e) {
      var t = document.createElement("link");
      return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", m(t, e.attrs), p(e, t), t;
    }(t), n = function (e, t, r) {
      var n = r.css,
          i = r.sourceMap,
          o = void 0 === t.convertToAbsoluteUrls && i;
      (t.convertToAbsoluteUrls || o) && (n = d(n));
      i && (n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(i)))) + " */");
      var a = new Blob([n], {
        type: "text/css"
      }),
          s = e.href;
      e.href = URL.createObjectURL(a), s && URL.revokeObjectURL(s);
    }.bind(null, r, t), i = function i() {
      b(r), r.href && URL.revokeObjectURL(r.href);
    }) : (r = v(t), n = function (e, t) {
      var r = t.css,
          n = t.media;
      n && e.setAttribute("media", n);
      if (e.styleSheet) e.styleSheet.cssText = r;else {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }

        e.appendChild(document.createTextNode(r));
      }
    }.bind(null, r), i = function i() {
      b(r);
    });

    return n(e), function (t) {
      if (t) {
        if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
        n(e = t);
      } else i();
    };
  }

  e.exports = function (e, t) {
    if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
    (t = t || {}).attrs = "object" == typeof t.attrs ? t.attrs : {}, t.singleton || "boolean" == typeof t.singleton || (t.singleton = a()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
    var r = l(e, t);
    return h(r, t), function (e) {
      for (var n = [], i = 0; i < r.length; i++) {
        var a = r[i];
        (s = o[a.id]).refs--, n.push(s);
      }

      e && h(l(e, t), t);

      for (i = 0; i < n.length; i++) {
        var s;

        if (0 === (s = n[i]).refs) {
          for (var f = 0; f < s.parts.length; f++) {
            s.parts[f]();
          }

          delete o[s.id];
        }
      }
    };
  };

  var g,
      A = (g = [], function (e, t) {
    return g[e] = t, g.filter(Boolean).join("\n");
  });

  function w(e, t, r, n) {
    var i = r ? "" : n.css;
    if (e.styleSheet) e.styleSheet.cssText = A(t, i);else {
      var o = document.createTextNode(i),
          a = e.childNodes;
      a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(o, a[t]) : e.appendChild(o);
    }
  }
}, function (e, t) {
  e.exports = function (e) {
    var t = "undefined" != typeof window && window.location;
    if (!t) throw new Error("fixUrls requires window.location");
    if (!e || "string" != typeof e) return e;
    var r = t.protocol + "//" + t.host,
        n = r + t.pathname.replace(/\/[^\/]*$/, "/");
    return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
      var i,
          o = t.trim().replace(/^"(.*)"$/, function (e, t) {
        return t;
      }).replace(/^'(.*)'$/, function (e, t) {
        return t;
      });
      return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(o) ? e : (i = 0 === o.indexOf("//") ? o : 0 === o.indexOf("/") ? r + o : n + o.replace(/^\.\//, ""), "url(" + JSON.stringify(i) + ")");
    });
  };
}]);